var _defineProperty2 = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("react-redux"), require("@driftt/web-auth"), require("redux"), require("axios"), require("react-dom"), require("@driftt/tide-tooltips"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core", "ramda", "@driftt/tide-icons", "react-redux", "@driftt/web-auth", "redux", "axios", "react-dom", "@driftt/tide-tooltips"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core"), require("ramda"), require("@driftt/tide-icons"), require("react-redux"), require("@driftt/web-auth"), require("redux"), require("axios"), require("react-dom"), require("@driftt/tide-tooltips")) : t(e.react, e["@driftt/tide-core"], e.ramda, e["@driftt/tide-icons"], e["react-redux"], e["@driftt/web-auth"], e.redux, e.axios, e["react-dom"], e["@driftt/tide-tooltips"]);

    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (e, t, n, r, i, o, a, s, c, l) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 67);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    e.exports = n(68);
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" === typeof btoa) {
              var i = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  o = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(o).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          null != o && (r[o] = !0);
        }

        for (i = 0; i < e.length; i++) {
          var a = e[i];
          null != a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    var r = {},
        i = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        o = function (e) {
      var t = {};
      return function (e, n) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var r = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, n);

          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (i) {
            r = null;
          }
          t[e] = r;
        }

        return t[e];
      };
    }(),
        a = null,
        s = 0,
        c = [],
        l = n(71);

    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n],
            o = r[i.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](i.parts[a]);
          }

          for (; a < i.parts.length; a++) {
            o.parts.push(addStyle(i.parts[a], t));
          }
        } else {
          var s = [];

          for (a = 0; a < i.parts.length; a++) {
            s.push(addStyle(i.parts[a], t));
          }

          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var o = e[i],
            a = t.base ? o[0] + t.base : o[0],
            s = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function insertStyleElement(e, t) {
      var n = o(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = c[c.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), c.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var i = o(e.insertAt.before, n);
        n.insertBefore(t, i);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      t >= 0 && c.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var r = function getNonce() {
          0;
          return n.nc;
        }();

        r && (e.attrs.nonce = r);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function addStyle(e, t) {
      var n, r, i, o;

      if (t.transform && e.css) {
        if (!(o = "function" === typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = o;
      }

      if (t.singleton) {
        var c = s++;
        n = a || (a = createStyleElement(t)), r = applyToSingletonTag.bind(null, n, c, !1), i = applyToSingletonTag.bind(null, n, c, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), r = function updateLink(e, t, n) {
        var r = n.css,
            i = n.sourceMap,
            o = void 0 === t.convertToAbsoluteUrls && i;
        (t.convertToAbsoluteUrls || o) && (r = l(r));
        i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), i = function i() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(t), r = function applyToTag(e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), i = function i() {
        removeStyleElement(n);
      });

      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var i = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (s = r[a.id]).refs--, i.push(s);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (o = 0; o < i.length; o++) {
          var s;

          if (0 === (s = i[o]).refs) {
            for (var c = 0; c < s.parts.length; c++) {
              s.parts[c]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var u = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = u(t, i);else {
        var o = document.createTextNode(i),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
      }
    }
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        i = n(75),
        o = n(24),
        a = n(78),
        s = function () {
      function Observable(e) {
        this._isScalar = !1, e && (this._subscribe = e);
      }

      return Observable.prototype.lift = function (e) {
        var t = new Observable();
        return t.source = this, t.operator = e, t;
      }, Observable.prototype.subscribe = function (e, t, n) {
        var r = this.operator,
            o = i.toSubscriber(e, t, n);
        if (r ? r.call(o, this.source) : o.add(this.source || !o.syncErrorThrowable ? this._subscribe(o) : this._trySubscribe(o)), o.syncErrorThrowable && (o.syncErrorThrowable = !1, o.syncErrorThrown)) throw o.syncErrorValue;
        return o;
      }, Observable.prototype._trySubscribe = function (e) {
        try {
          return this._subscribe(e);
        } catch (t) {
          e.syncErrorThrown = !0, e.syncErrorValue = t, e.error(t);
        }
      }, Observable.prototype.forEach = function (e, t) {
        var n = this;
        if (t || (r.root.Rx && r.root.Rx.config && r.root.Rx.config.Promise ? t = r.root.Rx.config.Promise : r.root.Promise && (t = r.root.Promise)), !t) throw new Error("no Promise impl found");
        return new t(function (t, r) {
          var i;
          i = n.subscribe(function (t) {
            if (i) try {
              e(t);
            } catch (n) {
              r(n), i.unsubscribe();
            } else e(t);
          }, r, t);
        });
      }, Observable.prototype._subscribe = function (e) {
        return this.source.subscribe(e);
      }, Observable.prototype[o.observable] = function () {
        return this;
      }, Observable.prototype.pipe = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t - 0] = arguments[t];
        }

        return 0 === e.length ? this : a.pipeFromArray(e)(this);
      }, Observable.prototype.toPromise = function (e) {
        var t = this;
        if (e || (r.root.Rx && r.root.Rx.config && r.root.Rx.config.Promise ? e = r.root.Rx.config.Promise : r.root.Promise && (e = r.root.Promise)), !e) throw new Error("no Promise impl found");
        return new e(function (e, n) {
          var r;
          t.subscribe(function (e) {
            return r = e;
          }, function (e) {
            return n(e);
          }, function () {
            return e(r);
          });
        });
      }, Observable.create = function (e) {
        return new Observable(e);
      }, Observable;
    }();

    t.Observable = s;
  }, function (e, t, n) {
    e.exports = n(162)();
  }, function (e, t, n) {
    e.exports = n(156)();
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r) && r.length) {
              var o = classNames.apply(null, r);
              o && e.push(o);
            } else if ("object" === i) for (var a in r) {
              n.call(r, a) && r[a] && e.push(a);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (r = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(33),
        o = n(22),
        a = n(37),
        s = n(23),
        c = function (e) {
      function Subscriber(t, n, r) {
        switch (e.call(this), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length) {
          case 0:
            this.destination = a.empty;
            break;

          case 1:
            if (!t) {
              this.destination = a.empty;
              break;
            }

            if ("object" === typeof t) {
              if (isTrustedSubscriber(t)) {
                var i = t[s.rxSubscriber]();
                this.syncErrorThrowable = i.syncErrorThrowable, this.destination = i, i.add(this);
              } else this.syncErrorThrowable = !0, this.destination = new l(this, t);

              break;
            }

          default:
            this.syncErrorThrowable = !0, this.destination = new l(this, t, n, r);
        }
      }

      return r(Subscriber, e), Subscriber.prototype[s.rxSubscriber] = function () {
        return this;
      }, Subscriber.create = function (e, t, n) {
        var r = new Subscriber(e, t, n);
        return r.syncErrorThrowable = !1, r;
      }, Subscriber.prototype.next = function (e) {
        this.isStopped || this._next(e);
      }, Subscriber.prototype.error = function (e) {
        this.isStopped || (this.isStopped = !0, this._error(e));
      }, Subscriber.prototype.complete = function () {
        this.isStopped || (this.isStopped = !0, this._complete());
      }, Subscriber.prototype.unsubscribe = function () {
        this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
      }, Subscriber.prototype._next = function (e) {
        this.destination.next(e);
      }, Subscriber.prototype._error = function (e) {
        this.destination.error(e), this.unsubscribe();
      }, Subscriber.prototype._complete = function () {
        this.destination.complete(), this.unsubscribe();
      }, Subscriber.prototype._unsubscribeAndRecycle = function () {
        var e = this._parent,
            t = this._parents;
        return this._parent = null, this._parents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parent = e, this._parents = t, this;
      }, Subscriber;
    }(o.Subscription);

    t.Subscriber = c;

    var l = function (e) {
      function SafeSubscriber(t, n, r, o) {
        var s;
        e.call(this), this._parentSubscriber = t;
        var c = this;
        i.isFunction(n) ? s = n : n && (s = n.next, r = n.error, o = n.complete, n !== a.empty && (c = Object.create(n), i.isFunction(c.unsubscribe) && this.add(c.unsubscribe.bind(c)), c.unsubscribe = this.unsubscribe.bind(this))), this._context = c, this._next = s, this._error = r, this._complete = o;
      }

      return r(SafeSubscriber, e), SafeSubscriber.prototype.next = function (e) {
        if (!this.isStopped && this._next) {
          var t = this._parentSubscriber;
          t.syncErrorThrowable ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe() : this.__tryOrUnsub(this._next, e);
        }
      }, SafeSubscriber.prototype.error = function (e) {
        if (!this.isStopped) {
          var t = this._parentSubscriber;
          if (this._error) t.syncErrorThrowable ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe()) : (this.__tryOrUnsub(this._error, e), this.unsubscribe());else {
            if (!t.syncErrorThrowable) throw this.unsubscribe(), e;
            t.syncErrorValue = e, t.syncErrorThrown = !0, this.unsubscribe();
          }
        }
      }, SafeSubscriber.prototype.complete = function () {
        var e = this;

        if (!this.isStopped) {
          var t = this._parentSubscriber;

          if (this._complete) {
            var n = function wrappedComplete() {
              return e._complete.call(e._context);
            };

            t.syncErrorThrowable ? (this.__tryOrSetError(t, n), this.unsubscribe()) : (this.__tryOrUnsub(n), this.unsubscribe());
          } else this.unsubscribe();
        }
      }, SafeSubscriber.prototype.__tryOrUnsub = function (e, t) {
        try {
          e.call(this._context, t);
        } catch (n) {
          throw this.unsubscribe(), n;
        }
      }, SafeSubscriber.prototype.__tryOrSetError = function (e, t, n) {
        try {
          t.call(this._context, n);
        } catch (r) {
          return e.syncErrorValue = r, e.syncErrorThrown = !0, !0;
        }

        return !1;
      }, SafeSubscriber.prototype._unsubscribe = function () {
        var e = this._parentSubscriber;
        this._context = null, this._parentSubscriber = null, e.unsubscribe();
      }, SafeSubscriber;
    }(c);

    function isTrustedSubscriber(e) {
      return e instanceof c || "syncErrorThrowable" in e && e[s.rxSubscriber];
    }
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = "undefined" !== typeof window && window,
          r = "undefined" !== typeof self && "undefined" !== typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && self,
          i = n || "undefined" !== typeof e && e || r;
      t.root = i, function () {
        if (!i) throw new Error("RxJS could not find any global context (window, self, global)");
      }();
    }).call(this, n(17));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (r) {
      "object" === typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(47);
    t.getIsVideoUserOnly = function (e) {
      void 0 === e && (e = []);
      var t = r.without([i.DriftScopesIF.SALES_SEQUENCES], e);
      return r.equals([i.DriftScopesIF.video], t) || t.includes(i.DriftScopesIF.video_free) && t.includes(i.DriftScopesIF.video) && 2 === t.length;
    }, t.getIsOrgAdmin = function (e) {
      return void 0 === e && (e = []), e.includes(i.DriftScopesIF.org_admin);
    }, t.getIsReportingUser = function (e) {
      return void 0 === e && (e = []), e.includes(i.DriftRolesIF.reporting);
    }, t.getIsPlaybooksUser = function (e) {
      return void 0 === e && (e = []), e.includes(i.DriftRolesIF.playbooks);
    }, t.getIsCalendarUser = function (e, t) {
      return void 0 === e && (e = []), void 0 === t && (t = {}), r.contains(i.DriftScopesIF.calendar_user, e) || r.pathOr(!1, ["has_calendar_user_license"], t);
    }, t.getIsBotsV2User = function (e) {
      return void 0 === e && (e = {}), r.pathOr(!1, ["has_siftrock_bots_v2"], e);
    }, t.getConversationFreeOrg = function (e) {
      return void 0 === e && (e = {}), r.pathOr(!1, ["conversation_free_org"], e);
    }, t.isFreeOrg = function (e) {
      return void 0 === e && (e = {}), !(r.pathOr(!1, ["standard_trial"], e) || r.pathOr(!1, ["premium_team"], e) || r.pathOr(!1, ["premium_drift"], e) || r.pathOr(!1, ["premium_enterprise"], e));
    }, t.isStandardOrAboveOrg = function (e) {
      return void 0 === e && (e = {}), r.pathOr(!1, ["premium_drift"], e) || r.pathOr(!1, ["premium_enterprise"], e) || r.pathOr(!1, ["premium_team"], e);
    }, t.isProOrAboveOrg = function (e) {
      return void 0 === e && (e = {}), r.pathOr(!1, ["premium_enterprise"], e) || r.pathOr(!1, ["premium_team"], e);
    }, t.hasCalendarRouting = function (e) {
      return void 0 === e && (e = {}), r.pathOr(!1, ["has_calendar_routing"], e);
    };
  }, function (e, t, n) {
    !function webpackUniversalModuleDefinition(t, r) {
      e.exports = r(n(0));
    }(window, function (e) {
      return function (e) {
        var t = {};

        function __webpack_require__(n) {
          if (t[n]) return t[n].exports;
          var r = t[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
        }

        return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
          __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
          });
        }, __webpack_require__.r = function (e) {
          "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, __webpack_require__.t = function (e, t) {
          if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
          if (4 & t && "object" === typeof e && e && e.__esModule) return e;
          var n = Object.create(null);
          if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var r in e) {
            __webpack_require__.d(n, r, function (t) {
              return e[t];
            }.bind(null, r));
          }
          return n;
        }, __webpack_require__.n = function (e) {
          var t = e && e.__esModule ? function getDefault() {
            return e.default;
          } : function getModuleExports() {
            return e;
          };
          return __webpack_require__.d(t, "a", t), t;
        }, __webpack_require__.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 2);
      }([function (t, n) {
        t.exports = e;
      }, function (e, t) {
        e.exports = "data:image/png;base64,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";
      }, function (e, t, n) {
        e.exports = n(8);
      }, function (e, t, n) {
        var r = n(4);
        "string" === typeof r && (r = [[e.i, r, ""]]);
        n(6)(r, {
          hmr: !0,
          transform: void 0,
          insertInto: void 0
        }), r.locals && (e.exports = r.locals);
      }, function (e, t, n) {
        (e.exports = n(5)(!1)).push([e.i, ".integrated-help-launcher--container {\n  border: none;\n  display: flex;\n  height: 76px;\n  width: 76px;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: 24px;\n  right: 24px;\n  visibility: visible;\n  z-index: 2147483647;\n  max-height: 100vh;\n  max-width: 100vw;\n  -webkit-transition: none 0s ease 0s;\n  transition: none 0s ease 0s;\n  background: none transparent;\n  opacity: 1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button {\n  z-index: 1;\n  cursor: pointer;\n  width: 52px;\n  height: 52px;\n  background-color: rgba(21, 122, 251, 1);\n  border-radius: .3125rem;\n  box-shadow: 0 2px 6px 0 rgba(32,0,0,.4);\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button img {\n  width: 52px;\n  height: 52px;\n}", ""]);
      }, function (e, t) {
        e.exports = function (e) {
          var t = [];
          return t.toString = function toString() {
            return this.map(function (t) {
              var n = function cssWithMappingToString(e, t) {
                var n = e[1] || "",
                    r = e[3];
                if (!r) return n;

                if (t && "function" === typeof btoa) {
                  var i = function toComment(e) {
                    return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                  }(r),
                      o = r.sources.map(function (e) {
                    return "/*# sourceURL=" + r.sourceRoot + e + " */";
                  });

                  return [n].concat(o).concat([i]).join("\n");
                }

                return [n].join("\n");
              }(t, e);

              return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
            }).join("");
          }, t.i = function (e, n) {
            "string" === typeof e && (e = [[null, e, ""]]);

            for (var r = {}, i = 0; i < this.length; i++) {
              var o = this[i][0];
              "number" === typeof o && (r[o] = !0);
            }

            for (i = 0; i < e.length; i++) {
              var a = e[i];
              "number" === typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
            }
          }, t;
        };
      }, function (e, t, n) {
        var r = {},
            i = function (e) {
          var t;
          return function () {
            return "undefined" === typeof t && (t = function () {
              return window && document && document.all && !window.atob;
            }.apply(this, arguments)), t;
          };
        }(),
            a = function (e) {
          var t = {};
          return function (e, n) {
            if ("function" === typeof e) return e();

            if ("undefined" === typeof t[e]) {
              var r = function (e, t) {
                return t ? t.querySelector(e) : document.querySelector(e);
              }.call(this, e, n);

              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (i) {
                r = null;
              }
              t[e] = r;
            }

            return t[e];
          };
        }(),
            s = null,
            c = 0,
            l = [],
            u = n(7);

        function addStylesToDom(e, t) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n],
                o = r[i.id];

            if (o) {
              o.refs++;

              for (var a = 0; a < o.parts.length; a++) {
                o.parts[a](i.parts[a]);
              }

              for (; a < i.parts.length; a++) {
                o.parts.push(addStyle(i.parts[a], t));
              }
            } else {
              var s = [];

              for (a = 0; a < i.parts.length; a++) {
                s.push(addStyle(i.parts[a], t));
              }

              r[i.id] = {
                id: i.id,
                refs: 1,
                parts: s
              };
            }
          }
        }

        function listToStyles(e, t) {
          for (var n = [], r = {}, i = 0; i < e.length; i++) {
            var o = e[i],
                a = t.base ? o[0] + t.base : o[0],
                s = {
              css: o[1],
              media: o[2],
              sourceMap: o[3]
            };
            r[a] ? r[a].parts.push(s) : n.push(r[a] = {
              id: a,
              parts: [s]
            });
          }

          return n;
        }

        function insertStyleElement(e, t) {
          var n = a(e.insertInto);
          if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
          var r = l[l.length - 1];
          if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
            if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
            var i = a(e.insertAt.before, n);
            n.insertBefore(t, i);
          }
        }

        function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
          var t = l.indexOf(e);
          t >= 0 && l.splice(t, 1);
        }

        function createStyleElement(e) {
          var t = document.createElement("style");

          if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
            var r = function getNonce() {
              return n.nc;
            }();

            r && (e.attrs.nonce = r);
          }

          return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
        }

        function addAttrs(e, t) {
          Object.keys(t).forEach(function (n) {
            e.setAttribute(n, t[n]);
          });
        }

        function addStyle(e, t) {
          var n, r, i, a;

          if (t.transform && e.css) {
            if (!(a = t.transform(e.css))) return function () {};
            e.css = a;
          }

          if (t.singleton) {
            var l = c++;
            n = s || (s = createStyleElement(t)), r = applyToSingletonTag.bind(null, n, l, !1), i = applyToSingletonTag.bind(null, n, l, !0);
          } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
            var t = document.createElement("link");
            return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
          }(t), r = function updateLink(e, t, n) {
            var r = n.css,
                i = n.sourceMap,
                o = void 0 === t.convertToAbsoluteUrls && i;
            (t.convertToAbsoluteUrls || o) && (r = u(r)), i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
            var a = new Blob([r], {
              type: "text/css"
            }),
                s = e.href;
            e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
          }.bind(null, n, t), i = function o() {
            removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
          }) : (n = createStyleElement(t), r = function applyToTag(e, t) {
            var n = t.css,
                r = t.media;
            if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
              for (; e.firstChild;) {
                e.removeChild(e.firstChild);
              }

              e.appendChild(document.createTextNode(n));
            }
          }.bind(null, n), i = function o() {
            removeStyleElement(n);
          });

          return r(e), function updateStyle(t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              r(e = t);
            } else i();
          };
        }

        e.exports = function (e, t) {
          if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
          (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
          var n = listToStyles(e, t);
          return addStylesToDom(n, t), function update(e) {
            for (var i = [], o = 0; o < n.length; o++) {
              var a = n[o];
              (s = r[a.id]).refs--, i.push(s);
            }

            for (e && addStylesToDom(listToStyles(e, t), t), o = 0; o < i.length; o++) {
              var s;

              if (0 === (s = i[o]).refs) {
                for (var c = 0; c < s.parts.length; c++) {
                  s.parts[c]();
                }

                delete r[s.id];
              }
            }
          };
        };

        var p = function () {
          var e = [];
          return function (t, n) {
            return e[t] = n, e.filter(Boolean).join("\n");
          };
        }();

        function applyToSingletonTag(e, t, n, r) {
          var i = n ? "" : r.css;
          if (e.styleSheet) e.styleSheet.cssText = p(t, i);else {
            var o = document.createTextNode(i),
                a = e.childNodes;
            a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(o, a[t]) : e.appendChild(o);
          }
        }
      }, function (e, t) {
        e.exports = function (e) {
          var t = "undefined" !== typeof window && window.location;
          if (!t) throw new Error("fixUrls requires window.location");
          if (!e || "string" !== typeof e) return e;
          var n = t.protocol + "//" + t.host,
              r = n + t.pathname.replace(/\/[^\/]*$/, "/");
          return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
            var i,
                o = t.trim().replace(/^"(.*)"$/, function (e, t) {
              return t;
            }).replace(/^'(.*)'$/, function (e, t) {
              return t;
            });
            return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
          });
        };
      }, function (e, t, n) {
        "use strict";

        n.r(t);
        var r = {};
        n.r(r), n.d(r, "startInteraction", function () {
          return s;
        });
        var i = {};

        function _defineProperties(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function _typeof2(e) {
          return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(e) {
            return typeof e;
          } : function _typeof2(e) {
            return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        function _typeof(e) {
          return (_typeof = "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? function _typeof(e) {
            return _typeof2(e);
          } : function _typeof(e) {
            return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
          })(e);
        }

        function _getPrototypeOf(e) {
          return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
        }

        function _setPrototypeOf(e, t) {
          return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        n.r(i), n.d(i, "saveHelpInteractionStart", function () {
          return c;
        }), n.d(i, "getLastHelpInteractionEpoch", function () {
          return l;
        }), n.d(i, "shouldLaunchHelpInteraction", function () {
          return u;
        });

        var o = n(0),
            a = n.n(o),
            s = function startInteraction(e) {
          return window.drift && window.drift.api.startInteraction({
            interactionId: e
          });
        },
            c = function saveHelpInteractionStart() {
          window.localStorage && window.localStorage.setItem && window.localStorage.setItem("drift-integrated-help-triggered", new Date().getTime() + "");
        },
            l = function getLastHelpInteractionEpoch() {
          var e = window.localStorage && window.localStorage.getItem && window.localStorage.getItem("drift-integrated-help-triggered"),
              t = parseInt(e);
          return isNaN(t) ? null : t;
        },
            u = function shouldLaunchHelpInteraction() {
          var e = l(),
              t = new Date();
          return t.setDate(t.getDate() - 1), !e || e < t.getTime();
        },
            p = n(1),
            f = n.n(p),
            d = (n(3), function (e) {
          function Launcher(e) {
            var t;
            return function _classCallCheck(e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, Launcher), (t = function _possibleConstructorReturn(e, t) {
              return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }(e) : t;
            }(this, _getPrototypeOf(Launcher).call(this, e))).state = {
              show: !1
            }, t.hideLauncher = function () {
              t.state.show || console.warn("Integrated Help launcher is already hidden"), t.setState({
                show: !1
              });
            }, t.showLauncher = function () {
              t.state.show && console.warn("Integrated Help launcher is already visible"), t.setState({
                show: !0
              });
            }, t.setupWidget = function () {
              window.drift && window.drift.on("ready", function () {
                t.setState({
                  show: !0
                }), window.drift.hide(), window.drift.on("sidebarOpen", t.hideLauncher), window.drift.on("welcomeMesage:open", function () {
                  return window.drift.hide();
                }), window.drift.on("awayMessage:open", window.drift.hide()), window.drift.on("sidebarClose", t.showLauncherAndHideWidget), window.drift.config({
                  enableWelcomeMessage: !1,
                  enableCampaigns: !1,
                  disableNewConversations: !0
                });
              });
            }, t.showLauncherAndHideWidget = function (e) {
              e.data.widgetVisible && window.drift.hide(), t.setState({
                show: !0
              });
            }, t.launchHelp = function () {
              u() ? t.launchInteraction() : window.drift.api.openChat();
            }, t.launchInteraction = function () {
              var e = t.props.interactionId;
              c(), t.setState({
                show: !1
              }, s(e));
            }, window.HelpLauncher = {
              hide: function hide() {
                return t.hideLauncher();
              },
              show: function show() {
                return t.showLauncher();
              }
            }, t;
          }

          return function _inherits(e, t) {
            if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && _setPrototypeOf(e, t);
          }(Launcher, o.Component), function _createClass(e, t, n) {
            t && _defineProperties(e.prototype, t), n && _defineProperties(e, n);
          }(Launcher, [{
            key: "componentDidMount",
            value: function componentDidMount() {
              this.props.interactionId ? this.setupWidget() : console.warn("No interaction id found to trigger help launcher");
            }
          }, {
            key: "render",
            value: function render() {
              return this.state.show ? a.a.createElement("div", {
                className: "integrated-help-launcher--container"
              }, a.a.createElement("div", {
                className: "integrated-help-launcher--button",
                onClick: this.launchHelp
              }, a.a.createElement("img", {
                src: f.a,
                alt: "background"
              }))) : null;
            }
          }]), Launcher;
        }());

        n.d(t, "widgetUtils", function () {
          return h;
        }), n.d(t, "helpUtils", function () {
          return m;
        });
        var h = r,
            m = i;
        t.default = d;
      }]);
    });
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(9),
        o = n(13),
        a = n(22),
        s = n(38),
        c = n(80),
        l = n(23),
        u = function (e) {
      function SubjectSubscriber(t) {
        e.call(this, t), this.destination = t;
      }

      return r(SubjectSubscriber, e), SubjectSubscriber;
    }(o.Subscriber);

    t.SubjectSubscriber = u;

    var p = function (e) {
      function Subject() {
        e.call(this), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
      }

      return r(Subject, e), Subject.prototype[l.rxSubscriber] = function () {
        return new u(this);
      }, Subject.prototype.lift = function (e) {
        var t = new f(this, this);
        return t.operator = e, t;
      }, Subject.prototype.next = function (e) {
        if (this.closed) throw new s.ObjectUnsubscribedError();
        if (!this.isStopped) for (var t = this.observers, n = t.length, r = t.slice(), i = 0; i < n; i++) {
          r[i].next(e);
        }
      }, Subject.prototype.error = function (e) {
        if (this.closed) throw new s.ObjectUnsubscribedError();
        this.hasError = !0, this.thrownError = e, this.isStopped = !0;

        for (var t = this.observers, n = t.length, r = t.slice(), i = 0; i < n; i++) {
          r[i].error(e);
        }

        this.observers.length = 0;
      }, Subject.prototype.complete = function () {
        if (this.closed) throw new s.ObjectUnsubscribedError();
        this.isStopped = !0;

        for (var e = this.observers, t = e.length, n = e.slice(), r = 0; r < t; r++) {
          n[r].complete();
        }

        this.observers.length = 0;
      }, Subject.prototype.unsubscribe = function () {
        this.isStopped = !0, this.closed = !0, this.observers = null;
      }, Subject.prototype._trySubscribe = function (t) {
        if (this.closed) throw new s.ObjectUnsubscribedError();
        return e.prototype._trySubscribe.call(this, t);
      }, Subject.prototype._subscribe = function (e) {
        if (this.closed) throw new s.ObjectUnsubscribedError();
        return this.hasError ? (e.error(this.thrownError), a.Subscription.EMPTY) : this.isStopped ? (e.complete(), a.Subscription.EMPTY) : (this.observers.push(e), new c.SubjectSubscription(this, e));
      }, Subject.prototype.asObservable = function () {
        var e = new i.Observable();
        return e.source = this, e;
      }, Subject.create = function (e, t) {
        return new f(e, t);
      }, Subject;
    }(i.Observable);

    t.Subject = p;

    var f = function (e) {
      function AnonymousSubject(t, n) {
        e.call(this), this.destination = t, this.source = n;
      }

      return r(AnonymousSubject, e), AnonymousSubject.prototype.next = function (e) {
        var t = this.destination;
        t && t.next && t.next(e);
      }, AnonymousSubject.prototype.error = function (e) {
        var t = this.destination;
        t && t.error && this.destination.error(e);
      }, AnonymousSubject.prototype.complete = function () {
        var e = this.destination;
        e && e.complete && this.destination.complete();
      }, AnonymousSubject.prototype._subscribe = function (e) {
        return this.source ? this.source.subscribe(e) : a.Subscription.EMPTY;
      }, AnonymousSubject;
    }(p);

    t.AnonymousSubject = f;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(47),
        i = n(114),
        o = n(115),
        a = n(116),
        s = n(117),
        c = n(118),
        l = n(119),
        u = n(120),
        p = n(121),
        f = function generateAppConfig(e, t) {
      switch (t) {
        case r.DriftAppsIF.conversationsWeb:
          return i.default(e);

        case r.DriftAppsIF.settingsWeb:
          return o.default(e);

        case r.DriftAppsIF.trafficControl:
          return a.default(e);

        case r.DriftAppsIF.insightsWeb:
          return s.default(e);

        case r.DriftAppsIF.contactsWeb:
          return c.default(e);

        case r.DriftAppsIF.conversationsDesktop:
          return u.default(e);

        case r.DriftAppsIF.automationWeb:
          return p.default(e);

        default:
          throw new Error("need to pass in a valid app");
      }
    };

    t.generateConversationsWebAppConfig = function (e) {
      return f(e, r.DriftAppsIF.conversationsWeb);
    }, t.generateSettingsWebAppConfig = function (e) {
      return f(e, r.DriftAppsIF.settingsWeb);
    }, t.generateTrafficControlNavConfig = function (e) {
      return f(e, r.DriftAppsIF.trafficControl);
    }, t.generateInsightsWebAppConfig = function (e) {
      return f(e, r.DriftAppsIF.insightsWeb);
    }, t.generateContactsWebAppConfig = function (e) {
      return f(e, r.DriftAppsIF.contactsWeb);
    }, t.generateMarketplaceWebAppConfig = function (e) {
      return function generateAppConfigForOrg(e, t) {
        switch (t) {
          case r.DriftAppsIF.marketplaceWeb:
            return l.default(e);

          default:
            throw new Error("need to pass in a valid app");
        }
      }(e, r.DriftAppsIF.marketplaceWeb);
    }, t.generateConversationsDesktopAppConfig = function (e) {
      return f(e, r.DriftAppsIF.conversationsDesktop);
    }, t.generateAutomationWebAppConfig = function (e) {
      return f(e, r.DriftAppsIF.automationWeb);
    }, t.default = f;
  }, function (e, t, n) {
    "use strict";

    var r = n(34),
        i = n(35),
        o = n(33),
        a = n(76),
        s = n(36),
        c = n(77),
        l = function () {
      function Subscription(e) {
        this.closed = !1, this._parent = null, this._parents = null, this._subscriptions = null, e && (this._unsubscribe = e);
      }

      var e;
      return Subscription.prototype.unsubscribe = function () {
        var e,
            t = !1;

        if (!this.closed) {
          var n = this._parent,
              l = this._parents,
              u = this._unsubscribe,
              p = this._subscriptions;
          this.closed = !0, this._parent = null, this._parents = null, this._subscriptions = null;

          for (var f = -1, d = l ? l.length : 0; n;) {
            n.remove(this), n = ++f < d && l[f] || null;
          }

          if (o.isFunction(u)) a.tryCatch(u).call(this) === s.errorObject && (t = !0, e = e || (s.errorObject.e instanceof c.UnsubscriptionError ? flattenUnsubscriptionErrors(s.errorObject.e.errors) : [s.errorObject.e]));
          if (r.isArray(p)) for (f = -1, d = p.length; ++f < d;) {
            var h = p[f];
            if (i.isObject(h)) if (a.tryCatch(h.unsubscribe).call(h) === s.errorObject) {
              t = !0, e = e || [];
              var m = s.errorObject.e;
              m instanceof c.UnsubscriptionError ? e = e.concat(flattenUnsubscriptionErrors(m.errors)) : e.push(m);
            }
          }
          if (t) throw new c.UnsubscriptionError(e);
        }
      }, Subscription.prototype.add = function (e) {
        if (!e || e === Subscription.EMPTY) return Subscription.EMPTY;
        if (e === this) return this;
        var t = e;

        switch (typeof e) {
          case "function":
            t = new Subscription(e);

          case "object":
            if (t.closed || "function" !== typeof t.unsubscribe) return t;
            if (this.closed) return t.unsubscribe(), t;

            if ("function" !== typeof t._addParent) {
              var n = t;
              (t = new Subscription())._subscriptions = [n];
            }

            break;

          default:
            throw new Error("unrecognized teardown " + e + " added to Subscription.");
        }

        return (this._subscriptions || (this._subscriptions = [])).push(t), t._addParent(this), t;
      }, Subscription.prototype.remove = function (e) {
        var t = this._subscriptions;

        if (t) {
          var n = t.indexOf(e);
          -1 !== n && t.splice(n, 1);
        }
      }, Subscription.prototype._addParent = function (e) {
        var t = this._parent,
            n = this._parents;
        t && t !== e ? n ? -1 === n.indexOf(e) && n.push(e) : this._parents = [e] : this._parent = e;
      }, Subscription.EMPTY = ((e = new Subscription()).closed = !0, e), Subscription;
    }();

    function flattenUnsubscriptionErrors(e) {
      return e.reduce(function (e, t) {
        return e.concat(t instanceof c.UnsubscriptionError ? t.errors : t);
      }, []);
    }

    t.Subscription = l;
  }, function (e, t, n) {
    "use strict";

    var r = n(16).root.Symbol;
    t.rxSubscriber = "function" === typeof r && "function" === typeof r.for ? r.for("rxSubscriber") : "@@rxSubscriber", t.$$rxSubscriber = t.rxSubscriber;
  }, function (e, t, n) {
    "use strict";

    var r = n(16);

    function getSymbolObservable(e) {
      var t,
          n = e.Symbol;
      return "function" === typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
    }

    t.getSymbolObservable = getSymbolObservable, t.observable = getSymbolObservable(r.root), t.$$observable = t.observable;
  }, function (e, t, n) {
    "use strict";

    var r = n(16);

    function symbolIteratorPonyfill(e) {
      var t = e.Symbol;
      if ("function" === typeof t) return t.iterator || (t.iterator = t("iterator polyfill")), t.iterator;
      var n = e.Set;
      if (n && "function" === typeof new n()["@@iterator"]) return "@@iterator";
      var r = e.Map;
      if (r) for (var i = Object.getOwnPropertyNames(r.prototype), o = 0; o < i.length; ++o) {
        var a = i[o];
        if ("entries" !== a && "size" !== a && r.prototype[a] === r.prototype.entries) return a;
      }
      return "@@iterator";
    }

    t.symbolIteratorPonyfill = symbolIteratorPonyfill, t.iterator = symbolIteratorPonyfill(r.root), t.$$iterator = t.iterator;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(9),
        o = n(44),
        a = n(27),
        s = n(45),
        c = function (e) {
      function ArrayObservable(t, n) {
        e.call(this), this.array = t, this.scheduler = n, n || 1 !== t.length || (this._isScalar = !0, this.value = t[0]);
      }

      return r(ArrayObservable, e), ArrayObservable.create = function (e, t) {
        return new ArrayObservable(e, t);
      }, ArrayObservable.of = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t - 0] = arguments[t];
        }

        var n = e[e.length - 1];
        s.isScheduler(n) ? e.pop() : n = null;
        var r = e.length;
        return r > 1 ? new ArrayObservable(e, n) : 1 === r ? new o.ScalarObservable(e[0], n) : new a.EmptyObservable(n);
      }, ArrayObservable.dispatch = function (e) {
        var t = e.array,
            n = e.index,
            r = e.count,
            i = e.subscriber;
        n >= r ? i.complete() : (i.next(t[n]), i.closed || (e.index = n + 1, this.schedule(e)));
      }, ArrayObservable.prototype._subscribe = function (e) {
        var t = this.array,
            n = t.length,
            r = this.scheduler;
        if (r) return r.schedule(ArrayObservable.dispatch, 0, {
          array: t,
          index: 0,
          count: n,
          subscriber: e
        });

        for (var i = 0; i < n && !e.closed; i++) {
          e.next(t[i]);
        }

        e.complete();
      }, ArrayObservable;
    }(i.Observable);

    t.ArrayObservable = c;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function EmptyObservable(t) {
        e.call(this), this.scheduler = t;
      }

      return r(EmptyObservable, e), EmptyObservable.create = function (e) {
        return new EmptyObservable(e);
      }, EmptyObservable.dispatch = function (e) {
        e.subscriber.complete();
      }, EmptyObservable.prototype._subscribe = function (e) {
        var t = this.scheduler;
        if (t) return t.schedule(EmptyObservable.dispatch, 0, {
          subscriber: e
        });
        e.complete();
      }, EmptyObservable;
    }(n(9).Observable);

    t.EmptyObservable = i;
  }, function (e, t, n) {
    (function (t) {
      var r = n(50),
          i = "undefined" !== typeof window ? window : "undefined" !== typeof t ? t : "undefined" !== typeof self ? self : {};

      function isUndefined(e) {
        return void 0 === e;
      }

      function isPlainObject(e) {
        return "[object Object]" === Object.prototype.toString.call(e);
      }

      function isString(e) {
        return "[object String]" === Object.prototype.toString.call(e);
      }

      function isArray(e) {
        return "[object Array]" === Object.prototype.toString.call(e);
      }

      function supportsFetch() {
        if (!("fetch" in i)) return !1;

        try {
          return new Headers(), new Request(""), new Response(), !0;
        } catch (e) {
          return !1;
        }
      }

      function each(e, t) {
        var n, r;
        if (isUndefined(e.length)) for (n in e) {
          hasKey(e, n) && t.call(null, n, e[n]);
        } else if (r = e.length) for (n = 0; n < r; n++) {
          t.call(null, n, e[n]);
        }
      }

      function truncate(e, t) {
        if ("number" !== typeof t) throw new Error("2nd argument to `truncate` function should be a number");
        return "string" !== typeof e || 0 === t ? e : e.length <= t ? e : e.substr(0, t) + "\u2026";
      }

      function hasKey(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      function joinRegExp(e) {
        for (var t, n = [], r = 0, i = e.length; r < i; r++) {
          isString(t = e[r]) ? n.push(t.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1")) : t && t.source && n.push(t.source);
        }

        return new RegExp(n.join("|"), "i");
      }

      function htmlElementAsString(e) {
        var t,
            n,
            r,
            i,
            o,
            a = [];
        if (!e || !e.tagName) return "";
        if (a.push(e.tagName.toLowerCase()), e.id && a.push("#" + e.id), (t = e.className) && isString(t)) for (n = t.split(/\s+/), o = 0; o < n.length; o++) {
          a.push("." + n[o]);
        }
        var s = ["type", "name", "title", "alt"];

        for (o = 0; o < s.length; o++) {
          r = s[o], (i = e.getAttribute(r)) && a.push("[" + r + '="' + i + '"]');
        }

        return a.join("");
      }

      function isOnlyOneTruthy(e, t) {
        return !!(!!e ^ !!t);
      }

      function isSameStacktrace(e, t) {
        if (isOnlyOneTruthy(e, t)) return !1;
        var n,
            r,
            i = e.frames,
            o = t.frames;
        if (void 0 === i || void 0 === o) return !1;
        if (i.length !== o.length) return !1;

        for (var a = 0; a < i.length; a++) {
          if (n = i[a], r = o[a], n.filename !== r.filename || n.lineno !== r.lineno || n.colno !== r.colno || n.function !== r.function) return !1;
        }

        return !0;
      }

      var o = 3,
          a = 51200,
          s = 40;

      function jsonSize(e) {
        return function utf8Length(e) {
          return ~-encodeURI(e).split(/%..|./).length;
        }(JSON.stringify(e));
      }

      function serializeValue(e) {
        if ("string" === typeof e) {
          return truncate(e, 40);
        }

        if ("number" === typeof e || "boolean" === typeof e || "undefined" === typeof e) return e;
        var t = Object.prototype.toString.call(e);
        return "[object Object]" === t ? "[Object]" : "[object Array]" === t ? "[Array]" : "[object Function]" === t ? e.name ? "[Function: " + e.name + "]" : "[Function]" : e;
      }

      e.exports = {
        isObject: function isObject(e) {
          return "object" === typeof e && null !== e;
        },
        isError: function isError(e) {
          switch (Object.prototype.toString.call(e)) {
            case "[object Error]":
            case "[object Exception]":
            case "[object DOMException]":
              return !0;

            default:
              return e instanceof Error;
          }
        },
        isErrorEvent: function isErrorEvent(e) {
          return "[object ErrorEvent]" === Object.prototype.toString.call(e);
        },
        isDOMError: function isDOMError(e) {
          return "[object DOMError]" === Object.prototype.toString.call(e);
        },
        isDOMException: function isDOMException(e) {
          return "[object DOMException]" === Object.prototype.toString.call(e);
        },
        isUndefined: isUndefined,
        isFunction: function isFunction(e) {
          return "function" === typeof e;
        },
        isPlainObject: isPlainObject,
        isString: isString,
        isArray: isArray,
        isEmptyObject: function isEmptyObject(e) {
          if (!isPlainObject(e)) return !1;

          for (var t in e) {
            if (e.hasOwnProperty(t)) return !1;
          }

          return !0;
        },
        supportsErrorEvent: function supportsErrorEvent() {
          try {
            return new ErrorEvent(""), !0;
          } catch (e) {
            return !1;
          }
        },
        supportsDOMError: function supportsDOMError() {
          try {
            return new DOMError(""), !0;
          } catch (e) {
            return !1;
          }
        },
        supportsDOMException: function supportsDOMException() {
          try {
            return new DOMException(""), !0;
          } catch (e) {
            return !1;
          }
        },
        supportsFetch: supportsFetch,
        supportsReferrerPolicy: function supportsReferrerPolicy() {
          if (!supportsFetch()) return !1;

          try {
            return new Request("pickleRick", {
              referrerPolicy: "origin"
            }), !0;
          } catch (e) {
            return !1;
          }
        },
        supportsPromiseRejectionEvent: function supportsPromiseRejectionEvent() {
          return "function" === typeof PromiseRejectionEvent;
        },
        wrappedCallback: function wrappedCallback(e) {
          return function dataCallback(t, n) {
            var r = e(t) || t;
            return n && n(r) || r;
          };
        },
        each: each,
        objectMerge: function objectMerge(e, t) {
          return t ? (each(t, function (t, n) {
            e[t] = n;
          }), e) : e;
        },
        truncate: truncate,
        objectFrozen: function objectFrozen(e) {
          return !!Object.isFrozen && Object.isFrozen(e);
        },
        hasKey: hasKey,
        joinRegExp: joinRegExp,
        urlencode: function urlencode(e) {
          var t = [];
          return each(e, function (e, n) {
            t.push(encodeURIComponent(e) + "=" + encodeURIComponent(n));
          }), t.join("&");
        },
        uuid4: function uuid4() {
          var e = i.crypto || i.msCrypto;

          if (!isUndefined(e) && e.getRandomValues) {
            var t = new Uint16Array(8);
            e.getRandomValues(t), t[3] = 4095 & t[3] | 16384, t[4] = 16383 & t[4] | 32768;

            var n = function pad(e) {
              for (var t = e.toString(16); t.length < 4;) {
                t = "0" + t;
              }

              return t;
            };

            return n(t[0]) + n(t[1]) + n(t[2]) + n(t[3]) + n(t[4]) + n(t[5]) + n(t[6]) + n(t[7]);
          }

          return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (e) {
            var t = 16 * Math.random() | 0;
            return ("x" === e ? t : 3 & t | 8).toString(16);
          });
        },
        htmlTreeAsString: function htmlTreeAsString(e) {
          for (var t, n = [], r = 0, i = 0, o = " > ".length; e && r++ < 5 && !("html" === (t = htmlElementAsString(e)) || r > 1 && i + n.length * o + t.length >= 80);) {
            n.push(t), i += t.length, e = e.parentNode;
          }

          return n.reverse().join(" > ");
        },
        htmlElementAsString: htmlElementAsString,
        isSameException: function isSameException(e, t) {
          return !isOnlyOneTruthy(e, t) && (e = e.values[0], t = t.values[0], e.type === t.type && e.value === t.value && !function isBothUndefined(e, t) {
            return isUndefined(e) && isUndefined(t);
          }(e.stacktrace, t.stacktrace) && isSameStacktrace(e.stacktrace, t.stacktrace));
        },
        isSameStacktrace: isSameStacktrace,
        parseUrl: function parseUrl(e) {
          if ("string" !== typeof e) return {};
          var t = e.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/),
              n = t[6] || "",
              r = t[8] || "";
          return {
            protocol: t[2],
            host: t[4],
            path: t[5],
            relative: t[5] + n + r
          };
        },
        fill: function fill(e, t, n, r) {
          if (null != e) {
            var i = e[t];
            e[t] = n(i), e[t].__raven__ = !0, e[t].__orig__ = i, r && r.push([e, t, i]);
          }
        },
        safeJoin: function safeJoin(e, t) {
          if (!isArray(e)) return "";

          for (var n = [], r = 0; r < e.length; r++) {
            try {
              n.push(String(e[r]));
            } catch (i) {
              n.push("[value cannot be serialized]");
            }
          }

          return n.join(t);
        },
        serializeException: function serializeException(e, t, n) {
          if (!isPlainObject(e)) return e;
          n = "number" !== typeof (t = "number" !== typeof t ? o : t) ? a : n;

          var i = function serializeObject(e, t) {
            return 0 === t ? serializeValue(e) : isPlainObject(e) ? Object.keys(e).reduce(function (n, r) {
              return n[r] = serializeObject(e[r], t - 1), n;
            }, {}) : Array.isArray(e) ? e.map(function (e) {
              return serializeObject(e, t - 1);
            }) : serializeValue(e);
          }(e, t);

          return jsonSize(r(i)) > n ? serializeException(e, t - 1) : i;
        },
        serializeKeysForMessage: function serializeKeysForMessage(e, t) {
          if ("number" === typeof e || "string" === typeof e) return e.toString();
          if (!Array.isArray(e)) return "";
          if (0 === (e = e.filter(function (e) {
            return "string" === typeof e;
          })).length) return "[object has no keys]";
          if (t = "number" !== typeof t ? s : t, e[0].length >= t) return e[0];

          for (var n = e.length; n > 0; n--) {
            var r = e.slice(0, n).join(", ");
            if (!(r.length > t)) return n === e.length ? r : r + "\u2026";
          }

          return "";
        },
        sanitize: function sanitize(e, t) {
          if (!isArray(t) || isArray(t) && 0 === t.length) return e;
          var n,
              i = joinRegExp(t),
              o = "********";

          try {
            n = JSON.parse(r(e));
          } catch (a) {
            return e;
          }

          return function sanitizeWorker(e) {
            return isArray(e) ? e.map(function (e) {
              return sanitizeWorker(e);
            }) : isPlainObject(e) ? Object.keys(e).reduce(function (t, n) {
              return i.test(n) ? t[n] = o : t[n] = sanitizeWorker(e[n]), t;
            }, {}) : e;
          }(n);
        }
      };
    }).call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    var r = n(89);

    t.filter = function filter(e, t) {
      return r.filter(e, t)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(72),
        i = n(73),
        o = n(74);

    function encode(e, t) {
      return t.encode ? t.strict ? r(e) : encodeURIComponent(e) : e;
    }

    function extract(e) {
      var t = e.indexOf("?");
      return -1 === t ? "" : e.slice(t + 1);
    }

    function parse(e, t) {
      var n = function parserForArrayFormat(e) {
        var t;

        switch (e.arrayFormat) {
          case "index":
            return function (e, n, r) {
              t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === r[e] && (r[e] = {}), r[e][t[1]] = n) : r[e] = n;
            };

          case "bracket":
            return function (e, n, r) {
              t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== r[e] ? r[e] = [].concat(r[e], n) : r[e] = [n] : r[e] = n;
            };

          default:
            return function (e, t, n) {
              void 0 !== n[e] ? n[e] = [].concat(n[e], t) : n[e] = t;
            };
        }
      }(t = i({
        arrayFormat: "none"
      }, t)),
          r = Object.create(null);

      return "string" !== typeof e ? r : (e = e.trim().replace(/^[?#&]/, "")) ? (e.split("&").forEach(function (e) {
        var t = e.replace(/\+/g, " ").split("="),
            i = t.shift(),
            a = t.length > 0 ? t.join("=") : void 0;
        a = void 0 === a ? null : o(a), n(o(i), a, r);
      }), Object.keys(r).sort().reduce(function (e, t) {
        var n = r[t];
        return Boolean(n) && "object" === typeof n && !Array.isArray(n) ? e[t] = function keysSorter(e) {
          return Array.isArray(e) ? e.sort() : "object" === typeof e ? keysSorter(Object.keys(e)).sort(function (e, t) {
            return Number(e) - Number(t);
          }).map(function (t) {
            return e[t];
          }) : e;
        }(n) : e[t] = n, e;
      }, Object.create(null))) : r;
    }

    t.extract = extract, t.parse = parse, t.stringify = function (e, t) {
      !1 === (t = i({
        encode: !0,
        strict: !0,
        arrayFormat: "none"
      }, t)).sort && (t.sort = function () {});

      var n = function encoderForArrayFormat(e) {
        switch (e.arrayFormat) {
          case "index":
            return function (t, n, r) {
              return null === n ? [encode(t, e), "[", r, "]"].join("") : [encode(t, e), "[", encode(r, e), "]=", encode(n, e)].join("");
            };

          case "bracket":
            return function (t, n) {
              return null === n ? encode(t, e) : [encode(t, e), "[]=", encode(n, e)].join("");
            };

          default:
            return function (t, n) {
              return null === n ? encode(t, e) : [encode(t, e), "=", encode(n, e)].join("");
            };
        }
      }(t);

      return e ? Object.keys(e).sort(t.sort).map(function (r) {
        var i = e[r];
        if (void 0 === i) return "";
        if (null === i) return encode(r, t);

        if (Array.isArray(i)) {
          var o = [];
          return i.slice().forEach(function (e) {
            void 0 !== e && o.push(n(r, e, o.length));
          }), o.join("&");
        }

        return encode(r, t) + "=" + encode(i, t);
      }).filter(function (e) {
        return e.length > 0;
      }).join("&") : "";
    }, t.parseUrl = function (e, t) {
      return {
        url: e.split("?")[0] || "",
        query: parse(extract(e), t)
      };
    };
  }, function (e, t, n) {
    var r, i, o;
    !function (n) {
      var a = /iPhone/i,
          s = /iPod/i,
          c = /iPad/i,
          l = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
          u = /Android/i,
          p = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
          f = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
          d = /Windows Phone/i,
          h = /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
          m = /BlackBerry/i,
          g = /BB10/i,
          A = /Opera Mini/i,
          v = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
          b = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
          y = new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i"),
          E = function match(e, t) {
        return e.test(t);
      },
          C = function IsMobileClass(e) {
        var t = e || navigator.userAgent,
            n = t.split("[FBAN");
        if ("undefined" !== typeof n[1] && (t = n[0]), "undefined" !== typeof (n = t.split("Twitter"))[1] && (t = n[0]), this.apple = {
          phone: E(a, t),
          ipod: E(s, t),
          tablet: !E(a, t) && E(c, t),
          device: E(a, t) || E(s, t) || E(c, t)
        }, this.amazon = {
          phone: E(p, t),
          tablet: !E(p, t) && E(f, t),
          device: E(p, t) || E(f, t)
        }, this.android = {
          phone: E(p, t) || E(l, t),
          tablet: !E(p, t) && !E(l, t) && (E(f, t) || E(u, t)),
          device: E(p, t) || E(f, t) || E(l, t) || E(u, t)
        }, this.windows = {
          phone: E(d, t),
          tablet: E(h, t),
          device: E(d, t) || E(h, t)
        }, this.other = {
          blackberry: E(m, t),
          blackberry10: E(g, t),
          opera: E(A, t),
          firefox: E(b, t),
          chrome: E(v, t),
          device: E(m, t) || E(g, t) || E(A, t) || E(b, t) || E(v, t)
        }, this.seven_inch = E(y, t), this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch, this.phone = this.apple.phone || this.android.phone || this.windows.phone, this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet, "undefined" === typeof window) return this;
      },
          w = function instantiate() {
        var e = new C();
        return e.Class = C, e;
      };

      e.exports && "undefined" === typeof window ? e.exports = C : e.exports && "undefined" !== typeof window ? e.exports = w() : (i = [], r = n.isMobile = w(), void 0 === (o = "function" === typeof r ? r.apply(t, i) : r) || (e.exports = o));
    }(this);
  }, function (e, t, n) {
    (function (t) {
      var r = n(174),
          i = "undefined" !== typeof window ? window : "undefined" !== typeof t ? t : "undefined" !== typeof self ? self : {},
          o = i.Raven,
          a = new r();
      a.noConflict = function () {
        return i.Raven = o, a;
      }, a.afterLoad(), e.exports = a, e.exports.Client = r;
    }).call(this, n(17));
  }, function (e, t, n) {
    "use strict";

    t.isFunction = function isFunction(e) {
      return "function" === typeof e;
    };
  }, function (e, t, n) {
    "use strict";

    t.isArray = Array.isArray || function (e) {
      return e && "number" === typeof e.length;
    };
  }, function (e, t, n) {
    "use strict";

    t.isObject = function isObject(e) {
      return null != e && "object" === typeof e;
    };
  }, function (e, t, n) {
    "use strict";

    t.errorObject = {
      e: {}
    };
  }, function (e, t, n) {
    "use strict";

    t.empty = {
      closed: !0,
      next: function next(e) {},
      error: function error(e) {
        throw e;
      },
      complete: function complete() {}
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function ObjectUnsubscribedError() {
        var t = e.call(this, "object unsubscribed");
        this.name = t.name = "ObjectUnsubscribedError", this.stack = t.stack, this.message = t.message;
      }

      return r(ObjectUnsubscribedError, e), ObjectUnsubscribedError;
    }(Error);

    t.ObjectUnsubscribedError = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13);

    t.map = function map(e, t) {
      return function mapOperation(n) {
        if ("function" !== typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return n.lift(new o(e, t));
      };
    };

    var o = function () {
      function MapOperator(e, t) {
        this.project = e, this.thisArg = t;
      }

      return MapOperator.prototype.call = function (e, t) {
        return t.subscribe(new a(e, this.project, this.thisArg));
      }, MapOperator;
    }();

    t.MapOperator = o;

    var a = function (e) {
      function MapSubscriber(t, n, r) {
        e.call(this, t), this.project = n, this.count = 0, this.thisArg = r || this;
      }

      return r(MapSubscriber, e), MapSubscriber.prototype._next = function (e) {
        var t;

        try {
          t = this.project.call(this.thisArg, e, this.count++);
        } catch (n) {
          return void this.destination.error(n);
        }

        this.destination.next(t);
      }, MapSubscriber;
    }(i.Subscriber);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function OuterSubscriber() {
        e.apply(this, arguments);
      }

      return r(OuterSubscriber, e), OuterSubscriber.prototype.notifyNext = function (e, t, n, r, i) {
        this.destination.next(t);
      }, OuterSubscriber.prototype.notifyError = function (e, t) {
        this.destination.error(e);
      }, OuterSubscriber.prototype.notifyComplete = function (e) {
        this.destination.complete();
      }, OuterSubscriber;
    }(n(13).Subscriber);

    t.OuterSubscriber = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(16),
        i = n(42),
        o = n(43),
        a = n(35),
        s = n(9),
        c = n(25),
        l = n(82),
        u = n(24);

    t.subscribeToResult = function subscribeToResult(e, t, n, p) {
      var f = new l.InnerSubscriber(e, n, p);
      if (f.closed) return null;
      if (t instanceof s.Observable) return t._isScalar ? (f.next(t.value), f.complete(), null) : (f.syncErrorThrowable = !0, t.subscribe(f));

      if (i.isArrayLike(t)) {
        for (var d = 0, h = t.length; d < h && !f.closed; d++) {
          f.next(t[d]);
        }

        f.closed || f.complete();
      } else {
        if (o.isPromise(t)) return t.then(function (e) {
          f.closed || (f.next(e), f.complete());
        }, function (e) {
          return f.error(e);
        }).then(null, function (e) {
          r.root.setTimeout(function () {
            throw e;
          });
        }), f;
        if (t && "function" === typeof t[c.iterator]) for (var m = t[c.iterator]();;) {
          var g = m.next();

          if (g.done) {
            f.complete();
            break;
          }

          if (f.next(g.value), f.closed) break;
        } else if (t && "function" === typeof t[u.observable]) {
          var A = t[u.observable]();
          if ("function" === typeof A.subscribe) return A.subscribe(new l.InnerSubscriber(e, n, p));
          f.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
        } else {
          var v = "You provided " + (a.isObject(t) ? "an invalid object" : "'" + t + "'") + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
          f.error(new TypeError(v));
        }
      }

      return null;
    };
  }, function (e, t, n) {
    "use strict";

    t.isArrayLike = function (e) {
      return e && "number" === typeof e.length;
    };
  }, function (e, t, n) {
    "use strict";

    t.isPromise = function isPromise(e) {
      return e && "function" !== typeof e.subscribe && "function" === typeof e.then;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function ScalarObservable(t, n) {
        e.call(this), this.value = t, this.scheduler = n, this._isScalar = !0, n && (this._isScalar = !1);
      }

      return r(ScalarObservable, e), ScalarObservable.create = function (e, t) {
        return new ScalarObservable(e, t);
      }, ScalarObservable.dispatch = function (e) {
        var t = e.done,
            n = e.value,
            r = e.subscriber;
        t ? r.complete() : (r.next(n), r.closed || (e.done = !0, this.schedule(e)));
      }, ScalarObservable.prototype._subscribe = function (e) {
        var t = this.value,
            n = this.scheduler;
        if (n) return n.schedule(ScalarObservable.dispatch, 0, {
          done: !1,
          value: t,
          subscriber: e
        });
        e.next(t), e.closed || e.complete();
      }, ScalarObservable;
    }(n(9).Observable);

    t.ScalarObservable = i;
  }, function (e, t, n) {
    "use strict";

    t.isScheduler = function isScheduler(e) {
      return e && "function" === typeof e.schedule;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(41),
        o = n(40);

    t.mergeMap = function mergeMap(e, t, n) {
      return void 0 === n && (n = Number.POSITIVE_INFINITY), function mergeMapOperatorFunction(r) {
        return "number" === typeof t && (n = t, t = null), r.lift(new a(e, t, n));
      };
    };

    var a = function () {
      function MergeMapOperator(e, t, n) {
        void 0 === n && (n = Number.POSITIVE_INFINITY), this.project = e, this.resultSelector = t, this.concurrent = n;
      }

      return MergeMapOperator.prototype.call = function (e, t) {
        return t.subscribe(new s(e, this.project, this.resultSelector, this.concurrent));
      }, MergeMapOperator;
    }();

    t.MergeMapOperator = a;

    var s = function (e) {
      function MergeMapSubscriber(t, n, r, i) {
        void 0 === i && (i = Number.POSITIVE_INFINITY), e.call(this, t), this.project = n, this.resultSelector = r, this.concurrent = i, this.hasCompleted = !1, this.buffer = [], this.active = 0, this.index = 0;
      }

      return r(MergeMapSubscriber, e), MergeMapSubscriber.prototype._next = function (e) {
        this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
      }, MergeMapSubscriber.prototype._tryNext = function (e) {
        var t,
            n = this.index++;

        try {
          t = this.project(e, n);
        } catch (r) {
          return void this.destination.error(r);
        }

        this.active++, this._innerSub(t, e, n);
      }, MergeMapSubscriber.prototype._innerSub = function (e, t, n) {
        this.add(i.subscribeToResult(this, e, t, n));
      }, MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete();
      }, MergeMapSubscriber.prototype.notifyNext = function (e, t, n, r, i) {
        this.resultSelector ? this._notifyResultSelector(e, t, n, r) : this.destination.next(t);
      }, MergeMapSubscriber.prototype._notifyResultSelector = function (e, t, n, r) {
        var i;

        try {
          i = this.resultSelector(e, t, n, r);
        } catch (o) {
          return void this.destination.error(o);
        }

        this.destination.next(i);
      }, MergeMapSubscriber.prototype.notifyComplete = function (e) {
        var t = this.buffer;
        this.remove(e), this.active--, t.length > 0 ? this._next(t.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
      }, MergeMapSubscriber;
    }(o.OuterSubscriber);

    t.MergeMapSubscriber = s;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, function (e) {
      e.USER = "USER", e.END_USER = "END_USER", e.NONE = "NONE", e.LEAD = "LEAD";
    }(t.UserTypeIF || (t.UserTypeIF = {})), function (e) {
      e.AVAILABLE = "AVAILABLE", e.OFFLINE = "OFFLINE";
    }(t.AvailabilityIF || (t.AvailabilityIF = {})), function (e) {
      e.org_admin = "org_admin", e.member = "member", e.agent = "agent", e.convoALL = "convo-ALL", e.video = "video", e.video_free = "video_free", e.SALES_SEQUENCES = "SALES_SEQUENCES", e.calendar_user = "calendar_user";
    }(t.DriftScopesIF || (t.DriftScopesIF = {})), function (e) {
      e.reporting = "Reporting", e.playbooks = "Playbooks";
    }(t.DriftRolesIF || (t.DriftRolesIF = {})), function (e) {
      e.conversationsWeb = "conversationsWeb", e.settingsWeb = "settingsWeb", e.trafficControl = "trafficControl", e.insightsWeb = "insightsWeb", e.contactsWeb = "contactsWeb", e.marketplaceWeb = "marketplaceWeb", e.conversationsDesktop = "conversationsDesktop", e.automationWeb = "automationWeb";
    }(t.DriftAppsIF || (t.DriftAppsIF = {}));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        o = n(0),
        a = _interopRequireDefault(o),
        s = _interopRequireDefault(n(49));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var c = function (e) {
      function Notification(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Notification);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, e));

        return t.getBarStyle = t.getBarStyle.bind(t), t.getActionStyle = t.getActionStyle.bind(t), t.getTitleStyle = t.getTitleStyle.bind(t), t.handleClick = t.handleClick.bind(t), e.onDismiss && e.isActive && (t.dismissTimeout = setTimeout(e.onDismiss, e.dismissAfter)), t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Notification, o.Component), i(Notification, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          !1 !== e.dismissAfter && ({}.hasOwnProperty.call(e, "isLast") || clearTimeout(this.dismissTimeout), e.onDismiss && (e.isActive && !this.props.isActive || e.dismissAfter && !1 === this.props.dismissAfter) && (this.dismissTimeout = setTimeout(e.onDismiss, e.dismissAfter)));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.dismissAfter && clearTimeout(this.dismissTimeout);
        }
      }, {
        key: "getBarStyle",
        value: function getBarStyle() {
          if (!1 === this.props.style) return {};
          var e = this.props,
              t = e.isActive,
              n = e.barStyle,
              i = e.activeBarStyle,
              o = {
            position: "fixed",
            bottom: "2rem",
            left: "-100%",
            width: "auto",
            padding: "1rem",
            margin: 0,
            color: "#fafafa",
            font: "1rem normal Roboto, sans-serif",
            borderRadius: "5px",
            background: "#212121",
            borderSizing: "border-box",
            boxShadow: "0 0 1px 1px rgba(10, 10, 11, .125)",
            cursor: "default",
            WebKitTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            MozTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            msTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            OTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            transition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            WebkitTransform: "translatez(0)",
            MozTransform: "translatez(0)",
            msTransform: "translatez(0)",
            OTransform: "translatez(0)",
            transform: "translatez(0)"
          };
          return t ? r({}, o, {
            left: "1rem"
          }, n, i) : r({}, o, n);
        }
      }, {
        key: "getActionStyle",
        value: function getActionStyle() {
          return !1 !== this.props.style ? r({}, {
            padding: "0.125rem",
            marginLeft: "1rem",
            color: "#f44336",
            font: ".75rem normal Roboto, sans-serif",
            lineHeight: "1rem",
            letterSpacing: ".125ex",
            textTransform: "uppercase",
            borderRadius: "5px",
            cursor: "pointer"
          }, this.props.actionStyle) : {};
        }
      }, {
        key: "getTitleStyle",
        value: function getTitleStyle() {
          return !1 !== this.props.style ? r({}, {
            fontWeight: "700",
            marginRight: ".5rem"
          }, this.props.titleStyle) : {};
        }
      }, {
        key: "handleClick",
        value: function handleClick() {
          if (this.props.onClick && "function" === typeof this.props.onClick) return this.props.onClick();
        }
      }, {
        key: "render",
        value: function render() {
          var e = "notification-bar";
          return this.props.isActive && (e += " " + this.props.activeClassName), this.props.className && (e += " " + this.props.className), a.default.createElement("div", {
            className: e,
            style: this.getBarStyle()
          }, a.default.createElement("div", {
            className: "notification-bar-wrapper"
          }, this.props.title ? a.default.createElement("span", {
            className: "notification-bar-title",
            style: this.getTitleStyle()
          }, this.props.title) : null, a.default.createElement("span", {
            className: "notification-bar-message"
          }, this.props.message), this.props.action ? a.default.createElement("span", {
            className: "notification-bar-action",
            onClick: this.handleClick,
            style: this.getActionStyle()
          }, this.props.action) : null));
        }
      }]), Notification;
    }();

    c.propTypes = s.default, c.defaultProps = {
      isActive: !1,
      dismissAfter: 2e3,
      activeClassName: "notification-bar-active"
    }, t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(11));

    t.default = {
      message: r.default.oneOfType([r.default.string, r.default.element]).isRequired,
      action: r.default.oneOfType([r.default.bool, r.default.string, r.default.node]),
      onClick: r.default.func,
      style: r.default.bool,
      actionStyle: r.default.object,
      titleStyle: r.default.object,
      barStyle: r.default.object,
      activeBarStyle: r.default.object,
      dismissAfter: r.default.oneOfType([r.default.bool, r.default.number]),
      onDismiss: r.default.func,
      className: r.default.string,
      activeClassName: r.default.string,
      isActive: r.default.bool,
      title: r.default.oneOfType([r.default.string, r.default.node])
    };
  }, function (e, t) {
    function indexOf(e, t) {
      for (var n = 0; n < e.length; ++n) {
        if (e[n] === t) return n;
      }

      return -1;
    }

    function serializer(e, t) {
      var n = [],
          r = [];
      return null == t && (t = function cycleReplacer(e, t) {
        return n[0] === t ? "[Circular ~]" : "[Circular ~." + r.slice(0, indexOf(n, t)).join(".") + "]";
      }), function (i, o) {
        if (n.length > 0) {
          var a = indexOf(n, this);
          ~a ? n.splice(a + 1) : n.push(this), ~a ? r.splice(a, 1 / 0, i) : r.push(i), ~indexOf(n, o) && (o = t.call(this, i, o));
        } else n.push(o);

        return null == e ? o instanceof Error ? function stringifyError(e) {
          var t = {
            stack: e.stack,
            message: e.message,
            name: e.name
          };

          for (var n in e) {
            Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
          }

          return t;
        }(o) : o : e.call(this, i, o);
      };
    }

    (e.exports = function stringify(e, t, n, r) {
      return JSON.stringify(e, serializer(t, r), n);
    }).getSerialize = serializer;
  }, function (e) {
    e.exports = {
      CUSTOMER_API: "https://customer2.api.driftqa.com",
      KONG_CUSTOMER_API: "https://api.driftqa.com/customer",
      CONVERSATION_API: "https://conversation2.api.driftqa.com",
      AUTH_API: "https://api.driftqa.com/auth",
      WS_CHAT_BASE: "chat.api.driftqa.com",
      WS: "wss://ws.api.driftqa.com",
      WS_NUM_SHARDS: 50,
      START: "https://start.driftqa.com",
      CUSTOMER_WEB_URL: "https://app.driftqa.com",
      DEVELOPERS_WEB_URL: "https://dev.driftqa.com",
      SEGMENT_ID: "26F56Q24FYGhT79jXwkS3Ax002VxcoCN",
      FREE_SUPPORT_INBOX_ID: "10617",
      PROFILE_URL: "driftqa.me",
      SENTRY_KEY: "https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073",
      SEND_TO_SENTRY: !1,
      SEGMENT_TRACKING_BLACKLIST: [42653],
      SUPPORT_TICKET_INTERACTION_ID: 303381,
      HELP_URL: "http://help.drift.com",
      FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
      PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
      DRIFT_VIDEO_URL: "https://app-qa.video.drift.com",
      DRIFT_INSIDER_URL: "https://insider.drift.com/login/",
      DRIFT_EMAIL_URL: "https://email.driftqa.com/",
      HYFY_EXISTING_REDIRECT: "https://app-qa.video.drift.com/accounts/existing-redirect/",
      METRICS_API: "https://metrics.api.driftqa.com"
    };
  }, function (e) {
    e.exports = {
      CUSTOMER_API: "https://customer.api.drift.com",
      CONVERSATION_API: "https://conversation.api.drift.com",
      KONG_CUSTOMER_API: "https://api.drift.com/customer",
      AUTH_API: "https://api.drift.com/auth",
      WS_CHAT_BASE: "chat.api.drift.com",
      WS: "wss://chat.api.drift.com",
      WS_NUM_SHARDS: 50,
      START: "https://start.drift.com",
      CUSTOMER_WEB_URL: "https://app.drift.com",
      DEVELOPERS_WEB_URL: "https://dev.drift.com",
      SEGMENT_ID: "YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX",
      FREE_SUPPORT_INBOX_ID: "21653",
      PROFILE_URL: "drift.me",
      SENTRY_KEY: "https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073",
      SEND_TO_SENTRY: !0,
      SEGMENT_TRACKING_BLACKLIST: [42653],
      SUPPORT_TICKET_INTERACTION_ID: 51833,
      HELP_URL: "http://help.drift.com",
      FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 54308,
      PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 53556,
      DRIFT_VIDEO_URL: "https://video.drift.com",
      DRIFT_INSIDER_URL: "https://insider.drift.com/login/",
      DRIFT_EMAIL_URL: "https://email.drift.com/",
      HYFY_EXISTING_REDIRECT: "https://video.drift.com/accounts/existing-redirect/",
      METRICS_API: "https://metrics.api.drift.com"
    };
  }, function (e, t) {
    e.exports = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(39);

    t.map = function map(e, t) {
      return r.map(e, t)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(81);

    t.switchMap = function switchMap(e, t) {
      return r.switchMap(e, t)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(26);
    t.of = r.ArrayObservable.of;
  }, function (e, t, n) {
    "use strict";

    var r = n(83);
    t.from = r.FromObservable.create;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(26),
        o = n(45),
        a = n(90);

    t.merge = function merge() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t - 0] = arguments[t];
      }

      var n = Number.POSITIVE_INFINITY,
          s = null,
          c = e[e.length - 1];
      return o.isScheduler(c) ? (s = e.pop(), e.length > 1 && "number" === typeof e[e.length - 1] && (n = e.pop())) : "number" === typeof c && (n = e.pop()), null === s && 1 === e.length && e[0] instanceof r.Observable ? e[0] : a.mergeAll(n)(new i.ArrayObservable(e, s));
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(20),
        o = n(38),
        a = function (e) {
      function BehaviorSubject(t) {
        e.call(this), this._value = t;
      }

      return r(BehaviorSubject, e), Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function get() {
          return this.getValue();
        },
        enumerable: !0,
        configurable: !0
      }), BehaviorSubject.prototype._subscribe = function (t) {
        var n = e.prototype._subscribe.call(this, t);

        return n && !n.closed && t.next(this._value), n;
      }, BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) throw this.thrownError;
        if (this.closed) throw new o.ObjectUnsubscribedError();
        return this._value;
      }, BehaviorSubject.prototype.next = function (t) {
        e.prototype.next.call(this, this._value = t);
      }, BehaviorSubject;
    }(i.Subject);

    t.BehaviorSubject = a;
  }, function (e, t, n) {
    e.exports = function (e) {
      function t(r) {
        if (n[r]) return n[r].exports;
        var i = n[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
      }

      var n = {};
      return t.m = e, t.c = n, t.i = function (e) {
        return e;
      }, t.d = function (e, n, r) {
        t.o(e, n) || Object.defineProperty(e, n, {
          configurable: !1,
          enumerable: !0,
          get: r
        });
      }, t.n = function (e) {
        var n = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(n, "a", n), n;
      }, t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, t.p = "/", t(t.s = 0);
    }([function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), n.d(t, "SW_PATHNAME", function () {
        return r;
      }), n.d(t, "getSwPath", function () {
        return i;
      });

      var r = "/serviceworker-notifications/sw/sw-3.0.15.js",
          i = function o() {
        return "/serviceworker-notifications/sw/sw-3.0.15.js";
      };
    }]);
  }, function (e, t, n) {
    var r = n(110),
        i = n(111);

    e.exports = function v4(e, t, n) {
      var o = t && n || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var a = (e = e || {}).random || (e.rng || r)();
      if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) for (var s = 0; s < 16; ++s) {
        t[o + s] = a[s];
      }
      return t || i(a);
    };
  }, function (e, t) {
    e.exports = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(48);
    Object.defineProperty(t, "Notification", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(r).default;
      }
    });
    var i = n(158);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "NotificationStack", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(i).default;
      }
    });
  }, function (e, t, n) {
    window, e.exports = function (e) {
      var t = {};

      function n(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var i in e) {
          n.d(r, i, function (t) {
            return e[t];
          }.bind(null, i));
        }
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 0);
    }([function (e, t, n) {
      (function (t) {
        e.exports = t.Phoenix = n(2);
      }).call(this, n(1));
    }, function (e, t) {
      var n;

      n = function () {
        return this;
      }();

      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (e) {
        "object" == typeof window && (n = window);
      }

      e.exports = n;
    }, function (t, r, i) {
      "use strict";

      function o(e) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }

      function s(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }

      function a(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      function c(e, t, n) {
        return t && a(e.prototype, t), n && a(e, n), e;
      }

      i.r(r), i.d(r, "Channel", function () {
        return v;
      }), i.d(r, "Socket", function () {
        return y;
      }), i.d(r, "LongPoll", function () {
        return E;
      }), i.d(r, "Ajax", function () {
        return C;
      }), i.d(r, "Presence", function () {
        return w;
      });

      var l = "undefined" != typeof self ? self : window,
          u = {
        connecting: 0,
        open: 1,
        closing: 2,
        closed: 3
      },
          p = 1e4,
          f = {
        closed: "closed",
        errored: "errored",
        joined: "joined",
        joining: "joining",
        leaving: "leaving"
      },
          d = {
        close: "phx_close",
        error: "phx_error",
        join: "phx_join",
        reply: "phx_reply",
        leave: "phx_leave"
      },
          h = [d.close, d.error, d.join, d.reply, d.leave],
          m = {
        longpoll: "longpoll",
        websocket: "websocket"
      },
          g = function y(e) {
        return "function" == typeof e ? e : function () {
          return e;
        };
      },
          A = function () {
        function e(t, n, r, i) {
          s(this, e), this.channel = t, this.event = n, this.payload = r || function () {
            return {};
          }, this.receivedResp = null, this.timeout = i, this.timeoutTimer = null, this.recHooks = [], this.sent = !1;
        }

        return c(e, [{
          key: "resend",
          value: function value(e) {
            this.timeout = e, this.reset(), this.send();
          }
        }, {
          key: "send",
          value: function value() {
            this.hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
              topic: this.channel.topic,
              event: this.event,
              payload: this.payload(),
              ref: this.ref,
              join_ref: this.channel.joinRef()
            }));
          }
        }, {
          key: "receive",
          value: function value(e, t) {
            return this.hasReceived(e) && t(this.receivedResp.response), this.recHooks.push({
              status: e,
              callback: t
            }), this;
          }
        }, {
          key: "reset",
          value: function value() {
            this.cancelRefEvent(), this.ref = null, this.refEvent = null, this.receivedResp = null, this.sent = !1;
          }
        }, {
          key: "matchReceive",
          value: function value(e) {
            var t = e.status,
                n = e.response;
            e.ref, this.recHooks.filter(function (e) {
              return e.status === t;
            }).forEach(function (e) {
              return e.callback(n);
            });
          }
        }, {
          key: "cancelRefEvent",
          value: function value() {
            this.refEvent && this.channel.off(this.refEvent);
          }
        }, {
          key: "cancelTimeout",
          value: function value() {
            clearTimeout(this.timeoutTimer), this.timeoutTimer = null;
          }
        }, {
          key: "startTimeout",
          value: function value() {
            var e = this;
            this.timeoutTimer && this.cancelTimeout(), this.ref = this.channel.socket.makeRef(), this.refEvent = this.channel.replyEventName(this.ref), this.channel.on(this.refEvent, function (t) {
              e.cancelRefEvent(), e.cancelTimeout(), e.receivedResp = t, e.matchReceive(t);
            }), this.timeoutTimer = setTimeout(function () {
              e.trigger("timeout", {});
            }, this.timeout);
          }
        }, {
          key: "hasReceived",
          value: function value(e) {
            return this.receivedResp && this.receivedResp.status === e;
          }
        }, {
          key: "trigger",
          value: function value(e, t) {
            this.channel.trigger(this.refEvent, {
              status: e,
              response: t
            });
          }
        }]), e;
      }(),
          v = function () {
        function e(t, n, r) {
          var i = this;
          s(this, e), this.state = f.closed, this.topic = t, this.params = g(n || {}), this.socket = r, this.bindings = [], this.bindingRef = 0, this.timeout = this.socket.timeout, this.joinedOnce = !1, this.joinPush = new A(this, d.join, this.params, this.timeout), this.pushBuffer = [], this.rejoinTimer = new _(function () {
            return i.rejoinUntilConnected();
          }, this.socket.reconnectAfterMs), this.joinPush.receive("ok", function () {
            i.state = f.joined, i.rejoinTimer.reset(), i.pushBuffer.forEach(function (e) {
              return e.send();
            }), i.pushBuffer = [];
          }), this.onClose(function () {
            i.rejoinTimer.reset(), i.socket.hasLogger() && i.socket.log("channel", "close ".concat(i.topic, " ").concat(i.joinRef())), i.state = f.closed, i.socket.remove(i);
          }), this.onError(function (e) {
            i.isLeaving() || i.isClosed() || (i.socket.hasLogger() && i.socket.log("channel", "error ".concat(i.topic), e), i.state = f.errored, i.rejoinTimer.scheduleTimeout());
          }), this.joinPush.receive("timeout", function () {
            i.isJoining() && (i.socket.hasLogger() && i.socket.log("channel", "timeout ".concat(i.topic, " (").concat(i.joinRef(), ")"), i.joinPush.timeout), new A(i, d.leave, g({}), i.timeout).send(), i.state = f.errored, i.joinPush.reset(), i.rejoinTimer.scheduleTimeout());
          }), this.on(d.reply, function (e, t) {
            i.trigger(i.replyEventName(t), e);
          });
        }

        return c(e, [{
          key: "rejoinUntilConnected",
          value: function value() {
            this.rejoinTimer.scheduleTimeout(), this.socket.isConnected() && this.rejoin();
          }
        }, {
          key: "join",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            if (this.joinedOnce) throw "tried to join multiple times. 'join' can only be called a single time per channel instance";
            return this.joinedOnce = !0, this.rejoin(e), this.joinPush;
          }
        }, {
          key: "onClose",
          value: function value(e) {
            this.on(d.close, e);
          }
        }, {
          key: "onError",
          value: function value(e) {
            return this.on(d.error, function (t) {
              return e(t);
            });
          }
        }, {
          key: "on",
          value: function value(e, t) {
            var n = this.bindingRef++;
            return this.bindings.push({
              event: e,
              ref: n,
              callback: t
            }), n;
          }
        }, {
          key: "off",
          value: function value(e, t) {
            this.bindings = this.bindings.filter(function (n) {
              return !(n.event === e && (void 0 === t || t === n.ref));
            });
          }
        }, {
          key: "canPush",
          value: function value() {
            return this.socket.isConnected() && this.isJoined();
          }
        }, {
          key: "push",
          value: function value(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.timeout;
            if (!this.joinedOnce) throw "tried to push '".concat(e, "' to '").concat(this.topic, "' before joining. Use channel.join() before pushing events");
            var r = new A(this, e, function () {
              return t;
            }, n);
            return this.canPush() ? r.send() : (r.startTimeout(), this.pushBuffer.push(r)), r;
          }
        }, {
          key: "leave",
          value: function value() {
            var e = this,
                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            this.state = f.leaving;

            var r = function n() {
              e.socket.hasLogger() && e.socket.log("channel", "leave ".concat(e.topic)), e.trigger(d.close, "leave");
            },
                i = new A(this, d.leave, g({}), t);

            return i.receive("ok", function () {
              return r();
            }).receive("timeout", function () {
              return r();
            }), i.send(), this.canPush() || i.trigger("ok", {}), i;
          }
        }, {
          key: "onMessage",
          value: function value(e, t, n) {
            return t;
          }
        }, {
          key: "isLifecycleEvent",
          value: function value(e) {
            return h.indexOf(e) >= 0;
          }
        }, {
          key: "isMember",
          value: function value(e, t, n, r) {
            return this.topic === e && (!r || r === this.joinRef() || !this.isLifecycleEvent(t) || (this.socket.hasLogger() && this.socket.log("channel", "dropping outdated message", {
              topic: e,
              event: t,
              payload: n,
              joinRef: r
            }), !1));
          }
        }, {
          key: "joinRef",
          value: function value() {
            return this.joinPush.ref;
          }
        }, {
          key: "sendJoin",
          value: function value(e) {
            this.state = f.joining, this.joinPush.resend(e);
          }
        }, {
          key: "rejoin",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
            this.isLeaving() || this.sendJoin(e);
          }
        }, {
          key: "trigger",
          value: function value(e, t, n, r) {
            var i = this.onMessage(e, t, n, r);
            if (t && !i) throw "channel onMessage callbacks must return the payload, modified or unmodified";

            for (var o = 0; o < this.bindings.length; o++) {
              var a = this.bindings[o];
              a.event === e && a.callback(i, n, r || this.joinRef());
            }
          }
        }, {
          key: "replyEventName",
          value: function value(e) {
            return "chan_reply_".concat(e);
          }
        }, {
          key: "isClosed",
          value: function value() {
            return this.state === f.closed;
          }
        }, {
          key: "isErrored",
          value: function value() {
            return this.state === f.errored;
          }
        }, {
          key: "isJoined",
          value: function value() {
            return this.state === f.joined;
          }
        }, {
          key: "isJoining",
          value: function value() {
            return this.state === f.joining;
          }
        }, {
          key: "isLeaving",
          value: function value() {
            return this.state === f.leaving;
          }
        }]), e;
      }(),
          b = {
        encode: function encode(e, t) {
          var n = [e.join_ref, e.ref, e.topic, e.event, e.payload];
          return t(JSON.stringify(n));
        },
        decode: function decode(e, t) {
          var n = function r(e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              var n = [],
                  r = !0,
                  i = !1,
                  o = void 0;

              try {
                for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
                  ;
                }
              } catch (e) {
                i = !0, o = e;
              } finally {
                try {
                  r || null == s.return || s.return();
                } finally {
                  if (i) throw o;
                }
              }

              return n;
            }(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }();
          }(JSON.parse(e), 5);

          return t({
            join_ref: n[0],
            ref: n[1],
            topic: n[2],
            event: n[3],
            payload: n[4]
          });
        }
      },
          y = function () {
        function e(t) {
          var n = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          s(this, e), this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
          }, this.channels = [], this.sendBuffer = [], this.ref = 0, this.timeout = r.timeout || p, this.transport = r.transport || l.WebSocket || E, this.defaultEncoder = b.encode, this.defaultDecoder = b.decode, this.transport !== E ? (this.encode = r.encode || this.defaultEncoder, this.decode = r.decode || this.defaultDecoder) : (this.encode = this.defaultEncoder, this.decode = this.defaultDecoder), this.heartbeatIntervalMs = r.heartbeatIntervalMs || 3e4, this.reconnectAfterMs = r.reconnectAfterMs || function (e) {
            return [1e3, 2e3, 5e3, 1e4][e - 1] || 1e4;
          }, this.logger = r.logger || null, this.longpollerTimeout = r.longpollerTimeout || 2e4, this.params = g(r.params || {}), this.endPoint = "".concat(t, "/").concat(m.websocket), this.heartbeatTimer = null, this.pendingHeartbeatRef = null, this.reconnectTimer = new _(function () {
            n.teardown(function () {
              return n.connect();
            });
          }, this.reconnectAfterMs);
        }

        return c(e, [{
          key: "protocol",
          value: function value() {
            return location.protocol.match(/^https/) ? "wss" : "ws";
          }
        }, {
          key: "endPointURL",
          value: function value() {
            var e = C.appendParams(C.appendParams(this.endPoint, this.params()), {
              vsn: "2.0.0"
            });
            return "/" !== e.charAt(0) ? e : "/" === e.charAt(1) ? "".concat(this.protocol(), ":").concat(e) : "".concat(this.protocol(), "://").concat(location.host).concat(e);
          }
        }, {
          key: "disconnect",
          value: function value(e, t, n) {
            this.reconnectTimer.reset(), this.teardown(e, t, n);
          }
        }, {
          key: "connect",
          value: function value(e) {
            var t = this;
            e && (console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor"), this.params = g(e)), this.conn || (this.conn = new this.transport(this.endPointURL()), this.conn.timeout = this.longpollerTimeout, this.conn.onopen = function () {
              return t.onConnOpen();
            }, this.conn.onerror = function (e) {
              return t.onConnError(e);
            }, this.conn.onmessage = function (e) {
              return t.onConnMessage(e);
            }, this.conn.onclose = function (e) {
              return t.onConnClose(e);
            });
          }
        }, {
          key: "log",
          value: function value(e, t, n) {
            this.logger(e, t, n);
          }
        }, {
          key: "hasLogger",
          value: function value() {
            return null !== this.logger;
          }
        }, {
          key: "onOpen",
          value: function value(e) {
            this.stateChangeCallbacks.open.push(e);
          }
        }, {
          key: "onClose",
          value: function value(e) {
            this.stateChangeCallbacks.close.push(e);
          }
        }, {
          key: "onError",
          value: function value(e) {
            this.stateChangeCallbacks.error.push(e);
          }
        }, {
          key: "onMessage",
          value: function value(e) {
            this.stateChangeCallbacks.message.push(e);
          }
        }, {
          key: "onConnOpen",
          value: function value() {
            this.hasLogger() && this.log("transport", "connected to ".concat(this.endPointURL())), this.flushSendBuffer(), this.reconnectTimer.reset(), this.resetHeartbeat(), this.resetChannelTimers(), this.stateChangeCallbacks.open.forEach(function (e) {
              return e();
            });
          }
        }, {
          key: "resetHeartbeat",
          value: function value() {
            var e = this;
            this.conn.skipHeartbeat || (this.pendingHeartbeatRef = null, clearInterval(this.heartbeatTimer), this.heartbeatTimer = setInterval(function () {
              return e.sendHeartbeat();
            }, this.heartbeatIntervalMs));
          }
        }, {
          key: "teardown",
          value: function value(e, t, n) {
            this.conn && (this.conn.onclose = function () {}, t ? this.conn.close(t, n || "") : this.conn.close(), this.conn = null), e && e();
          }
        }, {
          key: "onConnClose",
          value: function value(e) {
            this.hasLogger() && this.log("transport", "close", e), this.triggerChanError(), clearInterval(this.heartbeatTimer), e && 1e3 !== e.code && this.reconnectTimer.scheduleTimeout(), this.stateChangeCallbacks.close.forEach(function (t) {
              return t(e);
            });
          }
        }, {
          key: "onConnError",
          value: function value(e) {
            this.hasLogger() && this.log("transport", e), this.triggerChanError(), this.stateChangeCallbacks.error.forEach(function (t) {
              return t(e);
            });
          }
        }, {
          key: "triggerChanError",
          value: function value() {
            this.channels.forEach(function (e) {
              return e.trigger(d.error);
            });
          }
        }, {
          key: "connectionState",
          value: function value() {
            switch (this.conn && this.conn.readyState) {
              case u.connecting:
                return "connecting";

              case u.open:
                return "open";

              case u.closing:
                return "closing";

              default:
                return "closed";
            }
          }
        }, {
          key: "isConnected",
          value: function value() {
            return "open" === this.connectionState();
          }
        }, {
          key: "remove",
          value: function value(e) {
            this.channels = this.channels.filter(function (t) {
              return t.joinRef() !== e.joinRef();
            });
          }
        }, {
          key: "channel",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = new v(e, t, this);
            return this.channels.push(n), n;
          }
        }, {
          key: "push",
          value: function value(e) {
            var t = this;

            if (this.hasLogger()) {
              var n = e.topic,
                  r = e.event,
                  i = e.payload,
                  o = e.ref,
                  a = e.join_ref;
              this.log("push", "".concat(n, " ").concat(r, " (").concat(a, ", ").concat(o, ")"), i);
            }

            this.isConnected() ? this.encode(e, function (e) {
              return t.conn.send(e);
            }) : this.sendBuffer.push(function () {
              return t.encode(e, function (e) {
                return t.conn.send(e);
              });
            });
          }
        }, {
          key: "makeRef",
          value: function value() {
            var e = this.ref + 1;
            return e === this.ref ? this.ref = 0 : this.ref = e, this.ref.toString();
          }
        }, {
          key: "sendHeartbeat",
          value: function value() {
            if (this.isConnected()) {
              if (this.pendingHeartbeatRef) return this.pendingHeartbeatRef = null, this.hasLogger() && this.log("transport", "heartbeat timeout. Attempting to re-establish connection"), void this.conn.close(1e3, "hearbeat timeout");
              this.pendingHeartbeatRef = this.makeRef(), this.push({
                topic: "phoenix",
                event: "heartbeat",
                payload: {},
                ref: this.pendingHeartbeatRef
              });
            }
          }
        }, {
          key: "flushSendBuffer",
          value: function value() {
            this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach(function (e) {
              return e();
            }), this.sendBuffer = []);
          }
        }, {
          key: "onConnMessage",
          value: function value(e) {
            var t = this;
            this.decode(e.data, function (e) {
              var n = e.topic,
                  r = e.event,
                  i = e.payload,
                  o = e.ref,
                  a = e.join_ref;
              o && o === t.pendingHeartbeatRef && (t.pendingHeartbeatRef = null), t.hasLogger() && t.log("receive", "".concat(i.status || "", " ").concat(n, " ").concat(r, " ").concat(o && "(" + o + ")" || ""), i);

              for (var s = 0; s < t.channels.length; s++) {
                var c = t.channels[s];
                c.isMember(n, r, i, a) && c.trigger(r, i, o, a);
              }

              for (var l = 0; l < t.stateChangeCallbacks.message.length; l++) {
                t.stateChangeCallbacks.message[l](e);
              }
            });
          }
        }, {
          key: "resetChannelTimers",
          value: function value() {
            this.channels.forEach(function (e) {
              e.rejoinTimer.restart();
            });
          }
        }]), e;
      }(),
          E = function () {
        function e(t) {
          s(this, e), this.endPoint = null, this.token = null, this.skipHeartbeat = !0, this.onopen = function () {}, this.onerror = function () {}, this.onmessage = function () {}, this.onclose = function () {}, this.pollEndpoint = this.normalizeEndpoint(t), this.readyState = u.connecting, this.poll();
        }

        return c(e, [{
          key: "normalizeEndpoint",
          value: function value(e) {
            return e.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + m.websocket), "$1/" + m.longpoll);
          }
        }, {
          key: "endpointURL",
          value: function value() {
            return C.appendParams(this.pollEndpoint, {
              token: this.token
            });
          }
        }, {
          key: "closeAndRetry",
          value: function value() {
            this.close(), this.readyState = u.connecting;
          }
        }, {
          key: "ontimeout",
          value: function value() {
            this.onerror("timeout"), this.closeAndRetry();
          }
        }, {
          key: "poll",
          value: function value() {
            var e = this;
            this.readyState !== u.open && this.readyState !== u.connecting || C.request("GET", this.endpointURL(), "application/json", null, this.timeout, this.ontimeout.bind(this), function (t) {
              if (t) {
                var n = t.status,
                    r = t.token,
                    i = t.messages;
                e.token = r;
              } else n = 0;

              switch (n) {
                case 200:
                  i.forEach(function (t) {
                    return e.onmessage({
                      data: t
                    });
                  }), e.poll();
                  break;

                case 204:
                  e.poll();
                  break;

                case 410:
                  e.readyState = u.open, e.onopen(), e.poll();
                  break;

                case 0:
                case 500:
                  e.onerror(), e.closeAndRetry();
                  break;

                default:
                  throw "unhandled poll status ".concat(n);
              }
            });
          }
        }, {
          key: "send",
          value: function value(e) {
            var t = this;
            C.request("POST", this.endpointURL(), "application/json", e, this.timeout, this.onerror.bind(this, "timeout"), function (e) {
              e && 200 === e.status || (t.onerror(e && e.status), t.closeAndRetry());
            });
          }
        }, {
          key: "close",
          value: function value(e, t) {
            this.readyState = u.closed, this.onclose();
          }
        }]), e;
      }(),
          C = function () {
        function e() {
          s(this, e);
        }

        return c(e, null, [{
          key: "request",
          value: function value(e, t, n, r, i, o, a) {
            if (l.XDomainRequest) {
              var s = new XDomainRequest();
              this.xdomainRequest(s, e, t, r, i, o, a);
            } else {
              var c = l.XMLHttpRequest ? new l.XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
              this.xhrRequest(c, e, t, n, r, i, o, a);
            }
          }
        }, {
          key: "xdomainRequest",
          value: function value(e, t, n, r, i, o, a) {
            var s = this;
            e.timeout = i, e.open(t, n), e.onload = function () {
              var t = s.parseJSON(e.responseText);
              a && a(t);
            }, o && (e.ontimeout = o), e.onprogress = function () {}, e.send(r);
          }
        }, {
          key: "xhrRequest",
          value: function value(e, t, n, r, i, o, a, s) {
            var c = this;
            e.open(t, n, !0), e.timeout = o, e.setRequestHeader("Content-Type", r), e.onerror = function () {
              s && s(null);
            }, e.onreadystatechange = function () {
              if (e.readyState === c.states.complete && s) {
                var t = c.parseJSON(e.responseText);
                s(t);
              }
            }, a && (e.ontimeout = a), e.send(i);
          }
        }, {
          key: "parseJSON",
          value: function value(e) {
            if (!e || "" === e) return null;

            try {
              return JSON.parse(e);
            } catch (r) {
              return console && console.log("failed to parse JSON response", e), null;
            }
          }
        }, {
          key: "serialize",
          value: function value(e, t) {
            var n = [];

            for (var r in e) {
              if (e.hasOwnProperty(r)) {
                var i = t ? "".concat(t, "[").concat(r, "]") : r,
                    a = e[r];
                "object" === o(a) ? n.push(this.serialize(a, i)) : n.push(encodeURIComponent(i) + "=" + encodeURIComponent(a));
              }
            }

            return n.join("&");
          }
        }, {
          key: "appendParams",
          value: function value(e, t) {
            if (0 === Object.keys(t).length) return e;
            var n = e.match(/\?/) ? "&" : "?";
            return "".concat(e).concat(n).concat(this.serialize(t));
          }
        }]), e;
      }();

      C.states = {
        complete: 4
      };

      var w = function () {
        function e(t) {
          var n = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          s(this, e);
          var i = r.events || {
            state: "presence_state",
            diff: "presence_diff"
          };
          this.state = {}, this.pendingDiffs = [], this.channel = t, this.joinRef = null, this.caller = {
            onJoin: function onJoin() {},
            onLeave: function onLeave() {},
            onSync: function onSync() {}
          }, this.channel.on(i.state, function (t) {
            var r = n.caller,
                i = r.onJoin,
                o = r.onLeave,
                a = r.onSync;
            n.joinRef = n.channel.joinRef(), n.state = e.syncState(n.state, t, i, o), n.pendingDiffs.forEach(function (t) {
              n.state = e.syncDiff(n.state, t, i, o);
            }), n.pendingDiffs = [], a();
          }), this.channel.on(i.diff, function (t) {
            var r = n.caller,
                i = r.onJoin,
                o = r.onLeave,
                a = r.onSync;
            n.inPendingSyncState() ? n.pendingDiffs.push(t) : (n.state = e.syncDiff(n.state, t, i, o), a());
          });
        }

        return c(e, [{
          key: "onJoin",
          value: function value(e) {
            this.caller.onJoin = e;
          }
        }, {
          key: "onLeave",
          value: function value(e) {
            this.caller.onLeave = e;
          }
        }, {
          key: "onSync",
          value: function value(e) {
            this.caller.onSync = e;
          }
        }, {
          key: "list",
          value: function value(t) {
            return e.list(this.state, t);
          }
        }, {
          key: "inPendingSyncState",
          value: function value() {
            return !this.joinRef || this.joinRef !== this.channel.joinRef();
          }
        }], [{
          key: "syncState",
          value: function value(e, t, n, r) {
            var i = this,
                o = this.clone(e),
                a = {},
                s = {};
            return this.map(o, function (e, n) {
              t[e] || (s[e] = n);
            }), this.map(t, function (e, t) {
              var n = o[e];

              if (n) {
                var r = t.metas.map(function (e) {
                  return e.phx_ref;
                }),
                    c = n.metas.map(function (e) {
                  return e.phx_ref;
                }),
                    l = t.metas.filter(function (e) {
                  return c.indexOf(e.phx_ref) < 0;
                }),
                    u = n.metas.filter(function (e) {
                  return r.indexOf(e.phx_ref) < 0;
                });
                l.length > 0 && (a[e] = t, a[e].metas = l), u.length > 0 && (s[e] = i.clone(n), s[e].metas = u);
              } else a[e] = t;
            }), this.syncDiff(o, {
              joins: a,
              leaves: s
            }, n, r);
          }
        }, {
          key: "syncDiff",
          value: function value(e, t, n, r) {
            var o = t.joins,
                a = t.leaves,
                s = this.clone(e);
            return n || (n = function n() {}), r || (r = function o() {}), this.map(o, function (e, t) {
              var r = s[e];

              if (s[e] = t, r) {
                var o,
                    a = s[e].metas.map(function (e) {
                  return e.phx_ref;
                }),
                    c = r.metas.filter(function (e) {
                  return a.indexOf(e.phx_ref) < 0;
                });
                (o = s[e].metas).unshift.apply(o, function i(e) {
                  return function (e) {
                    if (Array.isArray(e)) {
                      for (var t = 0, n = new Array(e.length); t < e.length; t++) {
                        n[t] = e[t];
                      }

                      return n;
                    }
                  }(e) || function (e) {
                    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
                  }(e) || function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                  }();
                }(c));
              }

              n(e, r, t);
            }), this.map(a, function (e, t) {
              var n = s[e];

              if (n) {
                var i = t.metas.map(function (e) {
                  return e.phx_ref;
                });
                n.metas = n.metas.filter(function (e) {
                  return i.indexOf(e.phx_ref) < 0;
                }), r(e, n, t), 0 === n.metas.length && delete s[e];
              }
            }), s;
          }
        }, {
          key: "list",
          value: function value(e, t) {
            return t || (t = function t(e, n) {
              return n;
            }), this.map(e, function (e, n) {
              return t(e, n);
            });
          }
        }, {
          key: "map",
          value: function value(e, t) {
            return Object.getOwnPropertyNames(e).map(function (n) {
              return t(n, e[n]);
            });
          }
        }, {
          key: "clone",
          value: function value(e) {
            return JSON.parse(JSON.stringify(e));
          }
        }]), e;
      }(),
          _ = function () {
        function e(t, n) {
          s(this, e), this.callback = t, this.timerCalc = n, this.timer = null, this.tries = 0;
        }

        return c(e, [{
          key: "reset",
          value: function value() {
            this.tries = 0, this.clearTimer();
          }
        }, {
          key: "restart",
          value: function value() {
            var e = null !== this.timer;
            this.reset(), e && this.scheduleTimeout();
          }
        }, {
          key: "scheduleTimeout",
          value: function value() {
            var e = this;
            this.clearTimer(), this.timer = setTimeout(function () {
              e.tries = e.tries + 1, e.callback();
            }, this.timerCalc(this.tries + 1));
          }
        }, {
          key: "clearTimer",
          value: function value() {
            clearTimeout(this.timer), this.timer = null;
          }
        }]), e;
      }();
    }]);
  }, function (e, n, r) {
    (function (r) {
      var i;
      !function () {
        var o = "undefined" != typeof window && window === this ? this : "undefined" != typeof r && null != r ? r : this,
            a = "function" == typeof Object.defineProperties ? Object.defineProperty : function (e, t, n) {
          e != Array.prototype && e != Object.prototype && (e[t] = n.value);
        };

        function l() {
          l = function l() {}, o.Symbol || (o.Symbol = m);
        }

        var s = 0;

        function m(e) {
          return "jscomp_symbol_" + (e || "") + s++;
        }

        function p() {
          l();
          var e = o.Symbol.iterator;
          e || (e = o.Symbol.iterator = o.Symbol("iterator")), "function" != typeof Array.prototype[e] && a(Array.prototype, e, {
            configurable: !0,
            writable: !0,
            value: function value() {
              return q(this);
            }
          }), p = function p() {};
        }

        function q(e) {
          var t = 0;
          return function r(e) {
            return p(), (e = {
              next: e
            })[o.Symbol.iterator] = function () {
              return this;
            }, e;
          }(function () {
            return t < e.length ? {
              done: !1,
              value: e[t++]
            } : {
              done: !0
            };
          });
        }

        function t(e) {
          p();
          var t = e[Symbol.iterator];
          return t ? t.call(e) : q(e);
        }

        function u(e) {
          if (!(e instanceof Array)) {
            e = t(e);

            for (var n, r = []; !(n = e.next()).done;) {
              r.push(n.value);
            }

            e = r;
          }

          return e;
        }

        var c = 0;
        var f = "img script iframe link audio video source".split(" ");

        function z(e, n) {
          for (var r = (e = t(e)).next(); !r.done; r = e.next()) {
            if (r = r.value, n.includes(r.nodeName.toLowerCase()) || z(r.children, n)) return !0;
          }

          return !1;
        }

        function B(e, n) {
          if (2 < e.length) return performance.now();

          for (var r = [], i = (n = t(n)).next(); !i.done; i = n.next()) {
            i = i.value, r.push({
              timestamp: i.start,
              type: "requestStart"
            }), r.push({
              timestamp: i.end,
              type: "requestEnd"
            });
          }

          for (i = (n = t(e)).next(); !i.done; i = n.next()) {
            r.push({
              timestamp: i.value,
              type: "requestStart"
            });
          }

          for (r.sort(function (e, t) {
            return e.timestamp - t.timestamp;
          }), e = e.length, n = r.length - 1; 0 <= n; n--) {
            switch ((i = r[n]).type) {
              case "requestStart":
                e--;
                break;

              case "requestEnd":
                if (2 < ++e) return i.timestamp;
                break;

              default:
                throw Error("Internal Error: This should never happen");
            }
          }

          return 0;
        }

        function C(e) {
          e = e || {}, this.w = !!e.useMutationObserver, this.u = e.minValue || null, e = window.__tti && window.__tti.e;
          var n = window.__tti && window.__tti.o;
          this.a = e ? e.map(function (e) {
            return {
              start: e.startTime,
              end: e.startTime + e.duration
            };
          }) : [], n && n.disconnect(), this.b = [], this.f = new Map(), this.j = null, this.v = -1 / 0, this.i = !1, this.h = this.c = this.s = null, function w(e, t) {
            var n = XMLHttpRequest.prototype.send,
                r = c++;

            XMLHttpRequest.prototype.send = function (i) {
              for (var o = [], a = 0; a < arguments.length; ++a) {
                o[a - 0] = arguments[a];
              }

              var s = this;
              return e(r), this.addEventListener("readystatechange", function () {
                4 === s.readyState && t(r);
              }), n.apply(this, o);
            };
          }(this.m.bind(this), this.l.bind(this)), function x(e, t) {
            var n = fetch;

            fetch = function fetch(r) {
              for (var i = [], o = 0; o < arguments.length; ++o) {
                i[o - 0] = arguments[o];
              }

              return new Promise(function (r, o) {
                var a = c++;
                e(a), n.apply(null, [].concat(u(i))).then(function (e) {
                  t(a), r(e);
                }, function (e) {
                  t(e), o(e);
                });
              });
            };
          }(this.m.bind(this), this.l.bind(this)), function D(e) {
            e.c = new PerformanceObserver(function (n) {
              for (var r = (n = t(n.getEntries())).next(); !r.done; r = n.next()) {
                if ("resource" === (r = r.value).entryType && (e.b.push({
                  start: r.fetchStart,
                  end: r.responseEnd
                }), G(e, B(e.g, e.b) + 5e3)), "longtask" === r.entryType) {
                  var i = r.startTime + r.duration;
                  e.a.push({
                    start: r.startTime,
                    end: i
                  }), G(e, i + 5e3);
                }
              }
            }), e.c.observe({
              entryTypes: ["longtask", "resource"]
            });
          }(this), this.w && (this.h = function A(e) {
            var n = new MutationObserver(function (n) {
              for (var r = (n = t(n)).next(); !r.done; r = n.next()) {
                "childList" == (r = r.value).type && z(r.addedNodes, f) ? e(r) : "attributes" == r.type && f.includes(r.target.tagName.toLowerCase()) && e(r);
              }
            });
            return n.observe(document, {
              attributes: !0,
              childList: !0,
              subtree: !0,
              attributeFilter: ["href", "src"]
            }), n;
          }(this.B.bind(this)));
        }

        function F(e) {
          e.i = !0;
          var t = 0 < e.a.length ? e.a[e.a.length - 1].end : 0,
              n = B(e.g, e.b);
          G(e, Math.max(n + 5e3, t));
        }

        function G(e, t) {
          !e.i || e.v > t || (clearTimeout(e.j), e.j = setTimeout(function () {
            var t = performance.timing.navigationStart,
                n = B(e.g, e.b);
            t = (window.a && window.a.A ? 1e3 * window.a.A().C - t : 0) || performance.timing.domContentLoadedEventEnd - t;
            if (e.u) var r = e.u;else performance.timing.domContentLoadedEventEnd ? r = (r = performance.timing).domContentLoadedEventEnd - r.navigationStart : r = null;
            var i = performance.now();
            null === r && G(e, Math.max(n + 5e3, i + 1e3));
            var o = e.a;
            5e3 > i - n ? n = null : n = 5e3 > i - (n = o.length ? o[o.length - 1].end : t) ? null : Math.max(n, r), n && (e.s(n), clearTimeout(e.j), e.i = !1, e.c && e.c.disconnect(), e.h && e.h.disconnect()), G(e, performance.now() + 1e3);
          }, t - performance.now()), e.v = t);
        }

        C.prototype.getFirstConsistentlyInteractive = function () {
          var e = this;
          return new Promise(function (t) {
            e.s = t, "complete" == document.readyState ? F(e) : window.addEventListener("load", function () {
              F(e);
            });
          });
        }, C.prototype.m = function (e) {
          this.f.set(e, performance.now());
        }, C.prototype.l = function (e) {
          this.f.delete(e);
        }, C.prototype.B = function () {
          G(this, performance.now() + 5e3);
        }, o.Object.defineProperties(C.prototype, {
          g: {
            configurable: !0,
            enumerable: !0,
            get: function get() {
              return [].concat(u(this.f.values()));
            }
          }
        });
        var d = {
          getFirstConsistentlyInteractive: function getFirstConsistentlyInteractive(e) {
            return e = e || {}, "PerformanceLongTaskTiming" in window ? new C(e).getFirstConsistentlyInteractive() : Promise.resolve(null);
          }
        };
        e.exports ? e.exports = d : void 0 === (i = function () {
          return d;
        }.apply(n, [])) || (e.exports = i);
      }();
    }).call(this, r(17));
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };

      function generatePatches(e, t, n, r, i, o) {
        n && (Array.isArray(i) ? function generateArrayPatches(e, t, n, r, i, o) {
          for (var a = Math.min(i.length, o.length), s = 0; s < a; s++) {
            if (e.assigned[s] && i[s] !== o[s]) {
              var c = t.concat(s);
              n.push({
                op: "replace",
                path: c,
                value: o[s]
              }), r.push({
                op: "replace",
                path: c,
                value: i[s]
              });
            }
          }

          if (a < o.length) {
            for (var l = a; l < o.length; l++) {
              var u = t.concat(l);
              n.push({
                op: "add",
                path: u,
                value: o[l]
              });
            }

            r.push({
              op: "replace",
              path: t.concat("length"),
              value: i.length
            });
          } else if (a < i.length) {
            n.push({
              op: "replace",
              path: t.concat("length"),
              value: o.length
            });

            for (var p = a; p < i.length; p++) {
              var f = t.concat(p);
              r.push({
                op: "add",
                path: f,
                value: i[p]
              });
            }
          }
        }(e, t, n, r, i, o) : function generateObjectPatches(e, t, n, r, i, o) {
          each(e.assigned, function (e, a) {
            var s = i[e],
                c = o[e],
                l = a ? e in i ? "replace" : "add" : "remove";

            if (s !== i || "replace" !== l) {
              var u = t.concat(e);
              n.push("remove" === l ? {
                op: l,
                path: u
              } : {
                op: l,
                path: u,
                value: c
              }), r.push("add" === l ? {
                op: "remove",
                path: u
              } : "remove" === l ? {
                op: "add",
                path: u,
                value: s
              } : {
                op: "replace",
                path: u,
                value: s
              });
            }
          });
        }(e, t, n, r, i, o));
      }

      var r = "undefined" !== typeof Symbol ? Symbol("immer-nothing") : function defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }({}, "immer-nothing", !0),
          i = "undefined" !== typeof Symbol ? Symbol("immer-proxy-state") : "__$immer_state",
          o = "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.";
      var a = !("undefined" !== typeof e || "verifyMinified" !== function verifyMinified() {}.name),
          s = "undefined" !== typeof Proxy && "undefined" !== typeof Reflect;

      function isProxy(e) {
        return !!e && !!e[i];
      }

      function isProxyable(e) {
        if (!e) return !1;
        if ("object" !== ("undefined" === typeof e ? "undefined" : n(e))) return !1;
        if (Array.isArray(e)) return !0;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      }

      var c = Object.assign || function assign(e, t) {
        for (var n in t) {
          has(t, n) && (e[n] = t[n]);
        }

        return e;
      };

      function shallowCopy(e) {
        if (Array.isArray(e)) return e.slice();
        var t = void 0 === e.__proto__ ? Object.create(null) : {};
        return c(t, e);
      }

      function each(e, t) {
        if (Array.isArray(e)) for (var n = 0; n < e.length; n++) {
          t(n, e[n]);
        } else for (var r in e) {
          t(r, e[r]);
        }
      }

      function has(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      function finalize(e, t, n, r) {
        if (isProxy(e)) {
          var o = e[i];

          if (!0 === o.modified) {
            if (!0 === o.finalized) return o.copy;
            o.finalized = !0;

            var c = function finalizeObject(e, t, n, r, i) {
              var o = t.base;
              return each(e, function (a, s) {
                if (s !== o[a]) {
                  var c = r && !has(t.assigned, a);
                  e[a] = finalize(s, c && n.concat(a), c && r, i);
                }
              }), function freeze(e) {
                return a && Object.freeze(e), e;
              }(e);
            }(s ? o.copy : o.copy = shallowCopy(e), o, t, n, r);

            return generatePatches(o, t, n, r, o.base, c), c;
          }

          return o.base;
        }

        return function finalizeNonProxiedObject(e) {
          if (!isProxyable(e)) return;
          if (Object.isFrozen(e)) return;
          each(e, function (t, n) {
            isProxy(n) ? e[t] = finalize(n) : finalizeNonProxiedObject(n);
          });
        }(e), e;
      }

      function is(e, t) {
        return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
      }

      var l = null,
          u = {
        get: function get$1(e, t) {
          if (t === i) return e;

          if (e.modified) {
            var n = e.copy[t];
            return n === e.base[t] && isProxyable(n) ? e.copy[t] = createProxy(e, n) : n;
          }

          if (has(e.proxies, t)) return e.proxies[t];
          var r = e.base[t];
          return !isProxy(r) && isProxyable(r) ? e.proxies[t] = createProxy(e, r) : r;
        },
        has: function has$$1(e, t) {
          return t in source(e);
        },
        ownKeys: function ownKeys(e) {
          return Reflect.ownKeys(source(e));
        },
        set: function set$1(e, t, n) {
          if (e.assigned[t] = !0, !e.modified) {
            if (t in e.base && is(e.base[t], n) || has(e.proxies, t) && e.proxies[t] === n) return !0;
            markChanged(e);
          }

          return e.copy[t] = n, !0;
        },
        deleteProperty: function deleteProperty(e, t) {
          return e.assigned[t] = !1, markChanged(e), delete e.copy[t], !0;
        },
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
          var n = e.modified ? e.copy : has(e.proxies, t) ? e.proxies : e.base,
              r = Reflect.getOwnPropertyDescriptor(n, t);
          !r || Array.isArray(n) && "length" === t || (r.configurable = !0);
          return r;
        },
        defineProperty: function defineProperty$1() {
          throw new Error("Immer does not support defining properties on draft objects.");
        },
        setPrototypeOf: function setPrototypeOf() {
          throw new Error("Immer does not support `setPrototypeOf()`.");
        }
      },
          p = {};

      function source(e) {
        return !0 === e.modified ? e.copy : e.base;
      }

      function markChanged(e) {
        e.modified || (e.modified = !0, e.copy = shallowCopy(e.base), Object.assign(e.copy, e.proxies), e.parent && markChanged(e.parent));
      }

      function createProxy(e, t) {
        if (isProxy(t)) throw new Error("Immer bug. Plz report.");

        var n = function createState(e, t) {
          return {
            modified: !1,
            assigned: {},
            finalized: !1,
            parent: e,
            base: t,
            copy: void 0,
            proxies: {}
          };
        }(e, t),
            r = Array.isArray(t) ? Proxy.revocable([n], p) : Proxy.revocable(n, u);

        return l.push(r), r.proxy;
      }

      each(u, function (e, t) {
        p[e] = function () {
          return arguments[0] = arguments[0][0], t.apply(this, arguments);
        };
      }), p.deleteProperty = function (e, t) {
        if (isNaN(parseInt(t))) throw new Error("Immer does not support deleting properties from arrays: " + t);
        return u.deleteProperty.call(this, e[0], t);
      }, p.set = function (e, t, n) {
        if ("length" !== t && isNaN(parseInt(t))) throw new Error("Immer does not support setting non-numeric properties on arrays: " + t);
        return u.set.call(this, e[0], t, n);
      };
      var f = {},
          d = null;

      function source$1(e) {
        return e.hasCopy ? e.copy : e.base;
      }

      function markChanged$1(e) {
        e.modified || (e.modified = !0, e.parent && markChanged$1(e.parent));
      }

      function prepareCopy(e) {
        e.hasCopy || (e.hasCopy = !0, e.copy = shallowCopy(e.base));
      }

      function createProxy$1(e, t) {
        var n = shallowCopy(t);
        each(t, function (e) {
          Object.defineProperty(n, "" + e, function createPropertyProxy(e) {
            return f[e] || (f[e] = {
              configurable: !0,
              enumerable: !0,
              get: function get$$1() {
                return function _get(e, t) {
                  assertUnfinished(e);
                  var n = source$1(e)[t];
                  return !e.finalizing && n === e.base[t] && isProxyable(n) ? (prepareCopy(e), e.copy[t] = createProxy$1(e, n)) : n;
                }(this[i], e);
              },
              set: function set$$1(t) {
                !function _set(e, t, n) {
                  if (assertUnfinished(e), e.assigned[t] = !0, !e.modified) {
                    if (is(source$1(e)[t], n)) return;
                    markChanged$1(e), prepareCopy(e);
                  }

                  e.copy[t] = n;
                }(this[i], e, t);
              }
            });
          }("" + e));
        });

        var r = function createState$1(e, t, n) {
          return {
            modified: !1,
            assigned: {},
            hasCopy: !1,
            parent: e,
            base: n,
            proxy: t,
            copy: void 0,
            finished: !1,
            finalizing: !1,
            finalized: !1
          };
        }(e, n, t);

        return function createHiddenProperty(e, t, n) {
          Object.defineProperty(e, t, {
            value: n,
            enumerable: !1,
            writable: !0
          });
        }(n, i, r), d.push(r), n;
      }

      function assertUnfinished(e) {
        if (!0 === e.finished) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(e.copy || e.base));
      }

      function markChangesRecursively(e) {
        if (e && "object" === ("undefined" === typeof e ? "undefined" : n(e))) {
          var t = e[i];

          if (t) {
            var r = t.proxy,
                o = t.base;

            if (Array.isArray(e)) {
              if (hasArrayChanges(t)) {
                if (markChanged$1(t), t.assigned.length = !0, r.length < o.length) for (var a = r.length; a < o.length; a++) {
                  t.assigned[a] = !1;
                } else for (var s = o.length; s < r.length; s++) {
                  t.assigned[s] = !0;
                }
                each(r, function (e, n) {
                  t.assigned[e] || markChangesRecursively(n);
                });
              }
            } else {
              var c = function diffKeys(e, t) {
                var n = Object.keys(e),
                    r = Object.keys(t);
                return {
                  added: r.filter(function (e) {
                    return -1 === n.indexOf(e);
                  }),
                  removed: n.filter(function (e) {
                    return -1 === r.indexOf(e);
                  })
                };
              }(o, r),
                  l = c.added,
                  u = c.removed;

              (l.length > 0 || u.length > 0) && markChanged$1(t), each(l, function (e, n) {
                t.assigned[n] = !0;
              }), each(u, function (e, n) {
                t.assigned[n] = !1;
              }), each(r, function (e, n) {
                t.assigned[e] || markChangesRecursively(n);
              });
            }
          }
        }
      }

      function hasObjectChanges(e) {
        for (var t = e.base, n = e.proxy, r = Object.keys(n), i = r.length; 0 !== i;) {
          var o = r[--i];
          if (void 0 === t[o] && !has(t, o)) return !0;
        }

        return r.length !== Object.keys(t).length;
      }

      function hasArrayChanges(e) {
        var t = e.proxy;
        if (t.length !== e.base.length) return !0;
        var n = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!n || n.get);
      }

      function produceEs5(e, t, n) {
        if (isProxy(e)) {
          var r = t.call(e, e);
          return void 0 === r ? e : r;
        }

        var a = d;
        d = [];
        var s = n && [],
            c = n && [];

        try {
          var l = createProxy$1(void 0, e),
              u = t.call(l, l);
          each(d, function (e, t) {
            t.finalizing = !0;
          });
          var p = void 0;

          if (void 0 !== u && u !== l) {
            if (l[i].modified) throw new Error(o);
            p = finalize(u), s && (s.push({
              op: "replace",
              path: [],
              value: p
            }), c.push({
              op: "replace",
              path: [],
              value: e
            }));
          } else n && markChangesRecursively(l), function markChangesSweep() {
            for (var e = d.length - 1; e >= 0; e--) {
              var t = d[e];
              !1 === t.modified && (Array.isArray(t.base) ? hasArrayChanges(t) && markChanged$1(t) : hasObjectChanges(t) && markChanged$1(t));
            }
          }(), p = finalize(l, [], s, c);

          return each(d, function (e, t) {
            t.finished = !0;
          }), n && n(s, c), p;
        } finally {
          d = a;
        }
      }

      function produce(e, t, n) {
        if (arguments.length < 1 || arguments.length > 3) throw new Error("produce expects 1 to 3 arguments, got " + arguments.length);

        if ("function" === typeof e && "function" !== typeof t) {
          var r = t,
              a = e;
          return function () {
            for (var e = arguments.length, t = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
              t[n - 1] = arguments[n];
            }

            return produce(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r, function (e) {
              return a.call.apply(a, [e, e].concat(t));
            });
          };
        }

        if ("function" !== typeof t) throw new Error("if first argument is not a function, the second argument to produce should be a function");
        if (void 0 !== n && "function" !== typeof n) throw new Error("the third argument of a producer should not be set or a function");

        if (!isProxyable(e)) {
          var c = t(e);
          return void 0 === c ? e : normalizeResult(c);
        }

        return normalizeResult(function getUseProxies() {
          return s;
        }() ? function produceProxy(e, t, n) {
          if (isProxy(e)) {
            var r = t.call(e, e);
            return void 0 === r ? e : r;
          }

          var a = l;
          l = [];
          var s = n && [],
              c = n && [];

          try {
            var u = createProxy(void 0, e),
                p = t.call(u, u),
                f = void 0;

            if (void 0 !== p && p !== u) {
              if (u[i].modified) throw new Error(o);
              f = finalize(p), s && (s.push({
                op: "replace",
                path: [],
                value: f
              }), c.push({
                op: "replace",
                path: [],
                value: e
              }));
            } else f = finalize(u, [], s, c);

            return each(l, function (e, t) {
              return t.revoke();
            }), n && n(s, c), f;
          } finally {
            l = a;
          }
        }(e, t, n) : produceEs5(e, t, n));
      }

      function normalizeResult(e) {
        return e === r ? void 0 : e;
      }

      produce(function applyPatches(e, t) {
        for (var r = 0; r < t.length; r++) {
          var i = t[r],
              o = i.path;
          if (0 === o.length && "replace" === i.op) e = i.value;else {
            for (var a = e, s = 0; s < o.length - 1; s++) {
              if (!(a = a[o[s]]) || "object" !== ("undefined" === typeof a ? "undefined" : n(a))) throw new Error("Cannot apply patch, path doesn't resolve: " + o.join("/"));
            }

            var c = o[o.length - 1];

            switch (i.op) {
              case "replace":
              case "add":
                a[c] = i.value;
                break;

              case "remove":
                if (Array.isArray(a)) {
                  if (c !== a.length - 1) throw new Error("Remove can only remove the last key of an array, index: " + c + ", length: " + a.length);
                  a.length -= 1;
                } else delete a[c];

                break;

              default:
                throw new Error("Unsupported patch operation: " + i.op);
            }
          }
        }

        return e;
      });
      t.a = produce;
    }).call(this, n(179));
  }, function (e, t, n) {
    e.exports = n(180);
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t,
          n = Object.prototype,
          r = n.hasOwnProperty,
          i = "function" === typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";

      function define(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        define({}, "");
      } catch (A) {
        define = function define(e, t, n) {
          return e[t] = n;
        };
      }

      function wrap(e, t, n, r) {
        var i = t && t.prototype instanceof Generator ? t : Generator,
            o = Object.create(i.prototype),
            a = new Context(r || []);
        return o._invoke = function makeInvokeMethod(e, t, n) {
          var r = c;
          return function invoke(i, o) {
            if (r === u) throw new Error("Generator is already running");

            if (r === p) {
              if ("throw" === i) throw o;
              return doneResult();
            }

            for (n.method = i, n.arg = o;;) {
              var a = n.delegate;

              if (a) {
                var s = maybeInvokeDelegate(a, n);

                if (s) {
                  if (s === f) continue;
                  return s;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === c) throw r = p, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = u;
              var d = tryCatch(e, t, n);

              if ("normal" === d.type) {
                if (r = n.done ? p : l, d.arg === f) continue;
                return {
                  value: d.arg,
                  done: n.done
                };
              }

              "throw" === d.type && (r = p, n.method = "throw", n.arg = d.arg);
            }
          };
        }(e, n, a), o;
      }

      function tryCatch(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (A) {
          return {
            type: "throw",
            arg: A
          };
        }
      }

      e.wrap = wrap;
      var c = "suspendedStart",
          l = "suspendedYield",
          u = "executing",
          p = "completed",
          f = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var d = {};

      d[o] = function () {
        return this;
      };

      var h = Object.getPrototypeOf,
          m = h && h(h(values([])));
      m && m !== n && r.call(m, o) && (d = m);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(d);

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          define(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function AsyncIterator(e, t) {
        var n;

        this._invoke = function enqueue(i, o) {
          function callInvokeWithMethodAndArg() {
            return new t(function (n, a) {
              !function invoke(n, i, o, a) {
                var s = tryCatch(e[n], e, i);

                if ("throw" !== s.type) {
                  var c = s.arg,
                      l = c.value;
                  return l && "object" === typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    invoke("next", e, o, a);
                  }, function (e) {
                    invoke("throw", e, o, a);
                  }) : t.resolve(l).then(function (e) {
                    c.value = e, o(c);
                  }, function (e) {
                    return invoke("throw", e, o, a);
                  });
                }

                a(s.arg);
              }(i, o, n, a);
            });
          }

          return n = n ? n.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, n) {
        var r = e.iterator[n.method];

        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator.return && (n.method = "return", n.arg = t, maybeInvokeDelegate(e, n), "throw" === n.method)) return f;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return f;
        }

        var i = tryCatch(r, e.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, f;
        var o = i.arg;
        return o ? o.done ? (n[e.resultName] = o.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, f) : o : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, f);
      }

      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var n = e[o];
          if (n) return n.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var i = -1,
                a = function next() {
              for (; ++i < e.length;) {
                if (r.call(e, i)) return next.value = e[i], next.done = !1, next;
              }

              return next.value = t, next.done = !0, next;
            };

            return a.next = a;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }

      return GeneratorFunction.prototype = g.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, define(e, s, "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[a] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, n, r, i, o) {
        void 0 === o && (o = Promise);
        var a = new AsyncIterator(wrap(t, n, r, i), o);
        return e.isGeneratorFunction(n) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, defineIteratorMethods(g), define(g, s, "Generator"), g[o] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function next() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return next.value = n, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;

          function handle(r, i) {
            return a.type = "throw", a.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i],
                a = o.completion;
            if ("root" === o.tryLoc) return handle("end");

            if (o.tryLoc <= this.prev) {
              var s = r.call(o, "catchLoc"),
                  c = r.call(o, "finallyLoc");

              if (s && c) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var i = this.tryEntries[n];

            if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, f) : this.complete(a);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), f;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), resetTryEntry(n), f;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r = n.completion;

              if ("throw" === r.type) {
                var i = r.arg;
                resetTryEntry(n);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: values(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), f;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (i) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    var r = n(70);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".agent-status-pane {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  line-height: 1.3;\n  display: flex;\n  overflow: hidden;\n}\n\n.agent-status-pane .agent-status-information {\n  flex: auto;\n  overflow: hidden;\n}\n\n.agent-status-pane .agent-status-toggle {\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.agent-status-pane .agent-identifier {\n  display: flex;\n}\n\n.agent-status-pane .agent-display-name {\n  margin-right: 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-status-pane .agent-display-name,\n.agent-status-pane .agent-status-label {\n  color: var(--color-p1-10);\n}\n\n.agent-status-pane .agent-status-details {\n  color: #7a8a94;\n}\n\n.agent-status-pane .agent-status-label {\n  font-family: var(--main-font-family--semibold);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD",
      file: "style.css",
      sourcesContent: [".agent-status-pane {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  line-height: 1.3;\n  display: flex;\n  overflow: hidden;\n}\n\n.agent-status-pane .agent-status-information {\n  flex: auto;\n  overflow: hidden;\n}\n\n.agent-status-pane .agent-status-toggle {\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.agent-status-pane .agent-identifier {\n  display: flex;\n}\n\n.agent-status-pane .agent-display-name {\n  margin-right: 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-status-pane .agent-display-name,\n.agent-status-pane .agent-status-label {\n  color: var(--color-p1-10);\n}\n\n.agent-status-pane .agent-status-details {\n  color: #7a8a94;\n}\n\n.agent-status-pane .agent-status-label {\n  font-family: var(--main-font-family--semibold);\n}\n"]
    }]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var i,
            o = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(o) ? e : (i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
      });
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
        return "%" + e.charCodeAt(0).toString(16).toUpperCase();
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;
    e.exports = function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (i) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, a, s = function toObject(e) {
        if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), c = 1; c < arguments.length; c++) {
        for (var l in n = Object(arguments[c])) {
          i.call(n, l) && (s[l] = n[l]);
        }

        if (r) {
          a = r(n);

          for (var u = 0; u < a.length; u++) {
            o.call(n, a[u]) && (s[a[u]] = n[a[u]]);
          }
        }
      }

      return s;
    };
  }, function (e, t, n) {
    "use strict";

    var r = new RegExp("%[a-f0-9]{2}", "gi"),
        i = new RegExp("(%[a-f0-9]{2})+", "gi");

    function decodeComponents(e, t) {
      try {
        return decodeURIComponent(e.join(""));
      } catch (i) {}

      if (1 === e.length) return e;
      t = t || 1;
      var n = e.slice(0, t),
          r = e.slice(t);
      return Array.prototype.concat.call([], decodeComponents(n), decodeComponents(r));
    }

    function decode(e) {
      try {
        return decodeURIComponent(e);
      } catch (i) {
        for (var t = e.match(r), n = 1; n < t.length; n++) {
          t = (e = decodeComponents(t, n).join("")).match(r);
        }

        return e;
      }
    }

    e.exports = function (e) {
      if ("string" !== typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

      try {
        return e = e.replace(/\+/g, " "), decodeURIComponent(e);
      } catch (t) {
        return function customDecodeURIComponent(e) {
          for (var n = {
            "%FE%FF": "\uFFFD\uFFFD",
            "%FF%FE": "\uFFFD\uFFFD"
          }, r = i.exec(e); r;) {
            try {
              n[r[0]] = decodeURIComponent(r[0]);
            } catch (t) {
              var o = decode(r[0]);
              o !== r[0] && (n[r[0]] = o);
            }

            r = i.exec(e);
          }

          n["%C2"] = "\uFFFD";

          for (var a = Object.keys(n), s = 0; s < a.length; s++) {
            var c = a[s];
            e = e.replace(new RegExp(c, "g"), n[c]);
          }

          return e;
        }(e);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(13),
        i = n(23),
        o = n(37);

    t.toSubscriber = function toSubscriber(e, t, n) {
      if (e) {
        if (e instanceof r.Subscriber) return e;
        if (e[i.rxSubscriber]) return e[i.rxSubscriber]();
      }

      return e || t || n ? new r.Subscriber(e, t, n) : new r.Subscriber(o.empty);
    };
  }, function (e, t, n) {
    "use strict";

    var r,
        i = n(36);

    function tryCatcher() {
      try {
        return r.apply(this, arguments);
      } catch (e) {
        return i.errorObject.e = e, i.errorObject;
      }
    }

    t.tryCatch = function tryCatch(e) {
      return r = e, tryCatcher;
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function UnsubscriptionError(t) {
        e.call(this), this.errors = t;
        var n = Error.call(this, t ? t.length + " errors occurred during unsubscription:\n  " + t.map(function (e, t) {
          return t + 1 + ") " + e.toString();
        }).join("\n  ") : "");
        this.name = n.name = "UnsubscriptionError", this.stack = n.stack, this.message = n.message;
      }

      return r(UnsubscriptionError, e), UnsubscriptionError;
    }(Error);

    t.UnsubscriptionError = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(79);

    function pipeFromArray(e) {
      return e ? 1 === e.length ? e[0] : function piped(t) {
        return e.reduce(function (e, t) {
          return t(e);
        }, t);
      } : r.noop;
    }

    t.pipe = function pipe() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t - 0] = arguments[t];
      }

      return pipeFromArray(e);
    }, t.pipeFromArray = pipeFromArray;
  }, function (e, t, n) {
    "use strict";

    t.noop = function noop() {};
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function SubjectSubscription(t, n) {
        e.call(this), this.subject = t, this.subscriber = n, this.closed = !1;
      }

      return r(SubjectSubscription, e), SubjectSubscription.prototype.unsubscribe = function () {
        if (!this.closed) {
          this.closed = !0;
          var e = this.subject,
              t = e.observers;

          if (this.subject = null, t && 0 !== t.length && !e.isStopped && !e.closed) {
            var n = t.indexOf(this.subscriber);
            -1 !== n && t.splice(n, 1);
          }
        }
      }, SubjectSubscription;
    }(n(22).Subscription);

    t.SubjectSubscription = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(40),
        o = n(41);

    t.switchMap = function switchMap(e, t) {
      return function switchMapOperatorFunction(n) {
        return n.lift(new a(e, t));
      };
    };

    var a = function () {
      function SwitchMapOperator(e, t) {
        this.project = e, this.resultSelector = t;
      }

      return SwitchMapOperator.prototype.call = function (e, t) {
        return t.subscribe(new s(e, this.project, this.resultSelector));
      }, SwitchMapOperator;
    }(),
        s = function (e) {
      function SwitchMapSubscriber(t, n, r) {
        e.call(this, t), this.project = n, this.resultSelector = r, this.index = 0;
      }

      return r(SwitchMapSubscriber, e), SwitchMapSubscriber.prototype._next = function (e) {
        var t,
            n = this.index++;

        try {
          t = this.project(e, n);
        } catch (r) {
          return void this.destination.error(r);
        }

        this._innerSub(t, e, n);
      }, SwitchMapSubscriber.prototype._innerSub = function (e, t, n) {
        var r = this.innerSubscription;
        r && r.unsubscribe(), this.add(this.innerSubscription = o.subscribeToResult(this, e, t, n));
      }, SwitchMapSubscriber.prototype._complete = function () {
        var t = this.innerSubscription;
        t && !t.closed || e.prototype._complete.call(this);
      }, SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
      }, SwitchMapSubscriber.prototype.notifyComplete = function (t) {
        this.remove(t), this.innerSubscription = null, this.isStopped && e.prototype._complete.call(this);
      }, SwitchMapSubscriber.prototype.notifyNext = function (e, t, n, r, i) {
        this.resultSelector ? this._tryNotifyNext(e, t, n, r) : this.destination.next(t);
      }, SwitchMapSubscriber.prototype._tryNotifyNext = function (e, t, n, r) {
        var i;

        try {
          i = this.resultSelector(e, t, n, r);
        } catch (o) {
          return void this.destination.error(o);
        }

        this.destination.next(i);
      }, SwitchMapSubscriber;
    }(i.OuterSubscriber);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function InnerSubscriber(t, n, r) {
        e.call(this), this.parent = t, this.outerValue = n, this.outerIndex = r, this.index = 0;
      }

      return r(InnerSubscriber, e), InnerSubscriber.prototype._next = function (e) {
        this.parent.notifyNext(this.outerValue, e, this.outerIndex, this.index++, this);
      }, InnerSubscriber.prototype._error = function (e) {
        this.parent.notifyError(e, this), this.unsubscribe();
      }, InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this), this.unsubscribe();
      }, InnerSubscriber;
    }(n(13).Subscriber);

    t.InnerSubscriber = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(34),
        o = n(42),
        a = n(43),
        s = n(84),
        c = n(85),
        l = n(26),
        u = n(86),
        p = n(25),
        f = n(9),
        d = n(87),
        h = n(24),
        m = function (e) {
      function FromObservable(t, n) {
        e.call(this, null), this.ish = t, this.scheduler = n;
      }

      return r(FromObservable, e), FromObservable.create = function (e, t) {
        if (null != e) {
          if ("function" === typeof e[h.observable]) return e instanceof f.Observable && !t ? e : new FromObservable(e, t);
          if (i.isArray(e)) return new l.ArrayObservable(e, t);
          if (a.isPromise(e)) return new s.PromiseObservable(e, t);
          if ("function" === typeof e[p.iterator] || "string" === typeof e) return new c.IteratorObservable(e, t);
          if (o.isArrayLike(e)) return new u.ArrayLikeObservable(e, t);
        }

        throw new TypeError((null !== e && typeof e || e) + " is not observable");
      }, FromObservable.prototype._subscribe = function (e) {
        var t = this.ish,
            n = this.scheduler;
        return null == n ? t[h.observable]().subscribe(e) : t[h.observable]().subscribe(new d.ObserveOnSubscriber(e, n, 0));
      }, FromObservable;
    }(f.Observable);

    t.FromObservable = m;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(16),
        o = function (e) {
      function PromiseObservable(t, n) {
        e.call(this), this.promise = t, this.scheduler = n;
      }

      return r(PromiseObservable, e), PromiseObservable.create = function (e, t) {
        return new PromiseObservable(e, t);
      }, PromiseObservable.prototype._subscribe = function (e) {
        var t = this,
            n = this.promise,
            r = this.scheduler;
        if (null == r) this._isScalar ? e.closed || (e.next(this.value), e.complete()) : n.then(function (n) {
          t.value = n, t._isScalar = !0, e.closed || (e.next(n), e.complete());
        }, function (t) {
          e.closed || e.error(t);
        }).then(null, function (e) {
          i.root.setTimeout(function () {
            throw e;
          });
        });else if (this._isScalar) {
          if (!e.closed) return r.schedule(dispatchNext, 0, {
            value: this.value,
            subscriber: e
          });
        } else n.then(function (n) {
          t.value = n, t._isScalar = !0, e.closed || e.add(r.schedule(dispatchNext, 0, {
            value: n,
            subscriber: e
          }));
        }, function (t) {
          e.closed || e.add(r.schedule(dispatchError, 0, {
            err: t,
            subscriber: e
          }));
        }).then(null, function (e) {
          i.root.setTimeout(function () {
            throw e;
          });
        });
      }, PromiseObservable;
    }(n(9).Observable);

    function dispatchNext(e) {
      var t = e.value,
          n = e.subscriber;
      n.closed || (n.next(t), n.complete());
    }

    function dispatchError(e) {
      var t = e.err,
          n = e.subscriber;
      n.closed || n.error(t);
    }

    t.PromiseObservable = o;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(16),
        o = n(9),
        a = n(25),
        s = function (e) {
      function IteratorObservable(t, n) {
        if (e.call(this), this.scheduler = n, null == t) throw new Error("iterator cannot be null.");

        this.iterator = function getIterator(e) {
          var t = e[a.iterator];
          if (!t && "string" === typeof e) return new c(e);
          if (!t && void 0 !== e.length) return new l(e);
          if (!t) throw new TypeError("object is not iterable");
          return e[a.iterator]();
        }(t);
      }

      return r(IteratorObservable, e), IteratorObservable.create = function (e, t) {
        return new IteratorObservable(e, t);
      }, IteratorObservable.dispatch = function (e) {
        var t = e.index,
            n = e.hasError,
            r = e.iterator,
            i = e.subscriber;
        if (n) i.error(e.error);else {
          var o = r.next();
          o.done ? i.complete() : (i.next(o.value), e.index = t + 1, i.closed ? "function" === typeof r.return && r.return() : this.schedule(e));
        }
      }, IteratorObservable.prototype._subscribe = function (e) {
        var t = this.iterator,
            n = this.scheduler;
        if (n) return n.schedule(IteratorObservable.dispatch, 0, {
          index: 0,
          iterator: t,
          subscriber: e
        });

        for (;;) {
          var r = t.next();

          if (r.done) {
            e.complete();
            break;
          }

          if (e.next(r.value), e.closed) {
            "function" === typeof t.return && t.return();
            break;
          }
        }
      }, IteratorObservable;
    }(o.Observable);

    t.IteratorObservable = s;

    var c = function () {
      function StringIterator(e, t, n) {
        void 0 === t && (t = 0), void 0 === n && (n = e.length), this.str = e, this.idx = t, this.len = n;
      }

      return StringIterator.prototype[a.iterator] = function () {
        return this;
      }, StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
          done: !1,
          value: this.str.charAt(this.idx++)
        } : {
          done: !0,
          value: void 0
        };
      }, StringIterator;
    }(),
        l = function () {
      function ArrayIterator(e, t, n) {
        void 0 === t && (t = 0), void 0 === n && (n = function toLength(e) {
          var t = +e.length;
          if (isNaN(t)) return 0;
          if (0 === t || !function numberIsFinite(e) {
            return "number" === typeof e && i.root.isFinite(e);
          }(t)) return t;
          if ((t = function sign(e) {
            var t = +e;
            return 0 === t ? t : isNaN(t) ? t : t < 0 ? -1 : 1;
          }(t) * Math.floor(Math.abs(t))) <= 0) return 0;
          if (t > u) return u;
          return t;
        }(e)), this.arr = e, this.idx = t, this.len = n;
      }

      return ArrayIterator.prototype[a.iterator] = function () {
        return this;
      }, ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
          done: !1,
          value: this.arr[this.idx++]
        } : {
          done: !0,
          value: void 0
        };
      }, ArrayIterator;
    }();

    var u = Math.pow(2, 53) - 1;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(9),
        o = n(44),
        a = n(27),
        s = function (e) {
      function ArrayLikeObservable(t, n) {
        e.call(this), this.arrayLike = t, this.scheduler = n, n || 1 !== t.length || (this._isScalar = !0, this.value = t[0]);
      }

      return r(ArrayLikeObservable, e), ArrayLikeObservable.create = function (e, t) {
        var n = e.length;
        return 0 === n ? new a.EmptyObservable() : 1 === n ? new o.ScalarObservable(e[0], t) : new ArrayLikeObservable(e, t);
      }, ArrayLikeObservable.dispatch = function (e) {
        var t = e.arrayLike,
            n = e.index,
            r = e.length,
            i = e.subscriber;
        i.closed || (n >= r ? i.complete() : (i.next(t[n]), e.index = n + 1, this.schedule(e)));
      }, ArrayLikeObservable.prototype._subscribe = function (e) {
        var t = this.arrayLike,
            n = this.scheduler,
            r = t.length;
        if (n) return n.schedule(ArrayLikeObservable.dispatch, 0, {
          arrayLike: t,
          index: 0,
          length: r,
          subscriber: e
        });

        for (var i = 0; i < r && !e.closed; i++) {
          e.next(t[i]);
        }

        e.complete();
      }, ArrayLikeObservable;
    }(i.Observable);

    t.ArrayLikeObservable = s;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13),
        o = n(88);

    t.observeOn = function observeOn(e, t) {
      return void 0 === t && (t = 0), function observeOnOperatorFunction(n) {
        return n.lift(new a(e, t));
      };
    };

    var a = function () {
      function ObserveOnOperator(e, t) {
        void 0 === t && (t = 0), this.scheduler = e, this.delay = t;
      }

      return ObserveOnOperator.prototype.call = function (e, t) {
        return t.subscribe(new s(e, this.scheduler, this.delay));
      }, ObserveOnOperator;
    }();

    t.ObserveOnOperator = a;

    var s = function (e) {
      function ObserveOnSubscriber(t, n, r) {
        void 0 === r && (r = 0), e.call(this, t), this.scheduler = n, this.delay = r;
      }

      return r(ObserveOnSubscriber, e), ObserveOnSubscriber.dispatch = function (e) {
        var t = e.notification,
            n = e.destination;
        t.observe(n), this.unsubscribe();
      }, ObserveOnSubscriber.prototype.scheduleMessage = function (e) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new c(e, this.destination)));
      }, ObserveOnSubscriber.prototype._next = function (e) {
        this.scheduleMessage(o.Notification.createNext(e));
      }, ObserveOnSubscriber.prototype._error = function (e) {
        this.scheduleMessage(o.Notification.createError(e));
      }, ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(o.Notification.createComplete());
      }, ObserveOnSubscriber;
    }(i.Subscriber);

    t.ObserveOnSubscriber = s;

    var c = function () {
      return function ObserveOnMessage(e, t) {
        this.notification = e, this.destination = t;
      };
    }();

    t.ObserveOnMessage = c;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = function () {
      function Notification(e, t, n) {
        this.kind = e, this.value = t, this.error = n, this.hasValue = "N" === e;
      }

      return Notification.prototype.observe = function (e) {
        switch (this.kind) {
          case "N":
            return e.next && e.next(this.value);

          case "E":
            return e.error && e.error(this.error);

          case "C":
            return e.complete && e.complete();
        }
      }, Notification.prototype.do = function (e, t, n) {
        switch (this.kind) {
          case "N":
            return e && e(this.value);

          case "E":
            return t && t(this.error);

          case "C":
            return n && n();
        }
      }, Notification.prototype.accept = function (e, t, n) {
        return e && "function" === typeof e.next ? this.observe(e) : this.do(e, t, n);
      }, Notification.prototype.toObservable = function () {
        switch (this.kind) {
          case "N":
            return r.Observable.of(this.value);

          case "E":
            return r.Observable.throw(this.error);

          case "C":
            return r.Observable.empty();
        }

        throw new Error("unexpected notification kind value");
      }, Notification.createNext = function (e) {
        return "undefined" !== typeof e ? new Notification("N", e) : Notification.undefinedValueNotification;
      }, Notification.createError = function (e) {
        return new Notification("E", void 0, e);
      }, Notification.createComplete = function () {
        return Notification.completeNotification;
      }, Notification.completeNotification = new Notification("C"), Notification.undefinedValueNotification = new Notification("N", void 0), Notification;
    }();

    t.Notification = i;
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13);

    t.filter = function filter(e, t) {
      return function filterOperatorFunction(n) {
        return n.lift(new o(e, t));
      };
    };

    var o = function () {
      function FilterOperator(e, t) {
        this.predicate = e, this.thisArg = t;
      }

      return FilterOperator.prototype.call = function (e, t) {
        return t.subscribe(new a(e, this.predicate, this.thisArg));
      }, FilterOperator;
    }(),
        a = function (e) {
      function FilterSubscriber(t, n, r) {
        e.call(this, t), this.predicate = n, this.thisArg = r, this.count = 0;
      }

      return r(FilterSubscriber, e), FilterSubscriber.prototype._next = function (e) {
        var t;

        try {
          t = this.predicate.call(this.thisArg, e, this.count++);
        } catch (n) {
          return void this.destination.error(n);
        }

        t && this.destination.next(e);
      }, FilterSubscriber;
    }(i.Subscriber);
  }, function (e, t, n) {
    "use strict";

    var r = n(46),
        i = n(91);

    t.mergeAll = function mergeAll(e) {
      return void 0 === e && (e = Number.POSITIVE_INFINITY), r.mergeMap(i.identity, null, e);
    };
  }, function (e, t, n) {
    "use strict";

    t.identity = function identity(e) {
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(93);
    r.Observable.prototype.mergeMap = i.mergeMap, r.Observable.prototype.flatMap = i.mergeMap;
  }, function (e, t, n) {
    "use strict";

    var r = n(46);

    t.mergeMap = function mergeMap(e, t, n) {
      return void 0 === n && (n = Number.POSITIVE_INFINITY), r.mergeMap(e, t, n)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(29);
    r.Observable.prototype.filter = i.filter;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(96);
    r.Observable.prototype.do = i._do, r.Observable.prototype._do = i._do;
  }, function (e, t, n) {
    "use strict";

    var r = n(97);

    t._do = function _do(e, t, n) {
      return r.tap(e, t, n)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13);

    t.tap = function tap(e, t, n) {
      return function tapOperatorFunction(r) {
        return r.lift(new o(e, t, n));
      };
    };

    var o = function () {
      function DoOperator(e, t, n) {
        this.nextOrObserver = e, this.error = t, this.complete = n;
      }

      return DoOperator.prototype.call = function (e, t) {
        return t.subscribe(new a(e, this.nextOrObserver, this.error, this.complete));
      }, DoOperator;
    }(),
        a = function (e) {
      function DoSubscriber(t, n, r, o) {
        e.call(this, t);
        var a = new i.Subscriber(n, r, o);
        a.syncErrorThrowable = !0, this.add(a), this.safeSubscriber = a;
      }

      return r(DoSubscriber, e), DoSubscriber.prototype._next = function (e) {
        var t = this.safeSubscriber;
        t.next(e), t.syncErrorThrown ? this.destination.error(t.syncErrorValue) : this.destination.next(e);
      }, DoSubscriber.prototype._error = function (e) {
        var t = this.safeSubscriber;
        t.error(e), t.syncErrorThrown ? this.destination.error(t.syncErrorValue) : this.destination.error(e);
      }, DoSubscriber.prototype._complete = function () {
        var e = this.safeSubscriber;
        e.complete(), e.syncErrorThrown ? this.destination.error(e.syncErrorValue) : this.destination.complete();
      }, DoSubscriber;
    }(i.Subscriber);
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(99);
    r.Observable.prototype.mapTo = i.mapTo;
  }, function (e, t, n) {
    "use strict";

    var r = n(100);

    t.mapTo = function mapTo(e) {
      return r.mapTo(e)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13);

    t.mapTo = function mapTo(e) {
      return function (t) {
        return t.lift(new o(e));
      };
    };

    var o = function () {
      function MapToOperator(e) {
        this.value = e;
      }

      return MapToOperator.prototype.call = function (e, t) {
        return t.subscribe(new a(e, this.value));
      }, MapToOperator;
    }(),
        a = function (e) {
      function MapToSubscriber(t, n) {
        e.call(this, t), this.value = n;
      }

      return r(MapToSubscriber, e), MapToSubscriber.prototype._next = function (e) {
        this.destination.next(this.value);
      }, MapToSubscriber;
    }(i.Subscriber);
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(102);
    r.Observable.prototype.first = i.first;
  }, function (e, t, n) {
    "use strict";

    var r = n(103);

    t.first = function first(e, t, n) {
      return r.first(e, t, n)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = n(13),
        o = n(104);

    t.first = function first(e, t, n) {
      return function (r) {
        return r.lift(new a(e, t, n, r));
      };
    };

    var a = function () {
      function FirstOperator(e, t, n, r) {
        this.predicate = e, this.resultSelector = t, this.defaultValue = n, this.source = r;
      }

      return FirstOperator.prototype.call = function (e, t) {
        return t.subscribe(new s(e, this.predicate, this.resultSelector, this.defaultValue, this.source));
      }, FirstOperator;
    }(),
        s = function (e) {
      function FirstSubscriber(t, n, r, i, o) {
        e.call(this, t), this.predicate = n, this.resultSelector = r, this.defaultValue = i, this.source = o, this.index = 0, this.hasCompleted = !1, this._emitted = !1;
      }

      return r(FirstSubscriber, e), FirstSubscriber.prototype._next = function (e) {
        var t = this.index++;
        this.predicate ? this._tryPredicate(e, t) : this._emit(e, t);
      }, FirstSubscriber.prototype._tryPredicate = function (e, t) {
        var n;

        try {
          n = this.predicate(e, t, this.source);
        } catch (r) {
          return void this.destination.error(r);
        }

        n && this._emit(e, t);
      }, FirstSubscriber.prototype._emit = function (e, t) {
        this.resultSelector ? this._tryResultSelector(e, t) : this._emitFinal(e);
      }, FirstSubscriber.prototype._tryResultSelector = function (e, t) {
        var n;

        try {
          n = this.resultSelector(e, t);
        } catch (r) {
          return void this.destination.error(r);
        }

        this._emitFinal(n);
      }, FirstSubscriber.prototype._emitFinal = function (e) {
        var t = this.destination;
        this._emitted || (this._emitted = !0, t.next(e), t.complete(), this.hasCompleted = !0);
      }, FirstSubscriber.prototype._complete = function () {
        var e = this.destination;
        this.hasCompleted || "undefined" === typeof this.defaultValue ? this.hasCompleted || e.error(new o.EmptyError()) : (e.next(this.defaultValue), e.complete());
      }, FirstSubscriber;
    }(i.Subscriber);
  }, function (e, t, n) {
    "use strict";

    var r = this && this.__extends || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      function __() {
        this.constructor = e;
      }

      e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    },
        i = function (e) {
      function EmptyError() {
        var t = e.call(this, "no elements in sequence");
        this.name = t.name = "EmptyError", this.stack = t.stack, this.message = t.message;
      }

      return r(EmptyError, e), EmptyError;
    }(Error);

    t.EmptyError = i;
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(106);
    r.Observable.prototype.pluck = i.pluck;
  }, function (e, t, n) {
    "use strict";

    var r = n(107);

    t.pluck = function pluck() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t - 0] = arguments[t];
      }

      return r.pluck.apply(void 0, e)(this);
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(39);

    t.pluck = function pluck() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t - 0] = arguments[t];
      }

      var n = e.length;
      if (0 === n) throw new Error("list of properties cannot be empty.");
      return function (t) {
        return r.map(function plucker(e, t) {
          return function mapper(n) {
            for (var r = n, i = 0; i < t; i++) {
              var o = r[e[i]];
              if ("undefined" === typeof o) return;
              r = o;
            }

            return r;
          };
        }(e, n))(t);
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(9),
        i = n(109);
    r.Observable.empty = i.empty;
  }, function (e, t, n) {
    "use strict";

    var r = n(27);
    t.empty = r.EmptyObservable.create;
  }, function (e, t) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var r = new Uint8Array(16);

      e.exports = function whatwgRNG() {
        return n(r), r;
      };
    } else {
      var i = new Array(16);

      e.exports = function mathRNG() {
        for (var e, t = 0; t < 16; t++) {
          0 === (3 & t) && (e = 4294967296 * Math.random()), i[t] = e >>> ((3 & t) << 3) & 255;
        }

        return i;
      };
    }
  }, function (e, t) {
    for (var n = [], r = 0; r < 256; ++r) {
      n[r] = (r + 256).toString(16).substr(1);
    }

    e.exports = function bytesToUuid(e, t) {
      var r = t || 0,
          i = n;
      return [i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]]].join("");
    };
  }, function (e, t, n) {
    var r = n(113);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".agent-status-toggle-container {\n  border-top: 1px solid var(--color-p1-4);\n  padding: 10px 0px;\n  padding-left: 8px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;AACnB",
      file: "styles.css",
      sourcesContent: [".agent-status-toggle-container {\n  border-top: 1px solid var(--color-p1-4);\n  padding: 10px 0px;\n  padding-left: 8px;\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = i.getIsVideoUserOnly(n),
          s = i.getIsOrgAdmin(n),
          c = i.getIsCalendarUser(n, o),
          l = i.getIsBotsV2User(o),
          u = i.getConversationFreeOrg(o);
      return t = r.set(r.lensProp("isVideoUserOnly"), a, t), t = a ? r.set(r.lensProp("mySlicesHeaderCopy"), "My Video Conversations", t) : c ? r.set(r.lensProp("mySlicesHeaderCopy"), "My Meeting Conversations", t) : r.set(r.lensProp("mySlicesHeaderCopy"), "My Open Conversations", t), a || c ? (t = r.set(r.lensProp("hasFilteredConversationsList"), !1, t), t = r.set(r.lensProp("hasAbm"), !!o.ABM, t), t = r.set(r.lensProp("hasTargetSlice"), !1, t), t = r.set(r.lensProp("hasLiveSlice"), !1, t), t = r.set(r.lensProp("hideMyConversationsSliceWhenEmpty"), !0, t), t = a ? r.set(r.lensProp("hasClosedOnlySlice"), !0, t) : r.set(r.lensProp("hasClosedOnlySlice"), !1, t)) : (t = r.set(r.lensProp("hasFilteredConversationsList"), !0, t), t = r.set(r.lensProp("hasAbm"), !!o.ABM, t), t = r.set(r.lensProp("hasTargetSlice"), !!o.ABM && !!o.has_visitor_presence && !!o.has_target_slice, t), t = r.set(r.lensProp("hasLiveSlice"), !!o.has_inbox_visitor_presence, t), t = r.set(r.lensProp("hasClosedOnlySlice"), !1, t), t = r.set(r.lensProp("hideMyConversationsSliceWhenEmpty"), !1, t)), c ? (t = r.set(r.lensProp("hasComposer"), !1, t), t = r.set(r.lensProp("hasMeetingsInComposer"), !1, t)) : a ? (t = r.set(r.lensProp("hasComposer"), !0, t), t = r.set(r.lensProp("hasMeetingsInComposer"), !1, t)) : (t = r.set(r.lensProp("hasComposer"), !0, t), t = r.set(r.lensProp("hasMeetingsInComposer"), !0, t)), t = r.set(r.lensProp("hasConversationStatusDropdown"), !c, t), a ? (t = r.set(r.lensProp("hasCloseAndLeaveStatusOption"), !1, t), t = r.set(r.lensProp("statusOptions"), ["OPEN", "CLOSED"], t)) : (t = r.set(r.lensProp("hasCloseAndLeaveStatusOption"), !0, t), t = r.set(r.lensProp("statusOptions"), ["OPEN", "PENDING", "CLOSED"], t)), t = r.set(r.lensProp("hasAgentStatusTray"), !(a || c), t), t = r.set(r.lensProp("hasDriftAvailability"), !(a || c), t), t = r.set(r.lensProp("hasWidgetInstallBanner"), !(a || c), t), t = r.set(r.lensProp("hasWhatsNewBanner"), !a, t), t = r.set(r.lensProp("hasEnabledLinkedInSalesNavigator"), !a, t), a || c ? (t = r.set(r.lensProp("hasHyperlinkedContactName"), !1, t), t = r.set(r.lensProp("hasLeadActions"), !1, t)) : (t = r.set(r.lensProp("hasHyperlinkedContactName"), !0, t), t = r.set(r.lensProp("hasLeadActions"), !0, t)), t = r.set(r.lensProp("hasFullActivityTimelineButton"), !a, t), t = r.set(r.lensProp("showSubnav"), !!o.has_insights && s, t), t = a || l || u || c ? r.set(r.lensProp("hasNotifications"), !1, t) : r.set(r.lensProp("hasNotifications"), !0, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = e.roles,
          s = i.getIsReportingUser(a),
          c = i.getIsPlaybooksUser(a),
          l = i.getIsVideoUserOnly(n),
          u = i.getIsCalendarUser(n, o),
          p = i.getIsBotsV2User(o),
          f = !!o.saved_replies,
          d = !!o.premium_drift || !!o.premium_team || !!o.premium_enterprise,
          h = !!o.premium_enterprise || !!o.has_beta_team_view,
          m = i.getIsOrgAdmin(n),
          g = m && !!o.beta_bulk_close,
          A = m && !!o.premium_enterprise,
          v = m && !!o.premium_enterprise,
          b = m && i.isProOrAboveOrg(o);
      return p || l || s || c ? (t = r.set(r.lensProp("hasProfile"), !1, t), t = r.set(r.lensProp("hasDriftAssistant"), !1, t)) : (t = r.set(r.lensProp("hasProfile"), !0, t), t = r.set(r.lensProp("hasDriftAssistant"), !0, t)), l || u || p || s || c ? (t = r.set(r.lensProp("hasNotifications"), !1, t), t = r.set(r.lensProp("hasEmail"), !1, t)) : (t = r.set(r.lensProp("hasNotifications"), !0, t), t = r.set(r.lensProp("hasEmail"), !0, t)), t = l || c || s ? r.set(r.lensProp("hasMeetings"), !1, t) : r.set(r.lensProp("hasMeetings"), !p, t), t = r.set(r.lensProp("hasBilling"), !p, t), t = r.set(r.lensProp("hasManageTeammates"), !p, t), t = r.set(r.lensProp("hasTeams"), h, t), t = r.set(r.lensProp("hasDataPrivacy"), !p, t), t = r.set(r.lensProp("hasSecurity"), !p, t), t = r.set(r.lensProp("hasWidget"), !p, t), t = r.set(r.lensProp("hasConvoRouting"), !p, t), t = r.set(r.lensProp("hasBot"), !p, t), p ? (t = r.set(r.lensProp("hasSavedReplies"), !1, t), t = r.set(r.lensProp("hasEmailSendingDomains"), !0, t), t = r.set(r.lensProp("hasBulkClose"), !1, t), t = r.set(r.lensProp("hasRerouteConversations"), !1, t), t = r.set(r.lensProp("hasLimitChatsForReps"), !1, t), t = r.set(r.lensProp("hasSessionIntegrationSync"), !1, t)) : (t = r.set(r.lensProp("hasSavedReplies"), f, t), t = r.set(r.lensProp("hasEmailSendingDomains"), d, t), t = r.set(r.lensProp("hasBulkClose"), g, t), t = r.set(r.lensProp("hasRerouteConversations"), A, t), t = r.set(r.lensProp("hasLimitChatsForReps"), v, t), t = r.set(r.lensProp("hasSessionIntegrationSync"), b, t)), t = r.set(r.lensProp("hasTags"), !p, t), t = r.set(r.lensProp("hasEmailPreferencesLink"), !p, t), t = r.set(r.lensProp("hasInboxes"), !p, t), t = r.set(r.lensProp("hasAdvanced"), !p && m, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = e.roles,
          s = i.getIsReportingUser(a),
          c = i.getIsPlaybooksUser(a),
          l = i.getIsVideoUserOnly(n),
          u = i.getIsCalendarUser(n, o),
          p = i.getIsBotsV2User(o),
          f = i.getIsOrgAdmin(n),
          d = r.pathOr(!1, ["has_public_shipyard"], o),
          h = i.getConversationFreeOrg(o);
      return l || p ? (t = r.set(r.lensProp("hasShipyard"), !1, t), t = r.set(r.lensProp("hasProfile"), !1, t)) : t = r.set(r.lensProp("hasShipyard"), d, t), t = l || p || h || u || c || s ? r.set(r.lensProp("hasNotifications"), !1, t) : r.set(r.lensProp("hasNotifications"), !0, t), t = l || u || p || s || c ? r.set(r.lensProp("hasAgentStatus"), !1, t) : r.set(r.lensProp("hasAgentStatus"), !0, t), t = p ? r.set(r.lensProp("hasDriftStatus"), !1, t) : r.set(r.lensProp("hasDriftStatus"), f, t), t = r.set(r.lensProp("hasDevPlatformSwitch"), !p, t), t = r.set(r.lensProp("hasInsiderSwitch"), !p, t), t = r.set(r.lensProp("hasVideoSwitch"), !p, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = e.roles,
          s = i.getIsOrgAdmin(n),
          c = i.getIsReportingUser(a);
      return t = r.set(r.lensProp("hasInsights"), !!o.has_insights && (s || c), t), t = r.set(r.lensProp("hasSavedSearches"), !!o.enterprise_04_2018, t), t = r.set(r.lensProp("hasYearHistory"), !!o.premium_enterprise || !!o.enterprise_04_2018, t), t = r.set(r.lensProp("insightsBeta"), !!o.insights_beta, t), t = r.set(r.lensProp("insightsFeatureBeta"), !!o.insights_feature_beta, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.gates,
          o = i.getIsBotsV2User(n),
          a = r.pathOr(!1, ["marketo_prompt_upgrade"], n);
      return t = r.set(r.lensProp("hasEnrollInSequence"), !o, t), t = r.set(r.lensProp("hasSendMessageButton"), !o, t), t = r.set(r.lensProp("hasAccountsSubNav"), !o, t), t = r.set(r.lensProp("hasLiveViewSubNav"), !o, t), t = o ? r.set(r.lensProp("hasMarketoAccess"), !0, t) : r.set(r.lensProp("hasMarketoAccess"), !a, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = (e.id, e.createdAt, e.createdAt > 15759828e5);
      return t = r.set(r.lensProp("hasMarketingEmailPlaybooks"), !n, t), t = r.set(r.lensProp("hasSalesSequencePlaybooks"), !n, t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = i.getIsCalendarUser(n, o),
          s = i.isStandardOrAboveOrg(o) && !a,
          c = i.isProOrAboveOrg(o) && !a,
          l = i.getIsOrgAdmin(n) && !a,
          u = i.isFreeOrg(o) && !a,
          p = !!o.saved_replies;
      return t = r.set(r.lensProp("hasSavedReplies"), s || p, t), t = r.set(r.lensProp("hasInviteTeammates"), s, t), t = r.set(r.lensProp("hasSFCardInSidebar"), c, t), t = r.set(r.lensProp("hasAutosyncToSFDCToggle"), c, t), t = r.set(r.lensProp("hasInternalNotes"), s, t), t = r.set(r.lensProp("hasLeaveConversation"), s, t), t = r.set(r.lensProp("hasProspectingView"), s, t), t = r.set(r.lensProp("hasOptOutOfNewExperience"), s, t), t = r.set(r.lensProp("hasAgentAvailability"), !a, t), t = r.set(r.lensProp("hasNotificationSettings"), !a, t), t = r.set(r.lensProp("hasSearch"), !a, t), t = r.set(r.lensProp("hasReplyToConversation"), !a, t), t = r.set(r.lensProp("hasEditableEndUserAttributes"), !a, t), t = r.set(r.lensProp("hasAbilityToTag"), !a, t), t = r.set(r.lensProp("hasViewActivityTimeline"), !a, t), t = r.set(r.lensProp("hasEditableSavedReplies"), !a && !u, t), t = r.set(r.lensProp("hasShowAllConversationsInSidebar"), u, t), t = r.set(r.lensProp("hasRemoveParticipantFromConversation"), l, t), t = r.set(r.lensProp("hasInstallWidget"), l, t), t = r.set(r.lensProp("hasEditableTags"), l, t), t = r.set(r.lensProp("hasCalendarRouting"), i.hasCalendarRouting(o), t);
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;
    var r = n(3),
        i = n(18);

    t.default = function generateAppConfig(e) {
      var t = {},
          n = e.scopes,
          o = e.gates,
          a = e.roles,
          s = i.getIsOrgAdmin(n),
          c = i.getIsPlaybooksUser(a);
      return t = r.set(r.lensProp("hasAutomation"), !!o.has_automation && (s || c), t);
    };
  }, function (e, t, n) {
    var r = n(123);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".drift-status-flyout {\n  position: absolute;\n  left: 55px;\n  bottom: 0;\n  z-index: 100;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid var(--color-p1-4);\n  display: block;\n  box-shadow: var(--box-shadow-3);\n  width: 268px;\n  max-width: 268px;\n}\n\n.drift-status-flyout a,\n.drift-status-flyout span {\n  text-align: left;\n  background: none;\n  text-decoration: none;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.drift-status-options-wrapper a,\n.drift-status-options-wrapper span {\n  font-size: var(--font-size-small);\n  font-family: var(--main-font-family);\n  color: var(--color-p1-10);\n}\n\n.drift-status-options-wrapper {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n  margin: 0px 8px;\n}\n\n.drift-status-options-wrapper .tide-button {\n  padding: 6px 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.drift-status-options-wrapper .tide-nav button:first-child {\n  margin-top: 6px;\n}\n\n.drift-status-options-wrapper .tide-nav button:last-child {\n  margin-bottom: 6px;\n}\n\n.drift-status-flyout p {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin: 0;\n}\n\n.agent-status-flyout-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 15px 5px 15px;\n  cursor: auto;\n  position: relative;\n}\n\n.agent-status-flyout-header-container {\n  width: 100%;\n}\n\n.agent-status-flyout-header-container .user-avatar-container {\n  margin-top: -50px;\n}\n\n.agent-status-flyout-header-name {\n  color: var(--color-p1-9);\n  display: block;\n  max-width: 10rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 18px;\n  margin: 8px 0 0 0;\n}\n\n.agent-status-flyout-header-container .tide-heading + .tide-paragraph {\n  margin-top: 0px;\n}\n\n.agent-status-flyout-header-container .agent-status-flyout-profile-url {\n  display: block;\n  max-width: 10rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-6);\n  padding: 0 0 4px 0;\n}\n\n.drift-status-options-wrapper > nav {\n  padding: 0 0 2px 0;\n  border-top: 1px solid var(--color-p1-4);\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.agent-status-flyout-settings-nav-link {\n  font-size: var(--font-size-small);\n  margin-left: 5px;\n  color: var(--color-p1-10);\n}\n\n.drift-status-options-wrapper a:first-child {\n  padding-top: 12px;\n}\n\n.agent-flyout-link-container svg:hover {\n  cursor: pointer;\n}\n\n.agent-flyout-link-container svg:hover + .agent-status-flyout-settings-nav-link {\n  color: var(--color-p3);\n}\n\n.agent-flyout-status-logo {\n  margin-left: 3px;\n}\n\n.agent-flyout-status-logo > span {\n  margin-left: 8px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 6px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 7px;\n}\n\n.agent-flyout-notification-logo > span {\n  margin-left: 12px;\n}\n\n.agent-flyout-admin-panel {\n  margin-left: 4px;\n}\n\n.agent-flyout-admin-panel > span {\n  margin-left: 9px;\n}\n\n.agent-status-flyout-settings-nav-action {\n  padding-bottom: 15px;\n  padding-top: 10px;\n}\n\n.agent-status-section {\n  margin-left: 15px;\n}\n\n.agent-status-section .agent-status-flyout-settings-nav-action {\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-6);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B",
      file: "style.css",
      sourcesContent: [".drift-status-flyout {\n  position: absolute;\n  left: 55px;\n  bottom: 0;\n  z-index: 100;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid var(--color-p1-4);\n  display: block;\n  box-shadow: var(--box-shadow-3);\n  width: 268px;\n  max-width: 268px;\n}\n\n.drift-status-flyout a,\n.drift-status-flyout span {\n  text-align: left;\n  background: none;\n  text-decoration: none;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.drift-status-options-wrapper a,\n.drift-status-options-wrapper span {\n  font-size: var(--font-size-small);\n  font-family: var(--main-font-family);\n  color: var(--color-p1-10);\n}\n\n.drift-status-options-wrapper {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n  margin: 0px 8px;\n}\n\n.drift-status-options-wrapper .tide-button {\n  padding: 6px 8px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.drift-status-options-wrapper .tide-nav button:first-child {\n  margin-top: 6px;\n}\n\n.drift-status-options-wrapper .tide-nav button:last-child {\n  margin-bottom: 6px;\n}\n\n.drift-status-flyout p {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin: 0;\n}\n\n.agent-status-flyout-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 15px 5px 15px;\n  cursor: auto;\n  position: relative;\n}\n\n.agent-status-flyout-header-container {\n  width: 100%;\n}\n\n.agent-status-flyout-header-container .user-avatar-container {\n  margin-top: -50px;\n}\n\n.agent-status-flyout-header-name {\n  color: var(--color-p1-9);\n  display: block;\n  max-width: 10rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 18px;\n  margin: 8px 0 0 0;\n}\n\n.agent-status-flyout-header-container .tide-heading + .tide-paragraph {\n  margin-top: 0px;\n}\n\n.agent-status-flyout-header-container .agent-status-flyout-profile-url {\n  display: block;\n  max-width: 10rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-6);\n  padding: 0 0 4px 0;\n}\n\n.drift-status-options-wrapper > nav {\n  padding: 0 0 2px 0;\n  border-top: 1px solid var(--color-p1-4);\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.agent-status-flyout-settings-nav-link {\n  font-size: var(--font-size-small);\n  margin-left: 5px;\n  color: var(--color-p1-10);\n}\n\n.drift-status-options-wrapper a:first-child {\n  padding-top: 12px;\n}\n\n.agent-flyout-link-container svg:hover {\n  cursor: pointer;\n}\n\n.agent-flyout-link-container svg:hover + .agent-status-flyout-settings-nav-link {\n  color: var(--color-p3);\n}\n\n.agent-flyout-status-logo {\n  margin-left: 3px;\n}\n\n.agent-flyout-status-logo > span {\n  margin-left: 8px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 6px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 7px;\n}\n\n.agent-flyout-notification-logo > span {\n  margin-left: 12px;\n}\n\n.agent-flyout-admin-panel {\n  margin-left: 4px;\n}\n\n.agent-flyout-admin-panel > span {\n  margin-left: 9px;\n}\n\n.agent-status-flyout-settings-nav-action {\n  padding-bottom: 15px;\n  padding-top: 10px;\n}\n\n.agent-status-section {\n  margin-left: 15px;\n}\n\n.agent-status-section .agent-status-flyout-settings-nav-action {\n  font-size: var(--font-size-copy);\n  color: var(--color-p1-6);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(125);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".main-navigation .navigation-status-section .new-agent-status {\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator-no-notifications svg {\n  width: 19px;\n  height: 18px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  bottom: -2px;\n  left: 24px;\n  margin: 0;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator svg {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  left: 0;\n  bottom: 0;\n}\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar {\n  padding: 4px;\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-image-placeholder {\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-image-placeholder {\n  height: 32px;\n  width: 32px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,OAAO;EACP,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;AACb",
      file: "style.css",
      sourcesContent: [".main-navigation .navigation-status-section .new-agent-status {\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator-no-notifications svg {\n  width: 19px;\n  height: 18px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  bottom: -2px;\n  left: 24px;\n  margin: 0;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator svg {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  left: 0;\n  bottom: 0;\n}\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar {\n  padding: 4px;\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-image-placeholder {\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-image-placeholder {\n  height: 32px;\n  width: 32px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(127);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".upgrade-status-bar {\n  padding: 0px;\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .upgrade-status-bar > span {\n  position: absolute;\n  left: 9px;\n  bottom: 6px;\n}\n\n.upgrade-status-bar > span svg {\n  width: 15px;\n  margin: 0 auto;\n  display: block;\n}\n\n.upgrade-status-bar > span svg path {\n  fill: var(--color-s1-4);\n}\n\n.upgrade-pop-over {\n  position: absolute;\n  bottom: 0;\n  left: 60px;\n  z-index: 100;\n  background: #fff;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  border-radius: 5px;\n  padding: 15px;\n  width: 230px;\n}\n\n.upgrade-pop-over h3 {\n  margin: 0;\n  color: var(--color-p1-9);\n}\n\n.upgrade-pop-over p {\n  color: var(--color-p1-7);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.upgrade-pop-over a {\n  width: 100%;\n}\n\n.upgrade-button-cta {\n  width: 100%;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb",
      file: "style.css",
      sourcesContent: [".upgrade-status-bar {\n  padding: 0px;\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .upgrade-status-bar > span {\n  position: absolute;\n  left: 9px;\n  bottom: 6px;\n}\n\n.upgrade-status-bar > span svg {\n  width: 15px;\n  margin: 0 auto;\n  display: block;\n}\n\n.upgrade-status-bar > span svg path {\n  fill: var(--color-s1-4);\n}\n\n.upgrade-pop-over {\n  position: absolute;\n  bottom: 0;\n  left: 60px;\n  z-index: 100;\n  background: #fff;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  border-radius: 5px;\n  padding: 15px;\n  width: 230px;\n}\n\n.upgrade-pop-over h3 {\n  margin: 0;\n  color: var(--color-p1-9);\n}\n\n.upgrade-pop-over p {\n  color: var(--color-p1-7);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.upgrade-pop-over a {\n  width: 100%;\n}\n\n.upgrade-button-cta {\n  width: 100%;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(129);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".nav-help-tooltip {\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n}\n\n.nav-help-flyout {\n  position: absolute;\n  left: 48px;\n  bottom: 0px;\n  z-index: 100;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid var(--main-navy-light);\n  display: block;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  width: 200px;\n  padding: 12px 8px 12px 8px;\n}\n\n.nav-help-flyout a {\n  text-align: left;\n  background: none;\n  text-decoration: none;\n}\n\n.nav-help-options-last {\n  margin-bottom: 16px;\n}\n\n.nav-help-flyout-options a,\n.nav-help-flyout-options span {\n  font-size: 14px;\n  color: var(--color-p1-10);\n  display: inline-block;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.nav-help-options-window-icon {\n  margin: 0 0.5px;\n  width: 13px;\n  height: 14px;\n}\n\n.nav-help-options-lightning-icon {\n  margin: 0 3.5px;\n  width: 7px;\n  height: 12px;\n}\n\n.nav-help-options-comments-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.nav-help-options-question-icon {\n  width: 14px;\n  height: 13px;\n}\n\n.nav-help-options-support-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.nav-help-flyout-options {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.nav-help-flyout-option-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.nav-help-flyout-option-item:last-of-type {\n  margin-bottom: 0px;\n}\n\n.nav-help-flyout h4 {\n  margin-bottom: 8px;\n  display: inline-block;\n  font-size: var(--font-size-small);\n  color: var(--color-p1-10);\n  padding-left: 8px;\n  margin-top: 0;\n}\n\n.nav-help-flyout .widget-status-toggle {\n  border-top: 1px solid var(--main-navy-light);\n  border-bottom: 1px solid var(--main-navy-light);\n  width: calc(100% - 30px);\n  padding: 15px 0;\n  margin: 0 auto;\n}\n\n.nav-help-flyout .tide-button {\n  padding-bottom: 8px;\n}\n\n.nav-help-flyout .nav-help-flyout-options nav button:last-child {\n  padding-bottom: 0;\n}\n\n.nav-help-flyout .widget-status-toggle strong {\n  font-family: var(--main-font-family--bold);\n}\n\n.nav-help-flyout .widget-status-toggle:active {\n  background: none;\n  outline: none;\n}\n\n.nav-help-flyout-options a:hover,\n.nav-help-flyout-options span:hover {\n  cursor: pointer;\n}\n\n.nav-help-wrapper {\n  position: relative;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,2CAA2C;EAC3C,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;EAC/C,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".nav-help-tooltip {\n  text-align: center;\n  padding: 0;\n  cursor: pointer;\n}\n\n.nav-help-flyout {\n  position: absolute;\n  left: 48px;\n  bottom: 0px;\n  z-index: 100;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid var(--main-navy-light);\n  display: block;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  width: 200px;\n  padding: 12px 8px 12px 8px;\n}\n\n.nav-help-flyout a {\n  text-align: left;\n  background: none;\n  text-decoration: none;\n}\n\n.nav-help-options-last {\n  margin-bottom: 16px;\n}\n\n.nav-help-flyout-options a,\n.nav-help-flyout-options span {\n  font-size: 14px;\n  color: var(--color-p1-10);\n  display: inline-block;\n  transition: all 0.3s ease;\n}\n\n.nav-help-options-window-icon {\n  margin: 0 0.5px;\n  width: 13px;\n  height: 14px;\n}\n\n.nav-help-options-lightning-icon {\n  margin: 0 3.5px;\n  width: 7px;\n  height: 12px;\n}\n\n.nav-help-options-comments-icon {\n  width: 14px;\n  height: 12px;\n}\n\n.nav-help-options-question-icon {\n  width: 14px;\n  height: 13px;\n}\n\n.nav-help-options-support-icon {\n  width: 14px;\n  height: 14px;\n}\n\n.nav-help-flyout-options {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.nav-help-flyout-option-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.nav-help-flyout-option-item:last-of-type {\n  margin-bottom: 0px;\n}\n\n.nav-help-flyout h4 {\n  margin-bottom: 8px;\n  display: inline-block;\n  font-size: var(--font-size-small);\n  color: var(--color-p1-10);\n  padding-left: 8px;\n  margin-top: 0;\n}\n\n.nav-help-flyout .widget-status-toggle {\n  border-top: 1px solid var(--main-navy-light);\n  border-bottom: 1px solid var(--main-navy-light);\n  width: calc(100% - 30px);\n  padding: 15px 0;\n  margin: 0 auto;\n}\n\n.nav-help-flyout .tide-button {\n  padding-bottom: 8px;\n}\n\n.nav-help-flyout .nav-help-flyout-options nav button:last-child {\n  padding-bottom: 0;\n}\n\n.nav-help-flyout .widget-status-toggle strong {\n  font-family: var(--main-font-family--bold);\n}\n\n.nav-help-flyout .widget-status-toggle:active {\n  background: none;\n  outline: none;\n}\n\n.nav-help-flyout-options a:hover,\n.nav-help-flyout-options span:hover {\n  cursor: pointer;\n}\n\n.nav-help-wrapper {\n  position: relative;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(131);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper,\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper > div:first-child {\n  height: 100%;\n  text-align: center;\n  width: 100%;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  align-items: center;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: 100%;\n  text-decoration: none;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container {\n  background-color: var(--color-p1-6);\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 3px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container > div {\n  background-color: var(--color-p1-2);\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed {\n  color: var(--color-p1-5);\n  font-size: 10px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed-number {\n  font-family: var(--main-font-family--bold);\n  font-size: 16px;\n}\n\n/* Tooltip */\n.nav-status-item.nav-status-item-onboarding .tide-tooltip {\n  width: 152px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-tooltip-content {\n  text-align: left;\n}\n\n.nav-onboarding-tooltip-progressbar-container {\n  background-color: var(--color-p1-6);\n  border-radius: 2px;\n  height: 8px;\n  margin: 4px 0 16px 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.nav-onboarding-tooltip-progressbar-container > div {\n  background-color: var(--color-p1-2);\n  border-radius: 2px;\n  height: 8px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title {\n  color: var(--color-p1-2);\n  margin-top: 0;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title + .nav-onboarding-tooltip-title {\n  margin-top: 6px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-copy {\n  color: var(--color-p1-2);\n  margin-bottom: 16px;\n}\n\n.nav-onboarding-get-started-tooltip-container .tide-tethered-tooltip-header {\n  margin-top: 8px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB",
      file: "style.css",
      sourcesContent: [".nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper,\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper > div:first-child {\n  height: 100%;\n  text-align: center;\n  width: 100%;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  align-items: center;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  height: 100%;\n  text-decoration: none;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container {\n  background-color: var(--color-p1-6);\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 3px;\n  overflow: hidden;\n  width: 100%;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container > div {\n  background-color: var(--color-p1-2);\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n  height: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed {\n  color: var(--color-p1-5);\n  font-size: 10px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed-number {\n  font-family: var(--main-font-family--bold);\n  font-size: 16px;\n}\n\n/* Tooltip */\n.nav-status-item.nav-status-item-onboarding .tide-tooltip {\n  width: 152px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-tooltip-content {\n  text-align: left;\n}\n\n.nav-onboarding-tooltip-progressbar-container {\n  background-color: var(--color-p1-6);\n  border-radius: 2px;\n  height: 8px;\n  margin: 4px 0 16px 0;\n  overflow: hidden;\n  width: 100%;\n}\n\n.nav-onboarding-tooltip-progressbar-container > div {\n  background-color: var(--color-p1-2);\n  border-radius: 2px;\n  height: 8px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title {\n  color: var(--color-p1-2);\n  margin-top: 0;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title + .nav-onboarding-tooltip-title {\n  margin-top: 6px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-copy {\n  color: var(--color-p1-2);\n  margin-bottom: 16px;\n}\n\n.nav-onboarding-get-started-tooltip-container .tide-tethered-tooltip-header {\n  margin-top: 8px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(133);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".hide-shipyard {\n  display: none;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;AACf",
      file: "style.css",
      sourcesContent: [".hide-shipyard {\n  display: none;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(135);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".app-link-container {\n  display: inline-block;\n  margin: 0 30px;\n  width: 100%;\n}\n\n.app-link-entry {\n  height: 45px;\n  display: flex;\n  align-items: center;\n}\n\n.app-link-entry:hover {\n  cursor: pointer;\n}\n\n.app-link-entry > .tide-icon > path {\n  fill: var(--color-p1-10);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B",
      file: "style.css",
      sourcesContent: [".app-link-container {\n  display: inline-block;\n  margin: 0 30px;\n  width: 100%;\n}\n\n.app-link-entry {\n  height: 45px;\n  display: flex;\n  align-items: center;\n}\n\n.app-link-entry:hover {\n  cursor: pointer;\n}\n\n.app-link-entry > .tide-icon > path {\n  fill: var(--color-p1-10);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(137);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".org-switcher {\n  margin: 0;\n  padding: 0 0 15px 42px;\n}\n\n.org-switcher .tide-heading + .tide-paragraph {\n  margin-top: -5px;\n}\n\n.org-switcher .organization-info-container:hover {\n  cursor: pointer;\n}\n\n.org-switcher .organization-info-container:hover .organization-global-name {\n  color: var(--color-p3-8);\n}\n\n.org-switcher .org-switcher-header {\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.3px;\n  padding-bottom: 5px;\n}\n\n.org-switcher .org-switcher-provision {\n  margin-top: 10px;\n  font-size: var(--font-size-subtle);\n  display: inherit;\n}\n\n.org-switcher .org-switcher-increment {\n  font-size: var(--font-size-subtle);\n  display: inline-block;\n}\n\n.org-switcher .org-switcher-increment:first-of-type {\n  margin-top: 8px;\n  margin-right: 60px;\n}\n\n.org-switcher .org-switcher-increment:last-of-type {\n  display: inherit;\n  padding-bottom: 20px;\n}\n\n.organization-info-container .organization-global-name  {\n  margin: 0;\n  padding: 0;\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 150px;\n  overflow: hidden;\n  display: block;\n}\n\n.organization-info-container .organization-logo {\n  margin-top: 3px;\n  border-radius: 3px;\n}\n\n.organization-info-container .organization-access-right {\n  margin: -5px 0 0 0;\n  padding: 0;\n  width: 140px;\n  font-size: var(--font-size-subtle);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.organization-info-container {\n  display: flex;\n  margin: 0px;\n}\n\n.organization-info-container div:not(:first-child) {\n  margin-left: 10px;\n}\n\n.org-switcher .organization-info-container.active {\n  position: relative;\n  padding-left: 12px;\n  margin-left: -12px;\n}\n\n.org-switcher .organization-info-container.active:after {\n  content: '';\n  background: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  height: 25px;\n  width: 2px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,UAAU;AACZ",
      file: "styles.css",
      sourcesContent: [".org-switcher {\n  margin: 0;\n  padding: 0 0 15px 42px;\n}\n\n.org-switcher .tide-heading + .tide-paragraph {\n  margin-top: -5px;\n}\n\n.org-switcher .organization-info-container:hover {\n  cursor: pointer;\n}\n\n.org-switcher .organization-info-container:hover .organization-global-name {\n  color: var(--color-p3-8);\n}\n\n.org-switcher .org-switcher-header {\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.3px;\n  padding-bottom: 5px;\n}\n\n.org-switcher .org-switcher-provision {\n  margin-top: 10px;\n  font-size: var(--font-size-subtle);\n  display: inherit;\n}\n\n.org-switcher .org-switcher-increment {\n  font-size: var(--font-size-subtle);\n  display: inline-block;\n}\n\n.org-switcher .org-switcher-increment:first-of-type {\n  margin-top: 8px;\n  margin-right: 60px;\n}\n\n.org-switcher .org-switcher-increment:last-of-type {\n  display: inherit;\n  padding-bottom: 20px;\n}\n\n.organization-info-container .organization-global-name  {\n  margin: 0;\n  padding: 0;\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 150px;\n  overflow: hidden;\n  display: block;\n}\n\n.organization-info-container .organization-logo {\n  margin-top: 3px;\n  border-radius: 3px;\n}\n\n.organization-info-container .organization-access-right {\n  margin: -5px 0 0 0;\n  padding: 0;\n  width: 140px;\n  font-size: var(--font-size-subtle);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.organization-info-container {\n  display: flex;\n  margin: 0px;\n}\n\n.organization-info-container div:not(:first-child) {\n  margin-left: 10px;\n}\n\n.org-switcher .organization-info-container.active {\n  position: relative;\n  padding-left: 12px;\n  margin-left: -12px;\n}\n\n.org-switcher .organization-info-container.active:after {\n  content: '';\n  background: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  height: 25px;\n  width: 2px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(139);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".find-your-team-email {\n  padding-top: 0;\n}\n\n.find-team-verification-form > button {\n   margin-top: 10px;\n   width: 100%;\n}\n\n.find-your-team-email h4.tide-heading {\n  padding-bottom: 8px;\n}\n\n.find-your-team-email .verify-email-cta {\n  padding: 0 10px 15px 10px;\n}\n\n.find-your-team-email .verify-email-sent-success {\n  text-align: center;\n  padding-top: 40px;\n}\n\n.find-your-team-email .verify-email-sent-success img {\n  width: 175px;\n  margin: 30px auto;\n  display: block;\n}\n\n.find-your-team-email .verify-email-sent-success .verify-email-success-copy {\n  margin-top: 10px;\n  font-size: 14px;\n  color: var(--color-p1-10);\n}\n\n.find-team-verification-form .find-team-verifcation-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: -5px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,cAAc;AAChB;;AAEA;GACG,gBAAgB;GAChB,WAAW;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;AAClB",
      file: "styles.css",
      sourcesContent: [".find-your-team-email {\n  padding-top: 0;\n}\n\n.find-team-verification-form > button {\n   margin-top: 10px;\n   width: 100%;\n}\n\n.find-your-team-email h4.tide-heading {\n  padding-bottom: 8px;\n}\n\n.find-your-team-email .verify-email-cta {\n  padding: 0 10px 15px 10px;\n}\n\n.find-your-team-email .verify-email-sent-success {\n  text-align: center;\n  padding-top: 40px;\n}\n\n.find-your-team-email .verify-email-sent-success img {\n  width: 175px;\n  margin: 30px auto;\n  display: block;\n}\n\n.find-your-team-email .verify-email-sent-success .verify-email-success-copy {\n  margin-top: 10px;\n  font-size: 14px;\n  color: var(--color-p1-10);\n}\n\n.find-team-verification-form .find-team-verifcation-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: -5px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(141);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".app-switcher-org-reccomendtaion-container {\n  border-bottom: 1px solid var(--color-p1-4);\n  width: 340px;\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content {\n  display: flex;\n  align-items: center;\n  height: 55px;\n  padding: 0px;\n}\n\n.app-switcher-org-reccomendtaion-container > h4 {\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content:first-of-type {\n  padding-top: 5px;\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust {\n  color: var(--color-p3-6);\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust:hover {\n  cursor: pointer;\n}\n\n.join-org-content .join-org-logo-container img {\n  width: 32px;\n  height: 32px;\n}\n\n.join-org-info > p.tide-paragraph-1 {\n  margin: 0px 0px 0px 10px;\n  padding: 0;\n}\n\n.join-org-content button {\n  margin-left: auto;\n  margin-right: 60px;\n}\n\n.join-org-content .duplicate-request-org-button {\n  margin-left: auto;\n  margin-right: 45px;\n}\n\n.join-org-info .join-org-name {\n  font-family: var(--main-font-family--semibold);\n}\n\n.join-org-info .join-org-teammate-count {\n  font-size: var(--font-size-subtle);\n  color: var(--color-p1-6);\n}\n\n.app-switcher-onboarding .verify-email-copy {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: 30px;\n}\n\n.verify-email-copy .verify-email-action {\n  text-decoration: underline;\n}\n\n.verify-email-copy .verify-email-action:hover {\n  color: var(--color-p1-10);\n  cursor: pointer;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB",
      file: "styles.css",
      sourcesContent: [".app-switcher-org-reccomendtaion-container {\n  border-bottom: 1px solid var(--color-p1-4);\n  width: 340px;\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content {\n  display: flex;\n  align-items: center;\n  height: 55px;\n  padding: 0px;\n}\n\n.app-switcher-org-reccomendtaion-container > h4 {\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content:first-of-type {\n  padding-top: 5px;\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust {\n  color: var(--color-p3-6);\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust:hover {\n  cursor: pointer;\n}\n\n.join-org-content .join-org-logo-container img {\n  width: 32px;\n  height: 32px;\n}\n\n.join-org-info > p.tide-paragraph-1 {\n  margin: 0px 0px 0px 10px;\n  padding: 0;\n}\n\n.join-org-content button {\n  margin-left: auto;\n  margin-right: 60px;\n}\n\n.join-org-content .duplicate-request-org-button {\n  margin-left: auto;\n  margin-right: 45px;\n}\n\n.join-org-info .join-org-name {\n  font-family: var(--main-font-family--semibold);\n}\n\n.join-org-info .join-org-teammate-count {\n  font-size: var(--font-size-subtle);\n  color: var(--color-p1-6);\n}\n\n.app-switcher-onboarding .verify-email-copy {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: 30px;\n}\n\n.verify-email-copy .verify-email-action {\n  text-decoration: underline;\n}\n\n.verify-email-copy .verify-email-action:hover {\n  color: var(--color-p1-10);\n  cursor: pointer;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(143);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".merge-account-email-container {\n  width: 300px;\n}\n\n.merge-account-email-container .merge-account-email-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container .merge-account-email-header {\n  margin-top: 20px;\n}\n\n.merge-account-email-container .tide-text-span.raw-input {\n  margin-bottom: 10px;\n}\n\n.merge-account-email-container button {\n  width: 300px;\n}\n\n.merge-account-email-container .invalid-credentials-error {\n  color: var(--color-s3);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container button.green-success-button {\n  background-color: var(--color-p2-8);\n  color: var(--color-p1-2);\n  border: 0px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,WAAW;AACb",
      file: "styles.css",
      sourcesContent: [".merge-account-email-container {\n  width: 300px;\n}\n\n.merge-account-email-container .merge-account-email-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container .merge-account-email-header {\n  margin-top: 20px;\n}\n\n.merge-account-email-container .tide-text-span.raw-input {\n  margin-bottom: 10px;\n}\n\n.merge-account-email-container button {\n  width: 300px;\n}\n\n.merge-account-email-container .invalid-credentials-error {\n  color: var(--color-s3);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container button.green-success-button {\n  background-color: var(--color-p2-8);\n  color: var(--color-p1-2);\n  border: 0px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(145);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".app-switcher-onboarding {\n  width: 352px;\n  margin: 20px auto;\n}\n\n.app-switcher-onboarding .return-to-switcher-copy {\n  color: var(--color-p3-6);\n  font-size: var(--font-size-small);\n}\n\n.app-switcher-onboarding .return-to-switcher-copy:hover {\n  cursor: pointer;\n}\n\n.return-to-switcher-copy .org-join-back-icon {\n  margin: -2px 5px 0px 0px;\n  align-items: center;\n}\n\n.org-join-back-icon path {\n  fill: var(--color-p3-6);\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB",
      file: "styles.css",
      sourcesContent: [".app-switcher-onboarding {\n  width: 352px;\n  margin: 20px auto;\n}\n\n.app-switcher-onboarding .return-to-switcher-copy {\n  color: var(--color-p3-6);\n  font-size: var(--font-size-small);\n}\n\n.app-switcher-onboarding .return-to-switcher-copy:hover {\n  cursor: pointer;\n}\n\n.return-to-switcher-copy .org-join-back-icon {\n  margin: -2px 5px 0px 0px;\n  align-items: center;\n}\n\n.org-join-back-icon path {\n  fill: var(--color-p3-6);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(147);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".drift-app-switch-nav > * {\n  box-sizing: content-box;\n}\n\n.drift-app-switch-nav {\n  -webkit-transition: .35s;\n  transition: .35s;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  width: 280px;\n  height: 100%;\n  left: -350px;\n  box-shadow: var(--box-shadow-3);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-sizing: content-box;\n  position: fixed;\n  z-index: 1;\n  opacity: 1;\n  padding: 0px 16px 16px 16px;\n  top: 0;\n  background: var(--color-p1-2);\n  cursor: auto;\n}\n\n.drift-app-switch-nav .app-switcher-app-list {\n  padding-bottom: 10px;\n}\n\n.drift-app-switch-nav.open {\n  -webkit-transition: .35s;\n  transition: .35s;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  left: -8px;\n  z-index: 999;\n  overflow-y: scroll;\n  top: 0;\n}\n\n.app-switcher-header {\n  font-family: var(--main-font-family--semibold);\n  display: inline-flex;\n  margin-left: 8px;\n  padding: 20px 0px 5px 0px;\n  height: 40px;\n  background-color: #fff;\n  width: 280px;\n  position: fixed;\n  top: 0px;\n}\n\n.app-switcher-app-list h4 {\n  font-size: var(--font-size-subtle);\n  padding-left: 38px;\n  margin-top: 60px;\n  margin-bottom: 0;\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-header-text {\n  margin: 0 0 0 14px;\n  font-size: var(--font-size-copy);\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-back-button {\n  margin-top: 2px;\n}\n\n.app-switcher-back-button:hover {\n  cursor: pointer;\n}\n\n/* Animations in switcher */\n.drift-app-switch-nav.open.expanded,\n.drift-app-switch-nav.open.transition-onboarding {\n  width: 420px;\n}\n\n.drift-app-switch-nav.open.transition-switcher {\n  width: 280px;\n}\n\n.drift-app-switch-nav.open.transition-onboarding .app-switcher-content {\n  -webkit-animation: fadeout-left .3s;\n          animation: fadeout-left .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  opacity: 1;\n}\n\n.drift-app-switch-nav.open.transition-switcher .app-switcher-onboarding {\n  -webkit-animation: fadeout-right .3s;\n          animation: fadeout-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  -webkit-animation: fadein-right .3s;\n          animation: fadein-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-content {\n  -webkit-animation: fadein-left .3s;\n          animation: fadein-left .3s;\n}\n\n@-webkit-keyframes fadein-right {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@keyframes fadein-right {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@-webkit-keyframes fadein-left {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n@keyframes fadein-left {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n\n@-webkit-keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n\n@keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes fadeout-left {\n  to {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n  }\n}\n\n@keyframes fadeout-left {\n  to {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n  }\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,wCAAgC;UAAhC,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,MAAM;EACN,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,wCAAgC;UAAhC,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,oCAA4B;YAA5B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAXA;EACE;IACE,UAAU;IACV,oCAA4B;YAA5B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAXA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,UAAU;EACZ;AACF;;;AAJA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;EAC/B;AACF;;AALA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;EAC/B;AACF",
      file: "style.css",
      sourcesContent: [".drift-app-switch-nav > * {\n  box-sizing: content-box;\n}\n\n.drift-app-switch-nav {\n  transition: .35s;\n  transition-timing-function: ease;\n  width: 280px;\n  height: 100%;\n  left: -350px;\n  box-shadow: var(--box-shadow-3);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-sizing: content-box;\n  position: fixed;\n  z-index: 1;\n  opacity: 1;\n  padding: 0px 16px 16px 16px;\n  top: 0;\n  background: var(--color-p1-2);\n  cursor: auto;\n}\n\n.drift-app-switch-nav .app-switcher-app-list {\n  padding-bottom: 10px;\n}\n\n.drift-app-switch-nav.open {\n  transition: .35s;\n  transition-timing-function: ease;\n  left: -8px;\n  z-index: 999;\n  overflow-y: scroll;\n  top: 0;\n}\n\n.app-switcher-header {\n  font-family: var(--main-font-family--semibold);\n  display: inline-flex;\n  margin-left: 8px;\n  padding: 20px 0px 5px 0px;\n  height: 40px;\n  background-color: #fff;\n  width: 280px;\n  position: fixed;\n  top: 0px;\n}\n\n.app-switcher-app-list h4 {\n  font-size: var(--font-size-subtle);\n  padding-left: 38px;\n  margin-top: 60px;\n  margin-bottom: 0;\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-header-text {\n  margin: 0 0 0 14px;\n  font-size: var(--font-size-copy);\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-back-button {\n  margin-top: 2px;\n}\n\n.app-switcher-back-button:hover {\n  cursor: pointer;\n}\n\n/* Animations in switcher */\n.drift-app-switch-nav.open.expanded,\n.drift-app-switch-nav.open.transition-onboarding {\n  width: 420px;\n}\n\n.drift-app-switch-nav.open.transition-switcher {\n  width: 280px;\n}\n\n.drift-app-switch-nav.open.transition-onboarding .app-switcher-content {\n  animation: fadeout-left .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  opacity: 1;\n}\n\n.drift-app-switch-nav.open.transition-switcher .app-switcher-onboarding {\n  animation: fadeout-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  animation: fadein-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-content {\n  animation: fadein-left .3s;\n}\n\n@keyframes fadein-right {\n  from {\n    opacity: 0;\n    transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@keyframes fadein-left {\n  from {\n    opacity: 0;\n    transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n\n@keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeout-left {\n  to {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(149);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, "/* Navbar styles - QA overrides in adjacent file */\n.main-navigation {\n  min-width: 48px;\n  max-width: 48px;\n  padding-top: 0px;\n  background: #000000;\n  position: relative;\n}\n\n.main-navigation .nav-item {\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  border: 2px solid transparent;\n  outline: none;\n  /* inherits a transition declaration from a parent file */\n}\n\n.main-navigation .nav-item:hover {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.active {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item:active {\n  background-color: var(--color-p1-8);\n  border-color: transparent;\n  outline: none;\n}\n\n.main-navigation .nav-item svg path,\n.main-navigation .nav-status-item svg g,\n.main-navigation .nav-status-item svg path {\n  fill: var(--color-p1-5-5);\n}\n\n.main-navigation .nav-item.active svg path {\n  fill: var(--color-p1-2);\n}\n\n/* Specific Drift logo/home icon styles */\n.main-navigation .nav-item.main-navigation-home {\n  height: 80px;\n  overflow: hidden;\n}\n\n.main-navigation .nav-item.main-navigation-home, .main-navigation .main-navigation-home > span {\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.main-navigation .nav-item.main-navigation-home:hover:not(.active) {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.main-navigation-home.active {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.main-navigation-home .drift-logo-wrapper {\n  display: block;\n  padding: 26px 10px;\n}\n\n.main-navigation .nav-item.main-navigation-home svg.logo path {\n  fill: var(--main-white);\n}\n\n/* Specific Nav icon + bottom status icon styles */\n.main-navigation .menu-item span {\n  display: block;\n  position: relative;\n  padding: 13px;\n}\n\n.main-navigation .menu-item.wide-icon span {\n  padding: 13px 12px; /* fixing padding issue for 20px wide briefcase icon */\n}\n\n.main-navigation .menu-item svg {\n  margin: 0 auto;\n  display: block;\n  max-height: 20px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip {\n  padding: 0;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand {\n  height: 15px;\n  width: 15px;\n  display: inline;\n  margin-left: 16px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand path {\n  fill: var(--color-p1-2);\n}\n\n/* Status section container */\n.main-navigation .navigation-status-section {\n  position: absolute;\n  width: 100%;\n  bottom: 9px;\n  left: 0px;\n}\n\n.main-navigation .navigation-status-section > div {\n  height: 32px;\n  width: 32px;\n  margin: 8px auto 0;\n  background: var(--color-p1-10);\n  border-radius: 3px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar,\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar:hover {\n  background: none;\n}\n\n.main-navigation .navigation-status-section > div:hover {\n  background: var(--color-p1-8);\n}\n\n.main-navigation .navigation-status-section .tide-tooltip {\n  margin-left: 8px;\n}\n\n.main-navigation .navigation-status-section .nav-status-item {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n/* Focus styles */\n.main-navigation .nav-item:focus:not(.active):not(.active):not(:hover) {\n  border-color: var(--color-p1-5);\n  background: #000;\n  outline: none;\n}\n\n.drift-status-nav-icon .user-avatar {\n  width: 100%;\n}\n\n/* Tooltip fixes */\n.main-navigation .nav-item.main-navigation-home .navigation-hover-tooltip--wrapper,\n.main-navigation .navigation-status-section > div .navigation-hover-tooltip--wrapper {\n  display: flex;\n  align-items: center;\n}\n\n@media all and (max-height: 674px) {\n  .main-navigation.main-navigation--no-subnav .nav-item.main-navigation-home {\n    height: 48px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .main-navigation-home > span {\n    margin-top: -16px;\n  }\n\n  .main-navigation.main-navigation--no-subnav > nav a {\n    height: 36px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .menu-item span {\n    padding: 7px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .navigation-status-section > div {\n    margin-top: 4px;\n  }\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA,kDAAkD;AAClD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,sDAAsD;AAC5E;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF",
      file: "style.css",
      sourcesContent: ["/* Navbar styles - QA overrides in adjacent file */\n.main-navigation {\n  min-width: 48px;\n  max-width: 48px;\n  padding-top: 0px;\n  background: #000000;\n  position: relative;\n}\n\n.main-navigation .nav-item {\n  display: block;\n  position: relative;\n  box-sizing: border-box;\n  border: 2px solid transparent;\n  outline: none;\n  /* inherits a transition declaration from a parent file */\n}\n\n.main-navigation .nav-item:hover {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.active {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item:active {\n  background-color: var(--color-p1-8);\n  border-color: transparent;\n  outline: none;\n}\n\n.main-navigation .nav-item svg path,\n.main-navigation .nav-status-item svg g,\n.main-navigation .nav-status-item svg path {\n  fill: var(--color-p1-5-5);\n}\n\n.main-navigation .nav-item.active svg path {\n  fill: var(--color-p1-2);\n}\n\n/* Specific Drift logo/home icon styles */\n.main-navigation .nav-item.main-navigation-home {\n  height: 80px;\n  overflow: hidden;\n}\n\n.main-navigation .nav-item.main-navigation-home, .main-navigation .main-navigation-home > span {\n  transition: all 0.3s ease;\n}\n\n.main-navigation .nav-item.main-navigation-home:hover:not(.active) {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.main-navigation-home.active {\n  background: var(--color-p1-10);\n}\n\n.main-navigation .nav-item.main-navigation-home .drift-logo-wrapper {\n  display: block;\n  padding: 26px 10px;\n}\n\n.main-navigation .nav-item.main-navigation-home svg.logo path {\n  fill: var(--main-white);\n}\n\n/* Specific Nav icon + bottom status icon styles */\n.main-navigation .menu-item span {\n  display: block;\n  position: relative;\n  padding: 13px;\n}\n\n.main-navigation .menu-item.wide-icon span {\n  padding: 13px 12px; /* fixing padding issue for 20px wide briefcase icon */\n}\n\n.main-navigation .menu-item svg {\n  margin: 0 auto;\n  display: block;\n  max-height: 20px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip {\n  padding: 0;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand {\n  height: 15px;\n  width: 15px;\n  display: inline;\n  margin-left: 16px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand path {\n  fill: var(--color-p1-2);\n}\n\n/* Status section container */\n.main-navigation .navigation-status-section {\n  position: absolute;\n  width: 100%;\n  bottom: 9px;\n  left: 0px;\n}\n\n.main-navigation .navigation-status-section > div {\n  height: 32px;\n  width: 32px;\n  margin: 8px auto 0;\n  background: var(--color-p1-10);\n  border-radius: 3px;\n  transition: all 0.3s ease;\n}\n\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar,\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar:hover {\n  background: none;\n}\n\n.main-navigation .navigation-status-section > div:hover {\n  background: var(--color-p1-8);\n}\n\n.main-navigation .navigation-status-section .tide-tooltip {\n  margin-left: 8px;\n}\n\n.main-navigation .navigation-status-section .nav-status-item {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n}\n\n/* Focus styles */\n.main-navigation .nav-item:focus:not(.active):not(.active):not(:hover) {\n  border-color: var(--color-p1-5);\n  background: #000;\n  outline: none;\n}\n\n.drift-status-nav-icon .user-avatar {\n  width: 100%;\n}\n\n/* Tooltip fixes */\n.main-navigation .nav-item.main-navigation-home .navigation-hover-tooltip--wrapper,\n.main-navigation .navigation-status-section > div .navigation-hover-tooltip--wrapper {\n  display: flex;\n  align-items: center;\n}\n\n@media all and (max-height: 674px) {\n  .main-navigation.main-navigation--no-subnav .nav-item.main-navigation-home {\n    height: 48px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .main-navigation-home > span {\n    margin-top: -16px;\n  }\n\n  .main-navigation.main-navigation--no-subnav > nav a {\n    height: 36px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .menu-item span {\n    padding: 7px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .navigation-status-section > div {\n    margin-top: 4px;\n  }\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(151);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, "/* QA styles */\n.main-navigation--qa,\n.main-navigation--qa.main-navigation {\n  background: rgb(122, 124, 36);\n}\n", "", {
      version: 3,
      sources: ["qa-styles.css"],
      names: [],
      mappings: "AAAA,cAAc;AACd;;EAEE,6BAA6B;AAC/B",
      file: "qa-styles.css",
      sourcesContent: ["/* QA styles */\n.main-navigation--qa,\n.main-navigation--qa.main-navigation {\n  background: rgb(122, 124, 36);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(153);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, "/*\nCSS FOR BOLT ANIMATIONS\n*/\n.main-navigation .main-navigation-home .logo-hover-bolt {\n  opacity: 0;\n  position: absolute;\n  -webkit-transition: opacity 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55),\n    top 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55), left 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n  transition: opacity 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55),\n    top 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55), left 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.main-navigation .main-navigation-home .logo-hover-bolt path {\n  fill: var(--color-p1-5);\n}\n\n/* Base styles */\n.main-navigation .main-navigation-home .logo-hover-bolt.large {\n  top: -10px;\n  left: 40px;\n  -webkit-transform: rotate(10deg);\n          transform: rotate(10deg);\n  -webkit-transition-delay: 0.3s;\n          transition-delay: 0.3s;\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.large path {\n  fill: var(--color-p1-2);\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.small1 {\n  top: -8px;\n  left: 18px;\n  -webkit-transform: rotate(-15deg) scale(0.5);\n          transform: rotate(-15deg) scale(0.5);\n  -webkit-transition-delay: 0.2s;\n          transition-delay: 0.2s;\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.small2 {\n  top: 5px;\n  left: 42px;\n  -webkit-transform: rotate(55deg) scale(0.5);\n          transform: rotate(55deg) scale(0.5);\n  -webkit-transition-delay: 0.1s;\n          transition-delay: 0.1s;\n}\n\n/* Hover states */\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt {\n  opacity: 1;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.large {\n  top: 3px;\n  left: 32px;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.small1 {\n  top: 10px;\n  left: 20px;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.small2 {\n  top: 17px;\n  left: 32px;\n}\n", "", {
      version: 3,
      sources: ["bolts.css"],
      names: [],
      mappings: "AAAA;;CAEC;AACD;EACE,UAAU;EACV,kBAAkB;EAClB;mGACiG;EADjG;mGACiG;AACnG;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,UAAU;EACV,UAAU;EACV,gCAAwB;UAAxB,wBAAwB;EACxB,8BAAsB;UAAtB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,4CAAoC;UAApC,oCAAoC;EACpC,8BAAsB;UAAtB,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,UAAU;EACV,2CAAmC;UAAnC,mCAAmC;EACnC,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,UAAU;AACZ;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ",
      file: "bolts.css",
      sourcesContent: ["/*\nCSS FOR BOLT ANIMATIONS\n*/\n.main-navigation .main-navigation-home .logo-hover-bolt {\n  opacity: 0;\n  position: absolute;\n  transition: opacity 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55),\n    top 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55), left 0.1s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n.main-navigation .main-navigation-home .logo-hover-bolt path {\n  fill: var(--color-p1-5);\n}\n\n/* Base styles */\n.main-navigation .main-navigation-home .logo-hover-bolt.large {\n  top: -10px;\n  left: 40px;\n  transform: rotate(10deg);\n  transition-delay: 0.3s;\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.large path {\n  fill: var(--color-p1-2);\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.small1 {\n  top: -8px;\n  left: 18px;\n  transform: rotate(-15deg) scale(0.5);\n  transition-delay: 0.2s;\n}\n.main-navigation .main-navigation-home .logo-hover-bolt.small2 {\n  top: 5px;\n  left: 42px;\n  transform: rotate(55deg) scale(0.5);\n  transition-delay: 0.1s;\n}\n\n/* Hover states */\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt {\n  opacity: 1;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.large {\n  top: 3px;\n  left: 32px;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.small1 {\n  top: 10px;\n  left: 20px;\n}\n.main-navigation .main-navigation-home:hover:not(.active) .logo-hover-bolt.small2 {\n  top: 17px;\n  left: 32px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(155);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".global-notifications-bar {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 10px;\n  padding-right: 16px;\n  height: 20px;\n  text-align: center;\n  -webkit-transition: all 200ms ease;\n  transition: all 200ms ease;\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.43;\n  letter-spacing: -0.16px;\n}\n\n.global-notification-text {\n  margin-right: 24px;\n}\n\n.global-notifications-bar--action-needed {\n  background-color: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--informational {\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--hidden {\n  height: 0px;\n  padding: 0 15px;\n}\n\n.global-notifications-bar--hidden .global-notification-text {\n  display: none\n}\n\n.global-notifications-bar--hidden .global-notification-actions {\n  display: none\n}\n\n.global-notifications-bar--warning {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--error {\n  background: var(--color-s3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--standard {\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button {\n  background-color: var(--color-p1-6);\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button button {\n  cursor: pointer;\n  color: var(--color-p1-2);\n  background-color: rgba(0,0,0,0.2);\n  border: none;\n  text-decoration: none;\n}\n\n.global-notifications-bar--update {\n  background: var(--main-black);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar .close-button {\n  position: absolute;\n  cursor: pointer;\n  right: 16px;\n}\n\n.global-notifications-bar .close-button path {\n  fill: var(--color-p1-2);\n}\n\n.global-notification-actions {\n  margin: 0 0 0 0;\n  display: inline-block;\n}\n\n.global-notification-actions > button:not(:last-child) {\n  margin-right: 8px\n}\n\n/* Disable Widget */\n.global-notifications-bar--disableWidget {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  padding: 16px 64px 16px 32px;\n}\n\n@media screen and (min-width: 1020px) {\n  .global-notifications-bar--disableWidget {\n    padding: 12px 64px 12px 32px;\n  }\n}\n\n.global-notifications-bar--disableWidget .global-notification-text {\n  text-align: left;\n}\n\n/* Enable Notifications */\n.global-notifications-bar--enableNotifications {\n  font-family: var(--main-font-family--bold);\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  display: flex;\n  justify-content: center;\n}\n\n.global-notifications-bar--enableNotifications .enable-notification-banner-body {\n  margin: 7px 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button {\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg {\n  margin-right: 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg path {\n  color: currentColor;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button:hover,\n.global-notifications-bar--enableNotifications .global-notification-action-button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n\n.global-notifications-bar--enableNotifications svg {\n  max-height: 13px;\n  max-width: 15px;\n  padding-right: 5px;\n}\n\n.global-notifications-bar--enableNotifications svg path {\n  color: #fff;\n  fill: currentColor;\n}\n\n/* Dissmiss Notifications Confirm Banner */\n.global-notifications-bar--dismissNotificationsConfirm {\n  background: var(--utility-yellow-light);\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n  height: auto;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .enable-notification-banner-body {\n  margin: 7px 0;\n  padding-bottom: 15px;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm p {\n  margin: 0 30px 10px;\n}\n\n@media screen and (min-width: 1525px) {\n  .global-notifications-bar--dismissNotificationsConfirm p {\n    margin: 15px 30px;\n  }\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button {\n  cursor: pointer;\n  color: var(--main-navy-extra-dark);\n  background: rgba(0, 0, 0, 0.1);\n  border: none;\n  margin: 0 0 0 10px;\n  text-decoration: none;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button:hover,\n.global-notifications-bar--dismissNotificationsConfirm button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--main-navy-extra-dark);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .close-button path {\n  fill: var(--main-navy-extra-dark);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kCAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,uCAAuC;EACvC,kCAAkC;EAClC,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC",
      file: "style.css",
      sourcesContent: [".global-notifications-bar {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 10px;\n  padding-right: 16px;\n  height: 20px;\n  text-align: center;\n  transition: all 200ms ease;\n  overflow: hidden;\n  position: relative;\n  flex-shrink: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.43;\n  letter-spacing: -0.16px;\n}\n\n.global-notification-text {\n  margin-right: 24px;\n}\n\n.global-notifications-bar--action-needed {\n  background-color: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--informational {\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--hidden {\n  height: 0px;\n  padding: 0 15px;\n}\n\n.global-notifications-bar--hidden .global-notification-text {\n  display: none\n}\n\n.global-notifications-bar--hidden .global-notification-actions {\n  display: none\n}\n\n.global-notifications-bar--warning {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--error {\n  background: var(--color-s3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--standard {\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button {\n  background-color: var(--color-p1-6);\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button button {\n  cursor: pointer;\n  color: var(--color-p1-2);\n  background-color: rgba(0,0,0,0.2);\n  border: none;\n  text-decoration: none;\n}\n\n.global-notifications-bar--update {\n  background: var(--main-black);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar .close-button {\n  position: absolute;\n  cursor: pointer;\n  right: 16px;\n}\n\n.global-notifications-bar .close-button path {\n  fill: var(--color-p1-2);\n}\n\n.global-notification-actions {\n  margin: 0 0 0 0;\n  display: inline-block;\n}\n\n.global-notification-actions > button:not(:last-child) {\n  margin-right: 8px\n}\n\n/* Disable Widget */\n.global-notifications-bar--disableWidget {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  padding: 16px 64px 16px 32px;\n}\n\n@media screen and (min-width: 1020px) {\n  .global-notifications-bar--disableWidget {\n    padding: 12px 64px 12px 32px;\n  }\n}\n\n.global-notifications-bar--disableWidget .global-notification-text {\n  text-align: left;\n}\n\n/* Enable Notifications */\n.global-notifications-bar--enableNotifications {\n  font-family: var(--main-font-family--bold);\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  display: flex;\n  justify-content: center;\n}\n\n.global-notifications-bar--enableNotifications .enable-notification-banner-body {\n  margin: 7px 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button {\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg {\n  margin-right: 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg path {\n  color: currentColor;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button:hover,\n.global-notifications-bar--enableNotifications .global-notification-action-button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n\n.global-notifications-bar--enableNotifications svg {\n  max-height: 13px;\n  max-width: 15px;\n  padding-right: 5px;\n}\n\n.global-notifications-bar--enableNotifications svg path {\n  color: #fff;\n  fill: currentColor;\n}\n\n/* Dissmiss Notifications Confirm Banner */\n.global-notifications-bar--dismissNotificationsConfirm {\n  background: var(--utility-yellow-light);\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n  height: auto;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .enable-notification-banner-body {\n  margin: 7px 0;\n  padding-bottom: 15px;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm p {\n  margin: 0 30px 10px;\n}\n\n@media screen and (min-width: 1525px) {\n  .global-notifications-bar--dismissNotificationsConfirm p {\n    margin: 15px 30px;\n  }\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button {\n  cursor: pointer;\n  color: var(--main-navy-extra-dark);\n  background: rgba(0, 0, 0, 0.1);\n  border: none;\n  margin: 0 0 0 10px;\n  text-decoration: none;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button:hover,\n.global-notifications-bar--dismissNotificationsConfirm button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--main-navy-extra-dark);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .close-button path {\n  fill: var(--main-navy-extra-dark);\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    var r = n(157);

    function emptyFunction() {}

    e.exports = function () {
      function shim(e, t, n, i, o, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim
      };
      return e.checkPropTypes = emptyFunction, e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        o = _interopRequireDefault(n(11)),
        a = _interopRequireDefault(n(159));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function defaultBarStyleFactory(e, t) {
      return r({}, t, {
        bottom: 2 + 4 * e + "rem"
      });
    }

    var s = function NotificationStack(e) {
      return i.default.createElement("div", {
        className: "notification-list"
      }, e.notifications.map(function (t, n) {
        var o = 0 === n && 1 === e.notifications.length,
            s = o || !e.dismissInOrder,
            c = e.barStyleFactory(n, t.barStyle, t),
            l = e.actionStyleFactory(n, t.actionStyle, t),
            u = e.activeBarStyleFactory(n, t.activeBarStyle, t),
            p = t.onClick || e.onClick,
            f = e.onDismiss,
            d = t.dismissAfter;
        return !1 !== d && (null == d && (d = e.dismissAfter), s || (d += 1e3 * n)), i.default.createElement(a.default, r({}, t, {
          key: t.key,
          isLast: o,
          action: t.action || e.action,
          dismissAfter: d,
          onDismiss: f.bind(void 0, t),
          onClick: p.bind(void 0, t),
          activeBarStyle: u,
          barStyle: c,
          actionStyle: l
        }));
      }));
    };

    s.propTypes = {
      activeBarStyleFactory: o.default.func,
      barStyleFactory: o.default.func,
      actionStyleFactory: o.default.func,
      dismissInOrder: o.default.bool,
      notifications: o.default.array.isRequired,
      onDismiss: o.default.func.isRequired,
      onClick: o.default.func,
      action: o.default.string
    }, s.defaultProps = {
      activeBarStyleFactory: defaultBarStyleFactory,
      barStyleFactory: defaultBarStyleFactory,
      actionStyleFactory: function defaultActionStyleFactory(e, t) {
        return r({}, t, {});
      },
      dismissInOrder: !0,
      dismissAfter: 1e3,
      onClick: function onClick() {}
    }, t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        o = n(0),
        a = _interopRequireDefault(o),
        s = _interopRequireDefault(n(49)),
        c = _interopRequireDefault(n(48));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = function (e) {
      function StackedNotification(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, StackedNotification);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (StackedNotification.__proto__ || Object.getPrototypeOf(StackedNotification)).call(this, e));

        return t.state = {
          isActive: !1
        }, t.handleClick = t.handleClick.bind(t), t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(StackedNotification, o.Component), i(StackedNotification, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.activeTimeout = setTimeout(this.setState.bind(this, {
            isActive: !0
          }), 1), this.dismiss(this.props.dismissAfter);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          e.dismissAfter !== this.props.dismissAfter && this.dismiss(e.dismissAfter);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          clearTimeout(this.activeTimeout), clearTimeout(this.dismissTimeout);
        }
      }, {
        key: "dismiss",
        value: function dismiss(e) {
          !1 !== e && (this.dismissTimeout = setTimeout(this.setState.bind(this, {
            isActive: !1
          }), e));
        }
      }, {
        key: "handleClick",
        value: function handleClick() {
          if (this.props.onClick && "function" === typeof this.props.onClick) return this.props.onClick(this.setState.bind(this, {
            isActive: !1
          }));
        }
      }, {
        key: "render",
        value: function render() {
          var e = this;
          return a.default.createElement(c.default, r({}, this.props, {
            onClick: this.handleClick,
            onDismiss: function onDismiss() {
              return setTimeout(e.props.onDismiss, 300);
            },
            isActive: this.state.isActive
          }));
        }
      }]), StackedNotification;
    }();

    l.propTypes = s.default, t.default = l;
  }, function (e, t, n) {
    var r = n(161);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".notification-bar {\n  left: 4rem !important;\n  z-index: 9000;\n}\n\n.transient-notification {\n  -webkit-transition: .5s all ease;\n  transition: .5s all ease;\n  font-family: var(--main-font-family) !important;\n  color: var(--main-white) !important;\n  font-size: 14px !important;\n}\n\n.transient-notification--success {\n  background: var(--main-green) !important;\n}\n\n.transient-notification--error {\n  background: var(--utility-red) !important;\n}\n\n.transient-notification--information {\n  background: var(--main-navy-dark) !important;\n}\n\n.notification-bar-action {\n  color: var(--main-white) !important;\n  font-size: 14px !important;\n  background: rgba(0,0,0,.2);\n  padding: 5px !important;\n  font-family: var(--main-font-family) !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n}\n\n.notification-bar-action:hover {\n  background: rgba(0,0,0,.3);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gCAAwB;EAAxB,wBAAwB;EACxB,+CAA+C;EAC/C,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,+CAA+C;EAC/C,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B",
      file: "style.css",
      sourcesContent: [".notification-bar {\n  left: 4rem !important;\n  z-index: 9000;\n}\n\n.transient-notification {\n  transition: .5s all ease;\n  font-family: var(--main-font-family) !important;\n  color: var(--main-white) !important;\n  font-size: 14px !important;\n}\n\n.transient-notification--success {\n  background: var(--main-green) !important;\n}\n\n.transient-notification--error {\n  background: var(--utility-red) !important;\n}\n\n.transient-notification--information {\n  background: var(--main-navy-dark) !important;\n}\n\n.notification-bar-action {\n  color: var(--main-white) !important;\n  font-size: 14px !important;\n  background: rgba(0,0,0,.2);\n  padding: 5px !important;\n  font-family: var(--main-font-family) !important;\n  text-transform: none !important;\n  letter-spacing: normal !important;\n}\n\n.notification-bar-action:hover {\n  background: rgba(0,0,0,.3);\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    var r = n(163);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, n, i, o, a) {
        if (a !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    (function (e, n) {
      var r = 200,
          i = "__lodash_hash_undefined__",
          o = 1,
          a = 2,
          s = 9007199254740991,
          c = "[object Arguments]",
          l = "[object Array]",
          u = "[object AsyncFunction]",
          p = "[object Boolean]",
          f = "[object Date]",
          d = "[object Error]",
          h = "[object Function]",
          m = "[object GeneratorFunction]",
          g = "[object Map]",
          A = "[object Number]",
          v = "[object Null]",
          b = "[object Object]",
          y = "[object Proxy]",
          E = "[object RegExp]",
          C = "[object Set]",
          w = "[object String]",
          _ = "[object Symbol]",
          x = "[object Undefined]",
          S = "[object ArrayBuffer]",
          k = "[object DataView]",
          O = /^\[object .+?Constructor\]$/,
          B = /^(?:0|[1-9]\d*)$/,
          T = {};
      T["[object Float32Array]"] = T["[object Float64Array]"] = T["[object Int8Array]"] = T["[object Int16Array]"] = T["[object Int32Array]"] = T["[object Uint8Array]"] = T["[object Uint8ClampedArray]"] = T["[object Uint16Array]"] = T["[object Uint32Array]"] = !0, T[c] = T[l] = T[S] = T[p] = T[k] = T[f] = T[d] = T[h] = T[g] = T[A] = T[b] = T[E] = T[C] = T[w] = T["[object WeakMap]"] = !1;

      var I = "object" == typeof e && e && e.Object === Object && e,
          R = "object" == typeof self && self && self.Object === Object && self,
          P = I || R || Function("return this")(),
          j = t && !t.nodeType && t,
          N = j && "object" == typeof n && n && !n.nodeType && n,
          D = N && N.exports === j,
          L = D && I.process,
          M = function () {
        try {
          return L && L.binding && L.binding("util");
        } catch (e) {}
      }(),
          U = M && M.isTypedArray;

      function arraySome(e, t) {
        for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
          if (t(e[n], n, e)) return !0;
        }

        return !1;
      }

      function mapToArray(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e, r) {
          n[++t] = [r, e];
        }), n;
      }

      function setToArray(e) {
        var t = -1,
            n = Array(e.size);
        return e.forEach(function (e) {
          n[++t] = e;
        }), n;
      }

      var F = Array.prototype,
          z = Function.prototype,
          H = Object.prototype,
          W = P["__core-js_shared__"],
          q = z.toString,
          G = H.hasOwnProperty,
          V = function () {
        var e = /[^.]+$/.exec(W && W.keys && W.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(),
          Y = H.toString,
          Z = RegExp("^" + q.call(G).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
          J = D ? P.Buffer : void 0,
          K = P.Symbol,
          X = P.Uint8Array,
          $ = H.propertyIsEnumerable,
          Q = F.splice,
          ee = K ? K.toStringTag : void 0,
          te = Object.getOwnPropertySymbols,
          ne = J ? J.isBuffer : void 0,
          re = function overArg(e, t) {
        return function (n) {
          return e(t(n));
        };
      }(Object.keys, Object),
          ie = getNative(P, "DataView"),
          oe = getNative(P, "Map"),
          ae = getNative(P, "Promise"),
          se = getNative(P, "Set"),
          ce = getNative(P, "WeakMap"),
          le = getNative(Object, "create"),
          ue = toSource(ie),
          pe = toSource(oe),
          fe = toSource(ae),
          de = toSource(se),
          he = toSource(ce),
          me = K ? K.prototype : void 0,
          ge = me ? me.valueOf : void 0;

      function Hash(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function ListCache(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function MapCache(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.clear(); ++t < n;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      function SetCache(e) {
        var t = -1,
            n = null == e ? 0 : e.length;

        for (this.__data__ = new MapCache(); ++t < n;) {
          this.add(e[t]);
        }
      }

      function Stack(e) {
        var t = this.__data__ = new ListCache(e);
        this.size = t.size;
      }

      function arrayLikeKeys(e, t) {
        var n = ye(e),
            r = !n && be(e),
            i = !n && !r && Ee(e),
            o = !n && !r && !i && Ce(e),
            a = n || r || i || o,
            s = a ? function baseTimes(e, t) {
          for (var n = -1, r = Array(e); ++n < e;) {
            r[n] = t(n);
          }

          return r;
        }(e.length, String) : [],
            c = s.length;

        for (var l in e) {
          !t && !G.call(e, l) || a && ("length" == l || i && ("offset" == l || "parent" == l) || o && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || isIndex(l, c)) || s.push(l);
        }

        return s;
      }

      function assocIndexOf(e, t) {
        for (var n = e.length; n--;) {
          if (eq(e[n][0], t)) return n;
        }

        return -1;
      }

      function baseGetTag(e) {
        return null == e ? void 0 === e ? x : v : ee && ee in Object(e) ? function getRawTag(e) {
          var t = G.call(e, ee),
              n = e[ee];

          try {
            e[ee] = void 0;
            var r = !0;
          } catch (o) {}

          var i = Y.call(e);
          r && (t ? e[ee] = n : delete e[ee]);
          return i;
        }(e) : function objectToString(e) {
          return Y.call(e);
        }(e);
      }

      function baseIsArguments(e) {
        return isObjectLike(e) && baseGetTag(e) == c;
      }

      function baseIsEqual(e, t, n, r, i) {
        return e === t || (null == e || null == t || !isObjectLike(e) && !isObjectLike(t) ? e !== e && t !== t : function baseIsEqualDeep(e, t, n, r, i, s) {
          var u = ye(e),
              h = ye(t),
              m = u ? l : ve(e),
              v = h ? l : ve(t),
              y = (m = m == c ? b : m) == b,
              x = (v = v == c ? b : v) == b,
              O = m == v;

          if (O && Ee(e)) {
            if (!Ee(t)) return !1;
            u = !0, y = !1;
          }

          if (O && !y) return s || (s = new Stack()), u || Ce(e) ? equalArrays(e, t, n, r, i, s) : function equalByTag(e, t, n, r, i, s, c) {
            switch (n) {
              case k:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;

              case S:
                return !(e.byteLength != t.byteLength || !s(new X(e), new X(t)));

              case p:
              case f:
              case A:
                return eq(+e, +t);

              case d:
                return e.name == t.name && e.message == t.message;

              case E:
              case w:
                return e == t + "";

              case g:
                var l = mapToArray;

              case C:
                var u = r & o;
                if (l || (l = setToArray), e.size != t.size && !u) return !1;
                var h = c.get(e);
                if (h) return h == t;
                r |= a, c.set(e, t);
                var m = equalArrays(l(e), l(t), r, i, s, c);
                return c.delete(e), m;

              case _:
                if (ge) return ge.call(e) == ge.call(t);
            }

            return !1;
          }(e, t, m, n, r, i, s);

          if (!(n & o)) {
            var B = y && G.call(e, "__wrapped__"),
                T = x && G.call(t, "__wrapped__");

            if (B || T) {
              var I = B ? e.value() : e,
                  R = T ? t.value() : t;
              return s || (s = new Stack()), i(I, R, n, r, s);
            }
          }

          if (!O) return !1;
          return s || (s = new Stack()), function equalObjects(e, t, n, r, i, a) {
            var s = n & o,
                c = getAllKeys(e),
                l = c.length,
                u = getAllKeys(t).length;
            if (l != u && !s) return !1;

            for (var p = l; p--;) {
              var f = c[p];
              if (!(s ? f in t : G.call(t, f))) return !1;
            }

            var d = a.get(e);
            if (d && a.get(t)) return d == t;
            var h = !0;
            a.set(e, t), a.set(t, e);

            for (var m = s; ++p < l;) {
              f = c[p];
              var g = e[f],
                  A = t[f];
              if (r) var v = s ? r(A, g, f, t, e, a) : r(g, A, f, e, t, a);

              if (!(void 0 === v ? g === A || i(g, A, n, r, a) : v)) {
                h = !1;
                break;
              }

              m || (m = "constructor" == f);
            }

            if (h && !m) {
              var b = e.constructor,
                  y = t.constructor;
              b != y && "constructor" in e && "constructor" in t && !("function" == typeof b && b instanceof b && "function" == typeof y && y instanceof y) && (h = !1);
            }

            return a.delete(e), a.delete(t), h;
          }(e, t, n, r, i, s);
        }(e, t, n, r, baseIsEqual, i));
      }

      function baseIsNative(e) {
        return !(!isObject(e) || function isMasked(e) {
          return !!V && V in e;
        }(e)) && (isFunction(e) ? Z : O).test(toSource(e));
      }

      function baseKeys(e) {
        if (!function isPrototype(e) {
          var t = e && e.constructor,
              n = "function" == typeof t && t.prototype || H;
          return e === n;
        }(e)) return re(e);
        var t = [];

        for (var n in Object(e)) {
          G.call(e, n) && "constructor" != n && t.push(n);
        }

        return t;
      }

      function equalArrays(e, t, n, r, i, s) {
        var c = n & o,
            l = e.length,
            u = t.length;
        if (l != u && !(c && u > l)) return !1;
        var p = s.get(e);
        if (p && s.get(t)) return p == t;
        var f = -1,
            d = !0,
            h = n & a ? new SetCache() : void 0;

        for (s.set(e, t), s.set(t, e); ++f < l;) {
          var m = e[f],
              g = t[f];
          if (r) var A = c ? r(g, m, f, t, e, s) : r(m, g, f, e, t, s);

          if (void 0 !== A) {
            if (A) continue;
            d = !1;
            break;
          }

          if (h) {
            if (!arraySome(t, function (e, t) {
              if (o = t, !h.has(o) && (m === e || i(m, e, n, r, s))) return h.push(t);
              var o;
            })) {
              d = !1;
              break;
            }
          } else if (m !== g && !i(m, g, n, r, s)) {
            d = !1;
            break;
          }
        }

        return s.delete(e), s.delete(t), d;
      }

      function getAllKeys(e) {
        return function baseGetAllKeys(e, t, n) {
          var r = t(e);
          return ye(e) ? r : function arrayPush(e, t) {
            for (var n = -1, r = t.length, i = e.length; ++n < r;) {
              e[i + n] = t[n];
            }

            return e;
          }(r, n(e));
        }(e, keys, Ae);
      }

      function getMapData(e, t) {
        var n = e.__data__;
        return function isKeyable(e) {
          var t = typeof e;
          return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
        }(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
      }

      function getNative(e, t) {
        var n = function getValue(e, t) {
          return null == e ? void 0 : e[t];
        }(e, t);

        return baseIsNative(n) ? n : void 0;
      }

      Hash.prototype.clear = function hashClear() {
        this.__data__ = le ? le(null) : {}, this.size = 0;
      }, Hash.prototype.delete = function hashDelete(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }, Hash.prototype.get = function hashGet(e) {
        var t = this.__data__;

        if (le) {
          var n = t[e];
          return n === i ? void 0 : n;
        }

        return G.call(t, e) ? t[e] : void 0;
      }, Hash.prototype.has = function hashHas(e) {
        var t = this.__data__;
        return le ? void 0 !== t[e] : G.call(t, e);
      }, Hash.prototype.set = function hashSet(e, t) {
        var n = this.__data__;
        return this.size += this.has(e) ? 0 : 1, n[e] = le && void 0 === t ? i : t, this;
      }, ListCache.prototype.clear = function listCacheClear() {
        this.__data__ = [], this.size = 0;
      }, ListCache.prototype.delete = function listCacheDelete(e) {
        var t = this.__data__,
            n = assocIndexOf(t, e);
        return !(n < 0) && (n == t.length - 1 ? t.pop() : Q.call(t, n, 1), --this.size, !0);
      }, ListCache.prototype.get = function listCacheGet(e) {
        var t = this.__data__,
            n = assocIndexOf(t, e);
        return n < 0 ? void 0 : t[n][1];
      }, ListCache.prototype.has = function listCacheHas(e) {
        return assocIndexOf(this.__data__, e) > -1;
      }, ListCache.prototype.set = function listCacheSet(e, t) {
        var n = this.__data__,
            r = assocIndexOf(n, e);
        return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
      }, MapCache.prototype.clear = function mapCacheClear() {
        this.size = 0, this.__data__ = {
          hash: new Hash(),
          map: new (oe || ListCache)(),
          string: new Hash()
        };
      }, MapCache.prototype.delete = function mapCacheDelete(e) {
        var t = getMapData(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }, MapCache.prototype.get = function mapCacheGet(e) {
        return getMapData(this, e).get(e);
      }, MapCache.prototype.has = function mapCacheHas(e) {
        return getMapData(this, e).has(e);
      }, MapCache.prototype.set = function mapCacheSet(e, t) {
        var n = getMapData(this, e),
            r = n.size;
        return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
      }, SetCache.prototype.add = SetCache.prototype.push = function setCacheAdd(e) {
        return this.__data__.set(e, i), this;
      }, SetCache.prototype.has = function setCacheHas(e) {
        return this.__data__.has(e);
      }, Stack.prototype.clear = function stackClear() {
        this.__data__ = new ListCache(), this.size = 0;
      }, Stack.prototype.delete = function stackDelete(e) {
        var t = this.__data__,
            n = t.delete(e);
        return this.size = t.size, n;
      }, Stack.prototype.get = function stackGet(e) {
        return this.__data__.get(e);
      }, Stack.prototype.has = function stackHas(e) {
        return this.__data__.has(e);
      }, Stack.prototype.set = function stackSet(e, t) {
        var n = this.__data__;

        if (n instanceof ListCache) {
          var i = n.__data__;
          if (!oe || i.length < r - 1) return i.push([e, t]), this.size = ++n.size, this;
          n = this.__data__ = new MapCache(i);
        }

        return n.set(e, t), this.size = n.size, this;
      };
      var Ae = te ? function (e) {
        return null == e ? [] : (e = Object(e), function arrayFilter(e, t) {
          for (var n = -1, r = null == e ? 0 : e.length, i = 0, o = []; ++n < r;) {
            var a = e[n];
            t(a, n, e) && (o[i++] = a);
          }

          return o;
        }(te(e), function (t) {
          return $.call(e, t);
        }));
      } : function stubArray() {
        return [];
      },
          ve = baseGetTag;

      function isIndex(e, t) {
        return !!(t = null == t ? s : t) && ("number" == typeof e || B.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }

      function toSource(e) {
        if (null != e) {
          try {
            return q.call(e);
          } catch (t) {}

          try {
            return e + "";
          } catch (t) {}
        }

        return "";
      }

      function eq(e, t) {
        return e === t || e !== e && t !== t;
      }

      (ie && ve(new ie(new ArrayBuffer(1))) != k || oe && ve(new oe()) != g || ae && "[object Promise]" != ve(ae.resolve()) || se && ve(new se()) != C || ce && "[object WeakMap]" != ve(new ce())) && (ve = function getTag(e) {
        var t = baseGetTag(e),
            n = t == b ? e.constructor : void 0,
            r = n ? toSource(n) : "";
        if (r) switch (r) {
          case ue:
            return k;

          case pe:
            return g;

          case fe:
            return "[object Promise]";

          case de:
            return C;

          case he:
            return "[object WeakMap]";
        }
        return t;
      });
      var be = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (e) {
        return isObjectLike(e) && G.call(e, "callee") && !$.call(e, "callee");
      },
          ye = Array.isArray;

      var Ee = ne || function stubFalse() {
        return !1;
      };

      function isFunction(e) {
        if (!isObject(e)) return !1;
        var t = baseGetTag(e);
        return t == h || t == m || t == u || t == y;
      }

      function isLength(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= s;
      }

      function isObject(e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      }

      function isObjectLike(e) {
        return null != e && "object" == typeof e;
      }

      var Ce = U ? function baseUnary(e) {
        return function (t) {
          return e(t);
        };
      }(U) : function baseIsTypedArray(e) {
        return isObjectLike(e) && isLength(e.length) && !!T[baseGetTag(e)];
      };

      function keys(e) {
        return function isArrayLike(e) {
          return null != e && isLength(e.length) && !isFunction(e);
        }(e) ? arrayLikeKeys(e) : baseKeys(e);
      }

      n.exports = function isEqual(e, t) {
        return baseIsEqual(e, t);
      };
    }).call(this, n(17), n(165)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, n) {
    var r = n(167);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".timeout-modal-seconds-countdown-span {\n    color: var(--color-s3-6);\n    font-family: var(--main-font-family--semibold);\n}\n\n.timeout-modal-minutes-countdown-span{\n    font-family: var(--main-font-family--semibold);\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;IACI,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD",
      file: "style.css",
      sourcesContent: [".timeout-modal-seconds-countdown-span {\n    color: var(--color-s3-6);\n    font-family: var(--main-font-family--semibold);\n}\n\n.timeout-modal-minutes-countdown-span{\n    font-family: var(--main-font-family--semibold);\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(169);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".app-layout {\n  width: 100vw;\n  height: 100vh;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.app-layout .app-layout-inner {\n\theight: 100%;\n\twidth: 100%;\n  display: inline-flex;\n  overflow: hidden;\n}\n\n.main-content-area {\n  width: 100%;\n  height: 100%;\n  background: white;\n  opacity: 0;\n  -webkit-transition: opacity .2s ease-in;\n  transition: opacity .2s ease-in\n}\n\n.app-layout--loaded .main-content-area{\n  opacity: 1;\n}\n\n.main-navigation > *:not(.logo) {\n  opacity: 0;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in\n}\n\n.app-layout--loaded .main-navigation > *:not(.logo) {\n  opacity: 1;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,aAAa;;EAEb,aAAa;EACb,sBAAsB;AACxB;;AAEA;CACC,YAAY;CACZ,WAAW;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,uCAA8B;EAA9B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oCAA2B;EAA3B;AACF;;AAEA;EACE,UAAU;AACZ",
      file: "style.css",
      sourcesContent: [".app-layout {\n  width: 100vw;\n  height: 100vh;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.app-layout .app-layout-inner {\n\theight: 100%;\n\twidth: 100%;\n  display: inline-flex;\n  overflow: hidden;\n}\n\n.main-content-area {\n  width: 100%;\n  height: 100%;\n  background: white;\n  opacity: 0;\n  transition: opacity .2s ease-in\n}\n\n.app-layout--loaded .main-content-area{\n  opacity: 1;\n}\n\n.main-navigation > *:not(.logo) {\n  opacity: 0;\n  transition: all 0.3s ease-in\n}\n\n.app-layout--loaded .main-navigation > *:not(.logo) {\n  opacity: 1;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(171);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".request-early-access-container .request-early-access-button-container {\n  margin-top: 20px;\n}\n\n.request-early-access-container .request-early-access-button-container .tide-button {\n  width: 250px;\n}\n\n.request-early-access-container .go-back-to-library-text {\n  width: 250px;\n  margin-top: 5px;\n  padding: 5px;\n}\n\n.request-early-access-container .go-back-to-library-text:hover {\n  background-color: var(--color-p1-3);\n  cursor: pointer;\n}\n\n.request-early-access-container .go-back-to-library-text > small {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n}\n\n.request-early-access-container .go-back-to-library-text .tide-icon {\n  padding-right: 5px;\n}\n\n.request-early-access-container .authorization-upgrade-complete {\n  margin-top: 8px;\n  padding: 5px;\n}\n\n.request-early-access-container .authorization-upgrade-complete > small {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n  color: var(--color-p2);\n}\n\n.request-early-access-container .request-early-access-success-text {\n  color: var(--color-p2-6);\n  font-weight: bold;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB",
      file: "styles.css",
      sourcesContent: [".request-early-access-container .request-early-access-button-container {\n  margin-top: 20px;\n}\n\n.request-early-access-container .request-early-access-button-container .tide-button {\n  width: 250px;\n}\n\n.request-early-access-container .go-back-to-library-text {\n  width: 250px;\n  margin-top: 5px;\n  padding: 5px;\n}\n\n.request-early-access-container .go-back-to-library-text:hover {\n  background-color: var(--color-p1-3);\n  cursor: pointer;\n}\n\n.request-early-access-container .go-back-to-library-text > small {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n}\n\n.request-early-access-container .go-back-to-library-text .tide-icon {\n  padding-right: 5px;\n}\n\n.request-early-access-container .authorization-upgrade-complete {\n  margin-top: 8px;\n  padding: 5px;\n}\n\n.request-early-access-container .authorization-upgrade-complete > small {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n  color: var(--color-p2);\n}\n\n.request-early-access-container .request-early-access-success-text {\n  color: var(--color-p2-6);\n  font-weight: bold;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(173);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(7)(!0)).push([e.i, ".authorization-takeover {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n.authorization-takeover .authorization-takeover-image-container {\n  margin-left: auto;\n}\n\n.authorization-takeover .authorization-takeover-action {\n  width: 425px;\n  margin-right: auto;\n  padding-left: 48px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB",
      file: "styles.css",
      sourcesContent: [".authorization-takeover {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n.authorization-takeover .authorization-takeover-image-container {\n  margin-left: auto;\n}\n\n.authorization-takeover .authorization-takeover-action {\n  width: 425px;\n  margin-right: auto;\n  padding-left: 48px;\n}\n"]
    }]);
  }, function (e, t, n) {
    (function (t) {
      var r = n(175),
          i = n(50),
          o = n(176),
          a = n(177),
          s = n(28),
          c = s.isErrorEvent,
          l = s.isDOMError,
          u = s.isDOMException,
          p = s.isError,
          f = s.isObject,
          d = s.isPlainObject,
          h = s.isUndefined,
          m = s.isFunction,
          g = s.isString,
          A = s.isArray,
          v = s.isEmptyObject,
          b = s.each,
          y = s.objectMerge,
          E = s.truncate,
          C = s.objectFrozen,
          w = s.hasKey,
          _ = s.joinRegExp,
          x = s.urlencode,
          S = s.uuid4,
          k = s.htmlTreeAsString,
          O = s.isSameException,
          B = s.isSameStacktrace,
          T = s.parseUrl,
          I = s.fill,
          R = s.supportsFetch,
          P = s.supportsReferrerPolicy,
          j = s.serializeKeysForMessage,
          N = s.serializeException,
          D = s.sanitize,
          L = n(178).wrapMethod,
          M = "source protocol user pass host port path".split(" "),
          U = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

      function now() {
        return +new Date();
      }

      var F = "undefined" !== typeof window ? window : "undefined" !== typeof t ? t : "undefined" !== typeof self ? self : {},
          z = F.document,
          H = F.navigator;

      function keepOriginalCallback(e, t) {
        return m(t) ? function (n) {
          return t(n, e);
        } : t;
      }

      function Raven() {
        for (var e in this._hasJSON = !("object" !== typeof JSON || !JSON.stringify), this._hasDocument = !h(z), this._hasNavigator = !h(H), this._lastCapturedException = null, this._lastData = null, this._lastEventId = null, this._globalServer = null, this._globalKey = null, this._globalProject = null, this._globalContext = {}, this._globalOptions = {
          release: F.SENTRY_RELEASE && F.SENTRY_RELEASE.id,
          logger: "javascript",
          ignoreErrors: [],
          ignoreUrls: [],
          whitelistUrls: [],
          includePaths: [],
          headers: null,
          collectWindowErrors: !0,
          captureUnhandledRejections: !0,
          maxMessageLength: 0,
          maxUrlLength: 250,
          stackTraceLimit: 50,
          autoBreadcrumbs: !0,
          instrument: !0,
          sampleRate: 1,
          sanitizeKeys: []
        }, this._fetchDefaults = {
          method: "POST",
          referrerPolicy: P() ? "origin" : ""
        }, this._ignoreOnError = 0, this._isRavenInstalled = !1, this._originalErrorStackTraceLimit = Error.stackTraceLimit, this._originalConsole = F.console || {}, this._originalConsoleMethods = {}, this._plugins = [], this._startTime = now(), this._wrappedBuiltIns = [], this._breadcrumbs = [], this._lastCapturedEvent = null, this._keypressTimeout, this._location = F.location, this._lastHref = this._location && this._location.href, this._resetBackoff(), this._originalConsole) {
          this._originalConsoleMethods[e] = this._originalConsole[e];
        }
      }

      Raven.prototype = {
        VERSION: "3.27.0",
        debug: !1,
        TraceKit: r,
        config: function config(e, t) {
          var n = this;
          if (n._globalServer) return this._logDebug("error", "Error: Raven has already been configured"), n;
          if (!e) return n;
          var i = n._globalOptions;
          t && b(t, function (e, t) {
            "tags" === e || "extra" === e || "user" === e ? n._globalContext[e] = t : i[e] = t;
          }), n.setDSN(e), i.ignoreErrors.push(/^Script error\.?$/), i.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/), i.ignoreErrors = _(i.ignoreErrors), i.ignoreUrls = !!i.ignoreUrls.length && _(i.ignoreUrls), i.whitelistUrls = !!i.whitelistUrls.length && _(i.whitelistUrls), i.includePaths = _(i.includePaths), i.maxBreadcrumbs = Math.max(0, Math.min(i.maxBreadcrumbs || 100, 100));
          var o = {
            xhr: !0,
            console: !0,
            dom: !0,
            location: !0,
            sentry: !0
          },
              a = i.autoBreadcrumbs;
          "[object Object]" === {}.toString.call(a) ? a = y(o, a) : !1 !== a && (a = o), i.autoBreadcrumbs = a;
          var s = {
            tryCatch: !0
          },
              c = i.instrument;
          return "[object Object]" === {}.toString.call(c) ? c = y(s, c) : !1 !== c && (c = s), i.instrument = c, r.collectWindowErrors = !!i.collectWindowErrors, n;
        },
        install: function install() {
          var e = this;
          return e.isSetup() && !e._isRavenInstalled && (r.report.subscribe(function () {
            e._handleOnErrorStackInfo.apply(e, arguments);
          }), e._globalOptions.captureUnhandledRejections && e._attachPromiseRejectionHandler(), e._patchFunctionToString(), e._globalOptions.instrument && e._globalOptions.instrument.tryCatch && e._instrumentTryCatch(), e._globalOptions.autoBreadcrumbs && e._instrumentBreadcrumbs(), e._drainPlugins(), e._isRavenInstalled = !0), Error.stackTraceLimit = e._globalOptions.stackTraceLimit, this;
        },
        setDSN: function setDSN(e) {
          var t = this._parseDSN(e),
              n = t.path.lastIndexOf("/"),
              r = t.path.substr(1, n);

          this._dsn = e, this._globalKey = t.user, this._globalSecret = t.pass && t.pass.substr(1), this._globalProject = t.path.substr(n + 1), this._globalServer = this._getGlobalServer(t), this._globalEndpoint = this._globalServer + "/" + r + "api/" + this._globalProject + "/store/", this._resetBackoff();
        },
        context: function context(e, t, n) {
          return m(e) && (n = t || [], t = e, e = {}), this.wrap(e, t).apply(this, n);
        },
        wrap: function wrap(e, t, n) {
          var r = this;
          if (h(t) && !m(e)) return e;
          if (m(e) && (t = e, e = void 0), !m(t)) return t;

          try {
            if (t.__raven__) return t;
            if (t.__raven_wrapper__) return t.__raven_wrapper__;
          } catch (o) {
            return t;
          }

          function wrapped() {
            var i = [],
                a = arguments.length,
                s = !e || e && !1 !== e.deep;

            for (n && m(n) && n.apply(this, arguments); a--;) {
              i[a] = s ? r.wrap(e, arguments[a]) : arguments[a];
            }

            try {
              return t.apply(this, i);
            } catch (o) {
              throw r._ignoreNextOnError(), r.captureException(o, e), o;
            }
          }

          for (var i in t) {
            w(t, i) && (wrapped[i] = t[i]);
          }

          return wrapped.prototype = t.prototype, t.__raven_wrapper__ = wrapped, wrapped.__raven__ = !0, wrapped.__orig__ = t, wrapped;
        },
        uninstall: function uninstall() {
          return r.report.uninstall(), this._detachPromiseRejectionHandler(), this._unpatchFunctionToString(), this._restoreBuiltIns(), this._restoreConsole(), Error.stackTraceLimit = this._originalErrorStackTraceLimit, this._isRavenInstalled = !1, this;
        },
        _promiseRejectionHandler: function _promiseRejectionHandler(e) {
          this._logDebug("debug", "Raven caught unhandled promise rejection:", e), this.captureException(e.reason, {
            mechanism: {
              type: "onunhandledrejection",
              handled: !1
            }
          });
        },
        _attachPromiseRejectionHandler: function _attachPromiseRejectionHandler() {
          return this._promiseRejectionHandler = this._promiseRejectionHandler.bind(this), F.addEventListener && F.addEventListener("unhandledrejection", this._promiseRejectionHandler), this;
        },
        _detachPromiseRejectionHandler: function _detachPromiseRejectionHandler() {
          return F.removeEventListener && F.removeEventListener("unhandledrejection", this._promiseRejectionHandler), this;
        },
        captureException: function captureException(e, t) {
          if (t = y({
            trimHeadFrames: 0
          }, t || {}), c(e) && e.error) e = e.error;else {
            if (l(e) || u(e)) {
              var n = e.name || (l(e) ? "DOMError" : "DOMException"),
                  i = e.message ? n + ": " + e.message : n;
              return this.captureMessage(i, y(t, {
                stacktrace: !0,
                trimHeadFrames: t.trimHeadFrames + 1
              }));
            }

            if (p(e)) e = e;else {
              if (!d(e)) return this.captureMessage(e, y(t, {
                stacktrace: !0,
                trimHeadFrames: t.trimHeadFrames + 1
              }));
              t = this._getCaptureExceptionOptionsFromPlainObject(t, e), e = new Error(t.message);
            }
          }
          this._lastCapturedException = e;

          try {
            var o = r.computeStackTrace(e);

            this._handleStackInfo(o, t);
          } catch (a) {
            if (e !== a) throw a;
          }

          return this;
        },
        _getCaptureExceptionOptionsFromPlainObject: function _getCaptureExceptionOptionsFromPlainObject(e, t) {
          var n = Object.keys(t).sort(),
              r = y(e, {
            message: "Non-Error exception captured with keys: " + j(n),
            fingerprint: [o(n)],
            extra: e.extra || {}
          });
          return r.extra.__serialized__ = N(t), r;
        },
        captureMessage: function captureMessage(e, t) {
          if (!this._globalOptions.ignoreErrors.test || !this._globalOptions.ignoreErrors.test(e)) {
            var n,
                i = y({
              message: e += ""
            }, t = t || {});

            try {
              throw new Error(e);
            } catch (l) {
              n = l;
            }

            n.name = null;
            var o = r.computeStackTrace(n),
                a = A(o.stack) && o.stack[1];
            a && "Raven.captureException" === a.func && (a = o.stack[2]);
            var s = a && a.url || "";

            if ((!this._globalOptions.ignoreUrls.test || !this._globalOptions.ignoreUrls.test(s)) && (!this._globalOptions.whitelistUrls.test || this._globalOptions.whitelistUrls.test(s))) {
              if (this._globalOptions.stacktrace || t.stacktrace || "" === i.message) {
                i.fingerprint = null == i.fingerprint ? e : i.fingerprint, (t = y({
                  trimHeadFrames: 0
                }, t)).trimHeadFrames += 1;

                var c = this._prepareFrames(o, t);

                i.stacktrace = {
                  frames: c.reverse()
                };
              }

              return i.fingerprint && (i.fingerprint = A(i.fingerprint) ? i.fingerprint : [i.fingerprint]), this._send(i), this;
            }
          }
        },
        captureBreadcrumb: function captureBreadcrumb(e) {
          var t = y({
            timestamp: now() / 1e3
          }, e);

          if (m(this._globalOptions.breadcrumbCallback)) {
            var n = this._globalOptions.breadcrumbCallback(t);

            if (f(n) && !v(n)) t = n;else if (!1 === n) return this;
          }

          return this._breadcrumbs.push(t), this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs && this._breadcrumbs.shift(), this;
        },
        addPlugin: function addPlugin(e) {
          var t = [].slice.call(arguments, 1);
          return this._plugins.push([e, t]), this._isRavenInstalled && this._drainPlugins(), this;
        },
        setUserContext: function setUserContext(e) {
          return this._globalContext.user = e, this;
        },
        setExtraContext: function setExtraContext(e) {
          return this._mergeContext("extra", e), this;
        },
        setTagsContext: function setTagsContext(e) {
          return this._mergeContext("tags", e), this;
        },
        clearContext: function clearContext() {
          return this._globalContext = {}, this;
        },
        getContext: function getContext() {
          return JSON.parse(i(this._globalContext));
        },
        setEnvironment: function setEnvironment(e) {
          return this._globalOptions.environment = e, this;
        },
        setRelease: function setRelease(e) {
          return this._globalOptions.release = e, this;
        },
        setDataCallback: function setDataCallback(e) {
          var t = this._globalOptions.dataCallback;
          return this._globalOptions.dataCallback = keepOriginalCallback(t, e), this;
        },
        setBreadcrumbCallback: function setBreadcrumbCallback(e) {
          var t = this._globalOptions.breadcrumbCallback;
          return this._globalOptions.breadcrumbCallback = keepOriginalCallback(t, e), this;
        },
        setShouldSendCallback: function setShouldSendCallback(e) {
          var t = this._globalOptions.shouldSendCallback;
          return this._globalOptions.shouldSendCallback = keepOriginalCallback(t, e), this;
        },
        setTransport: function setTransport(e) {
          return this._globalOptions.transport = e, this;
        },
        lastException: function lastException() {
          return this._lastCapturedException;
        },
        lastEventId: function lastEventId() {
          return this._lastEventId;
        },
        isSetup: function isSetup() {
          return !!this._hasJSON && (!!this._globalServer || (this.ravenNotConfiguredError || (this.ravenNotConfiguredError = !0, this._logDebug("error", "Error: Raven has not been configured.")), !1));
        },
        afterLoad: function afterLoad() {
          var e = F.RavenConfig;
          e && this.config(e.dsn, e.config).install();
        },
        showReportDialog: function showReportDialog(e) {
          if (z) {
            if (!(e = y({
              eventId: this.lastEventId(),
              dsn: this._dsn,
              user: this._globalContext.user || {}
            }, e)).eventId) throw new a("Missing eventId");
            if (!e.dsn) throw new a("Missing DSN");
            var t = encodeURIComponent,
                n = [];

            for (var r in e) {
              if ("user" === r) {
                var i = e.user;
                i.name && n.push("name=" + t(i.name)), i.email && n.push("email=" + t(i.email));
              } else n.push(t(r) + "=" + t(e[r]));
            }

            var o = this._getGlobalServer(this._parseDSN(e.dsn)),
                s = z.createElement("script");

            s.async = !0, s.src = o + "/api/embed/error-page/?" + n.join("&"), (z.head || z.body).appendChild(s);
          }
        },
        _ignoreNextOnError: function _ignoreNextOnError() {
          var e = this;
          this._ignoreOnError += 1, setTimeout(function () {
            e._ignoreOnError -= 1;
          });
        },
        _triggerEvent: function _triggerEvent(e, t) {
          var n, r;

          if (this._hasDocument) {
            for (r in t = t || {}, e = "raven" + e.substr(0, 1).toUpperCase() + e.substr(1), z.createEvent ? (n = z.createEvent("HTMLEvents")).initEvent(e, !0, !0) : (n = z.createEventObject()).eventType = e, t) {
              w(t, r) && (n[r] = t[r]);
            }

            if (z.createEvent) z.dispatchEvent(n);else try {
              z.fireEvent("on" + n.eventType.toLowerCase(), n);
            } catch (i) {}
          }
        },
        _breadcrumbEventHandler: function _breadcrumbEventHandler(e) {
          var t = this;
          return function (n) {
            if (t._keypressTimeout = null, t._lastCapturedEvent !== n) {
              var r;
              t._lastCapturedEvent = n;

              try {
                r = k(n.target);
              } catch (i) {
                r = "<unknown>";
              }

              t.captureBreadcrumb({
                category: "ui." + e,
                message: r
              });
            }
          };
        },
        _keypressEventHandler: function _keypressEventHandler() {
          var e = this;
          return function (t) {
            var n;

            try {
              n = t.target;
            } catch (o) {
              return;
            }

            var r = n && n.tagName;

            if (r && ("INPUT" === r || "TEXTAREA" === r || n.isContentEditable)) {
              var i = e._keypressTimeout;
              i || e._breadcrumbEventHandler("input")(t), clearTimeout(i), e._keypressTimeout = setTimeout(function () {
                e._keypressTimeout = null;
              }, 1e3);
            }
          };
        },
        _captureUrlChange: function _captureUrlChange(e, t) {
          var n = T(this._location.href),
              r = T(t),
              i = T(e);
          this._lastHref = t, n.protocol === r.protocol && n.host === r.host && (t = r.relative), n.protocol === i.protocol && n.host === i.host && (e = i.relative), this.captureBreadcrumb({
            category: "navigation",
            data: {
              to: t,
              from: e
            }
          });
        },
        _patchFunctionToString: function _patchFunctionToString() {
          var e = this;
          e._originalFunctionToString = Function.prototype.toString, Function.prototype.toString = function () {
            return "function" === typeof this && this.__raven__ ? e._originalFunctionToString.apply(this.__orig__, arguments) : e._originalFunctionToString.apply(this, arguments);
          };
        },
        _unpatchFunctionToString: function _unpatchFunctionToString() {
          this._originalFunctionToString && (Function.prototype.toString = this._originalFunctionToString);
        },
        _instrumentTryCatch: function _instrumentTryCatch() {
          var e = this,
              t = e._wrappedBuiltIns;

          function wrapTimeFn(t) {
            return function (n, r) {
              for (var i = new Array(arguments.length), o = 0; o < i.length; ++o) {
                i[o] = arguments[o];
              }

              var a = i[0];
              return m(a) && (i[0] = e.wrap({
                mechanism: {
                  type: "instrument",
                  data: {
                    function: t.name || "<anonymous>"
                  }
                }
              }, a)), t.apply ? t.apply(this, i) : t(i[0], i[1]);
            };
          }

          var n = this._globalOptions.autoBreadcrumbs;

          function wrapEventTarget(r) {
            var i = F[r] && F[r].prototype;
            i && i.hasOwnProperty && i.hasOwnProperty("addEventListener") && (I(i, "addEventListener", function (t) {
              return function (i, o, a, s) {
                try {
                  o && o.handleEvent && (o.handleEvent = e.wrap({
                    mechanism: {
                      type: "instrument",
                      data: {
                        target: r,
                        function: "handleEvent",
                        handler: o && o.name || "<anonymous>"
                      }
                    }
                  }, o.handleEvent));
                } catch (p) {}

                var c, l, u;
                return n && n.dom && ("EventTarget" === r || "Node" === r) && (l = e._breadcrumbEventHandler("click"), u = e._keypressEventHandler(), c = function before(e) {
                  if (e) {
                    var t;

                    try {
                      t = e.type;
                    } catch (n) {
                      return;
                    }

                    return "click" === t ? l(e) : "keypress" === t ? u(e) : void 0;
                  }
                }), t.call(this, i, e.wrap({
                  mechanism: {
                    type: "instrument",
                    data: {
                      target: r,
                      function: "addEventListener",
                      handler: o && o.name || "<anonymous>"
                    }
                  }
                }, o, c), a, s);
              };
            }, t), I(i, "removeEventListener", function (e) {
              return function (t, n, r, i) {
                try {
                  n = n && (n.__raven_wrapper__ ? n.__raven_wrapper__ : n);
                } catch (o) {}

                return e.call(this, t, n, r, i);
              };
            }, t));
          }

          I(F, "setTimeout", wrapTimeFn, t), I(F, "setInterval", wrapTimeFn, t), F.requestAnimationFrame && I(F, "requestAnimationFrame", function (t) {
            return function (n) {
              return t(e.wrap({
                mechanism: {
                  type: "instrument",
                  data: {
                    function: "requestAnimationFrame",
                    handler: t && t.name || "<anonymous>"
                  }
                }
              }, n));
            };
          }, t);

          for (var r = ["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"], i = 0; i < r.length; i++) {
            wrapEventTarget(r[i]);
          }
        },
        _instrumentBreadcrumbs: function _instrumentBreadcrumbs() {
          var e = this,
              t = this._globalOptions.autoBreadcrumbs,
              n = e._wrappedBuiltIns;

          function wrapProp(t, n) {
            t in n && m(n[t]) && I(n, t, function (n) {
              return e.wrap({
                mechanism: {
                  type: "instrument",
                  data: {
                    function: t,
                    handler: n && n.name || "<anonymous>"
                  }
                }
              }, n);
            });
          }

          if (t.xhr && "XMLHttpRequest" in F) {
            var r = F.XMLHttpRequest && F.XMLHttpRequest.prototype;
            I(r, "open", function (t) {
              return function (n, r) {
                return g(r) && -1 === r.indexOf(e._globalKey) && (this.__raven_xhr = {
                  method: n,
                  url: r,
                  status_code: null
                }), t.apply(this, arguments);
              };
            }, n), I(r, "send", function (t) {
              return function () {
                var n = this;

                function onreadystatechangeHandler() {
                  if (n.__raven_xhr && 4 === n.readyState) {
                    try {
                      n.__raven_xhr.status_code = n.status;
                    } catch (t) {}

                    e.captureBreadcrumb({
                      type: "http",
                      category: "xhr",
                      data: n.__raven_xhr
                    });
                  }
                }

                for (var r = ["onload", "onerror", "onprogress"], i = 0; i < r.length; i++) {
                  wrapProp(r[i], n);
                }

                return "onreadystatechange" in n && m(n.onreadystatechange) ? I(n, "onreadystatechange", function (t) {
                  return e.wrap({
                    mechanism: {
                      type: "instrument",
                      data: {
                        function: "onreadystatechange",
                        handler: t && t.name || "<anonymous>"
                      }
                    }
                  }, t, onreadystatechangeHandler);
                }) : n.onreadystatechange = onreadystatechangeHandler, t.apply(this, arguments);
              };
            }, n);
          }

          t.xhr && R() && I(F, "fetch", function (t) {
            return function () {
              for (var n = new Array(arguments.length), r = 0; r < n.length; ++r) {
                n[r] = arguments[r];
              }

              var i,
                  o = n[0],
                  a = "GET";
              if ("string" === typeof o ? i = o : "Request" in F && o instanceof F.Request ? (i = o.url, o.method && (a = o.method)) : i = "" + o, -1 !== i.indexOf(e._globalKey)) return t.apply(this, n);
              n[1] && n[1].method && (a = n[1].method);
              var s = {
                method: a,
                url: i,
                status_code: null
              };
              return t.apply(this, n).then(function (t) {
                return s.status_code = t.status, e.captureBreadcrumb({
                  type: "http",
                  category: "fetch",
                  data: s
                }), t;
              }).catch(function (t) {
                throw e.captureBreadcrumb({
                  type: "http",
                  category: "fetch",
                  data: s,
                  level: "error"
                }), t;
              });
            };
          }, n), t.dom && this._hasDocument && (z.addEventListener ? (z.addEventListener("click", e._breadcrumbEventHandler("click"), !1), z.addEventListener("keypress", e._keypressEventHandler(), !1)) : z.attachEvent && (z.attachEvent("onclick", e._breadcrumbEventHandler("click")), z.attachEvent("onkeypress", e._keypressEventHandler())));
          var i = F.chrome,
              o = !(i && i.app && i.app.runtime) && F.history && F.history.pushState && F.history.replaceState;

          if (t.location && o) {
            var a = F.onpopstate;

            F.onpopstate = function () {
              var t = e._location.href;
              if (e._captureUrlChange(e._lastHref, t), a) return a.apply(this, arguments);
            };

            var s = function historyReplacementFunction(t) {
              return function () {
                var n = arguments.length > 2 ? arguments[2] : void 0;
                return n && e._captureUrlChange(e._lastHref, n + ""), t.apply(this, arguments);
              };
            };

            I(F.history, "pushState", s, n), I(F.history, "replaceState", s, n);
          }

          if (t.console && "console" in F && console.log) {
            var c = function consoleMethodCallback(t, n) {
              e.captureBreadcrumb({
                message: t,
                level: n.level,
                category: "console"
              });
            };

            b(["debug", "info", "warn", "error", "log"], function (e, t) {
              L(console, t, c);
            });
          }
        },
        _restoreBuiltIns: function _restoreBuiltIns() {
          for (var e; this._wrappedBuiltIns.length;) {
            var t = (e = this._wrappedBuiltIns.shift())[0],
                n = e[1],
                r = e[2];

            t[n] = r;
          }
        },
        _restoreConsole: function _restoreConsole() {
          for (var e in this._originalConsoleMethods) {
            this._originalConsole[e] = this._originalConsoleMethods[e];
          }
        },
        _drainPlugins: function _drainPlugins() {
          var e = this;
          b(this._plugins, function (t, n) {
            var r = n[0],
                i = n[1];
            r.apply(e, [e].concat(i));
          });
        },
        _parseDSN: function _parseDSN(e) {
          var t = U.exec(e),
              n = {},
              r = 7;

          try {
            for (; r--;) {
              n[M[r]] = t[r] || "";
            }
          } catch (i) {
            throw new a("Invalid DSN: " + e);
          }

          if (n.pass && !this._globalOptions.allowSecretKey) throw new a("Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key");
          return n;
        },
        _getGlobalServer: function _getGlobalServer(e) {
          var t = "//" + e.host + (e.port ? ":" + e.port : "");
          return e.protocol && (t = e.protocol + ":" + t), t;
        },
        _handleOnErrorStackInfo: function _handleOnErrorStackInfo(e, t) {
          (t = t || {}).mechanism = t.mechanism || {
            type: "onerror",
            handled: !1
          }, this._ignoreOnError || this._handleStackInfo(e, t);
        },
        _handleStackInfo: function _handleStackInfo(e, t) {
          var n = this._prepareFrames(e, t);

          this._triggerEvent("handle", {
            stackInfo: e,
            options: t
          }), this._processException(e.name, e.message, e.url, e.lineno, n, t);
        },
        _prepareFrames: function _prepareFrames(e, t) {
          var n = this,
              r = [];
          if (e.stack && e.stack.length && (b(e.stack, function (t, i) {
            var o = n._normalizeFrame(i, e.url);

            o && r.push(o);
          }), t && t.trimHeadFrames)) for (var i = 0; i < t.trimHeadFrames && i < r.length; i++) {
            r[i].in_app = !1;
          }
          return r = r.slice(0, this._globalOptions.stackTraceLimit);
        },
        _normalizeFrame: function _normalizeFrame(e, t) {
          var n = {
            filename: e.url,
            lineno: e.line,
            colno: e.column,
            function: e.func || "?"
          };
          return e.url || (n.filename = t), n.in_app = !(this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(n.filename) || /(Raven|TraceKit)\./.test(n.function) || /raven\.(min\.)?js$/.test(n.filename)), n;
        },
        _processException: function _processException(e, t, n, r, i, o) {
          var a,
              s = (e ? e + ": " : "") + (t || "");

          if ((!this._globalOptions.ignoreErrors.test || !this._globalOptions.ignoreErrors.test(t) && !this._globalOptions.ignoreErrors.test(s)) && (i && i.length ? (n = i[0].filename || n, i.reverse(), a = {
            frames: i
          }) : n && (a = {
            frames: [{
              filename: n,
              lineno: r,
              in_app: !0
            }]
          }), (!this._globalOptions.ignoreUrls.test || !this._globalOptions.ignoreUrls.test(n)) && (!this._globalOptions.whitelistUrls.test || this._globalOptions.whitelistUrls.test(n)))) {
            var c = y({
              exception: {
                values: [{
                  type: e,
                  value: t,
                  stacktrace: a
                }]
              },
              transaction: n
            }, o),
                l = c.exception.values[0];
            null == l.type && "" === l.value && (l.value = "Unrecoverable error caught"), !c.exception.mechanism && c.mechanism && (c.exception.mechanism = c.mechanism, delete c.mechanism), c.exception.mechanism = y({
              type: "generic",
              handled: !0
            }, c.exception.mechanism || {}), this._send(c);
          }
        },
        _trimPacket: function _trimPacket(e) {
          var t = this._globalOptions.maxMessageLength;

          if (e.message && (e.message = E(e.message, t)), e.exception) {
            var n = e.exception.values[0];
            n.value = E(n.value, t);
          }

          var r = e.request;
          return r && (r.url && (r.url = E(r.url, this._globalOptions.maxUrlLength)), r.Referer && (r.Referer = E(r.Referer, this._globalOptions.maxUrlLength))), e.breadcrumbs && e.breadcrumbs.values && this._trimBreadcrumbs(e.breadcrumbs), e;
        },
        _trimBreadcrumbs: function _trimBreadcrumbs(e) {
          for (var t, n, r, i = ["to", "from", "url"], o = 0; o < e.values.length; ++o) {
            if ((n = e.values[o]).hasOwnProperty("data") && f(n.data) && !C(n.data)) {
              r = y({}, n.data);

              for (var a = 0; a < i.length; ++a) {
                t = i[a], r.hasOwnProperty(t) && r[t] && (r[t] = E(r[t], this._globalOptions.maxUrlLength));
              }

              e.values[o].data = r;
            }
          }
        },
        _getHttpData: function _getHttpData() {
          if (this._hasNavigator || this._hasDocument) {
            var e = {};
            return this._hasNavigator && H.userAgent && (e.headers = {
              "User-Agent": H.userAgent
            }), F.location && F.location.href && (e.url = F.location.href), this._hasDocument && z.referrer && (e.headers || (e.headers = {}), e.headers.Referer = z.referrer), e;
          }
        },
        _resetBackoff: function _resetBackoff() {
          this._backoffDuration = 0, this._backoffStart = null;
        },
        _shouldBackoff: function _shouldBackoff() {
          return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
        },
        _isRepeatData: function _isRepeatData(e) {
          var t = this._lastData;
          return !(!t || e.message !== t.message || e.transaction !== t.transaction) && (e.stacktrace || t.stacktrace ? B(e.stacktrace, t.stacktrace) : !e.exception && !t.exception || O(e.exception, t.exception));
        },
        _setBackoffState: function _setBackoffState(e) {
          if (!this._shouldBackoff()) {
            var t = e.status;

            if (400 === t || 401 === t || 429 === t) {
              var n;

              try {
                n = R() ? e.headers.get("Retry-After") : e.getResponseHeader("Retry-After"), n = 1e3 * parseInt(n, 10);
              } catch (r) {}

              this._backoffDuration = n || 2 * this._backoffDuration || 1e3, this._backoffStart = now();
            }
          }
        },
        _send: function _send(e) {
          var t = this._globalOptions,
              n = {
            project: this._globalProject,
            logger: t.logger,
            platform: "javascript"
          },
              r = this._getHttpData();

          r && (n.request = r), e.trimHeadFrames && delete e.trimHeadFrames, (e = y(n, e)).tags = y(y({}, this._globalContext.tags), e.tags), e.extra = y(y({}, this._globalContext.extra), e.extra), e.extra["session:duration"] = now() - this._startTime, this._breadcrumbs && this._breadcrumbs.length > 0 && (e.breadcrumbs = {
            values: [].slice.call(this._breadcrumbs, 0)
          }), this._globalContext.user && (e.user = this._globalContext.user), t.environment && (e.environment = t.environment), t.release && (e.release = t.release), t.serverName && (e.server_name = t.serverName), e = this._sanitizeData(e), Object.keys(e).forEach(function (t) {
            (null == e[t] || "" === e[t] || v(e[t])) && delete e[t];
          }), m(t.dataCallback) && (e = t.dataCallback(e) || e), e && !v(e) && (m(t.shouldSendCallback) && !t.shouldSendCallback(e) || (this._shouldBackoff() ? this._logDebug("warn", "Raven dropped error due to backoff: ", e) : "number" === typeof t.sampleRate ? Math.random() < t.sampleRate && this._sendProcessedPayload(e) : this._sendProcessedPayload(e)));
        },
        _sanitizeData: function _sanitizeData(e) {
          return D(e, this._globalOptions.sanitizeKeys);
        },
        _getUuid: function _getUuid() {
          return S();
        },
        _sendProcessedPayload: function _sendProcessedPayload(e, t) {
          var n = this,
              r = this._globalOptions;
          if (this.isSetup()) if (e = this._trimPacket(e), this._globalOptions.allowDuplicates || !this._isRepeatData(e)) {
            this._lastEventId = e.event_id || (e.event_id = this._getUuid()), this._lastData = e, this._logDebug("debug", "Raven about to send:", e);
            var i = {
              sentry_version: "7",
              sentry_client: "raven-js/" + this.VERSION,
              sentry_key: this._globalKey
            };
            this._globalSecret && (i.sentry_secret = this._globalSecret);
            var o = e.exception && e.exception.values[0];
            this._globalOptions.autoBreadcrumbs && this._globalOptions.autoBreadcrumbs.sentry && this.captureBreadcrumb({
              category: "sentry",
              message: o ? (o.type ? o.type + ": " : "") + o.value : e.message,
              event_id: e.event_id,
              level: e.level || "error"
            });
            var a = this._globalEndpoint;

            (r.transport || this._makeRequest).call(this, {
              url: a,
              auth: i,
              data: e,
              options: r,
              onSuccess: function success() {
                n._resetBackoff(), n._triggerEvent("success", {
                  data: e,
                  src: a
                }), t && t();
              },
              onError: function failure(r) {
                n._logDebug("error", "Raven transport failed to send: ", r), r.request && n._setBackoffState(r.request), n._triggerEvent("failure", {
                  data: e,
                  src: a
                }), r = r || new Error("Raven send failed (no additional details provided)"), t && t(r);
              }
            });
          } else this._logDebug("warn", "Raven dropped repeat event: ", e);
        },
        _makeRequest: function _makeRequest(e) {
          var t = e.url + "?" + x(e.auth),
              n = null,
              r = {};

          if (e.options.headers && (n = this._evaluateHash(e.options.headers)), e.options.fetchParameters && (r = this._evaluateHash(e.options.fetchParameters)), R()) {
            r.body = i(e.data);
            var o = y({}, this._fetchDefaults),
                a = y(o, r);
            return n && (a.headers = n), F.fetch(t, a).then(function (t) {
              if (t.ok) e.onSuccess && e.onSuccess();else {
                var n = new Error("Sentry error code: " + t.status);
                n.request = t, e.onError && e.onError(n);
              }
            }).catch(function () {
              e.onError && e.onError(new Error("Sentry error code: network unavailable"));
            });
          }

          var s = F.XMLHttpRequest && new F.XMLHttpRequest();
          s && ("withCredentials" in s || "undefined" !== typeof XDomainRequest) && ("withCredentials" in s ? s.onreadystatechange = function () {
            if (4 === s.readyState) if (200 === s.status) e.onSuccess && e.onSuccess();else if (e.onError) {
              var t = new Error("Sentry error code: " + s.status);
              t.request = s, e.onError(t);
            }
          } : (s = new XDomainRequest(), t = t.replace(/^https?:/, ""), e.onSuccess && (s.onload = e.onSuccess), e.onError && (s.onerror = function () {
            var t = new Error("Sentry error code: XDomainRequest");
            t.request = s, e.onError(t);
          })), s.open("POST", t), n && b(n, function (e, t) {
            s.setRequestHeader(e, t);
          }), s.send(i(e.data)));
        },
        _evaluateHash: function _evaluateHash(e) {
          var t = {};

          for (var n in e) {
            if (e.hasOwnProperty(n)) {
              var r = e[n];
              t[n] = "function" === typeof r ? r() : r;
            }
          }

          return t;
        },
        _logDebug: function _logDebug(e) {
          this._originalConsoleMethods[e] && (this.debug || this._globalOptions.debug) && Function.prototype.apply.call(this._originalConsoleMethods[e], this._originalConsole, [].slice.call(arguments, 1));
        },
        _mergeContext: function _mergeContext(e, t) {
          h(t) ? delete this._globalContext[e] : this._globalContext[e] = y(this._globalContext[e] || {}, t);
        }
      }, Raven.prototype.setUser = Raven.prototype.setUserContext, Raven.prototype.setReleaseContext = Raven.prototype.setRelease, e.exports = Raven;
    }).call(this, n(17));
  }, function (e, t, n) {
    (function (t) {
      var r = n(28),
          i = {
        collectWindowErrors: !0,
        debug: !1
      },
          o = "undefined" !== typeof window ? window : "undefined" !== typeof t ? t : "undefined" !== typeof self ? self : {},
          a = [].slice,
          s = "?",
          c = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

      function getLocationHref() {
        return "undefined" === typeof document || null == document.location ? "" : document.location.href;
      }

      i.report = function reportModuleWrapper() {
        var e,
            t,
            n = [],
            l = null,
            u = null,
            p = null;

        function notifyHandlers(e, t) {
          var r = null;

          if (!t || i.collectWindowErrors) {
            for (var o in n) {
              if (n.hasOwnProperty(o)) try {
                n[o].apply(null, [e].concat(a.call(arguments, 2)));
              } catch (s) {
                r = s;
              }
            }

            if (r) throw r;
          }
        }

        function traceKitWindowOnError(t, n, o, a, l) {
          var u = r.isErrorEvent(l) ? l.error : l,
              f = r.isErrorEvent(t) ? t.message : t;
          if (p) i.computeStackTrace.augmentStackTraceWithInitialElement(p, n, o, f), processLastException();else if (u && r.isError(u)) notifyHandlers(i.computeStackTrace(u), !0);else {
            var d,
                h = {
              url: n,
              line: o,
              column: a
            },
                m = void 0;
            if ("[object String]" === {}.toString.call(f)) (d = f.match(c)) && (m = d[1], f = d[2]);
            h.func = s, notifyHandlers({
              name: m,
              message: f,
              url: getLocationHref(),
              stack: [h]
            }, !0);
          }
          return !!e && e.apply(this, arguments);
        }

        function processLastException() {
          var e = p,
              t = l;
          l = null, p = null, u = null, notifyHandlers.apply(null, [e, !1].concat(t));
        }

        function report(e, t) {
          var n = a.call(arguments, 1);

          if (p) {
            if (u === e) return;
            processLastException();
          }

          var r = i.computeStackTrace(e);
          if (p = r, u = e, l = n, setTimeout(function () {
            u === e && processLastException();
          }, r.incomplete ? 2e3 : 0), !1 !== t) throw e;
        }

        return report.subscribe = function subscribe(r) {
          !function installGlobalHandler() {
            t || (e = o.onerror, o.onerror = traceKitWindowOnError, t = !0);
          }(), n.push(r);
        }, report.unsubscribe = function unsubscribe(e) {
          for (var t = n.length - 1; t >= 0; --t) {
            n[t] === e && n.splice(t, 1);
          }
        }, report.uninstall = function unsubscribeAll() {
          !function uninstallGlobalHandler() {
            t && (o.onerror = e, t = !1, e = void 0);
          }(), n = [];
        }, report;
      }(), i.computeStackTrace = function computeStackTraceWrapper() {
        function computeStackTraceFromStackProp(e) {
          if ("undefined" !== typeof e.stack && e.stack) {
            for (var t, n, r, i = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, o = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx(?:-web)|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, a = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, c = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, l = /\((\S*)(?::(\d+))(?::(\d+))\)/, u = e.stack.split("\n"), p = [], f = (/^(.*) is undefined$/.exec(e.message), 0), d = u.length; f < d; ++f) {
              if (n = i.exec(u[f])) {
                var h = n[2] && 0 === n[2].indexOf("native");
                n[2] && 0 === n[2].indexOf("eval") && (t = l.exec(n[2])) && (n[2] = t[1], n[3] = t[2], n[4] = t[3]), r = {
                  url: h ? null : n[2],
                  func: n[1] || s,
                  args: h ? [n[2]] : [],
                  line: n[3] ? +n[3] : null,
                  column: n[4] ? +n[4] : null
                };
              } else if (n = o.exec(u[f])) r = {
                url: n[2],
                func: n[1] || s,
                args: [],
                line: +n[3],
                column: n[4] ? +n[4] : null
              };else {
                if (!(n = a.exec(u[f]))) continue;
                n[3] && n[3].indexOf(" > eval") > -1 && (t = c.exec(n[3])) ? (n[3] = t[1], n[4] = t[2], n[5] = null) : 0 !== f || n[5] || "undefined" === typeof e.columnNumber || (p[0].column = e.columnNumber + 1), r = {
                  url: n[3],
                  func: n[1] || s,
                  args: n[2] ? n[2].split(",") : [],
                  line: n[4] ? +n[4] : null,
                  column: n[5] ? +n[5] : null
                };
              }

              if (!r.func && r.line && (r.func = s), r.url && "blob:" === r.url.substr(0, 5)) {
                var m = new XMLHttpRequest();

                if (m.open("GET", r.url, !1), m.send(null), 200 === m.status) {
                  var g = m.responseText || "",
                      A = (g = g.slice(-300)).match(/\/\/# sourceMappingURL=(.*)$/);

                  if (A) {
                    var v = A[1];
                    "~" === v.charAt(0) && (v = ("undefined" === typeof document || null == document.location ? "" : document.location.origin ? document.location.origin : document.location.protocol + "//" + document.location.hostname + (document.location.port ? ":" + document.location.port : "")) + v.slice(1)), r.url = v.slice(0, -4);
                  }
                }
              }

              p.push(r);
            }

            return p.length ? {
              name: e.name,
              message: e.message,
              url: getLocationHref(),
              stack: p
            } : null;
          }
        }

        function augmentStackTraceWithInitialElement(e, t, n, r) {
          var i = {
            url: t,
            line: n
          };

          if (i.url && i.line) {
            if (e.incomplete = !1, i.func || (i.func = s), e.stack.length > 0 && e.stack[0].url === i.url) {
              if (e.stack[0].line === i.line) return !1;
              if (!e.stack[0].line && e.stack[0].func === i.func) return e.stack[0].line = i.line, !1;
            }

            return e.stack.unshift(i), e.partial = !0, !0;
          }

          return e.incomplete = !0, !1;
        }

        function computeStackTraceByWalkingCallerChain(e, t) {
          for (var n, r, o = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, a = [], c = {}, l = !1, u = computeStackTraceByWalkingCallerChain.caller; u && !l; u = u.caller) {
            if (u !== computeStackTrace && u !== i.report) {
              if (r = {
                url: null,
                func: s,
                line: null,
                column: null
              }, u.name ? r.func = u.name : (n = o.exec(u.toString())) && (r.func = n[1]), "undefined" === typeof r.func) try {
                r.func = n.input.substring(0, n.input.indexOf("{"));
              } catch (f) {}
              c["" + u] ? l = !0 : c["" + u] = !0, a.push(r);
            }
          }

          t && a.splice(0, t);
          var p = {
            name: e.name,
            message: e.message,
            url: getLocationHref(),
            stack: a
          };
          return augmentStackTraceWithInitialElement(p, e.sourceURL || e.fileName, e.line || e.lineNumber, e.message || e.description), p;
        }

        function computeStackTrace(e, t) {
          var n = null;
          t = null == t ? 0 : +t;

          try {
            if (n = computeStackTraceFromStackProp(e)) return n;
          } catch (r) {
            if (i.debug) throw r;
          }

          try {
            if (n = computeStackTraceByWalkingCallerChain(e, t + 1)) return n;
          } catch (r) {
            if (i.debug) throw r;
          }

          return {
            name: e.name,
            message: e.message,
            url: getLocationHref()
          };
        }

        return computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement, computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp, computeStackTrace;
      }(), e.exports = i;
    }).call(this, n(17));
  }, function (e, t) {
    function safeAdd(e, t) {
      var n = (65535 & e) + (65535 & t);
      return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
    }

    function md5cmn(e, t, n, r, i, o) {
      return safeAdd(function bitRotateLeft(e, t) {
        return e << t | e >>> 32 - t;
      }(safeAdd(safeAdd(t, e), safeAdd(r, o)), i), n);
    }

    function md5ff(e, t, n, r, i, o, a) {
      return md5cmn(t & n | ~t & r, e, t, i, o, a);
    }

    function md5gg(e, t, n, r, i, o, a) {
      return md5cmn(t & r | n & ~r, e, t, i, o, a);
    }

    function md5hh(e, t, n, r, i, o, a) {
      return md5cmn(t ^ n ^ r, e, t, i, o, a);
    }

    function md5ii(e, t, n, r, i, o, a) {
      return md5cmn(n ^ (t | ~r), e, t, i, o, a);
    }

    function binlMD5(e, t) {
      var n, r, i, o, a;
      e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
      var s = 1732584193,
          c = -271733879,
          l = -1732584194,
          u = 271733878;

      for (n = 0; n < e.length; n += 16) {
        r = s, i = c, o = l, a = u, s = md5ff(s, c, l, u, e[n], 7, -680876936), u = md5ff(u, s, c, l, e[n + 1], 12, -389564586), l = md5ff(l, u, s, c, e[n + 2], 17, 606105819), c = md5ff(c, l, u, s, e[n + 3], 22, -1044525330), s = md5ff(s, c, l, u, e[n + 4], 7, -176418897), u = md5ff(u, s, c, l, e[n + 5], 12, 1200080426), l = md5ff(l, u, s, c, e[n + 6], 17, -1473231341), c = md5ff(c, l, u, s, e[n + 7], 22, -45705983), s = md5ff(s, c, l, u, e[n + 8], 7, 1770035416), u = md5ff(u, s, c, l, e[n + 9], 12, -1958414417), l = md5ff(l, u, s, c, e[n + 10], 17, -42063), c = md5ff(c, l, u, s, e[n + 11], 22, -1990404162), s = md5ff(s, c, l, u, e[n + 12], 7, 1804603682), u = md5ff(u, s, c, l, e[n + 13], 12, -40341101), l = md5ff(l, u, s, c, e[n + 14], 17, -1502002290), s = md5gg(s, c = md5ff(c, l, u, s, e[n + 15], 22, 1236535329), l, u, e[n + 1], 5, -165796510), u = md5gg(u, s, c, l, e[n + 6], 9, -1069501632), l = md5gg(l, u, s, c, e[n + 11], 14, 643717713), c = md5gg(c, l, u, s, e[n], 20, -373897302), s = md5gg(s, c, l, u, e[n + 5], 5, -701558691), u = md5gg(u, s, c, l, e[n + 10], 9, 38016083), l = md5gg(l, u, s, c, e[n + 15], 14, -660478335), c = md5gg(c, l, u, s, e[n + 4], 20, -405537848), s = md5gg(s, c, l, u, e[n + 9], 5, 568446438), u = md5gg(u, s, c, l, e[n + 14], 9, -1019803690), l = md5gg(l, u, s, c, e[n + 3], 14, -187363961), c = md5gg(c, l, u, s, e[n + 8], 20, 1163531501), s = md5gg(s, c, l, u, e[n + 13], 5, -1444681467), u = md5gg(u, s, c, l, e[n + 2], 9, -51403784), l = md5gg(l, u, s, c, e[n + 7], 14, 1735328473), s = md5hh(s, c = md5gg(c, l, u, s, e[n + 12], 20, -1926607734), l, u, e[n + 5], 4, -378558), u = md5hh(u, s, c, l, e[n + 8], 11, -2022574463), l = md5hh(l, u, s, c, e[n + 11], 16, 1839030562), c = md5hh(c, l, u, s, e[n + 14], 23, -35309556), s = md5hh(s, c, l, u, e[n + 1], 4, -1530992060), u = md5hh(u, s, c, l, e[n + 4], 11, 1272893353), l = md5hh(l, u, s, c, e[n + 7], 16, -155497632), c = md5hh(c, l, u, s, e[n + 10], 23, -1094730640), s = md5hh(s, c, l, u, e[n + 13], 4, 681279174), u = md5hh(u, s, c, l, e[n], 11, -358537222), l = md5hh(l, u, s, c, e[n + 3], 16, -722521979), c = md5hh(c, l, u, s, e[n + 6], 23, 76029189), s = md5hh(s, c, l, u, e[n + 9], 4, -640364487), u = md5hh(u, s, c, l, e[n + 12], 11, -421815835), l = md5hh(l, u, s, c, e[n + 15], 16, 530742520), s = md5ii(s, c = md5hh(c, l, u, s, e[n + 2], 23, -995338651), l, u, e[n], 6, -198630844), u = md5ii(u, s, c, l, e[n + 7], 10, 1126891415), l = md5ii(l, u, s, c, e[n + 14], 15, -1416354905), c = md5ii(c, l, u, s, e[n + 5], 21, -57434055), s = md5ii(s, c, l, u, e[n + 12], 6, 1700485571), u = md5ii(u, s, c, l, e[n + 3], 10, -1894986606), l = md5ii(l, u, s, c, e[n + 10], 15, -1051523), c = md5ii(c, l, u, s, e[n + 1], 21, -2054922799), s = md5ii(s, c, l, u, e[n + 8], 6, 1873313359), u = md5ii(u, s, c, l, e[n + 15], 10, -30611744), l = md5ii(l, u, s, c, e[n + 6], 15, -1560198380), c = md5ii(c, l, u, s, e[n + 13], 21, 1309151649), s = md5ii(s, c, l, u, e[n + 4], 6, -145523070), u = md5ii(u, s, c, l, e[n + 11], 10, -1120210379), l = md5ii(l, u, s, c, e[n + 2], 15, 718787259), c = md5ii(c, l, u, s, e[n + 9], 21, -343485551), s = safeAdd(s, r), c = safeAdd(c, i), l = safeAdd(l, o), u = safeAdd(u, a);
      }

      return [s, c, l, u];
    }

    function binl2rstr(e) {
      var t,
          n = "",
          r = 32 * e.length;

      for (t = 0; t < r; t += 8) {
        n += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
      }

      return n;
    }

    function rstr2binl(e) {
      var t,
          n = [];

      for (n[(e.length >> 2) - 1] = void 0, t = 0; t < n.length; t += 1) {
        n[t] = 0;
      }

      var r = 8 * e.length;

      for (t = 0; t < r; t += 8) {
        n[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
      }

      return n;
    }

    function rstr2hex(e) {
      var t,
          n,
          r = "";

      for (n = 0; n < e.length; n += 1) {
        t = e.charCodeAt(n), r += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t);
      }

      return r;
    }

    function str2rstrUTF8(e) {
      return unescape(encodeURIComponent(e));
    }

    function rawMD5(e) {
      return function rstrMD5(e) {
        return binl2rstr(binlMD5(rstr2binl(e), 8 * e.length));
      }(str2rstrUTF8(e));
    }

    function rawHMACMD5(e, t) {
      return function rstrHMACMD5(e, t) {
        var n,
            r,
            i = rstr2binl(e),
            o = [],
            a = [];

        for (o[15] = a[15] = void 0, i.length > 16 && (i = binlMD5(i, 8 * e.length)), n = 0; n < 16; n += 1) {
          o[n] = 909522486 ^ i[n], a[n] = 1549556828 ^ i[n];
        }

        return r = binlMD5(o.concat(rstr2binl(t)), 512 + 8 * t.length), binl2rstr(binlMD5(a.concat(r), 640));
      }(str2rstrUTF8(e), str2rstrUTF8(t));
    }

    e.exports = function md5(e, t, n) {
      return t ? n ? rawHMACMD5(t, e) : function hexHMACMD5(e, t) {
        return rstr2hex(rawHMACMD5(e, t));
      }(t, e) : n ? rawMD5(e) : function hexMD5(e) {
        return rstr2hex(rawMD5(e));
      }(e);
    };
  }, function (e, t) {
    function RavenConfigError(e) {
      this.name = "RavenConfigError", this.message = e;
    }

    RavenConfigError.prototype = new Error(), RavenConfigError.prototype.constructor = RavenConfigError, e.exports = RavenConfigError;
  }, function (e, t, n) {
    var r = n(28);
    e.exports = {
      wrapMethod: function wrapMethod(e, t, n) {
        var i = e[t],
            o = e;

        if (t in e) {
          var a = "warn" === t ? "warning" : t;

          e[t] = function () {
            var e = [].slice.call(arguments),
                s = r.safeJoin(e, " "),
                c = {
              level: a,
              logger: "console",
              extra: {
                arguments: e
              }
            };
            "assert" === t ? !1 === e[0] && (s = "Assertion failed: " + (r.safeJoin(e.slice(1), " ") || "console.assert"), c.extra.arguments = e.slice(1), n && n(s, c)) : n && n(s, c), i && Function.prototype.apply.call(i, o, e);
          };
        }
      }
    };
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};

    function defaultSetTimout() {
      throw new Error("setTimeout has not been defined");
    }

    function defaultClearTimeout() {
      throw new Error("clearTimeout has not been defined");
    }

    function runTimeout(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === defaultSetTimout || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" === typeof setTimeout ? setTimeout : defaultSetTimout;
      } catch (e) {
        n = defaultSetTimout;
      }

      try {
        r = "function" === typeof clearTimeout ? clearTimeout : defaultClearTimeout;
      } catch (e) {
        r = defaultClearTimeout;
      }
    }();
    var o,
        a = [],
        s = !1,
        c = -1;

    function cleanUpNextTick() {
      s && o && (s = !1, o.length ? a = o.concat(a) : c = -1, a.length && drainQueue());
    }

    function drainQueue() {
      if (!s) {
        var e = runTimeout(cleanUpNextTick);
        s = !0;

        for (var t = a.length; t;) {
          for (o = a, a = []; ++c < t;) {
            o && o[c].run();
          }

          c = -1, t = a.length;
        }

        o = null, s = !1, function runClearTimeout(e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === defaultClearTimeout || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            return r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function Item(e, t) {
      this.fun = e, this.array = t;
    }

    function noop() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      a.push(new Item(e, t)), 1 !== a.length || s || runTimeout(drainQueue);
    }, Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = noop, i.addListener = noop, i.once = noop, i.off = noop, i.removeListener = noop, i.removeAllListeners = noop, i.emit = noop, i.prependListener = noop, i.prependOnceListener = noop, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, n, r) {
    "use strict";

    r.r(n);
    var i = {};
    r.r(i), r.d(i, "trackPageView", function () {
      return ft;
    }), r.d(i, "identifyUser", function () {
      return ht;
    }), r.d(i, "trackEvent", function () {
      return mt;
    }), r.d(i, "trackBrowserFingerprint", function () {
      return gt;
    });
    var o = {};
    r.r(o), r.d(o, "initializeSentry", function () {
      return Gi;
    }), r.d(o, "logError", function () {
      return Vi;
    });
    var a = {};
    r.r(a), r.d(a, "AxiosResponseError", function () {
      return AxiosResponseError;
    });
    var s = {};
    r.r(s), r.d(s, "unlistenPageTracking", function () {
      return Yi;
    });
    var c = r(0),
        l = r.n(c),
        u = r(5),
        p = r(51),
        f = r(52),
        d = "PRODUCTION" === window.__ENV__ ? f : p;

    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function _unsupportedIterableToArray(e, t) {
      if (e) {
        if ("string" === typeof e) return _arrayLikeToArray(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
      }
    }

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) return _arrayLikeToArray(e);
      }(e) || function _iterableToArray(e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || _unsupportedIterableToArray(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    var h = r(2),
        m = r.n(h);

    function _slicedToArray(e, t) {
      return function _arrayWithHoles(e) {
        if (Array.isArray(e)) return e;
      }(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (c) {
            i = !0, o = c;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }

          return n;
        }
      }(e, t) || _unsupportedIterableToArray(e, t) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function asyncGeneratorStep(e, t, n, r, i, o, a) {
      try {
        var s = e[o](a),
            c = s.value;
      } catch (l) {
        return void n(l);
      }

      s.done ? t(c) : Promise.resolve(c).then(r, i);
    }

    function _asyncToGenerator(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, i) {
          var o = e.apply(t, n);

          function _next(e) {
            asyncGeneratorStep(o, r, i, _next, _throw, "next", e);
          }

          function _throw(e) {
            asyncGeneratorStep(o, r, i, _next, _throw, "throw", e);
          }

          _next(void 0);
        });
      };
    }

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _createClass(e, t, n) {
      return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var g = r(12),
        A = r.n(g),
        v = r(3),
        b = r(1),
        y = r(4),
        E = function receiveUserConfig(e) {
      return {
        type: "RECEIVE_USER_CONFIG",
        config: e
      };
    },
        C = function receiveUserSettings(e) {
      return {
        type: "RECEIVE_USER_SETTINGS",
        settings: e
      };
    },
        w = function receiveUserProfile(e) {
      return {
        type: "RECEIVE_USER_PROFILE",
        profile: e
      };
    },
        _ = function receiveUserGates(e) {
      return {
        type: "RECEIVE_USER_GATES",
        gates: e
      };
    },
        x = function showTransientNotification(e) {
      return {
        type: "SHOW_TRANSIENT_NOTIFICATION",
        config: e
      };
    },
        S = function removeTransientNotification(e) {
      return {
        type: "REMOVE_TRANSIENT_NOTIFICATION",
        key: e.key
      };
    },
        k = r(53);

    function isNodeFound(e, t, n) {
      return e === t || (e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n));
    }

    var O = function testPassiveEventSupport() {
      if ("undefined" !== typeof window && "function" === typeof window.addEventListener) {
        var e = !1,
            t = Object.defineProperty({}, "passive", {
          get: function get() {
            e = !0;
          }
        }),
            n = function noop() {};

        return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
      }
    };

    var B,
        T = function autoInc(e) {
      return void 0 === e && (e = 0), function () {
        return ++e;
      };
    }(),
        I = {},
        R = {},
        P = ["touchstart", "touchmove"],
        j = "ignore-react-onclickoutside";

    function getEventHandlerOptions(e, t) {
      var n = null;
      return -1 !== P.indexOf(t) && B && (n = {
        passive: !e.props.preventDefault
      }), n;
    }

    var N = function onClickOutsideHOC(e, t) {
      var n,
          r,
          i = e.displayName || e.name || "Component";
      return r = n = function (n) {
        function onClickOutside(e) {
          var r;
          return (r = n.call(this, e) || this).__outsideClickHandler = function (e) {
            if ("function" !== typeof r.__clickOutsideHandlerProp) {
              var t = r.getInstance();

              if ("function" !== typeof t.props.handleClickOutside) {
                if ("function" !== typeof t.handleClickOutside) throw new Error("WrappedComponent: " + i + " lacks a handleClickOutside(event) function for processing outside click events.");
                t.handleClickOutside(e);
              } else t.props.handleClickOutside(e);
            } else r.__clickOutsideHandlerProp(e);
          }, r.__getComponentNode = function () {
            var e = r.getInstance();
            return t && "function" === typeof t.setClickOutsideRef ? t.setClickOutsideRef()(e) : "function" === typeof e.setClickOutsideRef ? e.setClickOutsideRef() : Object(k.findDOMNode)(e);
          }, r.enableOnClickOutside = function () {
            if ("undefined" !== typeof document && !R[r._uid]) {
              "undefined" === typeof B && (B = O()), R[r._uid] = !0;
              var e = r.props.eventTypes;
              e.forEach || (e = [e]), I[r._uid] = function (e) {
                null !== r.componentNode && (r.props.preventDefault && e.preventDefault(), r.props.stopPropagation && e.stopPropagation(), r.props.excludeScrollbar && function clickedScrollbar(e) {
                  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
                }(e) || function findHighest(e, t, n) {
                  if (e === t) return !0;

                  for (; e.parentNode;) {
                    if (isNodeFound(e, t, n)) return !0;
                    e = e.parentNode;
                  }

                  return e;
                }(e.target, r.componentNode, r.props.outsideClickIgnoreClass) === document && r.__outsideClickHandler(e));
              }, e.forEach(function (e) {
                document.addEventListener(e, I[r._uid], getEventHandlerOptions(r, e));
              });
            }
          }, r.disableOnClickOutside = function () {
            delete R[r._uid];
            var e = I[r._uid];

            if (e && "undefined" !== typeof document) {
              var t = r.props.eventTypes;
              t.forEach || (t = [t]), t.forEach(function (t) {
                return document.removeEventListener(t, e, getEventHandlerOptions(r, t));
              }), delete I[r._uid];
            }
          }, r.getRef = function (e) {
            return r.instanceRef = e;
          }, r._uid = T(), r;
        }

        !function _inheritsLoose(e, t) {
          e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
        }(onClickOutside, n);
        var r = onClickOutside.prototype;
        return r.getInstance = function getInstance() {
          if (!e.prototype.isReactComponent) return this;
          var t = this.instanceRef;
          return t.getInstance ? t.getInstance() : t;
        }, r.componentDidMount = function componentDidMount() {
          if ("undefined" !== typeof document && document.createElement) {
            var e = this.getInstance();
            if (t && "function" === typeof t.handleClickOutside && (this.__clickOutsideHandlerProp = t.handleClickOutside(e), "function" !== typeof this.__clickOutsideHandlerProp)) throw new Error("WrappedComponent: " + i + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            this.componentNode = this.__getComponentNode(), this.props.disableOnClickOutside || this.enableOnClickOutside();
          }
        }, r.componentDidUpdate = function componentDidUpdate() {
          this.componentNode = this.__getComponentNode();
        }, r.componentWillUnmount = function componentWillUnmount() {
          this.disableOnClickOutside();
        }, r.render = function render() {
          var t = this.props,
              n = (t.excludeScrollbar, function _objectWithoutProperties(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = {},
                o = Object.keys(e);

            for (r = 0; r < o.length; r++) {
              n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            }

            if (Object.getOwnPropertySymbols) {
              var a = Object.getOwnPropertySymbols(e);

              for (r = 0; r < a.length; r++) {
                n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }(t, ["excludeScrollbar"]));
          return e.prototype.isReactComponent ? n.ref = this.getRef : n.wrappedRef = this.getRef, n.disableOnClickOutside = this.disableOnClickOutside, n.enableOnClickOutside = this.enableOnClickOutside, Object(c.createElement)(e, n);
        }, onClickOutside;
      }(c.Component), n.displayName = "OnClickOutside(" + i + ")", n.defaultProps = {
        eventTypes: ["mousedown", "touchstart"],
        excludeScrollbar: t && t.excludeScrollbar || !1,
        outsideClickIgnoreClass: j,
        preventDefault: !1,
        stopPropagation: !1
      }, n.getClass = function () {
        return e.getClass ? e.getClass() : e;
      }, r;
    },
        D = (r(69), r(15)),
        L = r.n(D),
        M = function computeWSShardId(e) {
      return e % d.WS_NUM_SHARDS;
    },
        U = r(30),
        F = r.n(U),
        z = r(31),
        H = r.n(z),
        W = r(6),
        q = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee(e) {
        var t;
        return m.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (t = F.a.parse(document.location.search), !window.location.href.includes("/slack/auth")) {
                  n.next = 4;
                  break;
                }

                return n.abrupt("return", !1);

              case 4:
                if (!t.code) {
                  n.next = 9;
                  break;
                }

                return n.next = 7, Object(W.authenticateWithCode)({
                  authorizationCode: t.code,
                  clientId: e
                });

              case 7:
                return G(), n.abrupt("return", !0);

              case 9:
                return n.abrupt("return", !1);

              case 10:
              case "end":
                return n.stop();
            }
          }
        }, _callee);
      }));

      return function checkForNewAuthCode(t) {
        return e.apply(this, arguments);
      };
    }(),
        G = function clearAuthCodeFromURI() {
      var e = Object(W.constructUrlObjectWithoutAuthParams)(document.location);
      window.history.replaceState({}, document.title, e.href);
    },
        V = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee2() {
        var e, t;
        return m.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return e = F.a.parse(document.location.search), (t = !!e.token) && (Z(e.token), Y(e.token)), n.abrupt("return", t);

              case 4:
              case "end":
                return n.stop();
            }
          }
        }, _callee2);
      }));

      return function checkForNewToken() {
        return e.apply(this, arguments);
      };
    }(),
        Y = function clearTokenFromURI(e) {
      var t = document.location,
          n = t.protocol + "//" + t.host + t.pathname;
      window.history.replaceState({}, document.title, n);
    },
        Z = function setToken(e) {
      Object(W.setAccessToken)({
        token: e
      });
    },
        J = function getToken() {
      return Object(W.getAccessToken)();
    },
        K = function removeToken() {
      Object(W.deleteAccessToken)();
    },
        X = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee3(e, t) {
        var n;
        return m.a.wrap(function _callee3$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                !(n = !!J()) && t ? Object(W.redirectToLoginPage)(e) : n && oe();

              case 2:
              case "end":
                return r.stop();
            }
          }
        }, _callee3);
      }));

      return function noAuthRedirect(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        $ = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee4() {
        return m.a.wrap(function _callee4$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                H.a.apple.phone && (document.location = "".concat(d.START, "/download-ios-app")), H.a.android.phone && (document.location = "".concat(d.START, "/download-android-app"));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, _callee4);
      }));

      return function isMobileRedirect() {
        return e.apply(this, arguments);
      };
    }(),
        Q = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee5(e) {
        var t;
        return m.a.wrap(function _callee5$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                t = e.properties, Object(v.isEmpty)(t) || t.signUpDone || ho.isVideoOnlyUser() || (document.location = "".concat(d.CUSTOMER_WEB_URL, "/settings"));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee5);
      }));

      return function needsOnboardingRedirect(t) {
        return e.apply(this, arguments);
      };
    }(),
        ee = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee6(e) {
        return m.a.wrap(function _callee6$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                K(), Object(W.redirectToLoginPage)(e);

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, _callee6);
      }));

      return function badConnectionRedirect(t) {
        return e.apply(this, arguments);
      };
    }(),
        te = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee7(e) {
        var t, n;
        return m.a.wrap(function _callee7$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                t = ["/inbox", "/settings", "/meetings"], n = ["/inbox", "/settings"], ho.isCalendarUser() && !t.some(function (t) {
                  return e.includes(t);
                }) && (document.location = "".concat(d.CUSTOMER_WEB_URL, "/meetings")), ho.isVideoOnlyUser() && !n.some(function (t) {
                  return e.includes(t);
                }) && (document.location = "".concat(d.CUSTOMER_WEB_URL, "/inboxes"));

              case 4:
              case "end":
                return r.stop();
            }
          }
        }, _callee7);
      }));

      return function redirectByUserType(t) {
        return e.apply(this, arguments);
      };
    }();

    L.a.defaults.headers.post["Content-Type"] = "application/json";

    var ne = L.a.create({
      baseURL: d.CUSTOMER_API,
      headers: {
        Authorization: "bearer ".concat(J())
      }
    }),
        re = L.a.create({
      baseURL: d.KONG_CUSTOMER_API,
      headers: {
        Authorization: "bearer ".concat(J())
      }
    }),
        ie = (L.a.create({
      baseURL: d.CONVERSATION_API,
      headers: {
        Authorization: "bearer ".concat(J())
      }
    }), L.a.create({
      baseURL: d.AUTH_API,
      headers: {
        Authorization: "bearer ".concat(J())
      }
    })),
        oe = function asyncAPIAuthConfiguration() {
      ne.defaults.headers.Authorization = "bearer ".concat(J());
    },
        ae = L.a.create({
      baseURL: d.METRICS_API
    }),
        se = r(14),
        ce = r(20),
        le = r(54),
        ue = r(55),
        pe = r(9),
        fe = r(56),
        de = r(57),
        he = r(29),
        me = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }();

    var ge = function (e) {
      function ActionsObservable(e) {
        !function ActionsObservable_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ActionsObservable);

        var t = function ActionsObservable_possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));

        return t.source = e, t;
      }

      return function ActionsObservable_inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(ActionsObservable, pe["Observable"]), me(ActionsObservable, null, [{
        key: "of",
        value: function of() {
          return new this(fe.of.apply(void 0, arguments));
        }
      }, {
        key: "from",
        value: function from(e, t) {
          return new this(Object(de.from)(e, t));
        }
      }]), me(ActionsObservable, [{
        key: "lift",
        value: function lift(e) {
          var t = new ActionsObservable(this);
          return t.operator = e, t;
        }
      }, {
        key: "ofType",
        value: function ofType() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return he.filter.call(this, function (e) {
            var n = e.type,
                r = t.length;
            if (1 === r) return n === t[0];

            for (var i = 0; i < r; i++) {
              if (t[i] === n) return !0;
            }

            return !1;
          });
        }
      }]), ActionsObservable;
    }(),
        Ae = "@@redux-observable/EPIC_END",
        ve = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        be = {
      adapter: {
        input: function input(e) {
          return e;
        },
        output: function output(e) {
          return e;
        }
      }
    };

    var ye = r(58);

    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function ownKeys(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(n), !0).forEach(function (t) {
          _defineProperty(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    r(92), r(94), r(95), r(98), r(101), r(105), r(108);

    var Ee = r(59),
        Ce = function soundNotification() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "click";
      (function isFirstInLineCheck() {
        return new Promise(function (e) {
          var t = JSON.parse(window.localStorage.getItem("openTabs"));
          return window.thisTabID || (window.thisTabID = new Date().valueOf()), t.push(window.thisTabID), window.localStorage.setItem("openTabs", JSON.stringify(t)), setTimeout(function () {
            var t = 0 === JSON.parse(window.localStorage.getItem("openTabs")).indexOf(window.thisTabID);
            return e(t);
          }, 100);
        });
      })().then(function (t) {
        t && we(e);
      });
    },
        we = function soundNotificationImmediate() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "click";
      "none" !== e && (new Audio("https://s3.amazonaws.com/tide-assets/drift-".concat(e, ".mp3")).play().catch(function (e) {
        console.warn("Autoplay blocking is enabled. Can't play sound until user interaction", e);
      }), function clearTabs() {
        window.localStorage.setItem("openTabs", JSON.stringify([]));
      }());
    },
        _e = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee(e) {
        var t, n;
        return m.a.wrap(function _callee$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                return t = e.getKey ? e.getKey("p256dh") : "", n = e.getKey ? e.getKey("auth") : "", r.abrupt("return", ne.post("/notification/web/register", {
                  endpoint: e.endpoint,
                  key: t ? btoa(String.fromCharCode.apply(null, new Uint8Array(t))) : "",
                  authentication: n ? btoa(String.fromCharCode.apply(null, new Uint8Array(n))) : ""
                }));

              case 3:
              case "end":
                return r.stop();
            }
          }
        }, _callee);
      }));

      return function updateSubscription(t) {
        return e.apply(this, arguments);
      };
    }(),
        xe = r(60),
        Se = function userSoundSetting(e) {
      return e.user.settings["humane-notifications-browser-sound"];
    },
        ke = {},
        Oe = function cutovers() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ke,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_CUTOVERS":
          return Object(v.merge)(e, t.cutovers);

        default:
          return e;
      }
    },
        Be = {
      properties: {},
      users: [],
      allUsers: []
    },
        Te = function org() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Be,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_ORG_CONFIG":
          return Object(v.merge)(e, t.config);

        case "RECEIVE_ORG_PROPERTIES":
          var n = {
            properties: t.properties
          };
          return Object(v.merge)(e, n);

        case "RECEIVE_ORG_USERS":
          var r = {
            users: t.users
          };
          return Object(v.merge)(e, r);

        case "RECEIVE_ALL_ORG_USERS":
          var i = {
            allUsers: t.users
          };
          return Object(v.merge)(e, i);

        default:
          return e;
      }
    },
        Ie = function embed() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_EMBED_CONFIG":
          return t.config;

        default:
          return e;
      }
    },
        Re = {
      settings: {}
    },
        Pe = function user() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Re,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_USER_CONFIG":
          return Object(v.merge)(e, t.config);

        case "RECEIVE_USER_SETTINGS":
          return Object(v.merge)(e, {
            settings: t.settings
          });

        case "RECEIVE_USER_PROFILE":
          return Object(v.merge)(e, {
            profile: t.profile
          });

        case "RECEIVE_USER_GATES":
          return Object(v.merge)(e, {
            gates: t.gates
          });

        default:
          return e;
      }
    },
        je = function notifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SHOW_GLOBAL_NOTIFICATION":
          return Object(v.append)(t.config, e);

        case "REMOVE_GLOBAL_NOTIFICATION":
          return Object(v.remove)(t.index, 1, e);

        default:
          return e;
      }
    },
        Ne = {
      notificationHistory: [],
      hasBrowserNotificationsEnabled: !1
    },
        De = function browserNotifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ne,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "BROWSER_NOTIFICATIONS_GRANTED":
          return Object(v.merge)(e, {
            hasBrowserNotificationsEnabled: !0
          });

        case "BROWSER_NOTIFICATION_SENT":
          var n = Object(v.append)(t.notification, e.notificationHistory);
          return Object(v.merge)(e, n);

        default:
          return e;
      }
    },
        Le = function socket() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_SOCKET_CONNECTION":
          return t.socket;

        default:
          return e;
      }
    },
        Me = function getNotificationTypeClass() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "information";
      return "".concat({
        success: "transient-notification--success",
        error: "transient-notification--error",
        information: "transient-notification--information"
      }[e], " transient-notification");
    },
        Ue = function defaultClick(e) {
      return function () {
        return Je.dispatch(S({
          key: e
        }));
      };
    },
        Fe = function transientNotifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SHOW_TRANSIENT_NOTIFICATION":
          return Object(v.append)(function getNotificationDefaults(e) {
            var t = e.message,
                n = e.type,
                r = e.onClick;
            return {
              message: t,
              key: t,
              action: e.action || "Dismiss",
              className: Me(n),
              onClick: r || Ue(t)
            };
          }(t.config), e);

        case "REMOVE_TRANSIENT_NOTIFICATION":
          return Object(v.reject)(function isKey(e) {
            return Object(v.equals)(e.key, t.key);
          }, e);

        default:
          return e;
      }
    },
        ze = {
      status: {}
    },
        He = function integrations() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ze,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_INTEGRATION_STATUS":
          return Object(v.merge)(e, {
            status: t.integrations
          });

        default:
          return e;
      }
    },
        We = {
      beamerLoaded: !1
    },
        qe = function snippets() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : We,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SET_BEAMER_SNIPPET_LOADED":
          var n = t.beamerLoaded;
          return Object(v.merge)(e, {
            beamerLoaded: n
          });

        default:
          return e;
      }
    },
        Ge = new Ee.BehaviorSubject(function combineEpics() {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return function () {
        for (var e = arguments.length, n = Array(e), r = 0; r < e; r++) {
          n[r] = arguments[r];
        }

        return ye.merge.apply(void 0, function combineEpics_toConsumableArray(e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }

            return n;
          }

          return Array.from(e);
        }(t.map(function (e) {
          var t = e.apply(void 0, n);
          if (!t) throw new TypeError('combineEpics: one of the provided Epics "' + (e.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
          return t;
        })));
      };
    }(function sendBrowserNotification(e, t) {
      var n = t.getState;
      return e.ofType("SEND_BROWSER_NOTIFICATION").filter(function () {
        return function hasEnabledNotifications(e) {
          return e.browserNotifications.hasBrowserNotificationsEnabled;
        }(n());
      }).do(function (e) {
        return function newBrowserNotification(e) {
          var t = e.message,
              n = e.options,
              r = void 0 === n ? {} : n,
              i = e.click,
              o = new Notification(t, r);
          return i && (o.onclick = function (e) {
            e.preventDefault(), i();
          }), o;
        }(e.notification);
      }).do(function () {
        var e = Se(n());
        Ce(e);
      }).mapTo({
        type: "BROWSER_NOTIFICATION_SENT"
      });
    }, function registerForPushNotifications(e, t) {
      var n = t.getState;
      return e.ofType("RECEIVE_USER_CONFIG").first().do(function () {
        "serviceWorker" in navigator && "PushManager" in window && !ho.hasGates("web_socket_chat_notifications") && "granted" === Notification.permission ? navigator.serviceWorker.register(Object(xe.getSwPath)()).then(function (e) {
          e.update(), e.pushManager.getSubscription().then(function (t) {
            if (t) _e(t);else {
              var n = function urlB64ToUint8Array(e) {
                for (var t = (e + "=".repeat((4 - e.length % 4) % 4)).replace(/-/g, "+").replace(/_/g, "/"), n = window.atob(t), r = new Uint8Array(n.length), i = 0; i < n.length; ++i) {
                  r[i] = n.charCodeAt(i);
                }

                return r;
              }("BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA=");

              e.pushManager.subscribe({
                userVisibleOnly: !0,
                applicationServerKey: n
              }).then(function (e) {
                return _e(e);
              }).catch(function (e) {
                return console.error("unable to register service worker", e);
              });
            }
          }).catch(function (e) {
            return console.error("unable to get subscription", e);
          }), navigator.serviceWorker.addEventListener("message", function (e) {
            var t = Se(n());
            we(t);
          });
        }).catch(function (e) {
          return console.error("Service Worker Error", e);
        }) : console.warn("Push messaging is not supported");
      }).mergeMap(function () {
        return pe.Observable.empty();
      });
    })),
        Ve = function rootReducer(e) {
      return Object(se.combineReducers)(_objectSpread2(_objectSpread2({}, e), {}, {
        cutovers: Oe,
        org: Te,
        embed: Ie,
        user: Pe,
        globalNotifications: je,
        browserNotifications: De,
        socket: Le,
        transientNotifications: Fe,
        integrations: He,
        snippets: qe
      }));
    },
        Ye = function createEpicMiddleware(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : be;
      if ("function" !== typeof e) throw new TypeError("You must provide a root Epic to createEpicMiddleware");
      t = ve({}, be, t);

      var n = new ce.Subject(),
          r = t.adapter.input(new ge(n)),
          i = new ce.Subject(),
          o = void 0,
          a = function epicMiddleware(a) {
        return o = a, function (a) {
          var s;
          return (s = le.map.call(i, function (e) {
            var n = "dependencies" in t ? e(r, o, t.dependencies) : e(r, o);
            if (!n) throw new TypeError('Your root Epic "' + (e.name || "<anonymous>") + "\" does not return a stream. Double check you're not missing a return statement!");
            return n;
          }), ue.switchMap).call(s, function (e) {
            return t.adapter.output(e);
          }).subscribe(o.dispatch), i.next(e), function (e) {
            var t = a(e);
            return n.next(e), t;
          };
        };
      };

      return a.replaceEpic = function (e) {
        o.dispatch({
          type: Ae
        }), i.next(e);
      }, a;
    }(function rootEpic(e, t) {
      return Ge.mergeMap(function (n) {
        return n(e, t);
      });
    }),
        Ze = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || se.compose,
        Je = function configureStore() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = [Ye],
          n = Object(se.createStore)(Ve(), e, Ze(se.applyMiddleware.apply(void 0, t)));
      return n.asyncReducers = {}, n;
    }(),
        Ke = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee() {
        return m.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("users/me"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      }));

      return function getUser() {
        return e.apply(this, arguments);
      };
    }(),
        Xe = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee2() {
        return m.a.wrap(function _callee2$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("users/properties"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee2);
      }));

      return function getUserSettings() {
        return e.apply(this, arguments);
      };
    }(),
        $e = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee3() {
        return m.a.wrap(function _callee3$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("/users/profile"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee3);
      }));

      return function getUserProfile() {
        return e.apply(this, arguments);
      };
    }(),
        Qe = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee5(e) {
        var t;
        return m.a.wrap(function _callee5$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return t = [{
                  operation: "set",
                  property: "availability",
                  value: e
                }], n.abrupt("return", ne.patch("users/".concat(Je.getState().user.id, "/patch"), t));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee5);
      }));

      return function setUserAvailability(t) {
        return e.apply(this, arguments);
      };
    }(),
        et = function sendFindMyTeamVerificationEmail(e) {
      return re.post("/findTeam/verifyEmail", {
        email: e
      });
    },
        tt = function mergeAccounts(e, t) {
      return re.post("/multi_org/merge", {
        email: e,
        password: t
      });
    },
        nt = function nt() {
      return l.a.createElement("svg", {
        width: "14px",
        height: "14px",
        viewBox: "0 0 14 14"
      }, l.a.createElement("defs", null, l.a.createElement("circle", {
        id: "path-1",
        cx: "133",
        cy: "858",
        r: "5"
      })), l.a.createElement("g", {
        id: "flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, l.a.createElement("g", {
        id: "admin-copy-2",
        transform: "translate(-126.000000, -851.000000)"
      }, l.a.createElement("g", {
        id: "Oval-Copy",
        fill: "#13CB6E"
      }, l.a.createElement("circle", {
        stroke: "#394F5A",
        strokeWidth: "2",
        cx: "133",
        cy: "858",
        r: "6"
      })))));
    },
        rt = function rt() {
      return l.a.createElement("svg", {
        width: "18px",
        height: "17px",
        viewBox: "0 0 18 17"
      }, l.a.createElement("defs", null, l.a.createElement("circle", {
        id: "path-1",
        cx: "1222",
        cy: "896",
        r: "5"
      })), l.a.createElement("g", {
        id: "flow",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, l.a.createElement("g", {
        id: "admin-copy-2",
        transform: "translate(-1215.000000, -886.000000)"
      }, l.a.createElement("g", {
        id: "Oval-Copy",
        fill: "#13CB6E"
      }, l.a.createElement("circle", {
        stroke: "#394F5A",
        strokeWidth: "2",
        cx: "1222",
        cy: "896",
        r: "6"
      })), l.a.createElement("g", {
        id: "Artboard-2",
        transform: "translate(1223.000000, 886.000000)",
        fillRule: "nonzero"
      }, l.a.createElement("path", {
        style: {
          fill: "#394F5A"
        },
        d: "M9.53335714,7.57142857 C9.53335714,9.18544898 8.22879236,10.5 6.61128571,10.5 L2.92207143,10.5 C1.79586641,10.5 0.77024696,9.85033109 0.284798174,8.83235678 C-0.195939587,7.8213507 -0.0606505598,6.6249393 0.63662562,5.74678002 L1.07370103,5.19676901 C0.417941571,4.65915341 0,3.84179431 0,2.92857143 C0,1.31456515 1.30548666,0 2.92207143,0 L6.61128571,0 C7.73836991,0 8.76308647,0.649619183 9.24556588,1.66137673 C9.73062346,2.67240037 9.59516963,3.87108515 8.89766009,4.75321998 L8.46037216,5.30349842 C9.11585152,5.84111527 9.53335714,6.65835166 9.53335714,7.57142857 Z",
        id: "Path"
      }), l.a.createElement("path", {
        style: {
          fill: "#13CB6E"
        },
        d: "M2,2.92857143 C2,3.44114286 2.41321429,3.85714286 2.92207143,3.85714286 L4.69285714,3.85714286 L2.20242857,6.99107143 C1.9805,7.27057143 1.93778571,7.65128571 2.091,7.9735 C2.24421429,8.29478571 2.56828571,8.5 2.92207143,8.5 L6.61128571,8.5 C7.12107143,8.5 7.53335714,8.084 7.53335714,7.57142857 C7.53335714,7.05885714 7.12107143,6.64285714 6.61128571,6.64285714 L4.84142857,6.64285714 L7.33185714,3.50892857 C7.55285714,3.22942857 7.5965,2.84778571 7.44235714,2.5265 C7.28914286,2.20521429 6.966,2 6.61128571,2 L2.92207143,2 C2.41321429,2 2,2.416 2,2.92857143 Z",
        id: "Path"
      })))));
    },
        it = function it() {
      return l.a.createElement("svg", {
        width: "14",
        height: "14",
        xmlns: "http://www.w3.org/2000/svg"
      }, l.a.createElement("circle", {
        stroke: "#394F5A",
        strokeWidth: "2",
        cx: "419",
        cy: "858",
        r: "6",
        fill: "#F7D86B",
        transform: "translate(-412 -851)",
        fillRule: "evenodd"
      }));
    },
        ot = function ot() {
      return l.a.createElement("svg", {
        width: "18",
        height: "17",
        xmlns: "http://www.w3.org/2000/svg"
      }, l.a.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, l.a.createElement("circle", {
        stroke: "#394F5A",
        strokeWidth: "2",
        cx: "1222",
        cy: "896",
        r: "6",
        fill: "#F7D86B",
        transform: "translate(-1215 -886)"
      }), l.a.createElement("g", {
        fillRule: "nonzero"
      }, l.a.createElement("path", {
        d: "M17.533 7.571a2.925 2.925 0 0 1-2.922 2.929h-3.689a2.924 2.924 0 0 1-2.637-1.668 2.934 2.934 0 0 1 .352-3.085l.437-.55A2.927 2.927 0 0 1 8 2.929 2.926 2.926 0 0 1 10.922 0h3.69a2.92 2.92 0 0 1 2.634 1.661 2.936 2.936 0 0 1-.348 3.092l-.438.55a2.927 2.927 0 0 1 1.073 2.268z",
        fill: "#394F5A"
      }), l.a.createElement("path", {
        fill: "#13CB6E",
        d: "M10 2.929c0 .512.413.928.922.928h1.77l-2.49 3.134a.934.934 0 0 0-.111.982.923.923 0 0 0 .831.527h3.69c.51 0 .921-.416.921-.929a.925.925 0 0 0-.922-.928h-1.77l2.49-3.134a.934.934 0 0 0 .111-.982.922.922 0 0 0-.83-.527h-3.69a.926.926 0 0 0-.922.929z"
      }))));
    },
        at = {
      ACTIVE: "AVAILABLE",
      AWAY: "OFFLINE",
      ON_CALL: "ON_CALL"
    },
        st = {
      ON: "SNOOZE_ON",
      OFF: "SNOOZE_OFF"
    },
        ct = [{
      availabilityStatus: at.ACTIVE,
      notificationSnoozeStatus: st.OFF,
      icon: nt
    }, {
      availabilityStatus: at.ACTIVE,
      notificationSnoozeStatus: st.ON,
      icon: rt
    }, {
      availabilityStatus: at.ON_CALL,
      notificationSnoozeStatus: st.OFF,
      icon: nt
    }, {
      availabilityStatus: at.ON_CALL,
      notificationSnoozeStatus: st.ON,
      icon: rt
    }, {
      availabilityStatus: at.AWAY,
      notificationSnoozeStatus: st.OFF,
      icon: function icon() {
        return l.a.createElement("svg", {
          width: "14px",
          height: "14px",
          viewBox: "0 0 14 14"
        }, l.a.createElement("defs", null, l.a.createElement("circle", {
          id: "path-1",
          cx: "419",
          cy: "858",
          r: "5"
        })), l.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-412.000000, -851.000000)"
        }, l.a.createElement("g", {
          id: "Oval-Copy-3",
          fill: "#7695A5"
        }, l.a.createElement("circle", {
          stroke: "#394F5A",
          strokeWidth: "2",
          cx: "419",
          cy: "858",
          r: "6"
        })))));
      }
    }, {
      availabilityStatus: at.AWAY,
      notificationSnoozeStatus: st.ON,
      icon: function icon() {
        return l.a.createElement("svg", {
          width: "18px",
          height: "17px",
          viewBox: "0 0 18 17"
        }, l.a.createElement("defs", null, l.a.createElement("circle", {
          id: "path-1",
          cx: "1222",
          cy: "896",
          r: "5"
        })), l.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, l.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-1215.000000, -886.000000)"
        }, l.a.createElement("g", {
          id: "Oval-Copy",
          fill: "#7695A5"
        }, l.a.createElement("circle", {
          stroke: "#394F5A",
          strokeWidth: "2",
          cx: "1222",
          cy: "896",
          r: "6"
        })), l.a.createElement("g", {
          id: "Artboard-2",
          transform: "translate(1223.000000, 886.000000)",
          fillRule: "nonzero"
        }, l.a.createElement("path", {
          style: {
            fill: "#394F5A"
          },
          d: "M9.53335714,7.57142857 C9.53335714,9.18544898 8.22879236,10.5 6.61128571,10.5 L2.92207143,10.5 C1.79586641,10.5 0.77024696,9.85033109 0.284798174,8.83235678 C-0.195939587,7.8213507 -0.0606505598,6.6249393 0.63662562,5.74678002 L1.07370103,5.19676901 C0.417941571,4.65915341 0,3.84179431 0,2.92857143 C0,1.31456515 1.30548666,0 2.92207143,0 L6.61128571,0 C7.73836991,0 8.76308647,0.649619183 9.24556588,1.66137673 C9.73062346,2.67240037 9.59516963,3.87108515 8.89766009,4.75321998 L8.46037216,5.30349842 C9.11585152,5.84111527 9.53335714,6.65835166 9.53335714,7.57142857 Z",
          id: "Path"
        }), l.a.createElement("path", {
          style: {
            fill: "#7695A5"
          },
          d: "M2,2.92857143 C2,3.44114286 2.41321429,3.85714286 2.92207143,3.85714286 L4.69285714,3.85714286 L2.20242857,6.99107143 C1.9805,7.27057143 1.93778571,7.65128571 2.091,7.9735 C2.24421429,8.29478571 2.56828571,8.5 2.92207143,8.5 L6.61128571,8.5 C7.12107143,8.5 7.53335714,8.084 7.53335714,7.57142857 C7.53335714,7.05885714 7.12107143,6.64285714 6.61128571,6.64285714 L4.84142857,6.64285714 L7.33185714,3.50892857 C7.55285714,3.22942857 7.5965,2.84778571 7.44235714,2.5265 C7.28914286,2.20521429 6.966,2 6.61128571,2 L2.92207143,2 C2.41321429,2 2,2.416 2,2.92857143 Z",
          id: "Path"
        })))));
      }
    }],
        lt = function getStatusIcon(e, t, n) {
      return n ? t === st.ON ? ot : it : ct.find(function (n) {
        return n.availabilityStatus === e && n.notificationSnoozeStatus === t;
      }).icon;
    },
        ut = r(61),
        pt = r.n(ut),
        ft = function trackPageView(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      window.analytics && !d.SEGMENT_TRACKING_BLACKLIST.includes(t) && window.analytics && window.analytics.page(e, n);
    },
        dt = function getBrowserIdentifier() {
      return window.localStorage.getItem("drift.user.uuid") || window.localStorage.setItem("drift.user.uuid", pt()()), window.localStorage.getItem("drift.user.uuid");
    },
        ht = function identifyUser() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = Je.getState().user;
      if (t && t.orgId && t.id) return t.userJwt && window.drift && window.drift.setUserJwt && window.drift.setUserJwt(t.userJwt), window.analytics && window.analytics.identify("".concat(t.orgId, "-").concat(t.id), _objectSpread2({
        name: t.name,
        email: t.email,
        role: t.role,
        orgId: t.orgId
      }, e), {
        integrations: {
          drift: {
            userJwt: t.userJwt
          }
        }
      });
    },
        mt = function trackEvent(e, t) {
      var n = Je.getState().user;

      if (window.analytics && !d.SEGMENT_TRACKING_BLACKLIST.includes(n.orgId)) {
        var r = Object.assign({}, {
          email: n.email,
          orgId: n.orgId
        }, t);
        window.analytics.track(e, r);
      }
    },
        gt = function trackBrowserFingerprint() {
      mt("Site Accessed", {
        browserIdentifier: dt()
      });
    },
        At = function isActiveAvailability(e) {
      return e === at.ACTIVE || e === at.ON_CALL;
    },
        vt = function useAgentStatus() {
      var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).isAgentToggle,
          t = void 0 !== e && e,
          n = Object(u.useDispatch)(),
          r = Object(u.useSelector)(function (e) {
        return e.org.properties;
      }),
          i = r.limitNumChats,
          o = r.limitNumChatsEnabled,
          a = Object(u.useSelector)(function (e) {
        return e.user;
      }),
          s = At(a.availability),
          l = a.settings.atConversationLimit,
          p = Object(c.useCallback)(function (e) {
        n(E(e));
      }, [n]),
          f = _slicedToArray(Object(c.useState)(!1), 2),
          d = f[0],
          h = f[1],
          m = _slicedToArray(Object(c.useState)(null), 2),
          g = m[0],
          A = m[1],
          v = Object(c.useCallback)(function (e) {
        var t = e.source;

        if (!d) {
          var n = s ? at.AWAY : at.ACTIVE;

          if (a.availability !== n) {
            h(!0), A(n);
            var r = Object.assign({}, a, {
              availability: n
            });
            p(r), Qe(n).then(function (e) {
              var t = e.data;
              p(t);
            }).catch(function () {
              p(a);
            }).finally(function () {
              A(null), h(!1);
            }), mt("AgentStatusToggle clicked", {
              status: n,
              source: t
            });
          }
        }
      }, [a, s, d, p]),
          b = d ? At(g) : s,
          y = Object(c.useMemo)(function () {
        return o && l && b ? t ? "chat-limit" : "chat_limit" : b ? "available" : "away";
      }, [b, o, l, t]);

      return {
        currentUser: a,
        agentStatus: y,
        isActive: b,
        currentUserLoaded: !0,
        isAgentStatusLoaded: !0,
        limitNumChatsEnabled: o,
        limitNumChats: i,
        isUserAtConversationLimit: a.settings.atConversationLimit,
        toggleStatus: v
      };
    },
        bt = function AgentStatusPane(e) {
      var t = e.renderAgentName,
          n = e.source,
          r = vt({
        isAgentToggle: !0
      }),
          i = r.currentUser,
          o = r.isActive,
          a = r.isAgentStatusLoaded,
          s = r.limitNumChatsEnabled,
          u = r.limitNumChats,
          p = r.isUserAtConversationLimit,
          f = r.toggleStatus,
          d = r.agentStatus,
          h = Object(c.useMemo)(function () {
        return t ? i.name : null;
      }, [t, i.name]),
          m = Object(c.useMemo)(function () {
        return o ? "Available" : "Away";
      }, [o]),
          g = Object(c.useMemo)(function () {
        return s && p && o ? "Conversation limit reached (".concat(u, ")") : o ? "Accepting new conversations" : "Not accepting new conversations";
      }, [o, p, u, s]);
      if (!a) return null;
      return l.a.createElement("div", {
        className: "agent-status-pane"
      }, l.a.createElement("div", {
        className: "agent-status-information"
      }, l.a.createElement("div", {
        className: "agent-identifier"
      }, h && l.a.createElement("div", {
        className: "agent-display-name"
      }, h), l.a.createElement("div", {
        className: "agent-status-label"
      }, m)), l.a.createElement("div", {
        className: "agent-status-details"
      }, g)), l.a.createElement(b.AgentStatusToggle, {
        className: "agent-status-toggle",
        agentStatus: d,
        onChange: function handleAgentStatusToggled() {
          f({
            source: n
          });
        }
      }));
    };

    r(112);

    function _createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var yt = function (e) {
      _inherits(AgentStatusSection, c["Component"]);

      var t = _createSuper2(AgentStatusSection);

      function AgentStatusSection() {
        return _classCallCheck(this, AgentStatusSection), t.apply(this, arguments);
      }

      return _createClass(AgentStatusSection, [{
        key: "render",
        value: function render() {
          return l.a.createElement("div", {
            className: "agent-status-toggle-container"
          }, l.a.createElement(bt, {
            source: "AgentStatusPopover",
            renderAgentName: !1
          }));
        }
      }]), AgentStatusSection;
    }(),
        Et = function AgentStatusAvatar(e) {
      var t = e.withPresence,
          n = e.withBorder,
          r = e.size,
          i = vt(),
          o = i.agentStatus,
          a = i.currentUser;
      return l.a.createElement(b.Avatar, {
        withPresence: t,
        presenceState: o,
        withBorder: n,
        size: r,
        user: a
      });
    },
        Ct = r(21),
        wt = function appConfig(e) {
      return Object(Ct.generateTrafficControlNavConfig)(function getRoot(e) {
        return e.user;
      }(e));
    };

    r(122);

    function Popover_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var _t = 1,
        xt = function getAppLink(e) {
      return "".concat(d.CUSTOMER_WEB_URL).concat(e);
    },
        St = function DriftStatus() {
      return l.a.createElement(b.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = xt("/settings2/widget/hours");
        }
      }, l.a.createElement(y.Icon, {
        name: "widget-online",
        height: "18"
      }), l.a.createElement(b.Span, {
        className: "agent-status-flyout-settings-nav-link",
        role: "button"
      }, "Drift status"));
    },
        kt = function DriftSettings() {
      return l.a.createElement(b.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = xt("/settings2");
        }
      }, l.a.createElement(y.Icon, {
        name: "settings-1",
        height: "18"
      }), l.a.createElement(b.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, "Settings"));
    },
        Ot = function DriftNotifications() {
      return l.a.createElement(b.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = xt("/settings2/notifications");
        }
      }, l.a.createElement(y.Icon, {
        name: "notification",
        height: "18"
      }), l.a.createElement(b.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, "Notifications"));
    },
        Bt = function DriftAdminPanel() {
      return l.a.createElement(b.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = xt("/settings2/deal-admin");
        }
      }, l.a.createElement(y.Icon, {
        name: "drift-logo-round",
        height: "18"
      }), l.a.createElement(b.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, "Drift Admin Panel"));
    },
        Tt = function DriftHelp() {
      return l.a.createElement(b.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = xt("/help");
        }
      }, l.a.createElement(y.Icon, {
        name: "knowledgebase-book",
        height: "18"
      }), l.a.createElement(b.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, "Drift Help"));
    },
        It = function (e) {
      _inherits(DriftAgentFlyout, c["Component"]);

      var t = Popover_createSuper2(DriftAgentFlyout);

      function DriftAgentFlyout() {
        var e;

        _classCallCheck(this, DriftAgentFlyout);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).canAccessDriftAdminPanel = function () {
          return e.props.org.id === _t;
        }, e.canAccessDriftHelp = function () {
          var t = e.props.cutovers;
          return ho.hasScopes("org_admin") && t && t.DRIFT_HELP;
        }, e.logoutUser = function () {
          mt("User logged out"), Object(W.redirectToLoginPage)(e.props.authClientId);
        }, e;
      }

      return _createClass(DriftAgentFlyout, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.user,
              n = e.appConfig,
              r = Object(v.pathOr)(!1, ["hasAgentStatus"], n),
              i = Object(v.pathOr)(!1, ["hasNotifications"], n),
              o = Object(v.pathOr)(!1, ["hasDriftStatus"], n);
          return l.a.createElement(b.Div, {
            className: "drift-status-flyout"
          }, l.a.createElement(b.Div, {
            className: "agent-status-flyout-header"
          }, l.a.createElement(b.Div, {
            className: "agent-status-flyout-header-container"
          }, l.a.createElement(Et, {
            withPresence: !0,
            withBorder: !1,
            user: t,
            size: "small"
          }), l.a.createElement(b.H4, {
            className: "agent-status-flyout-header-name"
          }, " ", t.name || t.email, " "), l.a.createElement(b.P, {
            className: "agent-status-flyout-profile-url"
          }, " ", t.email, " "))), l.a.createElement(b.Div, {
            className: "drift-status-options-wrapper"
          }, r && l.a.createElement(yt, null), l.a.createElement(b.Nav, null, o && l.a.createElement(St, null), i && l.a.createElement(Ot, null), l.a.createElement(kt, null), this.canAccessDriftHelp() && l.a.createElement(Tt, null), this.canAccessDriftAdminPanel() && l.a.createElement(Bt, null))), l.a.createElement(b.Div, {
            className: "agent-status-section drift-status-options-wrapper drift-status-options-switch-account"
          }, l.a.createElement(b.Div, {
            className: "agent-status-flyout-settings-nav-action",
            onClick: this.logoutUser
          }, "Sign out")));
        }
      }]), DriftAgentFlyout;
    }(),
        Rt = Object(u.connect)(function mapStateToProps(e) {
      return {
        appConfig: wt(e),
        cutovers: e.cutovers
      };
    })(N(It)),
        Pt = {
      CONVERSATIONS_SUBNAV: {
        label: "Conversations",
        path: "/inboxes",
        requiredScopes: ["member", "calendar_user", "video"],
        requiredRoles: [],
        rejectIfHasScopes: ["org_admin"],
        iconSRC: "conversations",
        height: 18,
        width: 16
      },
      CONVERSATIONS_SUBNAV_ADMIN: {
        label: "Conversations",
        path: "/conversations/analysis",
        additionalPaths: ["/inboxes"],
        requiredScopes: ["org_admin"],
        requiredRoles: ["Reporting"],
        hasAllGates: ["has_insights"],
        iconSRC: "conversations",
        height: 18,
        width: 16
      },
      CONVERSATIONS_SUBNAV_NO_ANALYSIS: {
        label: "Conversations",
        path: "/inboxes",
        requiredScopes: ["org_admin"],
        requiredRoles: [],
        rejectIfHasGates: ["has_insights"],
        iconSRC: "conversations",
        height: 18,
        width: 16
      },
      PLAYBOOKS_BOTS: {
        label: "Playbooks",
        path: "/playbooks",
        additionalPaths: ["/automation"],
        requiredScopes: ["org_admin"],
        requiredRoles: ["Playbooks"],
        iconSRC: "bot-2",
        height: 18,
        width: 18
      },
      PLAYBOOKS_SEQUENCES: {
        label: "Sequences",
        path: "/playbooks",
        requiredScopes: ["member"],
        requiredRoles: [],
        rejectIfHasScopes: ["org_admin"],
        rejectIfHasGates: ["has_calendar_user_license"],
        iconSRC: "email-send",
        height: 18,
        width: 18
      },
      CONTACTS_SUBNAV: {
        label: "Visitors",
        path: "/contacts",
        additionalPaths: ["/live", "/accounts"],
        requiredScopes: ["member"],
        requiredRoles: [],
        rejectIfHasGates: ["has_calendar_user_license"],
        rejectIfHasScopes: ["org_admin"],
        iconSRC: "contacts",
        height: 18,
        width: 18
      },
      CONTACTS_SUBNAV_AUDIENCES: {
        label: "Visitors",
        path: "/audiences",
        additionalPaths: ["/contacts", "/live", "/accounts"],
        requiredScopes: ["org_admin"],
        requiredRoles: ["Playbooks"],
        hasAllGates: ["AUDIENCE"],
        rejectIfHasGates: ["has_calendar_user_license"],
        iconSRC: "contacts",
        height: 18,
        width: 16
      },
      CONTACTS_SUBNAV_ADMIN_NO_AUDIENCES: {
        label: "Visitors",
        path: "/contacts",
        additionalPaths: ["/live", "/accounts"],
        requiredScopes: ["org_admin"],
        requiredRoles: [],
        rejectIfHasGates: ["AUDIENCE", "has_calendar_user_license"],
        iconSRC: "contacts",
        height: 18,
        width: 16
      },
      REPORTS: {
        label: "Reports",
        path: "/reports",
        requiredScopes: ["member"],
        requiredRoles: ["Reporting", "Playbooks"],
        iconSRC: "bar-chart",
        height: 18,
        width: 18
      }
    },
        jt = ["HOME", "CONVERSATIONS_SUBNAV", "CONVERSATIONS_SUBNAV_ADMIN", "CONVERSATIONS_SUBNAV_NO_ANALYSIS", "CONTACTS_SUBNAV", "CONTACTS_SUBNAV_AUDIENCES", "CONTACTS_SUBNAV_ADMIN_NO_AUDIENCES", "PLAYBOOKS_SEQUENCES", "PLAYBOOKS_BOTS", "REPORTS"],
        Nt = "Navigation Item Clicked";

    r(124);

    function AgentStatus_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Dt = function (e) {
      _inherits(AgentStatus, c["Component"]);

      var t = AgentStatus_createSuper2(AgentStatus);

      function AgentStatus(e) {
        var n;
        return _classCallCheck(this, AgentStatus), (n = t.call(this, e)).toggleOpen = function () {
          !n.state.flyoutOpen && mt(Nt, {
            item: "AGENT_STATUS"
          }), n.setState(function (e) {
            return {
              flyoutOpen: !e.flyoutOpen
            };
          });
        }, n.closeFlyout = function () {
          n.setState({
            flyoutOpen: !1,
            justClosed: !0
          }), setTimeout(function () {
            return n.setState({
              justClosed: !1
            });
          }, 300);
        }, n.resolveNotificationSnoozeStatus = function () {
          return n.props.user.settings["notifications-snoozed"] ? st.ON : st.OFF;
        }, n.isActive = function () {
          var e = n.props.user;
          return e.availability === at.ACTIVE || e.availability === at.ON_CALL;
        }, n.resolveStatusIcon = function (e, t) {
          var r = Object(v.contains)(e.availability, Object(v.values)(at)) ? e.availability : at.AWAY,
              i = n.resolveNotificationSnoozeStatus();
          return lt(r, i, t);
        }, n.isAutoAway = function (e, t) {
          return !!t.properties.limitNumChatsEnabled && n.isActive() && e.settings.atConversationLimit;
        }, n.state = {
          flyoutOpen: !1
        }, n;
      }

      return _createClass(AgentStatus, [{
        key: "renderFlyOut",
        value: function renderFlyOut(e) {
          var t = this.state.flyoutOpen,
              n = this.props,
              r = n.onReceiveUserConfig,
              i = n.onReceiveUserSettings,
              o = n.user,
              a = n.org,
              s = n.switchAppLinks,
              c = n.showTransientNotification,
              u = n.authClientId;
          return t ? l.a.createElement(Rt, {
            user: o,
            org: a,
            notificationSnoozeStatus: this.resolveNotificationSnoozeStatus(),
            isActive: this.isActive(),
            isAutoAway: e,
            handleClickOutside: this.closeFlyout,
            onUpdateUser: r,
            onUpdateUserSettings: i,
            switchAppLinks: s,
            showTransientNotification: c,
            authClientId: u
          }) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.user,
              n = e.org,
              r = this.state.justClosed,
              i = this.isAutoAway(t, n);
          return l.a.createElement("div", {
            className: "new-agent-status with-new-status-avatar"
          }, l.a.createElement("div", {
            className: "drift-status-nav-icon"
          }, l.a.createElement("div", {
            className: "agent-status-avatar",
            onClick: r ? void 0 : this.toggleOpen
          }, l.a.createElement(Et, {
            withPresence: !0,
            withBorder: !0
          }))), this.renderFlyOut(i));
        }
      }]), AgentStatus;
    }(),
        Lt = Object(u.connect)(function makeMapStateToProps() {
      return function (e) {
        return {
          user: e.user,
          org: e.org
        };
      };
    }, function mapDispatchToProps(e) {
      return {
        onReceiveUserSettings: function onReceiveUserSettings(t) {
          e(C(t));
        },
        onReceiveUserConfig: function onReceiveUserConfig(t) {
          e(E(t));
        },
        showTransientNotification: function showTransientNotification(t) {
          e(x(t));
        }
      };
    })(Dt),
        Mt = function Mt() {
      return l.a.createElement("svg", {
        width: "12",
        height: "18",
        viewBox: "0 0 12 18"
      }, l.a.createElement("path", {
        d: "M7.44 5.75h2.473c.196 0 .375.11.464.284.09.174.074.384-.04.543l-7.825 10.98c-.1.14-.26.22-.425.22-.074 0-.148-.018-.22-.05-.226-.105-.347-.358-.286-.6L3.507 9.41H.522c-.167 0-.325-.08-.423-.215-.1-.137-.126-.312-.074-.47L2.768.36c.07-.215.27-.36.496-.36h8.214c.207 0 .394.12.477.31.084.19.048.41-.09.564L7.44 5.75zM3.67 1.02L1.243 8.365h2.932c.16 0 .312.073.41.2.1.128.135.293.096.45l-1.42 5.693L8.9 6.796H6.26c-.206 0-.392-.122-.476-.31-.083-.19-.048-.41.09-.565l4.61-4.902H3.67z",
        fill: "#FFF9B3",
        fillRule: "evenodd"
      }));
    };

    function StatusPopOver_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ut = N(function (e) {
      _inherits(StatusPopOver, c["Component"]);

      var t = StatusPopOver_createSuper2(StatusPopOver);

      function StatusPopOver() {
        var e;

        _classCallCheck(this, StatusPopOver);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).navigateToBilling = function () {
          mt("Bolt Flyout Upgrade CTA Clicked"), window.location.replace("/settings/billing");
        }, e;
      }

      return _createClass(StatusPopOver, [{
        key: "render",
        value: function render() {
          return l.a.createElement("div", {
            className: "upgrade-pop-over"
          }, l.a.createElement("div", {
            className: "upgrade-message"
          }, l.a.createElement("h3", null, "Your plan"), l.a.createElement("p", null, "You\u2019re on the Free plan which includes basic live chat and Drift meetings."), l.a.createElement(b.Button, {
            onClick: this.navigateToBilling,
            className: "upgrade-button-cta"
          }, l.a.createElement(Mt, {
            className: "upgrade-icon"
          }), "Get more Drift")));
        }
      }]), StatusPopOver;
    }());
    r(126);

    function UpgradeLink_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ft = function (e) {
      _inherits(UpgradeLink, c["Component"]);

      var t = UpgradeLink_createSuper2(UpgradeLink);

      function UpgradeLink(e) {
        var n;
        return _classCallCheck(this, UpgradeLink), (n = t.call(this, e)).toggleOpen = function () {
          !n.state.flyoutOpen && mt(Nt, {
            item: "UPGRADE"
          }), n.setState(function (e) {
            return {
              flyoutOpen: !e.flyoutOpen
            };
          });
        }, n.state = {
          flyoutOpen: !1
        }, n.onClickOutside = n.toggleOpen, n;
      }

      return _createClass(UpgradeLink, [{
        key: "renderFlyOut",
        value: function renderFlyOut() {
          return this.state.flyoutOpen ? l.a.createElement(Ut, {
            onClickOutside: this.toggleOpen
          }) : null;
        }
      }, {
        key: "render",
        value: function render() {
          return l.a.createElement("div", {
            className: "upgrade-status-bar"
          }, l.a.createElement("span", {
            onClick: this.toggleOpen
          }, l.a.createElement(Mt, null)), this.renderFlyOut());
        }
      }]), UpgradeLink;
    }(),
        zt = {
      showWelcomeMessage: null,
      hideWelcomeMessage: null,
      showWelcomeOrAwayMessage: null,
      openChat: null,
      hideChat: null,
      identify: null,
      track: null,
      startInteraction: null
    };

    Object.keys(zt).map(function (e) {
      return zt[e] = function newFunc() {
        var t = arguments;
        window.drift.api ? window.drift.api[e].apply(null, arguments) : window.drift.on("ready", function (n) {
          n[e].apply(null, t);
        });
      };
    });
    var Ht = zt,
        Wt = r(19),
        qt = r.n(Wt);

    function flyout_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Gt = N(function (e) {
      _inherits(HelpFlyout, c["Component"]);

      var t = flyout_createSuper2(HelpFlyout);

      function HelpFlyout() {
        var e;

        _classCallCheck(this, HelpFlyout);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).triggerTicketPlaybook = function () {
          Ht.startInteraction({
            interactionId: d.SUPPORT_TICKET_INTERACTION_ID
          });
        }, e.triggerFreeIntegratedHelp = function () {
          Ht.startInteraction({
            interactionId: d.PAID_USER_INTEGRATED_HELP_INTERACTION_ID
          });
        }, e.triggerPaidIntegratedHelp = function () {
          Ht.startInteraction({
            interactionId: d.PAID_USER_INTEGRATED_HELP_INTERACTION_ID
          });
        }, e.triggerIntegratedHelp = function () {
          Wt.helpUtils.shouldLaunchHelpInteraction() ? (ho.hasGates("premium_drift") ? e.triggerPaidIntegratedHelp() : e.triggerFreeIntegratedHelp(), Wt.helpUtils.saveHelpInteractionStart()) : Ht.openChat();
        }, e.handleChatWidget = function () {
          return l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              e.triggerIntegratedHelp(), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "open chat widget",
                  text: "Chat with us"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            className: "nav-help-options-question-icon",
            name: "comments-1"
          }), "Chat with us");
        }, e;
      }

      return _createClass(HelpFlyout, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          mt("Flyout Viewed", {
            subject: "integrated-help-tooltip"
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this;
          return l.a.createElement(b.Div, {
            className: "nav-help-flyout"
          }, l.a.createElement(b.H4, null, "How can we help?"), l.a.createElement(b.Div, {
            className: "nav-help-flyout-options"
          }, l.a.createElement("nav", null, l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              window.open(d.HELP_URL), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "trigger help center",
                  text: "Search our Help Center"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            className: "nav-help-options-window-icon",
            name: "window-search"
          }), "Search our Help Center"), l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              window.open("https://insider.drift.com/classes/"), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "trigger drift insider classes page",
                  text: "Find a Training"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            className: "nav-help-options-lightning-icon",
            name: "lightning-bolt"
          }), "Find a training"), ho.hasGates("premium_drift") && this.handleChatWidget(), l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              e.triggerTicketPlaybook(), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "trigger ticket playbook",
                  text: "Find a Training"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            className: "nav-help-options-comments-icon",
            name: "question-bubble"
          }), "Submit a help request"), l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              window.open("".concat(d.CUSTOMER_WEB_URL, "/settings2/help")), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "trigger support requests page",
                  text: "View your help requests"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            className: "nav-help-options-support-icon",
            name: "support-ticket"
          }), "View your help requests"), l.a.createElement(b.Button, {
            type: "utility",
            onClick: function onClick() {
              window.open("https://drift.status.io"), mt("Flyout Clicked", {
                subject: "integrated-help-tooltip",
                ctaInfo: {
                  type: "link",
                  CTA: "trigger status page",
                  text: "Check out Drift's status"
                }
              });
            }
          }, l.a.createElement(y.Icon, {
            height: 16,
            width: 16,
            name: "notification"
          }), "Check out Drift's status"))));
        }
      }]), HelpFlyout;
    }());
    r(128);

    function Help_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Vt = function (e) {
      _inherits(Help, c["Component"]);

      var t = Help_createSuper2(Help);

      function Help(e) {
        var n;
        return _classCallCheck(this, Help), (n = t.call(this, e)).toggleOpen = function () {
          !n.state.flyoutOpen && mt(Nt, {
            item: "HELP"
          }), n.state.flyoutOpen && mt("Flyout Dismissed", {
            subject: "integrated-help-tooltip"
          }), n.setState(function (e) {
            return {
              flyoutOpen: !e.flyoutOpen
            };
          });
        }, n.state = {
          flyoutOpen: !1
        }, n;
      }

      return _createClass(Help, [{
        key: "renderFlyOut",
        value: function renderFlyOut() {
          return this.state.flyoutOpen ? (mt("Flyout Triggered", {
            subject: "integrated-help-tooltip"
          }), l.a.createElement(Gt, {
            handleClickOutside: this.toggleOpen
          })) : null;
        }
      }, {
        key: "renderHoverTooltip",
        value: function renderHoverTooltip() {
          return l.a.createElement(b.ToolTip, {
            className: "navigation-hover-tooltip--wrapper",
            component: "Need help?",
            flow: "right",
            hover: !this.state.flyoutOpen
          }, l.a.createElement("div", {
            className: "nav-status-item"
          }, l.a.createElement(y.Icon, {
            width: 19,
            name: "question"
          })));
        }
      }, {
        key: "render",
        value: function render() {
          return l.a.createElement("div", {
            className: "nav-help-wrapper"
          }, l.a.createElement("div", {
            className: "nav-help-tooltip",
            onClick: this.toggleOpen
          }, this.renderHoverTooltip()), this.renderFlyOut());
        }
      }]), Help;
    }(),
        Yt = function settingsClick() {
      mt(Nt, {
        item: "SETTINGS"
      }), mt("Navigation Item Clicked", {
        subject: "settings"
      });
    },
        Zt = function SettingsIcon() {
      return l.a.createElement("div", {
        className: "nav-help-wrapper",
        "data-ocweb-id": "traffic-control.SettingsCog"
      }, l.a.createElement("a", {
        href: "".concat(d.CUSTOMER_WEB_URL, "/settings/team")
      }, l.a.createElement("div", {
        className: "nav-help-tooltip",
        onClick: Yt
      }, l.a.createElement(b.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: "Settings",
        flow: "right"
      }, l.a.createElement("div", {
        className: "nav-status-item"
      }, l.a.createElement(y.Icon, {
        width: 19,
        height: 24,
        name: "settings-1"
      }))))));
    },
        Jt = function getGlobalNotifications(e) {
      return e.globalNotifications;
    },
        Kt = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee() {
        return m.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("embeds/_default"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      }));

      return function getEmbedConfig() {
        return e.apply(this, arguments);
      };
    }(),
        Xt = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee3(e) {
        var t;
        return m.a.wrap(function _callee3$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return t = [{
                  operation: "set",
                  property: "chatEnabled",
                  value: e
                }], n.abrupt("return", ne.patch("embeds/_default/configuration", t));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee3);
      }));

      return function setChatEnabled(t) {
        return e.apply(this, arguments);
      };
    }(),
        $t = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee4() {
        return m.a.wrap(function _callee4$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("organizations/info"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee4);
      }));

      return function getOrgConfig() {
        return e.apply(this, arguments);
      };
    }(),
        Qt = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee5() {
        return m.a.wrap(function _callee5$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("organizations/properties"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee5);
      }));

      return function getOrgProperties() {
        return e.apply(this, arguments);
      };
    }(),
        en = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee6(e, t) {
        return m.a.wrap(function _callee6$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", ne.patch("/organizations/".concat(e, "/properties"), t));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee6);
      }));

      return function setOrgProperties(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        tn = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee7() {
        return m.a.wrap(function _callee7$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("/users"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee7);
      }));

      return function getOrgUsers() {
        return e.apply(this, arguments);
      };
    }(),
        nn = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee8() {
        return m.a.wrap(function _callee8$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("/users/getAll"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee8);
      }));

      return function getAllOrgUsers() {
        return e.apply(this, arguments);
      };
    }(),
        rn = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee10() {
        return m.a.wrap(function _callee10$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("/multi_org/info"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee10);
      }));

      return function getOrganizationsInfo() {
        return e.apply(this, arguments);
      };
    }(),
        on = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee12(e, t) {
        return m.a.wrap(function _callee12$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", ne.post("multi_org/switch?targetOrgId=".concat(e, "&clientId=").concat(t)));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee12);
      }));

      return function switchOrganization(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        an = function getJoinableOrganizations() {
      return ne.get("/findTeam/domains/joinable");
    },
        sn = function getSessionTimeoutSettings() {
      return ie.get("/organizations/timeout");
    },
        cn = r(62),
        ln = (r(130), function Onboarding(e) {
      var t = e.org,
          n = t.id,
          r = t.properties,
          i = r.widgetInstalled,
          o = r.welcome_org_checklist_completed,
          a = Object(u.useSelector)(Jt).length,
          s = _slicedToArray(Object(c.useState)(!r.has_seen_nav_onboarding_tooltip && !a), 2),
          p = s[0],
          f = s[1];

      Object(c.useEffect)(function () {
        a || r.has_seen_nav_onboarding_tooltip || f(!0);
      }, [a, r.has_seen_nav_onboarding_tooltip]);

      var h = Object(v.pickBy)(function (e, t) {
        return /^welcome.*completed$/.test(t);
      }, r),
          m = Object.values(h),
          g = m.filter(Boolean).length / m.length * 100 || 0,
          A = _slicedToArray(Object(c.useState)(function getHoverText() {
        var e = ["You\u2019re almost there \u26A1\uFE0F", "You got this \uD83D\uDCAA", "Keep going \uD83D\uDE80", "Doing great so far \uD83D\uDC4F", "Getting closer \uD83D\uDCAB", "Keep it up \uD83C\uDF89"];
        return e[Math.floor(Math.random() * e.length)];
      }()), 1)[0],
          y = {
        width: "".concat(g, "%")
      },
          E = function onGetStartedTooltipClick() {
        en(n, {
          has_seen_nav_onboarding_tooltip: !0
        }), f(!1);
      },
          C = l.a.createElement(b.Div, {
        className: "nav-onboarding-tooltip-progressbar-container"
      }, l.a.createElement(b.Div, {
        style: y
      })),
          w = l.a.createElement(b.Div, {
        className: "nav-onboarding-tooltip-content"
      }, l.a.createElement(b.H5, {
        className: "nav-onboarding-tooltip-title"
      }, "Continue setup"), l.a.createElement(b.H5, {
        className: "nav-onboarding-tooltip-title"
      }, g.toFixed(), "% complete"), C, A),
          _ = !1 === o ? "You\u2019re ".concat(g.toFixed(), "% complete!") : "Finish setting up Drift!",
          x = l.a.createElement(b.Div, {
        className: "nav-onboarding-tooltip-content"
      }, !1 === o && C, l.a.createElement(b.P, {
        className: "nav-onboarding-tooltip-copy"
      }, "Click here to continue setting up Drift. We\u2019ll", l.a.createElement("br", null), "also help you keep track of your progress."), l.a.createElement(b.Button, {
        type: "tertiary",
        className: "nav-onboarding-tooltip-button",
        onClick: E
      }, "Got it!"));

      return ho.hasGates("has_onboarding_experience") ? i && Object(v.isNil)(o) || o ? null : l.a.createElement(b.Div, {
        className: "nav-help-wrapper nav-status-item nav-status-item-onboarding"
      }, l.a.createElement(b.ToolTip, {
        flow: "right",
        render: function render() {
          return w;
        },
        hover: !p
      }, l.a.createElement(cn.EducationTooltip, {
        className: "nav-onboarding-get-started-tooltip-container",
        tooltipSide: "right",
        tooltipCaretPosition: "left",
        headerCopy: _,
        bodyCopy: x,
        ribbonType: "getstarted",
        showTooltip: p,
        onClose: E,
        hover: !1
      }, l.a.createElement("a", {
        className: "nav-onboarding-link",
        href: "".concat(d.CUSTOMER_WEB_URL, "/welcome")
      }, l.a.createElement(b.Div, {
        className: "nav-onboarding-progressbar-container"
      }, l.a.createElement(b.Div, {
        style: y
      })), l.a.createElement(b.Div, {
        className: "nav-onboarding-percent-completed"
      }, l.a.createElement(b.Span, {
        className: "nav-onboarding-percent-completed-number"
      }, g.toFixed()), "%"))))) : null;
    }),
        un = "qqVUHCYU6871",
        pn = ["enterprise_04_2018", "premium_enterprise", "premium_team", "premium_drift"],
        fn = function getBeamerFilters() {
      var e = [];
      return e = (e = (e = (e = (e = e.concat(function getExactIdentifiers() {
        return ["id".concat(Je.getState().user.id), "orgId".concat(Je.getState().user.orgId)];
      }())).concat(function getRole() {
        return ho.isAdmin() ? "admin" : ho.isUser() ? "user" : void 0;
      }())).concat(function getSize() {
        var e = Je.getState().org.users.length - 1,
            t = ["orgSize".concat(e)];
        return e >= 2 && t.push("orgSizeGreaterOrEqual2"), e >= 5 && t.push("orgSizeGreaterOrEqual5"), e >= 10 && t.push("orgSizeGreaterOrEqual10"), e >= 20 && t.push("orgSizeGreaterOrEqual20"), t;
      }())).concat(function getPlan() {
        var e = [];

        for (var t in pn) {
          var n = pn[t];

          if (ho.hasGates(n)) {
            e.push(n);
            break;
          }
        }

        return 0 === e.length && e.push("free"), e;
      }())).concat(function boolObjToArr(e) {
        return Object(v.map)(function (e) {
          return e[0];
        }, Object(v.filter)(function (e) {
          return !!e[1];
        }, Object(v.toPairs)(e)));
      }(mo.getAllIntegrations()));
    };

    r(132);

    function Shipyard_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var dn = function (e) {
      _inherits(Shipyard, c["Component"]);

      var t = Shipyard_createSuper2(Shipyard);

      function Shipyard() {
        var e;

        _classCallCheck(this, Shipyard);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).state = {
          showShipyard: !1
        }, e.initializeBeamer = function () {
          var t = e.props.user,
              n = (t.name ? t.name : "").split(" "),
              r = n[0];
          n.splice(0, 1);
          var i = n.join(" ");
          window.beamer_config = {
            selector: ".rocket-link",
            product_id: un,
            button_position: "top-left",
            onclick: function onclick(e) {
              return mt("Beamer Item Selected", {
                url: e
              });
            },
            top: -6,
            right: -6,
            user_firstname: r,
            user_lastname: i,
            user_email: t.email,
            user_id: t.id,
            filter_by_url: !0,
            filter: fn().join(";")
          };

          try {
            window.Beamer && (window.Beamer.init(), e.setState({
              showShipyard: !0
            }));
          } catch (o) {
            console.warn(o);
          }
        }, e;
      }

      return _createClass(Shipyard, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          !e.beamerLoaded && this.props.beamerLoaded && this.initializeBeamer();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state.showShipyard;
          return l.a.createElement("div", {
            onClick: function onClick() {
              return mt(Nt, {
                item: "SHIPYARD"
              });
            },
            className: A()("rocket-link", {
              "hide-shipyard": !e
            })
          }, l.a.createElement(b.ToolTip, {
            className: "navigation-hover-tooltip--wrapper",
            component: "Product updates",
            flow: "right"
          }, l.a.createElement("div", {
            className: "nav-status-item"
          }, l.a.createElement(y.Icon, {
            width: 16,
            height: 16,
            name: "rocket"
          }))));
        }
      }]), Shipyard;
    }(),
        hn = Object(u.connect)(function mapStateToProps(e) {
      return {
        beamerLoaded: e.snippets && e.snippets.beamerLoaded
      };
    })(dn);

    r(134);

    function AppLink_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var mn = function (e) {
      _inherits(AppLink, c["Component"]);

      var t = AppLink_createSuper2(AppLink);

      function AppLink() {
        var e;

        _classCallCheck(this, AppLink);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).goToApp = function () {
          var t = e.props.app;
          window.location.href = t.url;
        }, e;
      }

      return _createClass(AppLink, [{
        key: "render",
        value: function render() {
          var e = this.props.app;
          return l.a.createElement(b.Div, {
            className: "app-link-container",
            onClick: this.goToApp
          }, l.a.createElement(b.Div, {
            className: "app-link-entry"
          }, l.a.createElement(b.Button, {
            type: "utility",
            icon: e.iconName,
            onClick: function onClick() {
              return window.location.href = e.url;
            }
          }, e.name)));
        }
      }]), AppLink;
    }(),
        gn = function getName(e) {
      var t = e.org;
      return t && t.name || " ";
    },
        An = function nameComparator(e, t) {
      return gn(e).localeCompare(gn(t));
    },
        vn = function sortByName(e) {
      return Object(v.sort)(An, e);
    },
        bn = function onSwitchAccount(e) {
      mt("Org Switched", {}), Object(W.setAccessToken)({
        token: e
      }), window.location.replace("/");
    },
        yn = function applyOrgTransformationFromIdentity(e) {
      return e.map(function (e) {
        var t = e.orgName,
            n = e.email,
            r = e.token,
            i = e.scopes;
        e.name;
        return {
          org: {
            name: t || n,
            email: t && n,
            id: r
          },
          accessRights: i || [],
          properties: {
            "org-logo-url": e.orgLogo
          },
          onSwitch: bn
        };
      });
    },
        En = function getOrgDefaultLogo() {
      return l.a.createElement("svg", {
        className: "organization-logo",
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, l.a.createElement("defs", null, l.a.createElement("linearGradient", {
        id: "b",
        x1: "0%",
        y1: "12.773%",
        y2: "88.499%"
      }, l.a.createElement("stop", {
        offset: "0%",
        stopColor: "#1DB895"
      }), l.a.createElement("stop", {
        offset: "100%",
        stopColor: "#59DFBF"
      })), l.a.createElement("rect", {
        id: "a",
        width: "32",
        height: "32",
        rx: "4"
      }), l.a.createElement("linearGradient", {
        id: "d",
        x1: "0%",
        x2: "102%",
        y1: "0%",
        y2: "101%"
      }, l.a.createElement("stop", {
        offset: "0%",
        stopColor: "#0A29D9"
      }), l.a.createElement("stop", {
        offset: "100%",
        stopColor: "#8293F9"
      }))), l.a.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, l.a.createElement("mask", {
        id: "c",
        fill: "#fff"
      }, l.a.createElement("use", {
        href: "#a"
      })), l.a.createElement("use", {
        fill: "url(#b)",
        fillRule: "nonzero",
        href: "#a"
      }), l.a.createElement("g", {
        fill: "url(#d)",
        mask: "url(#c)"
      }, l.a.createElement("path", {
        d: "M3 0h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
      })), l.a.createElement("path", {
        fill: "#FFF",
        d: "M8 17.687h7.713L9.21 27.892 24 14.238h-8L20.632 5z",
        mask: "url(#c)"
      })));
    };

    r(136);

    function Switcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Cn = 5,
        wn = 10,
        _n = function OrgLogo(e) {
      var t = e.properties,
          n = t && t["org-logo-url"];
      return n ? l.a.createElement("img", {
        src: n,
        className: "organization-logo",
        height: "32",
        width: "32",
        alt: "org-logo"
      }) : En();
    },
        xn = function OrgSwitcher(e) {
      var t = e.organization,
          n = e.authClientId,
          r = e.onSwitch,
          i = e.isActive,
          o = function getOrganization(e) {
        return Object(v.merge)({
          org: {
            name: "",
            id: 0
          },
          accessRights: [],
          properties: {}
        }, e);
      }(t),
          a = o.org,
          s = a.name,
          c = a.email,
          u = a.id,
          p = o.accessRights,
          f = o.properties;

      return l.a.createElement("div", {
        className: A()("organization-info-container", {
          active: i(t)
        }),
        onClick: function onClick() {
          return r(u, n);
        }
      }, l.a.createElement("div", null, l.a.createElement(_n, {
        properties: f
      })), l.a.createElement("div", null, l.a.createElement(b.H4, {
        className: "organization-global-name"
      }, " ", s, " "), l.a.createElement(b.P, {
        className: "organization-access-right"
      }, " ", function getAuthorizationType(e) {
        return e.includes("org_admin") ? "Admin" : e.includes("calendar_user") ? "Calendar User" : "Chat User";
      }(p), " ", c && "\u2022 ".concat(c), " ")));
    },
        Sn = function (e) {
      _inherits(Switcher, c["Component"]);

      var t = Switcher_createSuper2(Switcher);

      function Switcher() {
        var e;

        _classCallCheck(this, Switcher);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).state = {
          maxLength: Cn
        }, e.getMaxLength = function () {
          return Object(v.min)(e.props.organizations.length, e.state.maxLength);
        }, e.incrementMaxLength = function () {
          e.setState({
            maxLength: e.state.maxLength + wn
          });
        }, e.decrementMaxLength = function () {
          e.setState({
            maxLength: e.state.maxLength - wn
          });
        }, e.canShowMore = function () {
          return e.props.organizations.length - e.state.maxLength > 0;
        }, e.canShowLess = function () {
          return e.state.maxLength > Cn;
        }, e;
      }

      return _createClass(Switcher, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.authClientId,
              n = e.organizations,
              r = e.isActive,
              i = e.onAdd;
          return l.a.createElement("div", {
            className: "org-switcher"
          }, l.a.createElement(b.H4, {
            className: "org-switcher-header"
          }, " ORGANIZATIONS "), n.length > 1 && n.slice(0, this.getMaxLength()).map(function (e, n) {
            return l.a.createElement(xn, {
              key: n,
              organization: e,
              authClientId: t,
              onSwitch: e.onSwitch,
              isActive: r
            });
          }), this.canShowMore() && l.a.createElement(b.A, {
            className: "org-switcher-increment",
            href: "#",
            onClick: this.incrementMaxLength
          }, " Show more "), this.canShowLess() && l.a.createElement(b.A, {
            className: "org-switcher-increment",
            href: "#",
            onClick: this.decrementMaxLength
          }, " Show less "), l.a.createElement(b.Button, {
            type: "utility",
            icon: "plus",
            onClick: i
          }, " Add an organization "));
        }
      }]), Switcher;
    }();

    function AccountSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var kn = function onAdd() {
      window.location.href = d.START;
    },
        On = function (e) {
      _inherits(OrgSwitcherSection, c["Component"]);

      var t = AccountSwitcher_createSuper2(OrgSwitcherSection);

      function OrgSwitcherSection(e) {
        var n;
        return _classCallCheck(this, OrgSwitcherSection), (n = t.call(this, e)).isActive = function (e) {
          var t = e.org;
          return Object(W.getAccessToken)() === (t && t.id);
        }, n.state = {
          organizations: yn(Object(W.getDisplayableIdentities)()) || []
        }, n;
      }

      return _createClass(OrgSwitcherSection, [{
        key: "render",
        value: function render() {
          return l.a.createElement(Sn, {
            organizations: this.state.organizations,
            isActive: this.isActive,
            onAdd: kn
          });
        }
      }]), OrgSwitcherSection;
    }();

    function OrgSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Bn = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee(e, t) {
        return m.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                on(e, t).then(function (e) {
                  var t = e.data,
                      n = t.accessToken,
                      r = t.expiresAt;
                  Object(W.setAccessToken)({
                    token: n,
                    expirationInSeconds: r
                  }), window.location.replace("/");
                }).catch(function (e) {
                  return console.error(e);
                });

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee);
      }));

      return function onSwitch(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Tn = function getAccounts(e) {
      return Object(v.compose)(vn, yn, function (t) {
        return function complementToEmail(e, t) {
          return Object(v.filter)(function (e) {
            return e.email !== t;
          }, e);
        }(t, e);
      })(Object(W.getDisplayableIdentities)());
    },
        In = function (e) {
      _inherits(OrgSwitcher, c["Component"]);

      var t = OrgSwitcher_createSuper2(OrgSwitcher);

      function OrgSwitcher(e) {
        var n;
        return _classCallCheck(this, OrgSwitcher), (n = t.call(this, e)).fetchOrganizations = _asyncToGenerator(m.a.mark(function _callee2() {
          var e, t;
          return m.a.wrap(function _callee2$(r) {
            for (;;) {
              switch (r.prev = r.next) {
                case 0:
                  return r.prev = 0, r.next = 3, rn();

                case 3:
                  e = r.sent, t = e.data, n.setState({
                    organizations: Object(v.concat)(n.hydrateActions(t), n.state.organizations)
                  }), r.next = 11;
                  break;

                case 8:
                  r.prev = 8, r.t0 = r.catch(0), console.error(r.t0);

                case 11:
                case "end":
                  return r.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        })), n.hydrateActions = function (e) {
          return e.map(function (e) {
            return Object(v.compose)(function (e) {
              return Object(v.assoc)("onSwitch", Bn, e);
            }, function (e) {
              return Object(v.assocPath)(["org", "email"], n.props.currentEmail, e);
            })(e);
          });
        }, n.isActive = function (e) {
          var t = e.org;
          return Object(v.equals)(n.props.currentOrg.id, t && t.id);
        }, n.state = {
          organizations: Tn(e.currentEmail) || []
        }, n;
      }

      return _createClass(OrgSwitcher, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.fetchOrganizations();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state.organizations,
              t = this.props,
              n = t.authClientId,
              r = t.onAdd;
          return l.a.createElement(Sn, {
            organizations: e,
            isActive: this.isActive,
            authClientId: n,
            onAdd: r
          });
        }
      }]), OrgSwitcher;
    }(),
        Rn = Object(u.connect)(function mapStateToProps(e) {
      return {
        currentOrg: e.org,
        currentEmail: e.user.email
      };
    })(In),
        Pn = function Organizations(e) {
      var t = e.onAdd,
          n = e.authClientId;
      return ho.isMultiOrg() ? l.a.createElement(Rn, {
        onAdd: t,
        authClientId: n
      }) : l.a.createElement(On, null);
    };

    r(138);

    function VerifyEmail_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var jn = function EmailForm(e) {
      var t = e.setEmail,
          n = e.verifyEmailRequest,
          r = e.email,
          i = e.info;
      return l.a.createElement(b.Div, null, l.a.createElement(b.H4, null, " Join an existing organization "), l.a.createElement(b.Form, {
        className: "find-team-verification-form"
      }, i && l.a.createElement(b.P, {
        className: "find-team-verifcation-info"
      }, " ", i, " "), l.a.createElement(b.Input, {
        onChange: t,
        minLength: "10",
        type: "email",
        placeholder: "Your other email address",
        required: !0
      }), l.a.createElement(b.AsyncButton, {
        promise: n,
        disabled: !r
      }, "Send verification email")));
    },
        Nn = function EmailSent(e) {
      var t = e.email;
      return l.a.createElement(b.Div, {
        className: "verify-email-sent-success"
      }, function getEmailSuccess() {
        return l.a.createElement("svg", {
          width: "162px",
          height: "153px",
          viewBox: "0 0 162 153",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          xlink: "http://www.w3.org/1999/xlink"
        }, l.a.createElement("defs", null, l.a.createElement("filter", {
          x: "-10.5%",
          y: "-17.4%",
          width: "121.0%",
          height: "134.8%",
          filterUnits: "objectBoundingBox",
          id: "filter-1"
        }, l.a.createElement("feGaussianBlur", {
          stdDeviation: "3.4",
          in: "SourceGraphic"
        })), l.a.createElement("filter", {
          x: "-13.9%",
          y: "-17.9%",
          width: "127.8%",
          height: "135.8%",
          filterUnits: "objectBoundingBox",
          id: "filter-2"
        }, l.a.createElement("feGaussianBlur", {
          stdDeviation: "3.4",
          in: "SourceGraphic"
        })), l.a.createElement("filter", {
          x: "-21.4%",
          y: "-24.1%",
          width: "143.1%",
          height: "148.2%",
          filterUnits: "objectBoundingBox",
          id: "filter-3"
        }, l.a.createElement("feOffset", {
          dx: "0",
          dy: "2",
          in: "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), l.a.createElement("feGaussianBlur", {
          stdDeviation: "4.5",
          in: "shadowOffsetOuter1",
          result: "shadowBlurOuter1"
        }), l.a.createElement("feColorMatrix", {
          values: "0 0 0 0 0.462745098   0 0 0 0 0.584313725   0 0 0 0 0.647058824  0 0 0 0.18 0",
          type: "matrix",
          in: "shadowBlurOuter1",
          result: "shadowMatrixOuter1"
        }), l.a.createElement("feMerge", null, l.a.createElement("feMergeNode", {
          in: "shadowMatrixOuter1"
        }), l.a.createElement("feMergeNode", {
          in: "SourceGraphic"
        }))), l.a.createElement("polygon", {
          id: "path-4",
          points: "0.0769370583 0.395822387 15.2276845 0.395822387 15.2276845 15.4543753 0.0769370583 15.4543753 0.0769370583 0.395822387"
        })), l.a.createElement("g", {
          id: "Page-1",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, l.a.createElement("g", {
          id: "01_buy-account-icp",
          transform: "translate(-200.000000, -208.000000)"
        }, l.a.createElement("g", {
          id: "Group-4",
          transform: "translate(200.000000, 208.000000)"
        }, l.a.createElement("g", {
          id: "Icon"
        }, l.a.createElement("ellipse", {
          id: "Oval-3-Copy",
          fill: "#F8FAFB",
          cx: "79.8063158",
          cy: "89.76",
          rx: "62.7536842",
          ry: "62.56"
        }), l.a.createElement("g", {
          id: "Group-7",
          transform: "translate(29.842105, 47.600000)"
        }, l.a.createElement("path", {
          d: "M99.7578947,42.9669014 L99.7578947,83.2725145 C99.7578947,86.1045179 96.6728086,88.4 92.8666476,88.4 L9.44914185,88.4 C5.64298091,88.4 2.55789474,86.1045179 2.55789474,83.2725145 L2.55789474,42.9669014 L2.55789474,34.8642196 C2.55789474,32.0389423 5.64298091,29.75 9.44914185,29.75 L92.8666476,29.75 C96.6728086,29.75 99.7578947,32.0389423 99.7578947,34.8642196 L99.7578947,42.9669014 Z",
          id: "Combined-Shape",
          fill: "#B4C3D8",
          filter: "url(#filter-1)"
        }), l.a.createElement("path", {
          d: "M87.8210526,15.3 L87.8210526,54.5116794 C87.8210526,57.2668195 85.4937069,59.5 82.6223925,59.5 L19.6933969,59.5 C16.8220826,59.5 14.4947368,57.2668195 14.4947368,54.5116794 L14.4947368,15.3 L14.4947368,7.4835542 C14.4947368,4.75808297 16.8220826,2.55 19.6933969,2.55 L82.6223925,2.55 C85.4937069,2.55 87.8210526,4.75808297 87.8210526,7.4835542 L87.8210526,15.3 Z",
          id: "Combined-Shape",
          fill: "#B4C3D8",
          filter: "url(#filter-2)"
        }), l.a.createElement("g", {
          id: "Group-6"
        }, l.a.createElement("g", {
          id: "Group-5",
          filter: "url(#filter-3)"
        }, l.a.createElement("polygon", {
          id: "Fill-24",
          fill: "#B4C3D8",
          points: "100.461683 28.0944083 50.6491348 60.1447068 0.852580573 28.0944083 50.6491348 0.351013244"
        }), l.a.createElement("polygon", {
          id: "Fill-30",
          fill: "#FFFFFF",
          points: "87.4113665 37.5947823 50.6491312 60.1439841 13.3844811 37.5947823 13.3844811 0.437732707 87.9289105 0.437732707"
        }), l.a.createElement("polyline", {
          id: "Path-2",
          stroke: "#B5D2E1",
          strokeWidth: "2.55",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          points: "42.6315789 27.7061473 49.3717636 34.4255289 62.9283667 20.922793"
        }), l.a.createElement("polygon", {
          id: "Fill-26",
          fill: "#EDF4F7",
          points: "100.461683 28.0944083 100.461683 88.9648277 0.852580573 88.9648277 0.852580573 28.0944083 50.6491348 60.1447068"
        }), l.a.createElement("polygon", {
          id: "Fill-28",
          fill: "#E1EEF4",
          points: "50.6486986 60.1444177 0.852144361 88.9645386 0.852144361 28.0941193"
        })))), l.a.createElement("g", {
          id: "Group-3",
          transform: "translate(30.534868, 0.200025)"
        }, l.a.createElement("mask", {
          id: "mask-5",
          fill: "white"
        }, l.a.createElement("use", {
          href: "#path-4"
        })), l.a.createElement("g", {
          id: "Clip-2"
        }), l.a.createElement("path", {
          d: "M8.64996488,1.13753474 L9.81610604,5.07444911 C9.9164349,5.41119692 10.1810704,5.67568126 10.5198621,5.77395959 L14.4806707,6.9330658 C15.476689,7.22501026 15.476689,8.62692176 14.4806707,8.91742095 L10.5198621,10.0765272 C10.1810704,10.1748055 9.9164349,10.4392898 9.81610604,10.7760376 L8.64996488,14.712952 C8.35770257,15.7015164 6.94728245,15.7015164 6.6535661,14.712952 L5.48887898,10.7760376 C5.38855012,10.4392898 5.12246055,10.1748055 4.78366892,10.0765272 L0.822860273,8.91742095 C-0.171704013,8.62692176 -0.171704013,7.22501026 0.822860273,6.9330658 L4.78366892,5.77395959 C5.12246055,5.67568126 5.38855012,5.41119692 5.48887898,5.07444911 L6.6535661,1.13753474 C6.94728245,0.147525072 8.35770257,0.147525072 8.64996488,1.13753474",
          id: "Fill-1",
          fill: "#4D9EFF",
          mask: "url(#mask-5)"
        })), l.a.createElement("path", {
          d: "M156.701619,82.5869228 L157.560957,85.4904694 C157.635113,85.740501 157.829955,85.9327219 158.08005,86.0064306 L161.001219,86.8620302 C161.73551,87.0759301 161.73551,88.1092979 161.001219,88.3246431 L158.08005,89.1802427 C157.829955,89.2525061 157.635113,89.4461723 157.560957,89.6947586 L156.701619,92.5983052 C156.484967,93.3281664 155.445327,93.3281664 155.228675,92.5983052 L154.369336,89.6947586 C154.296634,89.4461723 154.100339,89.2525061 153.850244,89.1802427 L150.929075,88.3246431 C150.194784,88.1092979 150.194784,87.0759301 150.929075,86.8620302 L153.850244,86.0064306 C154.100339,85.9327219 154.296634,85.740501 154.369336,85.4904694 L155.228675,82.5869228 C155.445327,81.8585069 156.484967,81.8585069 156.701619,82.5869228",
          id: "Fill-4",
          fill: "#0076FF"
        }), l.a.createElement("path", {
          d: "M144.792293,31.2091786 C144.792293,32.9102609 143.405138,34.2890481 141.693731,34.2890481 C139.982324,34.2890481 138.596623,32.9102609 138.596623,31.2091786 C138.596623,29.5080963 139.982324,28.1293091 141.693731,28.1293091 C143.405138,28.1293091 144.792293,29.5080963 144.792293,31.2091786 Z",
          id: "Stroke-6",
          stroke: "#B4C3D8",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M7.90136958,84.1551684 C7.90136958,85.8562507 6.51421413,87.2350379 4.80426149,87.2350379 C3.09285482,87.2350379 1.70569937,85.8562507 1.70569937,84.1551684 C1.70569937,82.4540861 3.09285482,81.0752989 4.80426149,81.0752989 C6.51421413,81.0752989 7.90136958,82.4540861 7.90136958,84.1551684 Z",
          id: "Stroke-8",
          stroke: "#4D9EFF",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), l.a.createElement("path", {
          d: "M4.66981748,41.5250794 C4.66981748,42.7521133 3.66943703,43.7450135 2.43495592,43.7450135 C1.20192885,43.7450135 0.201548402,42.7521133 0.201548402,41.5250794 C0.201548402,40.2980455 1.20192885,39.3051453 2.43495592,39.3051453 C3.66943703,39.3051453 4.66981748,40.2980455 4.66981748,41.5250794",
          id: "Fill-10",
          fill: "#B4C3D8"
        }), l.a.createElement("g", {
          id: "Group-15",
          transform: "translate(80.089004, 19.497991)"
        }, l.a.createElement("path", {
          d: "M0.164645949,0.300905129 L0.164645949,11.0378129",
          id: "Fill-12",
          fill: "#FFFFFF"
        }), l.a.createElement("path", {
          d: "M0.164645949,0.300905129 L0.164645949,11.0378129",
          id: "Stroke-14",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })), l.a.createElement("g", {
          id: "Group-19",
          transform: "translate(68.941353, 26.724339)"
        }, l.a.createElement("path", {
          d: "M0.772677575,0.488645649 L4.66514628,5.46181831",
          id: "Fill-16",
          fill: "#FFFFFF"
        }), l.a.createElement("path", {
          d: "M0.772677575,0.488645649 L4.66514628,5.46181831",
          id: "Stroke-18",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })), l.a.createElement("g", {
          id: "Group-23",
          transform: "translate(86.389850, 26.129069)"
        }, l.a.createElement("path", {
          d: "M4.89401239,0.0493912663 L0.511531748,6.05737696",
          id: "Fill-20",
          fill: "#FFFFFF"
        }), l.a.createElement("path", {
          d: "M4.89401239,0.0493912663 L0.511531748,6.05737696",
          id: "Stroke-22",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })))))));
      }(), l.a.createElement(b.H1, null, " Check your email! "), l.a.createElement(b.P, {
        className: "verify-email-success-copy"
      }, "We\u2019ve sent a verification email to ", t, ". Follow the instructions in the email to get started!"));
    },
        Dn = function (e) {
      _inherits(VerifyEmail, c["Component"]);

      var t = VerifyEmail_createSuper2(VerifyEmail);

      function VerifyEmail(e) {
        var n;
        return _classCallCheck(this, VerifyEmail), (n = t.call(this, e)).verifyEmailRequest = function () {
          var e = n.state.email;
          return et(e).then(function () {
            return n.setState({
              sentVerificationEmail: !0
            });
          }).catch(function (e) {
            return console.error(e);
          });
        }, n.setEmail = function (e) {
          var t = e.target.value;
          n.setState({
            email: t
          });
        }, n.resetState = function () {
          n.setState({
            email: "",
            sentVerificationEmail: !1
          });
        }, n.state = {
          email: "",
          sentVerificationEmail: !1
        }, n;
      }

      return _createClass(VerifyEmail, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.email,
              n = e.sentVerificationEmail,
              r = this.props.info;
          return l.a.createElement(b.Div, {
            className: "find-your-team-email"
          }, n ? l.a.createElement(Nn, {
            email: t
          }) : l.a.createElement(jn, {
            setEmail: this.setEmail,
            verifyEmailRequest: this.verifyEmailRequest,
            email: t,
            info: r
          }));
        }
      }]), VerifyEmail;
    }();

    r(140);

    function OrgRecommendations_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ln = 3,
        Mn = 5,
        Un = function OrgRequestSuccess() {
      return l.a.createElement(b.Button, {
        size: "small",
        className: "duplicate-request-org-button",
        type: "tertiary",
        disabled: !0
      }, "Requested");
    },
        Fn = function OrgRequestButton(e) {
      var t = e.setOrgRequested,
          n = e.orgId;
      return l.a.createElement(b.Button, {
        size: "small",
        onClick: function sendRequest() {
          (function orgJoinRequest(e) {
            return re.post("/findTeam/request?orgId=".concat(e));
          })(n).catch(function (e) {
            return console.error(e);
          }), t(n);
        }
      }, " Join ");
    },
        zn = function JoinOrgEntry(e) {
      var t = e.organization,
          n = t.orgLogo,
          r = t.orgName,
          i = t.teammateCount,
          o = t.orgId,
          a = e.setOrgRequested,
          s = e.isOrgRequested;
      return l.a.createElement("div", {
        className: "join-org-content"
      }, l.a.createElement("div", {
        className: "join-org-logo-container"
      }, n ? l.a.createElement("img", {
        src: n,
        alt: "logo"
      }) : En()), l.a.createElement("div", {
        className: "join-org-info"
      }, l.a.createElement(b.P, {
        className: "join-org-name"
      }, " ", function trimText(e) {
        return e && e.length > 15 ? "".concat(e.substr(0, Object(v.min)(e.length, 15)), "...") : e;
      }(r), " "), l.a.createElement(b.P, {
        className: "join-org-teammate-count"
      }, " ", i, " teammates ")), s(o) ? l.a.createElement(Un, null) : l.a.createElement(Fn, {
        setOrgRequested: a,
        orgId: o
      }));
    },
        Hn = function (e) {
      _inherits(OrgReccomendations, c["Component"]);

      var t = OrgRecommendations_createSuper2(OrgReccomendations);

      function OrgReccomendations(e) {
        var n;
        return _classCallCheck(this, OrgReccomendations), (n = t.call(this, e)).getMaxLength = function () {
          return Object(v.min)(n.props.organizations.length, n.state.maxLength);
        }, n.incrementMaxLength = function () {
          n.setState({
            maxLength: n.state.maxLength + Mn
          });
        }, n.decrementMaxLength = function () {
          n.setState({
            maxLength: n.state.maxLength - Mn
          });
        }, n.canShowMore = function () {
          return n.props.organizations.length - n.state.maxLength > 0;
        }, n.canShowLess = function () {
          return n.state.maxLength > Ln;
        }, n.setOrgRequested = function (e) {
          n.setState({
            orgsRequested: Object(v.append)(e, n.state.orgsRequested)
          });
        }, n.isOrgRequested = function (e) {
          return n.state.orgsRequested.includes(e);
        }, n.toggleShowVerifyEmail = function () {
          n.setState({
            showVerifyEmail: !n.state.showVerifyEmail
          });
        }, n.renderOrganizations = function () {
          var e = n.props.organizations;
          return l.a.createElement("div", null, l.a.createElement(b.H4, null, " Join an existing organization "), e.slice(0, n.getMaxLength()).map(function (e) {
            return l.a.createElement(zn, {
              organization: e,
              setOrgRequested: n.setOrgRequested,
              isOrgRequested: n.isOrgRequested
            });
          }), n.canShowMore() && l.a.createElement(b.Small, {
            className: "org-join-list-adjust",
            onClick: n.incrementMaxLength
          }, " Show more "), n.canShowLess() && l.a.createElement(b.Small, {
            className: "org-join-list-adjust",
            onClick: n.decrementMaxLength
          }, " Show less "), l.a.createElement("div", {
            className: "verify-email-copy"
          }, l.a.createElement("span", {
            role: "img",
            "aria-label": "oops"
          }, " \uD83E\uDD14 "), "Can\u2019t find the right organization?", l.a.createElement(b.Small, {
            onClick: n.toggleShowVerifyEmail,
            className: "verify-email-action"
          }, " Try a different email address ")));
        }, n.state = {
          maxLength: Ln,
          orgsRequested: [],
          showVerifyEmail: !1
        }, n;
      }

      return _createClass(OrgReccomendations, [{
        key: "render",
        value: function render() {
          var e = this.state.showVerifyEmail;
          return l.a.createElement("div", {
            className: "app-switcher-org-reccomendtaion-container"
          }, e ? l.a.createElement(Dn, null) : this.renderOrganizations());
        }
      }]), OrgReccomendations;
    }();

    r(142);

    function MergeAccount_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Wn = function (e) {
      _inherits(MergeAccount, c["Component"]);

      var t = MergeAccount_createSuper2(MergeAccount);

      function MergeAccount(e) {
        var n;
        return _classCallCheck(this, MergeAccount), (n = t.call(this, e)).setEmail = function (e) {
          var t = e.target.value;
          n.setState({
            email: t
          });
        }, n.setPassword = function (e) {
          var t = e.target.value;
          n.setState({
            password: t
          });
        }, n.mergeAccounts = function () {
          var e = n.state,
              t = e.email,
              r = e.password;
          return tt(t, r).then(function () {
            n.setState({
              mergeComplete: !0,
              error: ""
            }), setTimeout(function () {
              return n.props.onExit();
            }, 500);
          }).catch(function () {
            return n.setState({
              error: "Invalid Username or Password"
            });
          });
        }, n.getMergeAction = function () {
          var e = n.state,
              t = e.mergeComplete,
              r = e.email,
              i = e.password;
          return t ? l.a.createElement(b.Button, {
            type: "tertiary",
            className: "green-success-button",
            disabled: !0
          }, " Merge Completed ") : l.a.createElement(b.AsyncButton, {
            promise: n.mergeAccounts,
            disabled: !r || !i
          }, "Merge Accounts");
        }, n.state = {
          mergeComplete: !1,
          email: "",
          password: null,
          error: ""
        }, n;
      }

      return _createClass(MergeAccount, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.email,
              n = e.password,
              r = e.error;
          return l.a.createElement("div", {
            className: "merge-account-email-container"
          }, l.a.createElement(b.H4, {
            className: "merge-account-email-header"
          }, " Merge Accounts "), l.a.createElement(b.P, {
            className: "merge-account-email-info"
          }, "Looking to merge two email addresses? Submit your other account's credentials below!"), l.a.createElement(b.Input, {
            value: t,
            onChange: this.setEmail,
            type: "email",
            placeholder: "Your other email address"
          }), l.a.createElement(b.Input, {
            value: n,
            onChange: this.setPassword,
            type: "password",
            placeholder: "Your other account's password"
          }), this.getMergeAction(), l.a.createElement(b.P, {
            className: "merge-account-email-info"
          }, l.a.createElement("i", null, "Note: all of your account data and settings ", l.a.createElement("strong", null, "will remain the same"), ". This action only changes your email address and password to match ", this.props.currentEmail, ", which enables you to sign in with a single credential!")), r && l.a.createElement(b.P, {
            className: "invalid-credentials-error"
          }, " ", r, " "));
        }
      }]), MergeAccount;
    }(),
        qn = Object(u.connect)(function mapStateToProps(e) {
      return {
        currentEmail: e.user.email
      };
    })(Wn);

    r(144);

    function Onboarding_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Gn = function getVerifyHeader(e) {
      return "We can\u2019t find any other organizations that you can join using ".concat(e, ". Try using a different one.");
    },
        Vn = function getOrganizations(e) {
      return e.map(function (e) {
        var t = e.authorizedDomain;
        return _objectSpread2({
          orgLogo: e.orgLogo,
          orgName: e.orgName,
          teammateCount: e.teammateCount
        }, t);
      });
    },
        Yn = function (e) {
      _inherits(JoinOrganization, c["Component"]);

      var t = Onboarding_createSuper2(JoinOrganization);

      function JoinOrganization(e) {
        var n;
        return _classCallCheck(this, JoinOrganization), (n = t.call(this, e)).fetchJoinableOrganizations = function () {
          an().then(function (e) {
            var t = e.data;
            n.setState({
              joinableOrganizations: Vn(t)
            });
          }).catch(function (e) {
            n.setState({
              joinableOrganizations: []
            }), console.error(e);
          });
        }, n.state = {
          joinableOrganizations: null
        }, n;
      }

      return _createClass(JoinOrganization, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.fetchJoinableOrganizations();
        }
      }, {
        key: "renderContent",
        value: function renderContent() {
          var e = this.props,
              t = e.email,
              n = e.onExit,
              r = this.state.joinableOrganizations;
          return r ? l.a.createElement("div", null, r.length ? l.a.createElement(Hn, {
            organizations: r
          }) : l.a.createElement(Dn, {
            info: Gn(t)
          }), l.a.createElement(qn, {
            onExit: n
          })) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props.onExit;
          return l.a.createElement("div", {
            className: "app-switcher-onboarding"
          }, l.a.createElement(b.Small, {
            className: "return-to-switcher-copy",
            onClick: e
          }, l.a.createElement(y.Icon, {
            name: "arrow-1-left",
            width: "8",
            className: "org-join-back-icon"
          }), "Back"), this.renderContent());
        }
      }]), JoinOrganization;
    }(),
        Zn = Object(u.connect)(function mapStateToProps(e) {
      return {
        email: e.user.email
      };
    })(Yn);

    r(146);

    function AppSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Jn = function (e) {
      _inherits(AppSwitcher, c["Component"]);

      var t = AppSwitcher_createSuper2(AppSwitcher);

      function AppSwitcher() {
        var e;

        _classCallCheck(this, AppSwitcher);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).state = {
          showAppSwitcher: !1,
          showOnboarding: !1,
          isTransitioning: !1
        }, e.openAppSwitcher = function () {
          var t = e.state.showAppSwitcher;
          mt(Nt, {
            item: "APP_SWITCHER"
          }), e.setState({
            showAppSwitcher: !t
          });
        }, e.toggleOnboarding = function () {
          e.setState({
            isTransitioning: !0
          }), setTimeout(function () {
            return e.setState({
              showOnboarding: !e.state.showOnboarding,
              isTransitioning: !1
            });
          }, 300);
        }, e.handleClickOutside = function (t) {
          e.appSwitcherRef && !e.appSwitcherRef.contains(t.target) && e.state.showAppSwitcher && e.setState({
            showAppSwitcher: !1,
            showOnboarding: !1
          });
        }, e.setAppSwitcherRef = function (t) {
          e.appSwitcherRef = t;
        }, e.renderNavigator = function () {
          return l.a.createElement(b.Div, {
            className: "app-switcher-content"
          }, l.a.createElement(b.Div, {
            className: "app-switcher-header"
          }, l.a.createElement(b.Div, {
            className: "app-switcher-back-button",
            onClick: function onClick() {
              return e.setState({
                showAppSwitcher: !1
              });
            }
          }, l.a.createElement(y.Icon, {
            width: 16,
            height: 16,
            name: "arrow-2-left"
          })), l.a.createElement(b.H3, {
            className: "app-switcher-header-text"
          }, "Switch to...")), l.a.createElement(b.Div, {
            className: "app-switcher-app-list"
          }, l.a.createElement(b.H4, null, " APPS "), e.getApps().map(function (e) {
            return l.a.createElement(mn, {
              app: e,
              key: e.name
            });
          })), l.a.createElement(Pn, {
            onAdd: e.toggleOnboarding,
            authClientId: e.props.authClientId
          }));
        }, e;
      }

      return _createClass(AppSwitcher, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          document.addEventListener("mousedown", this.handleClickOutside);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          document.removeEventListener("mousedown", this.handleClickOutside);
        }
      }, {
        key: "getApps",
        value: function getApps() {
          var e = this.props,
              t = e.settingsLoaded,
              n = e.videoSignUpDone,
              r = e.appConfig,
              i = r.hasDevPlatformSwitch,
              o = r.hasInsiderSwitch,
              a = r.hasVideoSwitch,
              s = [{
            name: "Drift Email",
            url: d.DRIFT_EMAIL_URL,
            iconName: "email",
            iconWidth: 16,
            iconHeight: 16
          }];
          return o && s.push({
            name: "Insider",
            url: d.DRIFT_INSIDER_URL,
            iconName: "graduation-cap"
          }), i && s.push({
            name: "Developer Platform",
            url: d.DEVELOPERS_WEB_URL,
            iconName: "dev-platform"
          }), t && this.props.showVideoOption && a && s.unshift({
            name: "Drift Video",
            url: n ? d.DRIFT_VIDEO_URL : d.HYFY_EXISTING_REDIRECT,
            iconName: "library"
          }), s;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.showAppSwitcher,
              n = e.showOnboarding,
              r = e.isTransitioning;
          return l.a.createElement("div", {
            ref: this.setAppSwitcherRef
          }, " ", l.a.createElement(b.ToolTip, {
            className: "navigation-hover-tooltip--wrapper",
            component: "Switch apps",
            flow: "right"
          }, l.a.createElement(b.Div, {
            className: "nav-status-item",
            onClick: this.openAppSwitcher
          }, l.a.createElement(y.Icon, {
            name: "app-switch"
          }))), l.a.createElement(b.Div, {
            className: A()("drift-app-switch-nav", {
              open: t
            }, {
              "transition-onboarding": r && !n
            }, {
              "transition-switcher": r && n
            }, {
              expanded: n
            })
          }, n ? l.a.createElement(Zn, {
            onExit: this.toggleOnboarding
          }) : this.renderNavigator()));
        }
      }]), AppSwitcher;
    }(),
        Kn = Object(u.connect)(function mapStateToProps(e) {
      var t = !!e.user.settings;
      return {
        settingsLoaded: t,
        videoSignUpDone: t && e.user.settings.videoSignUpDone,
        appConfig: wt(e)
      };
    })(Jn),
        Xn = (r(148), r(150), r(152), Object.freeze(["/automation", "/inboxes", "/convo", "/playbooks", "/reports", "/marketplace", "/accounts", "/contacts", "/users", "/live", "/help", "/meetings", "/audiences", "/conversations/analysis"])),
        $n = function isActiveNavPath(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      return [e].concat(_toConsumableArray(t)).some(function (t) {
        return Xn.some(function (e) {
          return window.location.pathname.startsWith(e) && t.startsWith(e);
        }) || Qn(e) || e.startsWith("/settings/calendar") && window.location.pathname.startsWith("/settings/calendar");
      });
    },
        Qn = function isHomePath(e) {
      return ("/" === window.location.pathname || window.location.pathname.startsWith("/home") || window.location.pathname.startsWith("/dashboard")) && "/" === e;
    },
        er = function resolveAvailableNavItems() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function resolveDefaultAvailableNavItems() {
        return Object(v.pick)(jt, Pt);
      }();
      return Object.entries(e).filter(function (e) {
        var t = _slicedToArray(e, 2),
            n = (t[0], t[1]);

        return function userHasRequiredScopeOrRole(e) {
          return ho.hasAnyScope(e.requiredScopes) && !ho.hasAnyScope(e.rejectIfHasScopes) || ho.hasAnyRole(e.requiredRoles);
        }(n) && (!n.requiredGates || ho.hasGates(n.requiredGates)) && (!n.rejectIfHasGates || !ho.hasGates(n.rejectIfHasGates)) && (!n.cutoverFor || ho.hasCutover(n.cutoverFor)) && (!n.hasAllGates || ho.hasAllGates.apply(ho, _toConsumableArray(n.hasAllGates)));
      });
    },
        tr = function GenericNavItem(e) {
      var t = e.itemKey,
          n = e.item,
          r = e.clickFunc,
          i = A()("menu-item", "nav-item", {
        active: $n(n.path, n.additionalPaths)
      });
      return l.a.createElement("a", {
        href: n.path,
        target: n.external ? "_blank" : "_self",
        className: i,
        key: t,
        onClick: function onClick(e) {
          return r && r(e);
        }
      }, l.a.createElement(b.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: n.label,
        flow: "right"
      }, l.a.createElement(y.Icon, {
        name: n.iconSRC,
        className: "menu-item-icon",
        height: n.height,
        width: n.width
      })));
    },
        nr = function renderNavItems(e, t) {
      var n = er(e),
          r = t.settings && t.settings.videoSignUpDone,
          i = t.settings && t.settings.has_desktop_app && "false" !== t.settings.has_desktop_app;
      return n.map(function (e) {
        var t = _slicedToArray(e, 2),
            n = t[0],
            o = t[1];

        return "VIDEO" !== n || r || (o.path = "".concat(d.DRIFT_VIDEO_URL, "/accounts/existing-redirect?access_type=nav_icon")), "/inboxes" === o.path && i && (o.path = "/conversations", o.external = !0), l.a.createElement(tr, {
          key: n,
          itemKey: n,
          item: o,
          clickFunc: function clickFunc(e) {
            return function genericClickFunc(e, t) {
              mt(Nt, {
                item: t
              });
            }(0, n);
          }
        });
      });
    },
        rr = function resolveHomePath() {
      return ho.isCalendarUser() ? "/meetings" : ho.hasAnyRole("Playbooks") ? "/playbooks" : "/";
    },
        ir = function Navigation(e) {
      var t = e.navItems,
          n = e.switchAppLinks,
          r = e.loaded,
          i = e.user,
          o = e.authClientId,
          a = e.org,
          s = _slicedToArray(Object(c.useState)({}), 2),
          u = s[0],
          p = s[1],
          f = Object(v.pathOr)(!1, ["hasShipyard"], u);

      Object(c.useEffect)(function () {
        r && p(Object(Ct.generateTrafficControlNavConfig)(i));
      }, [r, i]);
      var d = Object(c.useMemo)(function () {
        return l.a.createElement(l.a.Fragment, null, l.a.createElement("a", {
          className: A()("main-navigation-home nav-item logo", {
            active: $n("/")
          }),
          href: rr(),
          onClick: function onClick() {
            return mt(Nt, {
              item: "HOME"
            });
          }
        }, r && l.a.createElement(l.a.Fragment, null, l.a.createElement(y.Icon, {
          name: "lightning-bolt-filled",
          className: "logo-hover-bolt large",
          height: 16,
          width: 12
        }), l.a.createElement(y.Icon, {
          name: "lightning-bolt-filled",
          className: "logo-hover-bolt small1",
          height: 16,
          width: 12
        }), l.a.createElement(y.Icon, {
          name: "lightning-bolt-filled",
          className: "logo-hover-bolt small2",
          height: 16,
          width: 12
        })), l.a.createElement(b.ToolTip, {
          className: "navigation-hover-tooltip--wrapper",
          component: "Home",
          flow: "right"
        }, l.a.createElement("span", {
          className: "drift-logo-wrapper"
        }, l.a.createElement(y.Icon, {
          name: "drift-logo-round",
          height: 24,
          width: 24,
          className: "logo"
        })))), nr(t, i), l.a.createElement("div", {
          className: "navigation-status-section"
        }, ho.isAdmin() && !ho.hasGates("premium_drift") && l.a.createElement(Ft, null), f && l.a.createElement(hn, {
          user: i
        }), ho.isAdmin() && l.a.createElement(ln, {
          org: a
        }), ho.hasCutover("APP_SWITCHER") && l.a.createElement(Kn, {
          authClientId: o,
          showVideoOption: !0
        }), l.a.createElement(Vt, null), ho.isAdmin() && l.a.createElement(Zt, null), l.a.createElement(Lt, {
          switchAppLinks: n,
          authClientId: o
        })));
      }, [o, f, t, a, n, i, r]);
      return l.a.createElement("nav", {
        className: A()("main-navigation", {
          "main-navigation--qa": "PRODUCTION" !== window.__ENV__
        }),
        "data-ocweb-id": "traffic-control.MainNav"
      }, d);
    },
        or = function showGlobalNotification(e) {
      return {
        type: "SHOW_GLOBAL_NOTIFICATION",
        config: e
      };
    },
        ar = function removeGlobalNotification(e) {
      return {
        type: "REMOVE_GLOBAL_NOTIFICATION",
        index: e
      };
    };

    r(154);

    function GlobalNotifications_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var sr = function (e) {
      _inherits(GlobalNotificationBar, c["Component"]);

      var t = GlobalNotifications_createSuper2(GlobalNotificationBar);

      function GlobalNotificationBar(e) {
        var n;
        return _classCallCheck(this, GlobalNotificationBar), (n = t.call(this, e)).toggleHidden = function () {
          n.setState(function (e) {
            return {
              hidden: !e.hidden
            };
          });
        }, n.close = function (e) {
          var t = n.props.remove;
          n.toggleHidden(), setTimeout(t, 1e3);
          var r = n.props.notification.callbacks;
          r && "function" === typeof r.onClose && r.onClose(e);
        }, n.state = {
          hidden: !0
        }, n;
      }

      return _createClass(GlobalNotificationBar, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          setTimeout(this.toggleHidden, 500);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          !Object(v.equals)(e.notification, this.props.notification) && e.notification && this.toggleHidden();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props.notification,
              n = this.state.hidden,
              r = t.body,
              i = t.className,
              o = t.type,
              a = void 0 === o ? "standard" : o,
              s = t.actions,
              c = void 0 === s ? [] : s,
              u = A()("global-notifications-bar", "global-notifications-bar--".concat(a), _defineProperty2({
            "global-notifications-bar--hidden": n
          }, i, !!i));
          return l.a.createElement("div", {
            className: u
          }, l.a.createElement("span", {
            className: "global-notification-text"
          }, r), l.a.createElement(cr, {
            actions: c,
            close: this.close
          }), l.a.createElement("span", {
            className: "close-button",
            onClick: function onClick() {
              return e.close({
                dismissed: !0
              });
            }
          }, l.a.createElement(y.Icon, {
            name: "close",
            width: 12
          })));
        }
      }]), GlobalNotificationBar;
    }(),
        cr = function Actions(e) {
      var t = e.actions,
          n = e.close;
      return l.a.createElement("div", {
        className: "global-notification-actions"
      }, t.map(function (e, t) {
        var r = e.action,
            i = e.title,
            o = e.icon;
        return l.a.createElement(b.Button, {
          key: "".concat(i, "-").concat(t),
          size: "small",
          type: "tertiary",
          onClick: function onClick() {
            return r(n);
          },
          className: "global-notification-action-button"
        }, o && l.a.createElement(y.Icon, {
          name: o
        }), i);
      }));
    },
        lr = function GlobalNotifications(e) {
      var t = e.globalNotifications,
          n = e.removeGlobalNotification;
      return t.length ? l.a.createElement(sr, {
        notification: t[0],
        remove: function remove() {
          return n(0);
        }
      }) : null;
    },
        ur = Object(u.connect)(function mapStateToProps(e) {
      return {
        globalNotifications: e.globalNotifications
      };
    }, function mapDispatchToProps(e) {
      return {
        removeGlobalNotification: function removeGlobalNotification(t) {
          e(ar(t));
        }
      };
    })(lr),
        pr = r(63),
        fr = (r(160), function TransientNotifications(e) {
      var t = e.transientNotifications,
          n = e.removeTransientNotification;
      return l.a.createElement(pr.NotificationStack, {
        notifications: t,
        onDismiss: function onDismiss(e) {
          return setTimeout(function () {
            return n(e);
          }, 750);
        },
        dismissAfter: 3e3
      });
    }),
        dr = Object(u.connect)(function mapStateToProps(e) {
      return {
        transientNotifications: e.transientNotifications
      };
    }, function mapDispatchToProps(e) {
      return {
        showTransientNotification: function showTransientNotification(t) {
          e(x(t));
        },
        removeTransientNotification: function removeTransientNotification(t) {
          e(S(t));
        }
      };
    })(fr),
        hr = function IntegratedHelpWidget(e) {
      var t = e.loaded,
          n = !ho.hasGates(["premium_team", "premium_drift", "premium_enterprise"]);
      if (!function canShowWidget() {
        return "PRODUCTION" === window.__ENV__ && !!t;
      }()) return null;
      var r = n ? d.FREE_USER_INTEGRATED_HELP_INTERACTION_ID : d.PAID_USER_INTEGRATED_HELP_INTERACTION_ID;
      return r && window.drift && window.drift.hide(), l.a.createElement(qt.a, {
        interactionId: r
      });
    },
        mr = r(11),
        gr = r.n(mr);

    function index_es_typeof(e) {
      return (index_es_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function index_es_defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function index_es_defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function index_es_inherits(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && function index_es_setPrototypeOf(e, t) {
        return (Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }(e, t);
    }

    function index_es_getPrototypeOf(e) {
      return (index_es_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function index_es_assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function debounced(e, t) {
      var n;
      return function () {
        for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) {
          i[o] = arguments[o];
        }

        n && clearTimeout(n), n = setTimeout(function () {
          e.apply(void 0, i), n = null;
        }, t);
      };
    }

    function throttled(e, t) {
      var n = 0;
      return function () {
        var r = new Date().getTime();
        if (!(r - n < t)) return n = r, e.apply(void 0, arguments);
      };
    }

    var Ar = "object" === ("undefined" == typeof window ? "undefined" : "undefined" == typeof window ? "undefined" : index_es_typeof(window)),
        vr = Ar ? document : {},
        br = function (e) {
      function t(e) {
        var n;
        if (function index_es_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), n = function index_es_possibleConstructorReturn(e, t) {
          return !t || "object" != typeof t && "function" != typeof t ? index_es_assertThisInitialized(e) : t;
        }(this, index_es_getPrototypeOf(t).call(this, e)), index_es_defineProperty(index_es_assertThisInitialized(n), "state", {
          idle: !1,
          oldDate: +new Date(),
          lastActive: +new Date(),
          remaining: null,
          pageX: null,
          pageY: null
        }), index_es_defineProperty(index_es_assertThisInitialized(n), "tId", null), index_es_defineProperty(index_es_assertThisInitialized(n), "_handleEvent", function (e) {
          var t = n.state,
              r = t.remaining,
              i = t.pageX,
              o = t.pageY,
              a = t.idle,
              s = n.props,
              c = s.timeout,
              l = s.onAction,
              u = s.debounce,
              p = s.throttle,
              f = s.stopOnIdle;

          if (u > 0 ? n.debouncedAction(e) : p > 0 ? n.throttledAction(e) : l(e), !r) {
            if ("mousemove" === e.type) {
              if (e.pageX === i && e.pageY === o) return;
              if (void 0 === e.pageX && void 0 === e.pageY) return;
              if (n.getElapsedTime() < 200) return;
            }

            clearTimeout(n.tId), n.tId = null, a && !f && n.toggleIdleState(e), n.setState({
              lastActive: +new Date(),
              pageX: e.pageX,
              pageY: e.pageY
            }), a && f || (n.tId = setTimeout(n.toggleIdleState, c));
          }
        }), e.debounce > 0 && e.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
        return e.debounce > 0 && (n.debouncedAction = debounced(e.onAction, e.debounce)), e.throttle > 0 && (n.throttledAction = throttled(e.onAction, e.throttle)), e.startOnMount || (n.state.idle = !0), n.toggleIdleState = n._toggleIdleState.bind(index_es_assertThisInitialized(n)), n.reset = n.reset.bind(index_es_assertThisInitialized(n)), n.pause = n.pause.bind(index_es_assertThisInitialized(n)), n.resume = n.resume.bind(index_es_assertThisInitialized(n)), n.getRemainingTime = n.getRemainingTime.bind(index_es_assertThisInitialized(n)), n.getElapsedTime = n.getElapsedTime.bind(index_es_assertThisInitialized(n)), n.getLastActiveTime = n.getLastActiveTime.bind(index_es_assertThisInitialized(n)), n.isIdle = n._isIdle.bind(index_es_assertThisInitialized(n)), n;
      }

      return index_es_inherits(t, c["Component"]), function index_es_createClass(e, t, n) {
        return t && index_es_defineProperties(e.prototype, t), n && index_es_defineProperties(e, n), e;
      }(t, [{
        key: "componentDidMount",
        value: function value() {
          this._bindEvents(), this.props.startOnMount && this.reset();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          e.debounce !== this.props.debounce && (this.debouncedAction = debounced(this.props.onAction, this.props.debounce)), e.throttle !== this.props.throttle && (this.throttledAction = throttled(this.props.onAction, this.props.throttle));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          clearTimeout(this.tId), this._unbindEvents(!0);
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.children || null;
        }
      }, {
        key: "_bindEvents",
        value: function value() {
          var e = this;

          if (Ar) {
            var t = this.state.eventsBound,
                n = this.props,
                r = n.element,
                i = n.events,
                o = n.passive,
                a = n.capture;
            t || (i.forEach(function (t) {
              r.addEventListener(t, e._handleEvent, {
                capture: a,
                passive: o
              });
            }), this.setState({
              eventsBound: !0
            }));
          }
        }
      }, {
        key: "_unbindEvents",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

          if (Ar) {
            var n = this.props,
                r = n.element,
                i = n.events,
                o = n.passive,
                a = n.capture;
            (this.state.eventsBound || t) && (i.forEach(function (t) {
              r.removeEventListener(t, e._handleEvent, {
                capture: a,
                passive: o
              });
            }), this.setState({
              eventsBound: !1
            }));
          }
        }
      }, {
        key: "_toggleIdleState",
        value: function value(e) {
          var t = this,
              n = this.state.idle,
              r = this.props,
              i = r.onActive,
              o = r.onIdle,
              a = r.stopOnIdle;
          this.setState({
            idle: !n
          }, function () {
            n ? a || (t._bindEvents(), i(e)) : (a && (clearTimeout(t.tId), t.tId = null, t._unbindEvents()), o(e));
          });
        }
      }, {
        key: "reset",
        value: function value() {
          clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
            idle: !1,
            oldDate: +new Date(),
            lastActive: +new Date(),
            remaining: null
          });
          var e = this.props.timeout;
          this.tId = setTimeout(this.toggleIdleState, e);
        }
      }, {
        key: "pause",
        value: function value() {
          null === this.state.remaining && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.setState({
            remaining: this.getRemainingTime()
          }));
        }
      }, {
        key: "resume",
        value: function value() {
          var e = this.state,
              t = e.remaining,
              n = e.idle;
          null !== t && (this._bindEvents(), n || (this.setState({
            remaining: null,
            lastActive: +new Date()
          }), this.tId = setTimeout(this.toggleIdleState, t)));
        }
      }, {
        key: "getRemainingTime",
        value: function value() {
          var e = this.state,
              t = e.remaining,
              n = e.lastActive,
              r = this.props.timeout;
          if (null !== t) return t < 0 ? 0 : t;
          var i = r - (+new Date() - n);
          return i < 0 ? 0 : i;
        }
      }, {
        key: "getElapsedTime",
        value: function value() {
          var e = this.state.oldDate;
          return +new Date() - e;
        }
      }, {
        key: "getLastActiveTime",
        value: function value() {
          return this.state.lastActive;
        }
      }, {
        key: "_isIdle",
        value: function value() {
          return this.state.idle;
        }
      }]), t;
    }();

    index_es_defineProperty(br, "propTypes", {
      timeout: gr.a.number,
      events: gr.a.arrayOf(gr.a.string),
      onIdle: gr.a.func,
      onActive: gr.a.func,
      onAction: gr.a.func,
      debounce: gr.a.number,
      throttle: gr.a.number,
      element: gr.a.oneOfType([gr.a.object, gr.a.element]),
      startOnMount: gr.a.bool,
      stopOnIdle: gr.a.bool,
      passive: gr.a.bool,
      capture: gr.a.bool
    }), index_es_defineProperty(br, "defaultProps", {
      timeout: 12e5,
      element: vr,
      events: ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mouseWheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove"],
      onIdle: function onIdle() {},
      onActive: function onActive() {},
      onAction: function onAction() {},
      debounce: 0,
      throttle: 0,
      startOnMount: !0,
      stopOnIdle: !1,
      capture: !0,
      passive: !0
    });
    var yr = br,
        Er = r(10),
        Cr = r.n(Er);

    function dist_index_es_defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function dist_index_es_getPrototypeOf(e) {
      return (dist_index_es_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function dist_index_es_setPrototypeOf(e, t) {
      return (dist_index_es_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dist_index_es_possibleConstructorReturn(e, t) {
      return !t || "object" !== typeof t && "function" !== typeof t ? function dist_index_es_assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function index_es_toConsumableArray(e) {
      return function index_es_arrayWithoutHoles(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function index_es_iterableToArray(e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function index_es_nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    function zeroPad(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
          n = String(e);
      if (0 === t) return n;
      var r = n.match(/(.*?)([0-9]+)(.*)/),
          i = r ? r[1] : "",
          o = r ? r[3] : "",
          a = r ? r[2] : n,
          s = a.length >= t ? a : (index_es_toConsumableArray(Array(t)).map(function () {
        return "0";
      }).join("") + a).slice(-1 * t);
      return "".concat(i).concat(s).concat(o);
    }

    var wr = {
      daysInHours: !1,
      zeroPadTime: 2
    };

    function formatTimeDelta(e, t) {
      var n = e.days,
          r = e.hours,
          i = e.minutes,
          o = e.seconds,
          a = Object.assign({}, wr, t),
          s = a.daysInHours,
          c = a.zeroPadTime,
          l = a.zeroPadDays,
          u = void 0 === l ? c : l,
          p = s ? zeroPad(r + 24 * n, c) : zeroPad(r, Math.min(2, c));
      return {
        days: s ? "" : zeroPad(n, u),
        hours: p,
        minutes: zeroPad(i, Math.min(2, c)),
        seconds: zeroPad(o, Math.min(2, c))
      };
    }

    var _r = r(164),
        xr = function (e) {
      function Countdown(e) {
        var t;
        return function dist_index_es_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Countdown), (t = dist_index_es_possibleConstructorReturn(this, dist_index_es_getPrototypeOf(Countdown).call(this, e))).mounted = !1, t.tick = function () {
          var e = t.props.onTick,
              n = t.calcTimeDelta();
          t.setTimeDeltaState(Object.assign({}, n)), e && n.total > 0 && e(n);
        }, t.start = function () {
          t.setState(function (e) {
            var t = e.offsetStart;
            return {
              offsetStart: 0,
              offsetTime: e.offsetTime + (t ? Date.now() - t : 0)
            };
          }, function () {
            var e = t.calcTimeDelta();
            t.setTimeDeltaState(e), t.props.onStart && t.props.onStart(e), t.props.controlled || (t.clearInterval(), t.interval = window.setInterval(t.tick, t.props.intervalDelay));
          });
        }, t.pause = function () {
          t.setState({
            offsetStart: t.calcOffsetStart()
          }, function () {
            t.clearInterval(), t.props.onPause && t.props.onPause(t.calcTimeDelta());
          });
        }, t.isPaused = function () {
          return t.state.offsetStart > 0;
        }, t.isCompleted = function () {
          return t.state.timeDelta.completed;
        }, t.state = {
          timeDelta: t.calcTimeDelta(),
          offsetStart: e.autoStart ? 0 : t.calcOffsetStart(),
          offsetTime: 0
        }, t;
      }

      return function dist_index_es_inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && dist_index_es_setPrototypeOf(e, t);
      }(Countdown, l.a.Component), function dist_index_es_createClass(e, t, n) {
        return t && dist_index_es_defineProperties(e.prototype, t), n && dist_index_es_defineProperties(e, n), e;
      }(Countdown, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.mounted = !0, this.props.autoStart && this.start(), this.props.onMount && this.props.onMount(this.calcTimeDelta());
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          _r(this.props, e) || this.setTimeDeltaState(this.calcTimeDelta());
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = !1, this.clearInterval();
        }
      }, {
        key: "calcTimeDelta",
        value: function calcTimeDelta$1() {
          var e = this.props;
          return function calcTimeDelta(e) {
            var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = n.now,
                i = void 0 === r ? Date.now : r,
                o = n.precision,
                a = void 0 === o ? 0 : o,
                s = n.controlled,
                c = void 0 !== s && s,
                l = n.offsetTime,
                u = void 0 === l ? 0 : l;
            t = "string" === typeof e ? new Date(e).getTime() : e instanceof Date ? e.getTime() : e, c || (t += u);
            var p = Math.round(1e3 * parseFloat((Math.max(0, c ? t : t - i()) / 1e3).toFixed(Math.max(0, Math.min(20, a))))),
                f = p / 1e3;
            return {
              total: p,
              days: Math.floor(f / 86400),
              hours: Math.floor(f / 3600 % 24),
              minutes: Math.floor(f / 60 % 60),
              seconds: Math.floor(f % 60),
              milliseconds: Number((f % 1 * 1e3).toFixed()),
              completed: p <= 0
            };
          }(e.date, {
            now: e.now,
            precision: e.precision,
            controlled: e.controlled,
            offsetTime: this.state ? this.state.offsetTime : 0
          });
        }
      }, {
        key: "calcOffsetStart",
        value: function calcOffsetStart() {
          return Date.now();
        }
      }, {
        key: "clearInterval",
        value: function clearInterval() {
          window.clearInterval(this.interval);
        }
      }, {
        key: "setTimeDeltaState",
        value: function setTimeDeltaState(e) {
          var t,
              n = this;
          if (!this.state.timeDelta.completed && e.completed && (this.clearInterval(), t = function callback() {
            return n.props.onComplete && n.props.onComplete(e);
          }), this.mounted) return this.setState({
            timeDelta: e
          }, t);
        }
      }, {
        key: "getApi",
        value: function getApi() {
          return this.api = this.api || {
            start: this.start,
            pause: this.pause,
            isPaused: this.isPaused,
            isCompleted: this.isCompleted
          };
        }
      }, {
        key: "getRenderProps",
        value: function getRenderProps() {
          var e = this.props,
              t = e.daysInHours,
              n = e.zeroPadTime,
              r = e.zeroPadDays,
              i = this.state.timeDelta;
          return Object.assign({}, i, {
            api: this.getApi(),
            props: this.props,
            formatted: formatTimeDelta(i, {
              daysInHours: t,
              zeroPadTime: n,
              zeroPadDays: r
            })
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.children,
              n = e.renderer,
              r = this.getRenderProps();
          if (n) return n(r);
          if (t && this.state.timeDelta.completed) return l.a.cloneElement(t, {
            countdown: r
          });
          var i = r.formatted,
              o = i.days,
              a = i.hours,
              s = i.minutes,
              c = i.seconds;
          return l.a.createElement("span", null, o, o ? ":" : "", a, ":", s, ":", c);
        }
      }]), Countdown;
    }();

    xr.defaultProps = Object.assign({}, wr, {
      controlled: !1,
      intervalDelay: 1e3,
      precision: 0,
      autoStart: !0
    }), xr.propTypes = {
      date: Cr.a.oneOfType([Cr.a.instanceOf(Date), Cr.a.string, Cr.a.number]).isRequired,
      daysInHours: Cr.a.bool,
      zeroPadTime: Cr.a.number,
      zeroPadDays: Cr.a.number,
      controlled: Cr.a.bool,
      intervalDelay: Cr.a.number,
      precision: Cr.a.number,
      autoStart: Cr.a.bool,
      children: Cr.a.element,
      renderer: Cr.a.func,
      now: Cr.a.func,
      onMount: Cr.a.func,
      onStart: Cr.a.func,
      onPause: Cr.a.func,
      onTick: Cr.a.func,
      onComplete: Cr.a.func
    };
    var Sr = xr;
    r(166);

    function TimeoutModal_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var kr = function countdownRenderer(e) {
      var t = e.seconds,
          n = e.minutes;
      return n <= 0 ? l.a.createElement(b.Span, {
        className: "timeout-modal-seconds-countdown-span"
      }, t, " second", t > 1 ? "s" : "") : l.a.createElement(b.Span, {
        className: "timeout-modal-minutes-countdown-span"
      }, n, " minute", n > 1 ? "s" : "");
    },
        Or = function (e) {
      _inherits(TimeoutModal, c["Component"]);

      var t = TimeoutModal_createSuper2(TimeoutModal);

      function TimeoutModal() {
        return _classCallCheck(this, TimeoutModal), t.apply(this, arguments);
      }

      return _createClass(TimeoutModal, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
          return !1;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.cancel,
              n = e.logOut,
              r = e.modalTime,
              i = l.a.createElement(Sr, {
            onComplete: function onComplete() {
              return n(!0);
            },
            date: Date.now() + r,
            renderer: kr
          });
          return l.a.createElement(b.Div, null, l.a.createElement(b.Modal, {
            size: "small",
            type: "warning",
            open: !0,
            onClose: t
          }, l.a.createElement(b.H3, null, "Still here?"), l.a.createElement(b.P, null, "For your security, your session will expire in ", i, " due to inactivity and you will be logged out. "), l.a.createElement(b.P, null, "Click \u201Ccontinue\u201D to keep using Drift or \u201Clog out\u201D to end your session"), l.a.createElement(b.Footer, null, l.a.createElement(b.Button, {
            type: "secondary",
            onClick: t
          }, "Continue"), l.a.createElement(b.Button, {
            type: "tertiary",
            onClick: function onClick() {
              return n(!1);
            }
          }, "Log out"))));
        }
      }]), TimeoutModal;
    }();

    function IdleTimeout_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Br = function (e) {
      _inherits(IdleTimeout, c["Component"]);

      var t = IdleTimeout_createSuper2(IdleTimeout);

      function IdleTimeout(e) {
        var n;
        return _classCallCheck(this, IdleTimeout), (n = t.call(this, e)).tabCloseHandler = function () {
          return Object(W.decreaseOpenTabCount)({
            tokenExpirationInMillis: n.state.sessionLength
          });
        }, n.retrieveSessionLength = function () {
          sn().then(function (e) {
            var t = e.data;
            return n.applySessionTimeoutSettings(t);
          }).catch(function (e) {
            console.error(e), n.applySessionTimeoutSettings(0);
          });
        }, n.applySessionTimeoutSettings = function (e) {
          e > 0 && (n.setState({
            timeoutEnabled: !0,
            sessionLength: e
          }), Object(W.removeAccessTokenExpiration)());
        }, n.onIdle = function () {
          n.setState({
            isIdle: !0
          });
        }, n.onContinue = function () {
          n.setState({
            isIdle: !1
          });
        }, n.onLogOut = function (e) {
          mt("User session timed out"), Object(W.redirectToLoginPage)(n.props.authClientId, e);
        }, n.state = {
          sessionLength: 0,
          timeoutEnabled: !1,
          isIdle: !1
        }, n;
      }

      return _createClass(IdleTimeout, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          Object(W.increaseOpenTabCount)(), window.addEventListener("beforeunload", this.tabCloseHandler), this.retrieveSessionLength();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("beforeunload", this.tabCloseHandler);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.timeoutEnabled,
              n = e.sessionLength;
          return t ? l.a.createElement(yr, {
            onIdle: this.onIdle,
            timeout: n - 12e4
          }, this.state.isIdle && l.a.createElement(Or, {
            cancel: this.onContinue,
            logOut: this.onLogOut,
            modalTime: 12e4
          })) : null;
        }
      }]), IdleTimeout;
    }(),
        Tr = (r(168), function AppLayout(e) {
      var t = e.render,
          n = e.org,
          r = e.user,
          i = e.navItems,
          o = e.authClientId,
          a = e.switchAppLinks,
          s = e.loaded,
          u = e.showIntegratedHelp,
          p = e.noNav,
          f = void 0 !== p && p,
          d = e.globalNotificationsEnabled,
          h = void 0 === d || d,
          m = Object(c.useMemo)(function () {
        return l.a.createElement(l.a.Fragment, null, l.a.createElement("div", {
          className: A()("app-layout", {
            "app-layout--loaded": s
          }),
          "data-ocweb-id": "traffic-control.AppLayout"
        }, h && l.a.createElement(ur, null), l.a.createElement(dr, null), l.a.createElement("div", {
          className: "app-layout-inner"
        }, !f && l.a.createElement(ir, {
          loaded: s,
          navItems: i,
          org: n,
          user: r,
          switchAppLinks: a,
          authClientId: o
        }), l.a.createElement("div", {
          className: "main-content-area"
        }, s && l.a.createElement(t, null)), u && l.a.createElement(hr, {
          loaded: s
        }))), l.a.createElement(Br, {
          authClientId: o
        }));
      }, [o, h, s, i, f, n, u, a, r]);
      return l.a.createElement(l.a.Fragment, null, m);
    });

    r(170);

    function VideoMessagingEarlyAccess_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ir = function redirectToDriftVideo() {
      window.location.href = d.DRIFT_VIDEO_URL;
    },
        Rr = function (e) {
      _inherits(VideoMessagingEarlyAccess, c["Component"]);

      var t = VideoMessagingEarlyAccess_createSuper2(VideoMessagingEarlyAccess);

      function VideoMessagingEarlyAccess(e) {
        var n;
        return _classCallCheck(this, VideoMessagingEarlyAccess), (n = t.call(this, e)).requestEarlyAccess = function () {
          mt("Video Plus Messaging Early Access Requested"), n.setState({
            earlyAccessRequested: !0
          });
        }, n.renderRequestEarlyAccess = function () {
          var e = n.state.earlyAccessRequested;
          return l.a.createElement(b.Div, {
            className: "request-early-access-button-container"
          }, l.a.createElement(b.P, null, "We\u2019re still working on the ability for all Drift Video users to start conversations on their videos. Opt in and we\u2019ll make sure you\u2019re one of the first to test it out."), e ? l.a.createElement(b.P, {
            className: "request-early-access-success-text"
          }, "You\u2019ve opted in to Drift Video + Conversations early access!") : l.a.createElement(b.Button, {
            onClick: n.requestEarlyAccess
          }, "Get Drift Video + Conversations"));
        }, n.renderTakeMeBackArrow = function () {
          return l.a.createElement(b.Div, {
            className: "go-back-to-library-text",
            onClick: Ir
          }, l.a.createElement(y.Icon, {
            name: "arrow-2-left",
            width: "18"
          }), " Take me back to my library");
        }, n.state = {
          earlyAccessRequested: !1
        }, n;
      }

      return _createClass(VideoMessagingEarlyAccess, [{
        key: "render",
        value: function render() {
          return l.a.createElement(b.Div, {
            className: "request-early-access-container"
          }, this.renderRequestEarlyAccess(), this.renderTakeMeBackArrow());
        }
      }]), VideoMessagingEarlyAccess;
    }(),
        Pr = Object.freeze({
      VIDEO_INSUFFICIENT_PRIVELEDGE: "Video-Only-Accessing-Chat",
      VIDEO_FREE_USER: "Free-Video-Accessing-Chat"
    }),
        jr = (r(172), Object.freeze(_defineProperty2({}, Pr.VIDEO_INSUFFICIENT_PRIVELEDGE, "Drift Video + Conversations is coming soon. Want early access?"))),
        Nr = Object.freeze(_defineProperty2({}, Pr.VIDEO_INSUFFICIENT_PRIVELEDGE, Rr)),
        Dr = Object.freeze(_defineProperty2({}, Pr.VIDEO_INSUFFICIENT_PRIVELEDGE, function VideoToChat() {
      return l.a.createElement("svg", {
        width: "318",
        height: "201",
        viewBox: "0 0 318 201",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, l.a.createElement("path", {
        d: "M159.5 201C215.005 201 260 156.005 260 100.5C260 44.9954 215.005 0 159.5 0C103.995 0 59 44.9954 59 100.5C59 156.005 103.995 201 159.5 201Z",
        fill: "#F8FAFB"
      }), l.a.createElement("g", {
        opacity: "0.6",
        filter: "url(#filter0_f)"
      }, l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M180.2 63.2372H25V48.6237C25 43.5282 29.926 39.4 36.0033 39.4H169.197C175.274 39.4 180.2 43.5282 180.2 48.6237V63.2372ZM180.2 63.2544V135.774C180.2 140.87 175.274 145 169.197 145H36.0033C29.926 145 25 140.87 25 135.774V63.2544H180.2Z",
        fill: "#B5D2E1"
      })), l.a.createElement("g", {
        filter: "url(#filter1_d)"
      }, l.a.createElement("path", {
        d: "M178.76 37H26.44C25.6447 37 25 37.6447 25 38.44V141.16C25 141.955 25.6447 142.6 26.44 142.6H178.76C179.555 142.6 180.2 141.955 180.2 141.16V38.44C180.2 37.6447 179.555 37 178.76 37Z",
        fill: "black"
      })), l.a.createElement("path", {
        d: "M178.51 37.25H26.69C25.8947 37.25 25.25 37.8947 25.25 38.69V140.91C25.25 141.705 25.8947 142.35 26.69 142.35H178.51C179.305 142.35 179.95 141.705 179.95 140.91V38.69C179.95 37.8947 179.305 37.25 178.51 37.25Z",
        fill: "white",
        stroke: "#E1EEF4",
        strokeWidth: "0.5"
      }), l.a.createElement("path", {
        d: "M25.6 44.8H179.6",
        stroke: "#F2F6F8",
        strokeWidth: "0.5"
      }), l.a.createElement("path", {
        d: "M125.6 44.8H25.6V102.8H125.6V44.8Z",
        fill: "#4E5C65"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M125.6 44.8H179.6V140.36C179.6 141.155 178.955 141.8 178.16 141.8H125.6V44.8Z",
        fill: "#EFF3F5"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.04 113.8H64.56C65.3553 113.8 66 114.445 66 115.24C66 116.035 65.3553 116.68 64.56 116.68H33.04C32.2447 116.68 31.6 116.035 31.6 115.24C31.6 114.445 32.2447 113.8 33.04 113.8Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M33.04 107.8H89.36C90.1553 107.8 90.8 108.445 90.8 109.24C90.8 110.035 90.1553 110.68 89.36 110.68H33.04C32.2447 110.68 31.6 110.035 31.6 109.24C31.6 108.445 32.2447 107.8 33.04 107.8Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("g", {
        filter: "url(#filter2_dd)"
      }, l.a.createElement("path", {
        d: "M82.9779 64.7171L84.6452 64.7424L83.1229 66.8129L86.4762 64.0625L84.7468 64.0363L85.8538 62.158L82.9779 64.7171Z",
        fill: "black"
      })), l.a.createElement("path", {
        d: "M82.9779 64.7171L84.6452 64.7424L83.1229 66.8129L86.4762 64.0625L84.7468 64.0363L85.8538 62.158L82.9779 64.7171Z",
        fill: "white"
      }), l.a.createElement("g", {
        filter: "url(#filter3_dd)"
      }, l.a.createElement("path", {
        d: "M80.4776 65.0407L81.1088 64.3638L81.4113 65.7128L81.5049 63.3734L80.8502 64.0755L80.4738 62.9644L80.4776 65.0407Z",
        fill: "black"
      })), l.a.createElement("path", {
        d: "M80.4776 65.0407L81.1088 64.3638L81.4113 65.7128L81.5049 63.3734L80.8502 64.0755L80.4738 62.9644L80.4776 65.0407Z",
        fill: "white"
      }), l.a.createElement("g", {
        filter: "url(#filter4_dd)"
      }, l.a.createElement("path", {
        d: "M84.2568 68.3974L84.6828 68.7752L83.7731 69.0195L85.3267 68.991L84.8848 68.5991L85.639 68.3166L84.2568 68.3974Z",
        fill: "black"
      })), l.a.createElement("path", {
        d: "M84.2568 68.3974L84.6828 68.7752L83.7731 69.0195L85.3267 68.991L84.8848 68.5991L85.639 68.3166L84.2568 68.3974Z",
        fill: "white"
      }), l.a.createElement("path", {
        d: "M74.96 81.6039C79.2457 81.6039 82.72 78.1296 82.72 73.8439C82.72 69.5582 79.2457 66.0839 74.96 66.0839C70.6743 66.0839 67.2 69.5582 67.2 73.8439C67.2 78.1296 70.6743 81.6039 74.96 81.6039Z",
        fill: "#353F45",
        fillOpacity: "0.2",
        stroke: "white",
        strokeWidth: "0.8"
      }), l.a.createElement("path", {
        d: "M72.72 71.4394V76.2485C72.72 76.6019 73.0065 76.8885 73.36 76.8885C73.4704 76.8885 73.5789 76.8599 73.675 76.8056L77.9272 74.4011C78.2349 74.2271 78.3433 73.8366 78.1693 73.5289C78.1121 73.4278 78.0284 73.3441 77.9272 73.2869L73.675 70.8823C73.3674 70.7083 72.9769 70.8167 72.8029 71.1244C72.7486 71.2205 72.72 71.329 72.72 71.4394Z",
        fill: "white"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M141.44 54.2H158.56C159.355 54.2 160 54.8447 160 55.64C160 56.4353 159.355 57.08 158.56 57.08H141.44C140.645 57.08 140 56.4353 140 55.64C140 54.8447 140.645 54.2 141.44 54.2Z",
        fill: "#D6DDE1",
        fillOpacity: "0.666412"
      }), l.a.createElement("path", {
        d: "M137.6 55.8C137.6 53.5909 135.809 51.8 133.6 51.8C131.391 51.8 129.6 53.5909 129.6 55.8C129.6 58.0091 131.391 59.8 133.6 59.8C135.809 59.8 137.6 58.0091 137.6 55.8Z",
        fill: "#D6DDE1",
        fillOpacity: "0.666412"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M132.04 67.8H164.16C164.955 67.8 165.6 68.4447 165.6 69.24C165.6 70.0353 164.955 70.68 164.16 70.68H132.04C131.245 70.68 130.6 70.0353 130.6 69.24C130.6 68.4447 131.245 67.8 132.04 67.8Z",
        fill: "#D6DDE1",
        fillOpacity: "0.666412"
      }), l.a.createElement("path", {
        d: "M176.6 69.4C176.6 67.1909 174.809 65.4 172.6 65.4C170.391 65.4 168.6 67.1909 168.6 69.4C168.6 71.6091 170.391 73.4 172.6 73.4C174.809 73.4 176.6 71.6091 176.6 69.4Z",
        fill: "#9EABB3"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M141.44 81.4H169.56C170.355 81.4 171 82.0447 171 82.84C171 83.6353 170.355 84.28 169.56 84.28H141.44C140.645 84.28 140 83.6353 140 82.84C140 82.0447 140.645 81.4 141.44 81.4Z",
        fill: "#D6DDE1",
        fillOpacity: "0.666412"
      }), l.a.createElement("path", {
        d: "M137.6 83C137.6 80.7909 135.809 79 133.6 79C131.391 79 129.6 80.7909 129.6 83C129.6 85.2091 131.391 87 133.6 87C135.809 87 137.6 85.2091 137.6 83Z",
        fill: "#D6DDE1",
        fillOpacity: "0.666412"
      }), l.a.createElement("path", {
        d: "M174.16 128.8H131.04C130.245 128.8 129.6 129.445 129.6 130.24V135.36C129.6 136.155 130.245 136.8 131.04 136.8H174.16C174.955 136.8 175.6 136.155 175.6 135.36V130.24C175.6 129.445 174.955 128.8 174.16 128.8Z",
        fill: "white"
      }), l.a.createElement("mask", {
        id: "mask0",
        x: "246",
        y: "57",
        width: "14",
        height: "13"
      }, l.a.createElement("path", {
        d: "M246.767 57.4344H259.271V69.9374H246.767V57.4344Z",
        fill: "white"
      })), l.a.createElement("g", {
        mask: "url(#mask0)"
      }, l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M253.842 58.0502L254.805 61.319C254.888 61.5986 255.106 61.8182 255.386 61.8998L258.654 62.8622C259.476 63.1046 259.476 64.2686 258.654 64.5098L255.386 65.4722C255.106 65.5538 254.888 65.7734 254.805 66.053L253.842 69.3218C253.601 70.1426 252.437 70.1426 252.195 69.3218L251.234 66.053C251.151 65.7734 250.931 65.5538 250.652 65.4722L247.383 64.5098C246.562 64.2686 246.562 63.1046 247.383 62.8622L250.652 61.8998C250.931 61.8182 251.151 61.5986 251.234 61.319L252.195 58.0502C252.437 57.2282 253.601 57.2282 253.842 58.0502Z",
        fill: "#4D9EFF"
      })), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.43275 101.472L6.17107 103.982C6.23478 104.198 6.40219 104.365 6.61706 104.428L9.12684 105.168C9.75772 105.353 9.75772 106.246 9.12684 106.432L6.61706 107.172C6.40219 107.234 6.23478 107.402 6.17107 107.617L5.43275 110.127C5.24661 110.758 4.35339 110.758 4.16725 110.127L3.42893 107.617C3.36647 107.402 3.19781 107.234 2.98294 107.172L0.47316 106.432C-0.15772 106.246 -0.15772 105.353 0.47316 105.168L2.98294 104.428C3.19781 104.365 3.36647 104.198 3.42893 103.982L4.16725 101.472C4.35339 100.843 5.24661 100.843 5.43275 101.472Z",
        fill: "#B4C3D8"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M301.2 52.4C301.2 53.7256 300.125 54.8 298.799 54.8C297.474 54.8 296.4 53.7256 296.4 52.4C296.4 51.0744 297.474 50 298.799 50C300.125 50 301.2 51.0744 301.2 52.4Z",
        stroke: "#B4C3D8",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M50.4 169C50.4 170.326 49.3253 171.4 48.0006 171.4C46.6747 171.4 45.6 170.326 45.6 169C45.6 167.674 46.6747 166.6 48.0006 166.6C49.3253 166.6 50.4 167.674 50.4 169Z",
        stroke: "#4D9EFF",
        strokeWidth: "2.4",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M318 121.6C318 122.705 317.104 123.6 315.999 123.6C314.896 123.6 314 122.705 314 121.6C314 120.495 314.896 119.6 315.999 119.6C317.104 119.6 318 120.495 318 121.6Z",
        fill: "#B4C3D8"
      }), l.a.createElement("g", {
        opacity: "0.6",
        filter: "url(#filter5_f)"
      }, l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M297.2 103.437H142V88.8237C142 83.7282 146.926 79.6 153.003 79.6H286.197C292.274 79.6 297.2 83.7282 297.2 88.8237V103.437ZM297.2 103.454V175.974C297.2 181.07 292.274 185.2 286.197 185.2H153.003C146.926 185.2 142 181.07 142 175.974V103.454H297.2Z",
        fill: "#B5D2E1"
      })), l.a.createElement("g", {
        filter: "url(#filter6_d)"
      }, l.a.createElement("path", {
        d: "M295.76 77.2H143.44C142.645 77.2 142 77.8447 142 78.64V181.36C142 182.155 142.645 182.8 143.44 182.8H295.76C296.555 182.8 297.2 182.155 297.2 181.36V78.64C297.2 77.8447 296.555 77.2 295.76 77.2Z",
        fill: "black"
      })), l.a.createElement("path", {
        d: "M295.51 77.45H143.69C142.895 77.45 142.25 78.0947 142.25 78.89V181.11C142.25 181.905 142.895 182.55 143.69 182.55H295.51C296.305 182.55 296.95 181.905 296.95 181.11V78.89C296.95 78.0947 296.305 77.45 295.51 77.45Z",
        fill: "white",
        stroke: "#E1EEF4",
        strokeWidth: "0.5"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M143.44 77H152V182.6H143.44C142.645 182.6 142 181.955 142 181.16V78.44C142 77.6447 142.645 77 143.44 77Z",
        fill: "#353F45"
      }), l.a.createElement("path", {
        d: "M179.8 77H150.2V182.6H179.8V77Z",
        fill: "#4E5C65"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.8 90H296.8V180.96C296.8 181.755 296.155 182.4 295.36 182.4H288.8V90Z",
        fill: "#F2F6F8"
      }), l.a.createElement("path", {
        d: "M183.397 90.2H295.826",
        stroke: "#F2F6F8",
        strokeWidth: "0.5",
        strokeLinecap: "square"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196.24 100.4H227.76C228.555 100.4 229.2 101.045 229.2 101.84C229.2 102.635 228.555 103.28 227.76 103.28H196.24C195.445 103.28 194.8 102.635 194.8 101.84C194.8 101.045 195.445 100.4 196.24 100.4Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        d: "M192.4 102C192.4 99.7909 190.609 98 188.4 98C186.191 98 184.4 99.7909 184.4 102C184.4 104.209 186.191 106 188.4 106C190.609 106 192.4 104.209 192.4 102Z",
        fill: "#DEE4E7"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196.24 114H252.56C253.355 114 254 114.645 254 115.44C254 116.235 253.355 116.88 252.56 116.88H196.24C195.445 116.88 194.8 116.235 194.8 115.44C194.8 114.645 195.445 114 196.24 114Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        d: "M192.4 115.6C192.4 113.391 190.609 111.6 188.4 111.6C186.191 111.6 184.4 113.391 184.4 115.6C184.4 117.809 186.191 119.6 188.4 119.6C190.609 119.6 192.4 117.809 192.4 115.6Z",
        fill: "#9EABB3"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196.24 127.6H246.16C246.955 127.6 247.6 128.245 247.6 129.04C247.6 129.835 246.955 130.48 246.16 130.48H196.24C195.445 130.48 194.8 129.835 194.8 129.04C194.8 128.245 195.445 127.6 196.24 127.6Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        d: "M192.4 129.2C192.4 126.991 190.609 125.2 188.4 125.2C186.191 125.2 184.4 126.991 184.4 129.2C184.4 131.409 186.191 133.2 188.4 133.2C190.609 133.2 192.4 131.409 192.4 129.2Z",
        fill: "#DEE4E7"
      }), l.a.createElement("path", {
        d: "M235.76 154.8H196.24C195.445 154.8 194.8 155.445 194.8 156.24C194.8 157.035 195.445 157.68 196.24 157.68H235.76C236.555 157.68 237.2 157.035 237.2 156.24C237.2 155.445 236.555 154.8 235.76 154.8Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        d: "M192.4 156.4C192.4 154.191 190.609 152.4 188.4 152.4C186.191 152.4 184.4 154.191 184.4 156.4C184.4 158.609 186.191 160.4 188.4 160.4C190.609 160.4 192.4 158.609 192.4 156.4Z",
        fill: "#DEE4E7"
      }), l.a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196.24 141.2H260.56C261.355 141.2 262 141.845 262 142.64C262 143.435 261.355 144.08 260.56 144.08H196.24C195.445 144.08 194.8 143.435 194.8 142.64C194.8 141.845 195.445 141.2 196.24 141.2Z",
        fill: "#DEE4E7",
        fillOpacity: "0.7"
      }), l.a.createElement("path", {
        d: "M192.4 142.8C192.4 140.591 190.609 138.8 188.4 138.8C186.191 138.8 184.4 140.591 184.4 142.8C184.4 145.009 186.191 146.8 188.4 146.8C190.609 146.8 192.4 145.009 192.4 142.8Z",
        fill: "#9EABB3"
      }), l.a.createElement("mask", {
        id: "mask1",
        x: "114",
        y: "138",
        width: "19",
        height: "25"
      }, l.a.createElement("path", {
        d: "M129.875 156.937C123.702 157.301 119.353 156.059 116.867 153.141C114.099 149.891 113.666 145.075 115.486 138.756C115.6 138.358 116.016 138.129 116.414 138.243C116.812 138.358 117.042 138.774 116.927 139.172C115.233 145.054 115.621 149.365 118.009 152.168C120.194 154.733 124.261 155.838 130.253 155.409L125.504 151.063C125.198 150.784 125.177 150.309 125.457 150.004C125.736 149.698 126.211 149.677 126.516 149.957L132.516 155.447C132.841 155.744 132.841 156.256 132.516 156.553L126.516 162.043C126.211 162.323 125.736 162.302 125.457 161.996C125.177 161.691 125.198 161.216 125.504 160.937L129.875 156.937Z",
        fill: "white"
      })), l.a.createElement("g", {
        mask: "url(#mask1)"
      }, l.a.createElement("path", {
        d: "M129.875 156.937C123.702 157.301 119.353 156.059 116.867 153.141C114.099 149.891 113.666 145.075 115.486 138.756C115.6 138.358 116.016 138.129 116.414 138.243C116.812 138.358 117.042 138.774 116.927 139.172C115.233 145.054 115.621 149.365 118.009 152.168C120.194 154.733 124.261 155.838 130.253 155.409L125.504 151.063C125.198 150.784 125.177 150.309 125.457 150.004C125.736 149.698 126.211 149.677 126.516 149.957L132.516 155.447C132.841 155.744 132.841 156.256 132.516 156.553L126.516 162.043C126.211 162.323 125.736 162.302 125.457 161.996C125.177 161.691 125.198 161.216 125.504 160.937L129.875 156.937Z",
        fill: "#D6DDE1"
      }), l.a.createElement("path", {
        d: "M109 165H139V135H109V165Z",
        fill: "#0071EB"
      })), l.a.createElement("defs", null, l.a.createElement("filter", {
        id: "filter0_f",
        x: "18.6",
        y: "33",
        width: "168",
        height: "118.4",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), l.a.createElement("feGaussianBlur", {
        stdDeviation: "3.2",
        result: "effect1_foregroundBlur"
      })), l.a.createElement("filter", {
        id: "filter1_d",
        x: "17",
        y: "30",
        width: "171.2",
        height: "121.6",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", {
        dy: "1"
      }), l.a.createElement("feGaussianBlur", {
        stdDeviation: "4"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.462745 0 0 0 0 0.584314 0 0 0 0 0.647059 0 0 0 0.179942 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
      })), l.a.createElement("filter", {
        id: "filter2_dd",
        x: "81.905",
        y: "61.0608",
        width: "5.63692",
        height: "6.86563",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.24 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.12 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
      })), l.a.createElement("filter", {
        id: "filter3_dd",
        x: "79.4738",
        y: "61.9644",
        width: "3.03111",
        height: "4.74839",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.24 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.12 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
      })), l.a.createElement("filter", {
        id: "filter4_dd",
        x: "82.7216",
        y: "66.6647",
        width: "4.08679",
        height: "4.11638",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.24 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", null), l.a.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.12 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
      })), l.a.createElement("filter", {
        id: "filter5_f",
        x: "138.8",
        y: "76.4",
        width: "161.6",
        height: "112",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), l.a.createElement("feGaussianBlur", {
        stdDeviation: "1.6",
        result: "effect1_foregroundBlur"
      })), l.a.createElement("filter", {
        id: "filter6_d",
        x: "134",
        y: "70.2",
        width: "171.2",
        height: "121.6",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
      }, l.a.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), l.a.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), l.a.createElement("feOffset", {
        dy: "1"
      }), l.a.createElement("feGaussianBlur", {
        stdDeviation: "4"
      }), l.a.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.462745 0 0 0 0 0.584314 0 0 0 0 0.647059 0 0 0 0.179942 0"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), l.a.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow",
        result: "shape"
      }))));
    })),
        Lr = function AuthorizationTakeover(e) {
      var t = e.title,
          n = e.UpgradeComponent,
          r = e.icon;
      return l.a.createElement(b.Div, null, l.a.createElement(b.Div, {
        className: "authorization-takeover"
      }, l.a.createElement(b.Div, {
        className: "authorization-takeover-image-container"
      }, r()), l.a.createElement(b.Div, {
        className: "authorization-takeover-action"
      }, l.a.createElement(b.Div, {
        className: "authorization-takeover-header"
      }, l.a.createElement(b.H1, null, t)), !!n && l.a.createElement(b.Div, {
        className: "authorization-takeover-upgrade"
      }, l.a.createElement(n, null)))));
    },
        Mr = function AuthorizationError(e) {
      var t = e.type;
      return l.a.createElement(Lr, {
        title: jr[t],
        UpgradeComponent: Nr[t],
        icon: Dr[t]
      });
    },
        Ur = function sendBrowserNotification(e) {
      return {
        type: "SEND_BROWSER_NOTIFICATION",
        notification: e
      };
    },
        Fr = {
      denied: "Browser Notifications Blocked",
      granted: "Browser Notifications Enabled"
    },
        zr = function handlePermission(e, t) {
      return "granted" === e && (Je.dispatch({
        type: "BROWSER_NOTIFICATIONS_GRANTED"
      }), new window.Notification("Hey Look!", {
        body: "You now will receive browser notifications \uD83D\uDE80"
      })), e;
    },
        Hr = function handleTracking(e) {
      mt(Fr[e]);
    },
        Wr = {
      body: l.a.createElement("p", null, "We strongly recommend enabling desktop notifications if you\u2019ll be using Drift on this computer - we don\u2019t want you to miss any conversations!"),
      type: "dismissNotificationsConfirm",
      actions: [{
        title: "Enable desktop notifications",
        action: function action(e) {
          e(), window.Notification.requestPermission().then(zr).then(Hr).catch(function (e) {
            return console.error("failed to enable browser notifications", e);
          });
        }
      }, {
        title: "Ask me next time",
        action: function action(e) {
          e(), function hideForSession() {
            window.sessionStorage && window.sessionStorage.setItem("hide-notifications-message", !0);
          }();
        }
      }, {
        title: "Never ask again on this computer",
        action: function action(e) {
          e(), function neverAskAgain() {
            window.localStorage && window.localStorage.setItem("never-show-enable-notifications", !0);
          }();
        }
      }]
    },
        qr = {
      body: l.a.createElement("div", {
        className: "enable-notification-banner-body"
      }, "Drift needs your permission to enable browser notifications"),
      type: "enableNotifications",
      actions: [{
        icon: "notification-active",
        title: "Enable browser notifications",
        action: function action(e) {
          e(), window.Notification.requestPermission().then(zr).then(Hr).catch(function (e) {
            return console.error("failed to enable browser notifications", e);
          });
        }
      }],
      callbacks: {
        onClose: function onClose(e) {
          e && e.dismissed && Je.dispatch(or(Wr));
        }
      }
    },
        Gr = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee(e) {
        var t, n;
        return m.a.wrap(function _callee$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (t = e.properties, n = t.widgetInstalled, !ho.hasGates("has_onboarding_experience")) {
                  r.next = 6;
                  break;
                }

                if (!ho.isAdmin() || n) {
                  r.next = 6;
                  break;
                }

                return r.abrupt("return");

              case 6:
                if (window.Notification) {
                  r.next = 8;
                  break;
                }

                return r.abrupt("return");

              case 8:
                if (window.localStorage) {
                  r.next = 10;
                  break;
                }

                return r.abrupt("return");

              case 10:
                if (window.sessionStorage) {
                  r.next = 12;
                  break;
                }

                return r.abrupt("return");

              case 12:
                if (!(!!window.localStorage.getItem("never-show-enable-notifications") || !!window.sessionStorage.getItem("hide-notifications-message"))) {
                  r.next = 15;
                  break;
                }

                return r.abrupt("return");

              case 15:
                if ("granted" !== window.Notification.permission) {
                  r.next = 17;
                  break;
                }

                return r.abrupt("return", Je.dispatch({
                  type: "BROWSER_NOTIFICATIONS_GRANTED"
                }));

              case 17:
                if (ho.isBot() || ho.hasAnyRole(["Playbooks", "Reporting"]) || "denied" === window.Notification.permission && "default" !== window.Notification.permission) {
                  r.next = 19;
                  break;
                }

                return r.abrupt("return", Je.dispatch(or(qr)));

              case 19:
              case "end":
                return r.stop();
            }
          }
        }, _callee);
      }));

      return function checkPermissions(t) {
        return e.apply(this, arguments);
      };
    }(),
        Vr = function receiveEmbedConfig(e) {
      return {
        type: "RECEIVE_EMBED_CONFIG",
        config: e
      };
    },
        Yr = {
      body: l.a.createElement("div", {
        className: "enable-notification-banner-body"
      }, l.a.createElement("span", {
        role: "img",
        "aria-label": "handwave emoji"
      }, "\uD83D\uDC4B"), " Hey there! We strongly recommend you turn Drift off for now so it doesn't immediately display on your site when you install."),
      type: "disableWidget",
      actions: [{
        title: "Turn Drift off for now",
        action: function action(e) {
          Je.dispatch(x({
            type: "success",
            message: "Drift was turned off!"
          })), Xt(!1).then(function (e) {
            Je.dispatch(Vr(e));
          }), mt("Widget Disabled From Banner"), e();
        }
      }]
    },
        Zr = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee(e, t) {
        var n, r, i, o;
        return m.a.wrap(function _callee$(a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (n = e.properties, r = n.widgetInstalled, i = t.configuration.chatEnabled, o = ho.hasGates("has_onboarding_experience"), ho.isAdmin()) {
                  a.next = 6;
                  break;
                }

                return a.abrupt("return");

              case 6:
                if (o) {
                  a.next = 8;
                  break;
                }

                return a.abrupt("return");

              case 8:
                if (i) {
                  a.next = 10;
                  break;
                }

                return a.abrupt("return");

              case 10:
                if (!r) {
                  a.next = 12;
                  break;
                }

                return a.abrupt("return");

              case 12:
                return a.abrupt("return", Je.dispatch(or(Yr)));

              case 13:
              case "end":
                return a.stop();
            }
          }
        }, _callee);
      }));

      return function checkWidgetEnabledButNotInstalled(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Jr = function installSegment() {
      var e = document.createElement("script");
      e.id = "segment-container", e.innerHTML = '\n  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="3.1.0";\n  }}();\n', document.body.appendChild(e);
    },
        Kr = function hasSegmentSnippet() {
      return document.getElementById("segment-container");
    },
        Xr = function installWidgetStub() {
      var e = window.drift = window.driftt = window.drift || window.driftt || [];
      ["identify", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on", "config", "setUserJwt", "waitForUserJwt"].forEach(function (t) {
        e[t] || (e[t] = function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          e.push([t].concat(r));
        });
      });
    },
        $r = function hideWelcomeMessage() {
      window.drift.config({
        enableWelcomeMessage: !1
      });
    },
        Qr = function disableSupportChat() {
      window.drift.config({
        widgetStatus: "AWAY",
        widgetMode: "MANUAL",
        inboxId: d.FREE_SUPPORT_INBOX_ID,
        messages: {
          awayMessage: "Need help with something? Leave us a message and we\u2019ll follow up as soon as we can.",
          thankYouMessage: "Thanks. You\u2019ll hear from us shortly."
        }
      });
    };

    function waitForUserJwt() {
      window.drift ? window.drift.waitForUserJwt() : console.warn("widget stub is not installed yet, you need to call installWidgetStub() first");
    }

    var ei,
        ti,
        ni = function installBeamer() {
      window.beamer_config = {
        lazy: !0
      };
      var e = document.createElement("script");
      e.id = "beamer-container", e.src = "https://app.getbeamer.com/js/beamer-embed.js", e.defer = "defer", e.type = "text/javascript", e.onload = function () {
        return Je.dispatch({
          type: "SET_BEAMER_SNIPPET_LOADED",
          beamerLoaded: !0
        });
      }, document.body.appendChild(e);
    },
        ri = function setStubs() {
      Xr(), !Kr() && Jr();
    },
        ii = function loadThirdParties() {
      waitForUserJwt(), function loadSegment() {
        window.analytics && window.analytics.load(d.SEGMENT_ID);
      }(), $r(), ni();
    },
        oi = function setSnippets() {
      Xr(), waitForUserJwt(), !Kr() && Jr(), $r(), ni();
    },
        ai = function getSocketAuth(e) {
      return function WSAuthAPI(e) {
        return L.a.create({
          baseURL: "https://".concat(e, "-").concat(M(e), ".").concat(d.WS_CHAT_BASE)
        });
      }(e).post("/api/auth", JSON.stringify({
        access_token: J()
      }));
    },
        si = r(64),
        ci = function OpenSocket(e) {
      var t = e.session_token,
          n = e.org_id,
          r = new si.Socket("wss://".concat(n, "-").concat(M(n), ".").concat(d.WS_CHAT_BASE, "/ws"), {
        params: {
          session_token: t
        }
      });
      return r.connect(), r;
    },
        li = function JoinChannel(e, t, n) {
      var r = t.channel(e);
      return n.forEach(function (e) {
        var t = e.topic,
            n = e.event;
        r.on(t, n);
      }), r.join().receive("ok", function () {}).receive("error", function () {}).receive("timeout", function () {}), r;
    },
        ui = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee() {
        return m.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ne.get("/integrations/all/public"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      }));

      return function getIntegrationStatus() {
        return e.apply(this, arguments);
      };
    }(),
        pi = function getCutovers() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
      return Promise.all([ne.get("/cutover/organizations/".concat(e, "?namespace=APP_SWITCHER")), ne.get("/cutover/organizations/".concat(e, "?namespace=DRIFT_HELP")), ne.get("/cutover/organizations/".concat(e, "?namespace=DRIFT_VIDEO_IN_NAV"))]).then(function (e) {
        var t = _slicedToArray(e, 3);

        return {
          data: {
            APP_SWITCHER: t[0].data.APP_SWITCHER,
            DRIFT_HELP: t[1].data.DRIFT_HELP,
            DRIFT_VIDEO_IN_NAV: t[2].data.DRIFT_VIDEO_IN_NAV
          }
        };
      });
    },
        fi = function chatNotification(e) {
      var t = e.body,
          n = e.attachments,
          r = e.conversationId,
          i = e.inboxId,
          o = e.subject,
          a = t,
          s = n && n.length ? "\n\uD83D\uDCCE Message sent with attachment." : o || a,
          c = {
        message: "#".concat(r, " ").concat(s),
        click: function click() {
          window.open("/inboxes/".concat(i, "/conversations/").concat(r));
        }
      };
      return function () {
        return Je.dispatch(Ur(c));
      };
    },
        di = function conversationEventHandlers(e) {
      var t = e.conversationId,
          n = e.inboxId,
          r = e.conversationEvent,
          i = r && r.type;
      if (!["ADDED_PARTICIPANTS", "REMOVED_PARTICIPANTS"].includes(i)) return noop;
      var o = {
        message: "You\u2019ve been ".concat("ADDED_PARTICIPANTS" === i ? "added to" : "removed from", " a conversation in Drift. Click here to view it."),
        click: function click() {
          window.open("/inboxes/".concat(n, "/conversations/").concat(t));
        }
      };
      return function () {
        return Je.dispatch(Ur(o));
      };
    },
        hi = {
      topic: "browser-notification",
      event: function event(e) {
        !function getNotificationEventHandler(e) {
          var t = e.body;
          t.message ? ({
            CHAT: fi(t.message),
            CONVERSATION_EVENT: di(t.message) || noop
          }[t.message.type] || noop)() : noop;
        }(e);
      }
    },
        mi = {
      topic: "account-presence",
      event: function event(e) {
        var t = e.account,
            n = e.event,
            r = e.companyData;

        if (t.ownerId === Je.getState().user.id) {
          var i = {
            message: "".concat(t.name, " is on your website right now!"),
            click: function click() {
              return n.driftId ? window.open("/inboxes?endUserId=".concat(n.driftId)) : window.open("/live?user=".concat(n.anonymousId, "&account=").concat(t.name));
            },
            options: {
              body: "Page: ".concat(n.attributes.title || n.attributes.url),
              icon: r.logo
            }
          };
          Je.dispatch(Ur(i));
        }
      }
    },
        gi = function receiveAllOrgUsers(e) {
      return {
        type: "RECEIVE_ALL_ORG_USERS",
        users: e
      };
    },
        Ai = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee() {
        var e, t;
        return m.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, n.next = 3, nn();

              case 3:
                e = n.sent, t = e.data, Je.dispatch(gi(t)), n.next = 11;
                break;

              case 8:
                n.prev = 8, n.t0 = n.catch(0), console.error(n.t0);

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function refetchOrgUsers() {
        return e.apply(this, arguments);
      };
    }(),
        vi = [mi, {
      topic: "gates-updated",
      event: function event(e) {
        Je.dispatch(_(e));
      }
    }, {
      topic: "user-updated",
      event: function () {
        var e = _asyncToGenerator(m.a.mark(function _callee2(e) {
          return m.a.wrap(function _callee2$(t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  Je.getState().user.id === e.id && Je.dispatch(E(e)), Ai();

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, _callee2);
        }));

        return function event(t) {
          return e.apply(this, arguments);
        };
      }()
    }, {
      topic: "user-new",
      event: function event(e) {
        Ai();
      }
    }],
        bi = [hi, {
      topic: "user-convo-limit-update",
      event: function event(e) {
        var t = Je.getState().user.settings;
        t.atConversationLimit = e.body.hasUserReachedLimit, Je.dispatch(C(t));
      }
    }],
        yi = r(65),
        Ei = r.n(yi),
        Ci = "undefined" !== typeof performance && performance,
        wi = Ci && Ci.now ? function () {
      return Ci.now();
    } : function () {
      return Date.now();
    };

    function throwIfEmpty(e) {
      if (!e) throw new Error("name must be non-empty");
    }

    if (Ci && Ci.mark) ei = function mark(e) {
      throwIfEmpty(e), Ci.mark("start " + e);
    }, ti = function stop(e) {
      throwIfEmpty(e), Ci.mark("end " + e), Ci.measure(e, "start " + e, "end " + e);
      var t = Ci.getEntriesByName(e);
      return t[t.length - 1];
    }, function getEntries() {
      return Ci.getEntriesByType("measure");
    }, function clear() {
      Ci.clearMarks(), Ci.clearMeasures();
    };else {
      var _i = {},
          xi = [];
      ei = function mark(e) {
        throwIfEmpty(e);
        var t = wi();
        _i["$" + e] = t;
      }, ti = function stop(e) {
        throwIfEmpty(e);
        var t = wi(),
            n = _i["$" + e];
        if (!n) throw new Error("no known mark: " + e);
        var r = {
          startTime: n,
          name: e,
          duration: t - n,
          entryType: "measure"
        };
        return function insertSorted(e, t) {
          for (var n, r = 0, i = e.length; r < i;) {
            e[n = r + i >>> 1].startTime < t.startTime ? r = n + 1 : i = n;
          }

          e.splice(r, 0, t);
        }(xi, r), r;
      }, function getEntries() {
        return xi;
      }, function clear() {
        _i = {}, xi = [];
      };
    }

    var Si = function recordMetrics(e) {
      return ae.post("/monitoring/metrics/add/bulk", e);
    },
        ki = function getMeta() {
      return {
        userId: Object(v.path)(["user", "id"], Je.getState()),
        orgId: Object(v.path)(["user", "orgId"], Je.getState()),
        userAgent: window.navigator.userAgent,
        host: new URL(window.location.href).origin,
        path: new URL(window.location.href).pathname,
        type: "timer"
      };
    },
        Oi = function metric(e, t) {
      return {
        metric: "traffic-control-".concat(e),
        value: t,
        dimensions: ki()
      };
    },
        Bi = [],
        Ti = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee() {
        return m.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (window.performance) {
                  e.next = 2;
                  break;
                }

                return e.abrupt("return");

              case 2:
                return e.prev = 2, e.abrupt("return", Ii());

              case 6:
                e.prev = 6, e.t0 = e.catch(2);

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, _callee, null, [[2, 6]]);
      }));

      return function recordPerformanceMetrics() {
        return e.apply(this, arguments);
      };
    }(),
        Ii = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee2() {
        return m.a.wrap(function _callee2$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Ei.a.getFirstConsistentlyInteractive().then(function (e) {
                  try {
                    isNaN(e) || Bi.push(Oi("time-to-interactive", Math.round(e))), window.performance.getEntriesByType("paint").forEach(function (e) {
                      isNaN(e.startTime) || isNaN(e.duration) || Bi.push(Oi(e.name, Math.round(e.startTime + e.duration)));
                    });
                    var t = window.performance.timing,
                        n = t.domContentLoadedEventStart,
                        r = t.domLoading;
                    isNaN(n) || isNaN(r) || Bi.push(Oi("dom-content-loaded", Math.round(n - r))), Si(Bi).catch(function (e) {
                      return console.warn("performance metrics send failed " + e);
                    });
                  } catch (i) {
                    console.warn("performance metrics collection failed " + i);
                  }
                }));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee2);
      }));

      return function getMetrics() {
        return e.apply(this, arguments);
      };
    }(),
        Ri = function () {
      var e = _asyncToGenerator(m.a.mark(function _callee3(e, t) {
        var n, r, i;
        return m.a.wrap(function _callee3$(o) {
          for (;;) {
            switch (o.prev = o.next) {
              case 0:
                return ei(t), o.next = 3, e.apply(null);

              case 3:
                return n = o.sent, r = ti(t), i = {
                  result: n,
                  timing: r.duration
                }, Bi.push(Oi(t, Math.round(i.timing))), o.abrupt("return", i);

              case 8:
              case "end":
                return o.stop();
            }
          }
        }, _callee3);
      }));

      return function tracedMethod(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Pi = function startTraceMark(e) {
      ei(e);
    },
        ji = function stopTraceMark(e) {
      try {
        var t = ti(e);
        return Bi.push(Oi(e, Math.round(t.duration))), t.duration;
      } catch (n) {
        return console.log("Tried to stop mark ".concat(e, " that doesn't exist")), null;
      }
    };

    function init_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ni = function (e) {
      _inherits(Init, c["Component"]);

      var t = init_createSuper2(Init);

      function Init(e) {
        var n;
        return _classCallCheck(this, Init), (n = t.call(this, e)).receiveInitialOrgData = function () {
          var e = _asyncToGenerator(m.a.mark(function _callee(e) {
            var t, r, i, o, a, s, c, l, u, p, f, d, h, g, A, v, b, y, E, C, w, _;

            return m.a.wrap(function _callee$(m) {
              for (;;) {
                switch (m.prev = m.next) {
                  case 0:
                    t = _slicedToArray(e, 10), r = t[0].data, i = t[1].data, o = t[2].data, a = t[3].data, s = t[4].data, c = t[5].data, l = t[6].data, u = t[7].data, p = t[8].data, f = t[9].data, d = n.props, h = d.onReceiveCutovers, g = d.onReceiveEmbedConfig, A = d.onReceiveUserSettings, v = d.onReceiveOrgProperties, b = d.onReceiveUserProfile, y = d.onReceiveOrgConfig, E = d.onReceiveOrgUsers, C = d.onReceiveAllOrgUsers, w = d.onReceiveUserConfig, _ = d.onReceiveIntegrationStatus, y(r), v(o), E(a), C(s), g(i), A(c), b(l), w(u), _(p), h(f);

                  case 12:
                  case "end":
                    return m.stop();
                }
              }
            }, _callee);
          }));

          return function (t) {
            return e.apply(this, arguments);
          };
        }(), n.state = {
          loaded: !1,
          orgId: null,
          hasAuthorizationError: null
        }, n;
      }

      return _createClass(Init, [{
        key: "setIsLoaded",
        value: function setIsLoaded(e) {
          this.setState({
            loaded: !0
          }, e);
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee3() {
            var e = this;
            return m.a.wrap(function _callee3$(t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return Pi("initial-mount"), window.localStorage.setItem("openTabs", "[]"), t.next = 4, Ri(function () {
                      return e.redirectChecks();
                    }, "redirect-checks");

                  case 4:
                    return t.next = 6, Ri(function () {
                      return e.getData();
                    }, "get-data");

                  case 6:
                    return t.next = 8, Ri(function () {
                      return te(window.location.pathname);
                    }, "user-type-redirects");

                  case 8:
                    return t.next = 10, Ri(function () {
                      return Q(e.props.org);
                    }, "onboarding-redirect");

                  case 10:
                    ri(), this.setIsLoaded(_asyncToGenerator(m.a.mark(function _callee2() {
                      return m.a.wrap(function _callee2$(t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return t.next = 2, Ri(function () {
                                return e.getSocketSession();
                              }, "check-socket-session");

                            case 2:
                              t.sent && (Ri(function () {
                                return e.joinOrgChannel();
                              }, "join-org-channel"), Ri(function () {
                                return e.joinUserChannel();
                              }, "join-user-channel")), Ri(function () {
                                return ht();
                              }, "identify-user"), Ri(function () {
                                return gt();
                              }, "browser-fingerprint"), Ri(function () {
                                return Zr(e.props.org, e.props.embed);
                              }, "check-widget-enabled"), Ri(function () {
                                return Gr(e.props.org);
                              }, "check-permissions"), ji("initial-mount"), Ti().then(ii);

                            case 10:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, _callee2);
                    })));

                  case 12:
                  case "end":
                    return t.stop();
                }
              }
            }, _callee3, this);
          }));

          return function componentDidMount() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "redirectChecks",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee4() {
            var e, t, n;
            return m.a.wrap(function _callee4$(r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return e = this.props, t = e.mobileRedirectEnabled, n = e.authClientId, t && $(), r.next = 4, Object(W.checkForGlobalSession)();

                  case 4:
                    return r.next = 6, V();

                  case 6:
                    return r.next = 8, q(n);

                  case 8:
                    return r.next = 10, X(n);

                  case 10:
                  case "end":
                    return r.stop();
                }
              }
            }, _callee4, this);
          }));

          return function redirectChecks() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "getData",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee6() {
            var e,
                t = this;
            return m.a.wrap(function _callee6$(n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return e = this.props.authClientId, n.prev = 1, n.next = 4, $t().then(function () {
                      var e = _asyncToGenerator(m.a.mark(function _callee5(e) {
                        var n, r, i;
                        return m.a.wrap(function _callee5$(o) {
                          for (;;) {
                            switch (o.prev = o.next) {
                              case 0:
                                return n = e && e.data, r = n && n.id, o.next = 4, Promise.all([Kt(), Qt(), tn(), nn(), Xe(), $e(), Ke(), ui(), pi(r)]);

                              case 4:
                                i = o.sent, t.receiveInitialOrgData([e].concat(_toConsumableArray(i)));

                              case 6:
                              case "end":
                                return o.stop();
                            }
                          }
                        }, _callee5);
                      }));

                      return function (t) {
                        return e.apply(this, arguments);
                      };
                    }());

                  case 4:
                    n.next = 10;
                    break;

                  case 6:
                    n.prev = 6, n.t0 = n.catch(1), console.error(n.t0), 403 === n.t0.response.status && ee(e);

                  case 10:
                  case "end":
                    return n.stop();
                }
              }
            }, _callee6, this, [[1, 6]]);
          }));

          return function getData() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "getSocketSession",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee7() {
            var e, t, n, r, i, o, a;
            return m.a.wrap(function _callee7$(s) {
              for (;;) {
                switch (s.prev = s.next) {
                  case 0:
                    return s.prev = 0, e = this.props, t = e.onReceiveSocketConnection, n = e.org, s.next = 4, ai(n.id);

                  case 4:
                    return r = s.sent, i = r.data, s.next = 8, this.connectToSocket(i);

                  case 8:
                    return o = s.sent, a = o.socket, t(a), s.abrupt("return", !0);

                  case 14:
                    return s.prev = 14, s.t0 = s.catch(0), console.warn("Socket error:", s.t0), s.abrupt("return", !1);

                  case 18:
                  case "end":
                    return s.stop();
                }
              }
            }, _callee7, this, [[0, 14]]);
          }));

          return function getSocketSession() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "connectToSocket",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee9(e) {
            var t, n, r;
            return m.a.wrap(function _callee9$(i) {
              for (;;) {
                switch (i.prev = i.next) {
                  case 0:
                    return t = e.session_token, n = e.org_id, r = new Promise(function () {
                      var e = _asyncToGenerator(m.a.mark(function _callee8(e, r) {
                        var i;
                        return m.a.wrap(function _callee8$(o) {
                          for (;;) {
                            switch (o.prev = o.next) {
                              case 0:
                                return o.next = 2, ci({
                                  session_token: t,
                                  org_id: n
                                });

                              case 2:
                                if (!(i = o.sent)) {
                                  o.next = 7;
                                  break;
                                }

                                return o.abrupt("return", e({
                                  socket: i
                                }));

                              case 7:
                                return o.abrupt("return", r("could not connect"));

                              case 8:
                              case "end":
                                return o.stop();
                            }
                          }
                        }, _callee8);
                      }));

                      return function (t, n) {
                        return e.apply(this, arguments);
                      };
                    }()), i.abrupt("return", r);

                  case 3:
                  case "end":
                    return i.stop();
                }
              }
            }, _callee9);
          }));

          return function connectToSocket(t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "joinOrgChannel",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee10() {
            var e, t, n, r;
            return m.a.wrap(function _callee10$(i) {
              for (;;) {
                switch (i.prev = i.next) {
                  case 0:
                    e = this.props, t = e.org, n = e.socket, r = vi, li("private-org:".concat(t.id), n, r);

                  case 3:
                  case "end":
                    return i.stop();
                }
              }
            }, _callee10, this);
          }));

          return function joinOrgChannel() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "joinUserChannel",
        value: function () {
          var e = _asyncToGenerator(m.a.mark(function _callee11() {
            var e, t, n, r, i;
            return m.a.wrap(function _callee11$(o) {
              for (;;) {
                switch (o.prev = o.next) {
                  case 0:
                    e = this.props, t = e.org, n = e.socket, r = e.user, i = bi, li("user:".concat(t.id, "-").concat(r.id, "-1"), n, i);

                  case 3:
                  case "end":
                    return o.stop();
                }
              }
            }, _callee11, this);
          }));

          return function joinUserChannel() {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.loaded,
              n = e.hasAuthorizationError;
          return t && n ? l.a.createElement(Mr, {
            type: n
          }) : l.a.createElement(Tr, Object.assign({}, this.props, {
            loaded: t
          }));
        }
      }]), Init;
    }(),
        Di = function receiveIntegrationStatus(e) {
      return {
        type: "RECEIVE_INTEGRATION_STATUS",
        integrations: e
      };
    },
        Li = Object(u.connect)(function mapStateToProps(e) {
      return {
        org: e.org,
        embed: e.embed,
        user: e.user,
        socket: e.socket,
        integrations: e.integrations
      };
    }, function mapDispatchToProps(e) {
      return {
        onReceiveCutovers: function onReceiveCutovers(t) {
          e(function receiveCutovers(e) {
            return {
              type: "RECEIVE_CUTOVERS",
              cutovers: e
            };
          }(t));
        },
        onReceiveOrgConfig: function onReceiveOrgConfig(t) {
          e(function receiveOrgConfig(e) {
            return {
              type: "RECEIVE_ORG_CONFIG",
              config: e
            };
          }(t));
        },
        onReceiveOrgProperties: function onReceiveOrgProperties(t) {
          e(function receiveOrgProperties(e) {
            return {
              type: "RECEIVE_ORG_PROPERTIES",
              properties: e
            };
          }(t));
        },
        onReceiveIntegrationStatus: function onReceiveIntegrationStatus(t) {
          e(Di(t));
        },
        onReceiveUserConfig: function onReceiveUserConfig(t) {
          e(E(t));
        },
        onReceiveUserProfile: function onReceiveUserProfile(t) {
          e(w(t));
        },
        onReceiveEmbedConfig: function onReceiveEmbedConfig(t) {
          e(Vr(t));
        },
        onReceiveUserSettings: function onReceiveUserSettings(t) {
          e(C(t));
        },
        onReceiveOrgUsers: function onReceiveOrgUsers(t) {
          e(function receiveOrgUsers(e) {
            return {
              type: "RECEIVE_ORG_USERS",
              users: e
            };
          }(t));
        },
        onReceiveAllOrgUsers: function onReceiveAllOrgUsers(t) {
          e(gi(t));
        },
        onReceiveSocketConnection: function onReceiveSocketConnection(t) {
          e(function receiveSocketConnection(e) {
            return {
              type: "RECEIVE_SOCKET_CONNECTION",
              socket: e
            };
          }(t));
        },
        showGlobalNotification: function showGlobalNotification(t) {
          e(or(t));
        },
        sendBrowserNotification: function sendBrowserNotification(t) {
          e(Ur(t));
        },
        showTransientNotification: function showTransientNotification(t) {
          e(x(t));
        },
        removeTransientNotification: function removeTransientNotification(t) {
          e(S(t));
        }
      };
    })(Ni),
        Mi = "No arguments were provided.",
        Ui = function Access(e) {
      var t = function checkScope(t) {
        return Object(v.pathOr)([], ["user", "scopes"], e.getState()).includes(t);
      },
          n = function checkRole(t) {
        return Object(v.pathOr)([], ["user", "roles"], e.getState()).includes(t);
      },
          r = function checkAnyRoles(e) {
        var t = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);

        for (var r in t) {
          if (n(t[r])) return !0;
        }

        return !1;
      },
          i = function checkGate(t) {
        var n = e.getState().user,
            r = (void 0 === n ? {} : n).gates;
        return !!r && !!r[t];
      },
          o = function checkCutover(t) {
        var n = e.getState().cutovers,
            r = void 0 === n ? {} : n;
        return !!r && !!r[t];
      };

      return {
        hasScopes: function hasScopes() {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
            n[r] = arguments[r];
          }

          return function checkScopes(e) {
            var n = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);
            if (!n.length) throw Mi;

            for (var r in n) {
              if (!t(n[r])) return !1;
            }

            return !0;
          }(n);
        },
        hasAnyScope: function hasAnyScope() {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
            n[r] = arguments[r];
          }

          return function checkAnyScopes(e) {
            var n = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);
            if (!n.length) throw Mi;

            for (var r in n) {
              if (t(n[r])) return !0;
            }

            return !1;
          }(n);
        },
        hasAnyRole: function hasAnyRole() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return r(t);
        },
        hasGates: function hasGates() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkGates(e) {
            var t = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);
            if (!t.length) throw Mi;

            for (var n in t) {
              if (i(t[n])) return !0;
            }

            return !1;
          }(t);
        },
        hasAllGates: function hasAllGates() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkAllGates(e) {
            var t = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);
            if (!t.length) return !0;

            for (var n in t) {
              if (!i(t[n])) return !1;
            }

            return !0;
          }(t);
        },
        hasCutover: function hasCutover() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkCutovers(e) {
            var t = Array.isArray(e[0]) ? e[0] : _toConsumableArray(e);
            if (!t.length) throw Mi;

            for (var n in t) {
              if (o(t[n])) return !0;
            }

            return !1;
          }(t);
        },
        hasLicense: function hasLicense(t) {
          return function checkOrgLicense(t) {
            var n = e.getState().org.license;
            return (void 0 === n ? [] : n).some(function (e) {
              return e.type === t;
            });
          }(t);
        },
        isAdmin: function isAdmin() {
          return t("org_admin");
        },
        isAgent: function isAgent() {
          return t("agent");
        },
        isUser: function isUser() {
          return t("user");
        },
        isMultiOrg: function isMultiOrg() {
          return t("multi_org");
        },
        isCalendarUser: function isCalendarUser() {
          return i("has_calendar_user_license");
        },
        isVideoOnlyUser: function isVideoOnlyUser() {
          return t("video") && !t("member") && !i("has_calendar_user_license") && !r(["Playbooks", "Reporting"]);
        },
        isChatUser: function isChatUser() {
          return i("chat");
        },
        isBot: function isBot() {
          return function checkBot() {
            return Object(v.pathOr)(!1, ["user", "bot"], e.getState());
          }();
        }
      };
    },
        Fi = function IntegrationStatus(e) {
      return {
        isIntegrationConnected: function isIntegrationConnected(t) {
          return function isIntegrationConnected(t) {
            return !!e.getState().integrations.status[t];
          }(t);
        },
        getAllIntegrations: function getAllIntegrations() {
          return e.getState().integrations.status;
        }
      };
    },
        zi = Fi,
        Hi = r(32),
        Wi = r.n(Hi),
        qi = Object.freeze({
      ignoreErrors: ["TypeError: Network request failed", "ajax error 404", "ajax error 403", "ajax error 401", "ajax error 0"]
    }),
        Gi = function initializeSentry(e) {
      Wi.a.config(e || d.SENTRY_KEY, qi).install();
    },
        Vi = function logError(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      e instanceof Error || (e = new Error(JSON.stringify(e))), d.SEND_TO_SENTRY ? Wi.a.captureException(e, _objectSpread2(_objectSpread2({}, t), {}, {
        level: "error"
      })) : function logErrorToConsole(e) {
        e.stack ? console.error(e.stack) : console.error(e);
      }(e);
    };

    function AxiosResponseError(e) {
      this.constructor.prototype.__proto__ = Error.prototype, "function" === typeof Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e.message).stack, this.name = "Service Error", this.message = "".concat(e.config.method.toUpperCase(), " - ").concat(e.response.status, ": ").concat(e.message, " (").concat(e.config.url, ")");
    }

    var Yi = function unlistenPageTracking(e, t) {
      return e ? (ft(e.location.pathname, t), e.listen(function (e) {
        ft(e.pathname, t);
      })) : (Vi("No history object provided to unlistenPageTracking."), function () {});
    };

    function objectWithoutProperties_objectWithoutProperties(e, t) {
      if (null == e) return {};

      var n,
          r,
          i = function _objectWithoutPropertiesLoose(e, t) {
        if (null == e) return {};
        var n,
            r,
            i = {},
            o = Object.keys(e);

        for (r = 0; r < o.length; r++) {
          n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        }

        return i;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);

        for (r = 0; r < o.length; r++) {
          n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
      }

      return i;
    }

    var Zi = r(66),
        Ji = function createReducer(e) {
      return function (t, n) {
        return function () {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t,
              i = arguments.length > 1 ? arguments[1] : void 0;
          return Object(Zi.a)(r, function (t) {
            if (!i.type) return t;

            var r = n[function resolveLocalAction(e, t) {
              return t.replace("".concat(e, "_"), "");
            }(e, i.type)];

            return r ? r({
              draft: t,
              action: i
            }) : t;
          });
        };
      };
    },
        Ki = function actionType(e, t) {
      return "".concat(e, "_").concat(t);
    },
        Xi = function CreateAction(e) {
      return function (t) {
        var n = t.type,
            r = objectWithoutProperties_objectWithoutProperties(t, ["type"]);
        return _objectSpread2({
          type: Ki(e, n)
        }, r);
      };
    },
        $i = function MergeReducers(e) {
      return function (t) {
        return [{
          key: e,
          reducer: Object(se.combineReducers)(t)
        }];
      };
    },
        Qi = function reduxInit(e) {
      return {
        createReducer: Ji(e),
        createAction: Xi(e),
        mergeReducers: $i(e)
      };
    },
        eo = Qi("TRAFFIC_CONTROL");

    eo.createReducer, eo.createAction, eo.mergeReducers;
    r.d(n, "tracking", function () {
      return oo;
    }), r.d(n, "router", function () {
      return ao;
    }), r.d(n, "logger", function () {
      return so;
    }), r.d(n, "errors", function () {
      return co;
    }), r.d(n, "injectReducers", function () {
      return lo;
    }), r.d(n, "injectEpics", function () {
      return uo;
    }), r.d(n, "GlobalStore", function () {
      return po;
    }), r.d(n, "driftAPI", function () {
      return fo;
    }), r.d(n, "access", function () {
      return ho;
    }), r.d(n, "integrationStatus", function () {
      return mo;
    }), r.d(n, "showTransientNotification", function () {
      return x;
    }), r.d(n, "removeTransientNotification", function () {
      return S;
    }), r.d(n, "sendBrowserNotification", function () {
      return Ur;
    }), r.d(n, "showGlobalNotification", function () {
      return or;
    }), r.d(n, "removeGlobalNotification", function () {
      return ar;
    }), r.d(n, "receiveUserSettings", function () {
      return C;
    }), r.d(n, "receiveUserProfile", function () {
      return w;
    }), r.d(n, "receiveUserGates", function () {
      return _;
    }), r.d(n, "receiveUserConfig", function () {
      return E;
    }), r.d(n, "receiveIntegrationStatus", function () {
      return Di;
    }), r.d(n, "GlobalNotifications", function () {
      return ur;
    }), r.d(n, "TransientNotifications", function () {
      return dr;
    }), r.d(n, "installSegment", function () {
      return Jr;
    }), r.d(n, "installWidgetStub", function () {
      return Xr;
    }), r.d(n, "disableSupportChat", function () {
      return Qr;
    }), r.d(n, "hideWelcomeMessage", function () {
      return $r;
    }), r.d(n, "hasSegmentSnippet", function () {
      return Kr;
    }), r.d(n, "setSnippets", function () {
      return oi;
    }), r.d(n, "reduxInit", function () {
      return Qi;
    }), window.noop = function () {};

    var to = [{
      label: "Switch to Dev.Drift",
      url: d.DEVELOPERS_WEB_URL
    }],
        no = function injectAllReducers(e) {
      e.forEach(function (e) {
        !function injectAsyncReducer(e, t) {
          var n = t.key,
              r = t.reducer;
          e.asyncReducers[n] = r, e.replaceReducer(Ve(e.asyncReducers));
        }(Je, e);
      });
    },
        ro = function injectAllEpics(e) {
      e.forEach(function (e) {
        !function injectAsyncEpic(e) {
          Ge.next(e);
        }(e);
      });
    },
        io = new Audio("https://s3.amazonaws.com/tide-assets/silence.mp3");

    io.muted = !0, io.play().catch(function () {
      document.addEventListener("click", function () {
        io.play();
      }, {
        once: !0
      });
    });
    var oo = i,
        ao = s,
        so = o,
        co = a,
        lo = no,
        uo = ro,
        po = Je,
        fo = Ht,
        ho = Ui(po),
        mo = zi(po);

    n.default = function ConnectedApp(e) {
      var t = e.render,
          n = e.reducers,
          r = void 0 === n ? [] : n,
          i = e.epics,
          o = void 0 === i ? [] : i,
          a = e.navItems,
          s = e.switchAppLinks,
          c = void 0 === s ? to : s,
          p = e.mobileRedirectEnabled,
          f = void 0 === p || p,
          h = e.noNav,
          m = void 0 !== h && h,
          g = e.authClientId,
          A = e.sentryId,
          v = e.showIntegratedHelp,
          b = void 0 === v || v,
          y = e.globalNotificationsEnabled,
          E = void 0 === y || y;
      return no(r), ro(o), d.SEND_TO_SENTRY && Gi(A), l.a.createElement(u.Provider, {
        store: Je
      }, l.a.createElement(Li, {
        render: t,
        navItems: a,
        switchAppLinks: c,
        mobileRedirectEnabled: f,
        authClientId: g,
        noNav: m,
        showIntegratedHelp: b,
        globalNotificationsEnabled: E
      }));
    };
  }]);
});